import { ProposalDecision, ToolName, ToolPolicy } from '../../agents/types.js';
import { BlameLogType } from '../../blamelog/index.js';
import { CaseState, CaseStatus, CaseType, SystemEndReason, } from '../../cases/index.js';
import { CaseTag } from '../../cases/index.js';
import { CollectorType, PaymentOptionType } from '../../collectors/index.js';
import { ConnectConnectionStatus } from '../../connect/connections/index.js';
import { ConnectCaseMappingStatus, RetractionReason, } from '../../connect/mappings/index.js';
import { ProductService } from '../../connect/products/index.js';
import { InterestType, LienType, ValuationSource, } from '../../cosmoV2/assets.js';
import { ProviderName } from '../../cosmoV2/providers/index.js';
import { SubmitToCourtError } from '../../court/auto-submit.js';
import { UdbetalingsRekvisitioner } from '../../court/index.js';
import { CreditorState } from '../../creditor/index.js';
import { AlternativeContactType, CompanyStarCycle, DissolvedStatus, FoundationCode, PrivateStarCycle, RelationType, } from '../../customers/index.js';
import { DebtRegistrationState, RegistryType, } from '../../debt-register/index.js';
import { DebtRegistrationError } from '../../debt-register/rki.js';
import { DocumentTypes } from '../../documents/index.js';
import { AutoBillingTiming, Timing, } from '../../economy/billing-appendix-setups/index.js';
import { DepositShareType } from '../../economy/billing/organize.js';
import { CaseVoucherEventType } from '../../economy/case-voucher-events/event-type.js';
import { State as CaseVoucherState } from '../../economy/case-vouchers/index.js';
import { CaseVoucherSource, PaymentType, State, } from '../../economy/case-vouchers/index.js';
import { CaseVoucherTags } from '../../economy/index.js';
import { PaymentPlanEntryStatus } from '../../economy/payment-plans/index.js';
import { PayoutState, PayoutType } from '../../economy/payouts/index.js';
import { CompoundingPeriod, ImposeInterestFrequency, VoucherCategory, VoucherTypeIds, VoucherTypeSetting, } from '../../economy/vouchers/index.js';
import { EmbedPlacement } from '../../embeds/index.js';
import { EndReasonCategory } from '../../end-reasons/index.js';
import { ImportState } from '../../imports/types.js';
import { Entity, Gender, PermissionLevels, TimespanUnit } from '../../index.js';
import { AggregationType } from '../../insights/aggregations.js';
import { BulkActionType } from '../../insights/bulk-actions.js';
import { FilterType } from '../../insights/index.js';
import { DiscountType, IntentType } from '../../intents/index.js';
import { InteractionEventType } from '../../interactions/events/index.js';
import { InteractionType, PhoneIncomingTag, PhoneOutgoingTag, ReturnReason, } from '../../interactions/index.js';
import { PerformedByType } from '../../performed-by/index.js';
import { SystemProcedure, SystemProcedureId } from '../../procedures/index.js';
import { PropertyDataType } from '../../properties/index.js';
import { TemplateMention, TemplateTag, TemplateType, } from '../../templates/index.js';
import { SKU } from '../../tenants/billing.js';
import { TenantStatus } from '../../tenants/index.js';
import { TribunalCaseStatus, TribunalCaseType, } from '../../tribunal/cases/types.js';
import { CourtMeetingState, DistraintType, TribunalJobType, } from '../../tribunal/jobs/types.js';
import { UpdateType } from '../../updates/index.js';
import { InterestFrom, VoucherApplicationTarget, VoucherApplicationType, } from '../../voucher-applications/index.js';
import { PathWarning, RequirementType, TimingType, TodoType, } from '../../workflows/index.js';
export default {
    is: {
        currently: 'da',
    },
    langs: {
        en: 'Engelsk',
        da: 'Dansk',
        sv: 'Svensk',
        no: 'Norsk',
        fi: 'Finsk',
        nl: 'Hollandsk',
        de: 'Tysk',
        fr: 'Fransk',
        es: 'Spansk',
        cs: 'Tjekkisk',
        el: 'Græsk',
    },
    tribunalCaseTypes: {
        [TribunalCaseType.DKBetalingspaakrav]: '🇩🇰 Betalingspåkrav',
        [TribunalCaseType.DKFogedrekvisition]: '🇩🇰 Fogedrekvisition',
        [TribunalCaseType.DKAndreFogedsager]: '🇩🇰 Andre fogedsager',
        [TribunalCaseType.GLStaevning]: '🇬🇱 Stævning',
        [TribunalCaseType.GLFogedBegaering]: '🇬🇱 Fogedbegæring',
        [TribunalCaseType.GLBetalingspaakrav]: '🇬🇱 Betalingspåkrav',
    },
    tribunalCaseStatuses: {
        [TribunalCaseStatus.Created]: 'Oprettet',
        [TribunalCaseStatus.Awaiting1Paategning]: 'Afventer 1.-påtegning',
        [TribunalCaseStatus.ClosedBecauseOfObjection]: 'Lukket grundet indsigelse',
        [TribunalCaseStatus.Closed]: 'Afsluttet',
        [TribunalCaseStatus.Awaiting2Paategning]: 'Afventer 2.-påtegning',
        [TribunalCaseStatus.AwaitingNoticeForBailiffMeeting]: 'Afventer mødeindkaldelse',
        [TribunalCaseStatus.AwaitingBailiffMeeting]: 'Afventer fogedmøde',
        [TribunalCaseStatus.AwaitingVerdict]: 'Afventer dom',
        [TribunalCaseStatus.AwaitingNoticeForFogedmoede]: 'Afventer indkaldelse',
        [TribunalCaseStatus.AwaitingFogedmoede]: 'Afventer fogedmøde',
    },
    tribunalJobTypes: {
        [TribunalJobType.GLCreateBetalingspaakrav]: 'Opret betalingspåkrav',
        [TribunalJobType.GLResendBetalingspaakrav]: 'Fremsendelse af revideret betalingspåkrav',
        [TribunalJobType.CreateBetalingspaakrav]: 'Opret betalingspåkrav',
        [TribunalJobType.ResendBetalingspaakrav]: 'Fremsendelse af revideret betalingspåkrav',
        [TribunalJobType.Register1Paategning]: 'Registrering af 1.-påtegning',
        [TribunalJobType.ClosedObjection]: 'Lukket efter 1.-påtegning grundet indsigelse',
        [TribunalJobType.Register2Paategning]: 'Registrering af 2.-påtegning',
        [TribunalJobType.CreateFogedrekvisition]: 'Opret fogedrekvisition',
        [TribunalJobType.RegisterInsolvency]: 'Registrér insolvenserklæring',
        [TribunalJobType.RegisterPolicePresentation]: 'Registrér politifremstilling',
        [TribunalJobType.CreateStaevning]: 'Opret stævning',
        [TribunalJobType.ResendStaevning]: 'Genfremsend stævning',
        [TribunalJobType.RegisterVerdict]: 'Dom registreret',
        [TribunalJobType.CreateFogedbegaering]: 'Opret fogedbegæring',
        [TribunalJobType.ResendFogedbegaering]: 'Genfremsend fogedbegæring',
        [TribunalJobType.CourtMeeting]: 'Retsmøde',
        [TribunalJobType.RegisterInsolvens]: 'Registrér insolvens',
        [TribunalJobType.Distraint]: 'Udlæg',
        [TribunalJobType.CreateOtherFogedsager]: 'Opret anden fogedsag',
        [TribunalJobType.Note]: 'Opret note',
        [TribunalJobType.CloseCase]: 'Markér sag som afsluttet',
    },
    distraintType: {
        [DistraintType.Property]: 'Fast ejendom',
        [DistraintType.Vehicle]: 'Motorkøretøj',
        [DistraintType.RentalDeposit]: 'Depositum i lejebolig',
        [DistraintType.CooperativeHousing]: 'Andelsbolig',
        [DistraintType.Other]: 'Andet',
        [DistraintType.MortgageDeed]: 'Ejerpantebrev',
        [DistraintType.ExcessTax]: 'Overskydende skat',
    },
    tenantStatus: {
        [TenantStatus.Active]: 'Aktiv',
        [TenantStatus.Demo]: 'Demo',
        [TenantStatus.Disabled]: 'Deaktiveret',
        [TenantStatus.GettingStarted]: 'Afventer go-live',
        [TenantStatus.Sandbox]: 'Sandbox',
    },
    tenantStatusPlural: {
        [TenantStatus.Active]: 'Aktive',
        [TenantStatus.Demo]: 'Demoer',
        [TenantStatus.Disabled]: 'Deaktiverede',
        [TenantStatus.GettingStarted]: 'Afventer go-live',
        [TenantStatus.Sandbox]: 'Sandboxes',
    },
    tenantBillingUnits: {
        "Concatenated SMS'": 'Sammenkædede SMSer',
        'Min.': 'Min.',
        'Pcs.': 'Stk.',
        Months: 'Måneder',
    },
    tenantBilling: {
        invoices: 'Fakturaer',
        invoice: 'Faktura',
        creditNote: 'Kreditnota',
        noInvoicesYet: 'Ingen fakturaer at vise',
        backToTenantBilling: 'Tilbage til fakturaer',
    },
    tenantSKU: {
        [SKU.DomesticSMS]: 'SMS national',
        [SKU.InternationalSMS]: 'SMS international',
        [SKU.DomesticAutoCall]: 'Automatisk opkald national',
        [SKU.InternationalAutoCall]: 'Automatisk opkald international',
        [SKU.DomesticLetter]: 'Kuvertering, national porto, et papir og håndtering',
        [SKU.InternationalLetter]: 'Kuvertering, international porto, et papir og håndtering',
        [SKU.LetterExtraSheet]: 'Ekstra-sider fysisk brev (duplex)',
        [SKU.ReturnLetter]: 'Håndtering af returpost',
        [SKU.DigitalSignature]: 'Digital signatur',
        [SKU.PhoneLookup]: 'Telefonnummeropslag',
        [SKU.EmailLookup]: 'Emailopslag',
        [SKU.CaseCreation]: 'Sagsoprettelse',
        [SKU.MigratedCaseCreation]: 'Sagoprettelse (migreret sag)',
        [SKU.MonthlyBaseFee]: 'Månedligt licensgebyr',
        [SKU.SupportAgreement]: 'Supportaftale',
        [SKU.EBoks0_60KB]: 'e-Boks-besked (0-60kb)',
        [SKU.EBoks61_120KB]: 'e-Boks-besked (61-120kb)',
        [SKU.EBoks121_300KB]: 'e-Boks-besked (121-300kb)',
        [SKU.EBoks301_480KB]: 'e-Boks-besked (301-480kb)',
        [SKU.EBoks481_960KB]: 'e-Boks-besked (481-960kb)',
        [SKU.EBoks961_1440KB]: 'e-Boks-besked (961-1440kb)',
        [SKU.EBoks1441_1920KB]: 'e-Boks-besked (1441-1920kb)',
        [SKU.EBoks1921_10080KB]: 'e-Boks-besked (1921-10080kb)',
        [SKU.Onboarding]: 'Onboarding',
        [SKU.NemId]: 'NemId-login på debitorweb',
        [SKU.MitID]: 'MitID-login på debitorweb',
        [SKU.FreezingSystemSignOn]: 'Indefrysning tilmelding',
        [SKU.FreezingSystemSignOff]: 'Indefrysning afmelding',
        [SKU.Consultancy]: 'Konsulentbistand',
        [SKU.CosmoPersonLookup]: 'Opslag person',
        [SKU.CosmoCompanyLookup]: 'Opslag virksomheder',
    },
    caseVoucherTableLabels: {
        overview: 'Gældsoversigt',
        detailed: 'Sagens økonomi udspecificeret',
        principalWithReferenceCaseVouchers: 'Sagens hovedstol med referenceposteringer',
    },
    documentSettings: {
        newDocumentSigningLink: 'Nyt link',
        name: 'Navn på flettefelt',
        description: 'Beskrivelse',
        signedProcedure: 'Trigger hvis dokumentet bliver underskrevet',
        declinedSigningProcedure: 'Trigger hvis underskrift af dokumentet afvises',
    },
    caseVoucherTables: {
        caseVoucherTable: 'Sagsposteringstabel',
        previewDescription: 'Søg en sag frem for at få forhåndsvist, hvordan tabellen vil se ud med sagens posteringer.',
        createNewTable: 'Tilføj tabel',
        name: 'Navn på flettefelt',
        description: 'Beskrivelse',
        includeHeader: 'Vis overskrift i tabel',
        includeSumRow: 'Vis sum i tabel',
        includeSubTotalRow: 'Vis subtotal i tabel',
        excludeVoucherTypesFromSubTotal: 'Sagsposteringstyper der ikke medregnes i subtotalen',
        showSubTotalPerCaseVoucher: 'Vis subtotal under hver sagspostering (inkl. referenceposteringer)',
        showDepositDistribution: 'Vis indbetalingsfordeling baseret på rentebetalingsrækkefølgen',
        showInterestCalculationDetails: 'Vis detaljer om renteberegning',
        showInterestStatus: 'Vis renteårsag (betalt og anerkendt)',
        includeDeleted: 'Vis slettede posteringer',
        includeFIKPaymentDetails: 'Vis FIK betalings-ID genereret af sagsposteringens referencenummer',
        includeDate: 'Vis dato',
        includeDueDate: 'Vis forfaldsdato',
        excludeNotDueCaseVouchers: 'Skjul ikke forfaldne fakturaer',
        onlyShowSelectedVoucherCategories: 'Vis kun udvalgte sagsposteringskategorier',
        includeReferenceCaseVouchers: 'Vis referenceposteringer',
        filterOnCaseVoucherProperties: 'Filtrer på sagsposteringsattributter',
        groupBy: 'Grupper sagsposteringer',
        groupByText: 'Tekst',
        groupIncludesPayments: 'Inkluder alle indbetalingstyper',
        excludePaymentsFromSubTotal: 'Ekskluder alle indbetalingstyper',
        matchPropertiesShouldBeTrue: 'Skal være sand',
        matchPropertiesShouldBeFalse: 'Skal være falsk',
        selectCaseForPreview: 'Vælg en sag for at forhåndsvise tabellen',
        display: 'Visning',
        filtering: 'Filtrering',
        grouping: 'Gruppering',
        type: 'Tabeltype',
        typeStandard: 'Standard',
        typeLedger: 'Kravsopgørelse med løbende saldo',
        typeLedgerDescription: 'Alle sagsposteringer og hver måneds rente i kronologisk rækkefølge, med hvad hver indbetaling dækkede samt resterende hovedstol, rente og omkostninger.',
    },
    economyCategories: {
        [VoucherCategory.DISBURSEMENT]: 'Udlæg',
        [VoucherCategory.FEE]: 'Honorar',
        [VoucherCategory.COLLECTIONCOMMISSION]: 'Inddrivelseshonorar',
        [VoucherCategory.OVERPAYMENT]: 'Overindbetaling',
        [VoucherCategory.PAYOUT]: 'Udbetaling',
        [VoucherCategory.TRANSACTION]: 'Transaktioner',
        [VoucherCategory.COST]: 'Omkostninger',
        [VoucherCategory.COURTCOST]: 'Retslige omkostninger',
        [VoucherCategory.INTEREST]: 'Renter',
        [VoucherCategory.PRINCIPAL]: 'Hovedstol',
        [VoucherCategory.VAT]: 'Moms',
    },
    pluralEconomyVoucherTypeLabels: {
        [VoucherTypeIds.PRINCIPAL]: 'Hovedstole',
        [VoucherTypeIds.INVOICE]: 'Fakturaer',
        [VoucherTypeIds.ONACCOUNTINVOICE]: 'Acontofakturaer',
        [VoucherTypeIds.FINALINVOICE]: 'Opgørelser',
        [VoucherTypeIds.CONTROLFEE]: 'Kontrolafgifter',
        [VoucherTypeIds.ADMINISTRATIONCOST]: 'Administrationsgebyrer',
        [VoucherTypeIds.UDTRAEKSGEBYR]: 'Udtræksgebyrer',
        [VoucherTypeIds.CREDITNOTE]: 'Kreditnotaer',
        [VoucherTypeIds.YEARLYINTEREST]: 'Årlige renter',
        [VoucherTypeIds.MONTHLYINTEREST]: 'Månedlige renter',
        [VoucherTypeIds.STARTEDMONTHINTEREST]: 'Renter per påbegyndt måned',
        [VoucherTypeIds.PROCESSINTEREST]: 'Procesrenter',
        [VoucherTypeIds.GLPROCESSINTEREST]: 'Procesrenter (GL)',
        [VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Renters rente (daglig rentetilskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Renters rente (månedlig rentetilskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Renters rente (kvartalsvis rentetilskrivning)',
        [VoucherTypeIds.REMINDERFEE]: 'Rykkergebyrer',
        [VoucherTypeIds.COLLECTIONCOST]: 'Inkassoomkostninger',
        [VoucherTypeIds.COLLECTIONFEE]: 'Inkassogebyrer',
        [VoucherTypeIds.BAILIFFSFEE]: 'Betalingspåkravsgebyrer',
        [VoucherTypeIds.WRITFEE]: 'Stævningsgebyrer',
        [VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Retsgebyrer uden civilretten',
        [VoucherTypeIds.COURTCLAIMSALARY]: 'Retsgebyrsalærer',
        [VoucherTypeIds.BAILIFSSALARY]: 'Sagsomkostninger',
        [VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Fogedrekvisitionsgebyrer',
        [VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Politifremstilling gebyrer',
        [VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Retsgebyrer med fogedretten',
        [VoucherTypeIds.WRITSALARY]: 'Betalingspåkravssalærer',
        [VoucherTypeIds.COMPENSATIONCOST]: 'Kompensationsgebyrer',
        [VoucherTypeIds.Folkeregisteropslag]: 'Folkeregisteropslag',
        [VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Immaterielretlige sager',
        [VoucherTypeIds.CIVILCOURTCOST]: 'Omkostninger til civilretten',
        [VoucherTypeIds.DEPOSIT]: 'Indbetalinger',
        [VoucherTypeIds.WITHDRAWAL]: 'Udbetalinger',
        [VoucherTypeIds.OVERPAYMENT]: 'Overindbetalinger',
        [VoucherTypeIds.COLLECTIONCOMMISSION]: 'Inddrivelseshonorarer',
        [VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Inddrivelseshonorarer (overvågning)',
        [VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Inddrivelseshonorarer (kreditorindbetaling)',
        [VoucherTypeIds.JURIDISKBISTAND]: 'Juridisk bistand',
        [VoucherTypeIds.ENDCASEFEE]: 'Sagsafslutningshonorarer',
        [VoucherTypeIds.STARTCASEFEE]: 'Sagsopstartshonorarer',
        [VoucherTypeIds.BPKFEE]: 'Betalingspåkravshonorarer',
        [VoucherTypeIds.FOGEDFEE]: 'Fogedrekvisitionshonorarer',
        [VoucherTypeIds.DEBTREGISTERREGISTRATIONFEE]: 'Gældsregister-registreringshonorarer',
        [VoucherTypeIds.BPKDISBURSEMENT]: 'Betalingspåkravsudlæg',
        [VoucherTypeIds.POLICEDISBURSEMENT]: 'Politifremstillingsudlæg',
        [VoucherTypeIds.FOGEDDISBURSEMENT]: 'Fogedrekvisitionsudlæg',
        [VoucherTypeIds.VAT]: 'Moms',
        [VoucherTypeIds.GAELDSBREV]: 'Gældsbreve',
        [VoucherTypeIds.SETTLEMENT]: 'Frivillige forlig',
        [VoucherTypeIds.FIXEDINTEREST]: 'Fast rente',
        [VoucherTypeIds.DEPOSITPAYOUT]: 'Udbetalinger af indbetalinger',
        [VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkeregisteropslag',
        [VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmeldelse af krav',
        [VoucherTypeIds.MeetingFee]: 'Mødesalærer',
        [VoucherTypeIds.STAEVNINGSGEBYR]: 'Stævningsgebyr',
        [VoucherTypeIds.BERAMMELSESAFGIFT]: 'Berammelsesafgifter',
        [VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Aflysning af udlæg',
        [VoucherTypeIds.LOCKSMITHFEE]: 'Låsesmedsgebyrer',
        [VoucherTypeIds.DRIVINGFEE]: 'Kørselsomkostninger',
        [VoucherTypeIds.OTHERFEE]: 'Anden omkostning',
        [VoucherTypeIds.REFUND]: 'Refusioner',
        [VoucherTypeIds.JOINTDEPOSIT]: 'Solidariske betalinger',
        [VoucherTypeIds.SEPROCESSINTEREST]: 'Rente (Sverige)',
        [VoucherTypeIds.SEKRONOFOGDENAPPLICATIONFEE]: 'Retsafgifter (Kronofogden)',
        [VoucherTypeIds.SEKRONOFOGDENREPRESENTATIONFEE]: 'Inkassosalær (betalingspåkrav)',
        [VoucherTypeIds.NOLATEINTEREST]: 'Forsinkelsesrenter (Norge)',
        [VoucherTypeIds.NOFORLIKSRADFEE]: 'Retsafgifter (forligsråd)',
        [VoucherTypeIds.NOLEGALCOLLECTIONFEE]: 'Tunge salærer (retslig inkasso)',
    },
    economyVoucherTypeLabels: {
        [VoucherTypeIds.PRINCIPAL]: 'Hovedstol',
        [VoucherTypeIds.INVOICE]: 'Faktura',
        [VoucherTypeIds.ONACCOUNTINVOICE]: 'Acontofaktura',
        [VoucherTypeIds.FINALINVOICE]: 'Opgørelse',
        [VoucherTypeIds.CONTROLFEE]: 'Kontrolafgift',
        [VoucherTypeIds.ADMINISTRATIONCOST]: 'Administrationsgebyr',
        [VoucherTypeIds.UDTRAEKSGEBYR]: 'Udtræksgebyr',
        [VoucherTypeIds.CREDITNOTE]: 'Kreditnota',
        [VoucherTypeIds.YEARLYINTEREST]: 'Årlig rente',
        [VoucherTypeIds.MONTHLYINTEREST]: 'Månedlig rente',
        [VoucherTypeIds.STARTEDMONTHINTEREST]: 'Rente per påbegyndt måned',
        [VoucherTypeIds.PROCESSINTEREST]: 'Procesrente',
        [VoucherTypeIds.GLPROCESSINTEREST]: 'Procesrente (GL)',
        [VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Renters rente (daglig rentetilskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Renters rente (månedlig rentetilskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Renters rente (kvartalsvis rentetilskrivning)',
        [VoucherTypeIds.REMINDERFEE]: 'Rykkergebyr',
        [VoucherTypeIds.COLLECTIONCOST]: 'Inkassoomkostning',
        [VoucherTypeIds.COLLECTIONFEE]: 'Inkassogebyr',
        [VoucherTypeIds.COMPENSATIONCOST]: 'Kompensationsgebyr',
        [VoucherTypeIds.Folkeregisteropslag]: 'Folkeregisteropslag',
        [VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Immaterielretlige sager',
        [VoucherTypeIds.DEPOSIT]: 'Indbetaling',
        [VoucherTypeIds.WITHDRAWAL]: 'Udbetaling',
        [VoucherTypeIds.OVERPAYMENT]: 'Overindbetaling',
        [VoucherTypeIds.COLLECTIONCOMMISSION]: 'Inddrivelseshonorar',
        [VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Inddrivelseshonorar (overvågning)',
        [VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Inddrivelseshonorar (kreditorindbetaling)',
        [VoucherTypeIds.JURIDISKBISTAND]: 'Juridisk bistand',
        [VoucherTypeIds.ENDCASEFEE]: 'Sagsafslutningshonorar',
        [VoucherTypeIds.STARTCASEFEE]: 'Sagsopstartshonorar',
        [VoucherTypeIds.BPKFEE]: 'Betalingspåkravshonorar',
        [VoucherTypeIds.FOGEDFEE]: 'Fogedrekvisitionshonorar',
        [VoucherTypeIds.DEBTREGISTERREGISTRATIONFEE]: 'Gældsregister-registreringshonorar',
        [VoucherTypeIds.BPKDISBURSEMENT]: 'Betalingspåkravsudlæg',
        [VoucherTypeIds.POLICEDISBURSEMENT]: 'Politifremstillingsudlæg',
        [VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Retsgebyr med fogedretten',
        [VoucherTypeIds.CIVILCOURTCOST]: 'Omkostning til civilretten',
        [VoucherTypeIds.FOGEDDISBURSEMENT]: 'Fogedrekvisitionsudlæg',
        [VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Retsgebyr uden civilretten',
        [VoucherTypeIds.COURTCLAIMSALARY]: 'Retsgebyrsalær',
        [VoucherTypeIds.VAT]: 'Moms',
        [VoucherTypeIds.BAILIFFSFEE]: 'Betalingspåkravsgebyr',
        [VoucherTypeIds.BAILIFSSALARY]: 'Sagsomkostninger',
        [VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Fogedrekvisitionsgebyr',
        [VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Politifremstillingsgebyr',
        [VoucherTypeIds.WRITFEE]: 'Stævningsgebyr',
        [VoucherTypeIds.WRITSALARY]: 'Stævningssalær',
        [VoucherTypeIds.GAELDSBREV]: 'Gældsbrev',
        [VoucherTypeIds.SETTLEMENT]: 'Frivilligt forlig',
        [VoucherTypeIds.FIXEDINTEREST]: 'Fast rente',
        [VoucherTypeIds.DEPOSITPAYOUT]: 'Udbetaling af indbetaling',
        [VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkeregisteropslag',
        [VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmeldelse af krav',
        [VoucherTypeIds.MeetingFee]: 'Mødesalær',
        [VoucherTypeIds.STAEVNINGSGEBYR]: 'Stævningsgebyr',
        [VoucherTypeIds.BERAMMELSESAFGIFT]: 'Berammelsesafgift',
        [VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Aflysning af udlæg',
        [VoucherTypeIds.LOCKSMITHFEE]: 'Låsesmedsgebyr',
        [VoucherTypeIds.DRIVINGFEE]: 'Kørselsomkostning',
        [VoucherTypeIds.OTHERFEE]: 'Andre omkostninger',
        [VoucherTypeIds.REFUND]: 'Refusion',
        [VoucherTypeIds.JOINTDEPOSIT]: 'Solidarisk betaling',
        [VoucherTypeIds.SEPROCESSINTEREST]: 'Rente (Sverige)',
        [VoucherTypeIds.SEKRONOFOGDENAPPLICATIONFEE]: 'Retsafgift (Kronofogden)',
        [VoucherTypeIds.SEKRONOFOGDENREPRESENTATIONFEE]: 'Inkassosalær (betalingspåkrav)',
        [VoucherTypeIds.NOLATEINTEREST]: 'Forsinkelsesrente (Norge)',
        [VoucherTypeIds.NOFORLIKSRADFEE]: 'Retsafgift (forligsråd)',
        [VoucherTypeIds.NOLEGALCOLLECTIONFEE]: 'Tungt salær (retslig inkasso)',
    },
    transactionAccounts: {
        transactionAccount: 'bankkonto',
        name: 'Navn på kontoen',
        referenceId: 'Referencenr.',
        edit: 'Redigér konto',
        bankAccountsPlaceholder: 'Navnet på din nye konto',
        add: 'Tilføj bankkonto',
    },
    connectionReasons: {
        someoneAddedTheFollowingVouchers: 'tilføjede følgende postering(er)',
        addedTheFollowingVouchers: 'Følgende postering(er) blev tilføjet',
        someoneDeletedTheFollowingVouchers: 'slettede følgende postering(er)',
        deletedTheFollowingVouchers: 'Følgende postering(er) blev slettet',
        thatResultedIn: 'Det resulterede i følgende afregning',
    },
    economyDownloadPostings: {
        postingReference: 'Bilagsnummer',
        creditorReference: 'Kreditorreference',
        transactionId: 'Posterings-id.',
        type: 'Type',
        ofVoucher: 'Af postering',
        date: 'Dato',
        currency: 'Valuta',
        amount: 'Beløb',
        accountType: 'Konto type',
        account: 'Konto',
    },
    systemTankHandles: {
        DEPOSITS: 'Indbetalinger',
    },
    billingModels: {
        name: 'Navn',
        preventNegativeCreditorBalance: 'Undgå negativ kreditorbalance',
        moreSettings: 'Flere indstillinger',
        forceCollectionCommissionBilling: 'Opkræv indrivelseshonorar automatisk, når en sag får et valgt tag – uanset om der er faldet betaling.',
        forceCollectionCommissionBillingVoucherTypeId: 'Vælg afregningsposteringstype',
        selectSeparateFeeVoucherType: 'Opkræv inddrivelseshonorar separat',
        selectVouchersGroup: 'Vælg posteringer',
        systemConnector: 'Systemafregningsmodel',
        tenantConnector: 'Oprettet afregningsmodel',
        voucherCategory: 'Posteringskategori',
        voucherType: 'Posteringstype',
        allVouchers: 'Alle posteringer',
        categoriesOrTypesFilter: 'Vælg posteringer som skal honoreres',
        caseTagFilter: 'Filtér honorering',
        caseTagSurveillanceFilter: 'Overvågning',
        caseTagCompanyFilter: 'Erhvervssager',
        caseTagPrivateFilter: 'Personsager',
        voucherTagFilter: 'Honorér efter hvem som har pålagt posteringen',
        imposedByCollector: 'Pålagt af inddriver',
        imposedByCreditor: 'Pålagt af kreditor',
        feeFraction: 'Honorér en andel af posteringen',
        feeFractionPlaceholder: 'Procentvis andel som skal honoreres',
        addShare: 'Tilføj honorarandel',
        byVoucherCategory: 'Efter posteringskategori',
        byVoucherType: 'Efter posteringstype',
        createBillingModel: 'Opret afregningsmodel',
        simulateBilling: 'Simulér afregning',
        simulateCompany: 'Simulér en virksomhed',
        simulateSurveillance: 'Simulér overvågning',
        simulateAmount: 'Beløb på indbetaling',
        previewBillingModel: 'Forhåndsvis afregningsmodel',
        selectBillingModel: 'Vælg afregningsmodel',
        searchBillingModels: 'Søg afregningsmodeller',
    },
    billingAppendixSetups: {
        tenantBillingAppendixSetup: 'Egne bilagsopsætninger',
        systemBillingAppendixSetup: 'Standard bilagsopsætninger',
        name: 'Navn',
        billingAppendixSetups: 'Opsætninger af afregningsbilag',
        noBillingAppendixSetupsToShow: 'Ingen bilagsopsætninger at vise',
        newBillingAppendixSetup: 'Ny bilagsopsætning',
        addBillingAppendixSetup: 'Opret bilagsopsætning',
        billing: 'Afregning',
        createNew: 'Opret bilagsopsætning',
        addNewSetup: 'Tilføj bilagsopsætning',
        appendixHandle: 'Navn på bilag',
        hideFromCreditor: 'Skjul afregninger af denne bilagstype på kreditorweb',
        includeVatInDepositShare: 'Inkluder moms i honoraret i indbetalingstabeller',
        selectBillingAppendixSetup: 'Vælg bilagsopsætning',
        searchBillingAppendixSetups: 'Søg bilagsopsætninger',
        previewBillingAppendixSetup: 'Forhåndsvis bilagsopsætning',
        autoBilling: 'Automatisk afregning',
        autoBillingDescription: 'Generér automatisk afregningen efter en fast tidsplan. Når slået fra, oprettes afregningen manuelt.',
        autoBillingOff: 'Slået fra',
        selectAllVoucherTypes: 'Vælg alle posteringstyper',
    },
    billingAppendixSetupTimings: {
        [Timing.Manual]: 'Manuel afregning',
        [Timing.ASAP]: 'Hurtigst muligt',
        [Timing.OnCaseEnd]: 'Efter sagsafslutning',
        [Timing.Weekly]: 'Ugentligt',
        [Timing.Monthly]: 'Månedligt',
        [Timing.Quarterly]: 'Kvartalvist',
    },
    autoBillingTimings: {
        [AutoBillingTiming.Weekdays0700]: 'Hverdage kl. 07:00',
    },
    caseVoucherStates: {
        [State.Unmapped]: 'Oprettet',
        [State.Unknown]: 'Uidentificeret',
        [State.Archived]: 'Arkiveret',
        [State.Overpayment]: 'Overindbetaling',
        [State.FullPayment]: 'Fuld betaling',
        [State.PartialPayment]: 'Delbetaling',
        [State.PaymentPlanEntryPayment]: 'Betaling af afdrag',
        [State.UnkownPaymentPlanPayment]: 'Ukendt afdragsbetaling',
        [State.AccordPayment]: 'Akkordbetaling',
        [State.PrincipalPayment]: 'Hovedstolsbetaling',
        [State.Pending]: 'Afventer',
    },
    caseVoucherSources: {
        [CaseVoucherSource.Collector]: 'Inddriver',
        [CaseVoucherSource.Creditor]: 'Kreditor',
    },
    depositShareType: {
        [DepositShareType.AdjustmentCredit]: 'Justering - kredit',
        [DepositShareType.AdjustmentDebit]: 'Justering - debet',
        [DepositShareType.Deposit]: 'Indbetaling',
        [DepositShareType.Fee]: 'Inddrivelseshonorar',
    },
    voucherTypeSettings: {
        voucherType: 'Posteringstype',
        category: 'Kategori',
        vat: 'Moms',
        setting: 'Indstilling',
        createNewVoucherType: 'Opret ny posteringstype',
        create: 'Opret',
        interruptsLimitationPeriod: 'Afbryder forældelsen',
        interruptsLimitationPeriodDesc: 'Indbetalinger af denne type starter gældens forældelsesfrist forfra.',
        customCaseVoucherType: 'Oprettede sagsposteringstyper',
        standardCaseVoucherType: 'Standard sagsposteringstyper',
        customBillingVoucherType: 'Oprettede afregningsposteringstyper',
        standardBillingVoucherType: 'Standard afregningsposteringstyper',
        caseVoucherType: 'Sagsposteringstype',
        caseVoucherTypeDesc: 'Navnet på posteringstypen, kategorien og eventuel indstilling.',
        label: 'Navn',
        noSetting: 'Ingen',
        interstDays: 'Rentedage',
        interstDaysDesc: 'Antal rentedage per periode.',
        interestRounding: 'Afrunding',
        interestRoundingDesc: 'Hvordan skal rentetilskrivningen afrundes?',
        interestRoundingContent: 'Afrundes til nærmeste øre dagligt',
        interestCompoundingPeriod: 'Rentetilskrivning',
        interestCompoundingPeriodDesc: 'Hvor ofte renten skal tilskrives hovedstolen. Dette kaldes også kapitaliseringsperioden.',
        interestCompoundVouchers: 'Tilskrivningsposteringer',
        interestCompoundVouchersDesc: 'Posteringstyper som skal betegnes som tilskrevede renter hvis de ligger som referencer til samme hovedstolspostering',
        interestFrequency: 'Rente beregningsfrekvens',
        interestFrequencyDesc: 'Hvor ofte renten beregnes.',
        interestTable: 'Rentesatstabel',
        interestTableDesc: 'Rentesatsens udvikling over tid.',
        interestTableFromDate: 'Fra dato',
        interestTableRate: 'Rentesats',
        interestTableAddRate: 'Tilføj rentesats',
        interestTableEditRate: 'Rediger rentesats',
        interestTableSaveRate: 'Gem',
        interestTableCancelEdit: 'Annullér',
        interestTableDeleteRate: 'Slet rentesats',
        interestTableNoRates: 'Ingen rentesatser endnu. Tilføj en for at komme i gang.',
        interestTableWarning: 'Ændringer kan påvirke eksisterende sager',
        interestTableWarningDesc: 'Ændringer i historiske rentesatser eller tilføjelse af rentesatser før dags dato kan ændre renterne på eksisterende sager, afdragsordningers afdragsforløb og allerede afregnede sager. Vær opmærksom.',
        editor: 'Posteringseditor',
        editorDesc: 'Konfigurer hvilke felter der er tilgængelige ved oprettelse af posteringer af denne type, og hvordan de opfører sig.',
        editorGroupInputs: 'Tilgængelige felter',
        editorGroupInputsDesc: 'Vælg hvilke felter brugeren kan udfylde ved oprettelse af en postering.',
        editorGroupBehavior: 'Adfærd',
        editorGroupBehaviorDesc: 'Hvordan posteringer af denne type opfører sig efter oprettelse.',
        editorGroupVisibility: 'Synlighed',
        editorGroupVisibilityDesc: 'Bestem hvor denne posteringstype og dens posteringer vises.',
        editorRequired: 'Påkrævet',
        editorDueDate: 'Forfaldsdato',
        editorDueDateDesc: 'Vis et felt for forfaldsdato.',
        editorDefaultAmount: 'Standardbeløb',
        editorDefaultAmountDesc: 'Forudfyld beløbsfeltet med denne værdi. Lad stå tomt for at deaktivere.',
        editorText: 'Fritekst',
        editorTextDesc: 'Vis et tekstfelt til yderligere bemærkninger.',
        editorReferenceId: 'Reference-id.',
        editorReferenceIdDesc: 'Vis et felt til et eksternt reference-id.. For eksempel et fakturanummer.',
        editorReferenceVoucher: 'Reference-postering',
        editorReferenceVoucherDesc: 'Tillad at posteringen kobles til en anden postering på samme sag.',
        editorAppendix: 'Bilag',
        editorAppendixDesc: 'Tillad vedhæftning af et bilag.',
        editorSource: 'Pålagt af-vælger',
        editorSourceDesc: 'Lad sagsbehandleren vælge om posteringen er pålagt af kreditor eller af inddriver.',
        editorSourceDefaultCreditor: 'Pålagt af kreditor som standard',
        editorAmountNegative: 'Tillad negative beløb',
        editorAmountNegativeDesc: 'Bruges til kreditnotaer og indbetalinger, hvor beløbet reducerer sagens saldo.',
        editorAddInterest: 'Tilføj procesrente automatisk',
        editorAddInterestDesc: 'Opretter en procesrente-postering, der refererer til denne postering.',
        editorShowOnCreditorWeb: 'Vis på kreditorportal',
        editorShowOnCreditorWebDesc: 'Synlig for kreditorer i selvbetjeningsportalen.',
        editorHideProperties: 'Skjul attributter',
        editorHidePropertiesDesc: 'Skjul panelet med posteringsattributter i editoren.',
        editorHideFromAllUsers: 'Skjul for alle brugere',
        editorHideFromAllUsersDesc: 'Posteringstypen kan ikke vælges ved oprettelse af en ny postering.',
        billingVoucherType: 'Afregningsposteringstype',
        billingVoucherTypeDesc: 'Navnet på posteringstypen og kategorien.',
        editorPayoutToContact: 'Udbetal til kontakt',
        editorPayoutToContactDesc: 'Sagsbehandleren vælger en kontakt med kontooplysninger, og der oprettes en udbetaling til kontakten, når posteringen oprettes. Bruges til leverandører hyret på vegne af kreditor, f.eks. en låsesmed.',
        editorCreditorDisbursement: 'Opkræv udlægget hos kreditor',
        editorCreditorDisbursementDesc: 'Sagsbehandleren kan tilføje beløbet til kreditorafregningen med den valgte afregningsposteringstype. Er det påkrævet, sker det hver gang.',
    },
    voucherTypeSetting: {
        [VoucherTypeSetting.AmountFromTable]: 'Beløb fra tabel',
        [VoucherTypeSetting.InterestFromTable]: 'Rente fra tabel',
        [VoucherTypeSetting.CompoundInterest]: 'Renters rente',
        [VoucherTypeSetting.FixedInterest]: 'Fast rente',
        [VoucherTypeSetting.InterestPercentage]: 'Rentesats',
        [VoucherTypeSetting.TextAsLabel]: 'Tekst som label',
        [VoucherTypeSetting.Payment]: 'Betaling',
    },
    compoundingPeriod: {
        [CompoundingPeriod.Daily]: 'Dailigt',
        [CompoundingPeriod.Monthly]: 'Månedligt',
        [CompoundingPeriod.Quarterly]: 'Kvartalvist',
    },
    imposeInterestFrequency: {
        [ImposeInterestFrequency.Daily]: 'Dagligt',
        [ImposeInterestFrequency.Monthly]: 'Per påbegyndt måned',
    },
    economy: {
        groupPostings: 'Grupper posteringer i udtækket',
        generalBillingSettings: 'Indstillinger for afregning',
        sendingBillingByEmail: 'Afsendelse af afregninger per email',
        doNotAttachBillingAppendicesInEmails: 'Undlad at vedhæfte afregningsbilag',
        billingModels: 'Afregningsmodeller',
        tenantBillingModels: 'Egne afregningsmodeller',
        defaultBillingModels: 'Standard afregningsmodeller',
        noBillingModelsToShow: 'Ingen afregningsmodeller at vise',
        newBillingModel: 'Afregningsmodel',
        addBillingModel: 'Opret afregningsmodel',
        billingAppendixSetup: 'Bilagsopsætning',
        standardPrice: 'listepris:',
        regNumber: 'Reg. nr.',
        accountNumber: 'Kontonummer',
        pipeFilterSelectVoucherTypes: 'Vælg posteringstyper',
        depositFile: 'Indbetalingsfil',
        caseEconomy: 'Sagens økonomi',
        costCeilingReached: 'Omkostningsloft nået',
        costCeilingReachedDescription: 'Renter og gebyrer på denne sag er begrænset til hovedstolen.',
        costCeilingExceeded: 'Omkostningsloft overskredet',
        costCeilingExceededDescription: 'Gebyrer og omkostninger på denne sag overstiger allerede i sig selv omkostningsloftet.',
        voucherAlreadyExists: 'findes allerede på sag',
        histItemHeader: 'Økonomi',
        sum: 'Sum',
        voucherType: 'Posteringstype',
        account: 'Konto',
        referenceId: 'Referencenummer',
        text: 'Beskrivelse',
        amount: 'Beløb',
        originalAmount: 'Oprindeligt beløb',
        amountAfterWriteOffs: 'Beløb efter afskrivninger',
        date: 'Dato',
        dueDate: 'Forfaldsdato',
        expirationDate: 'Forældelsesdato',
        expirationFromDate: 'Speciel startdato for forældelse',
        expirationManualSet: 'Forældelsesdato manuelt sat',
        expirationLength: 'Forældelsesvarighed (år)',
        expirationLengthStandard: 'Standard',
        expirationResetToCalculated: 'Beregn automatisk igen',
        expiredAmount: 'Forældet beløb',
        irrecoverableAmount: 'Uerholdeligt beløb',
        cannotMoveWrittenOffVoucher: 'Posteringen er helt eller delvist forældet eller uerholdelig og kan ikke flyttes til denne sag',
        addAppendix: 'Tilføj bilag',
        referenceVoucher: 'Referencepostering som posteringen skal tilknyttes',
        selectReferenceVoucher: 'Vælg referencepostering',
        interestRate: 'Renteprocent',
        interestAmount: 'Rentebeløb',
        interest: 'Rente',
        interestStartDate: 'Rentestartdato',
        interestStartDays: 'Dage til rentestart',
        interestEndDate: 'Renteslutdato',
        imposedByCreditor: 'Indleveret af kreditor',
        debtIrrecoverable: 'Uerholdelig',
        debtExpied: 'Forældet',
        markExpired: 'Foræld og luk sag',
        markSomeExpired: 'Foræld',
        markSomeExpiredPostings: 'posteringer',
        sureYouWantToMarkExpired: 'Er du sikker på at du vil markere posteringer forældet?',
        voucherCreationCreate: 'Opret',
        voucherCreationIncludeInterest: 'Tilføj procesrente',
        voucherCreationCreditorDeposit: 'Indbetaling til kreditor',
        addDisbursementToBilling: 'Opkræv udlægget hos kreditor',
        disbursementAddedToBilling: 'Udlægget opkræves hos kreditor',
        caseVoucherInfoType: 'Type',
        caseVoucherInfoTypeSeeDetails: 'Se detaljer om sagsposteringstypen',
        caseVoucherInfoCreatedAt: 'Oprettet',
        voucherInfoId: 'Posterings-id',
        voucherInfoCreatedBy: 'Oprettet af',
        caseVoucherInfoCategory: 'Kategori',
        caseVoucherInfoState: 'Status',
        caseVoucherInfoHeaderTheVoucher: 'Posteringen',
        caseVoucherInfoHeaderMeta: 'Information',
        caseVoucherInfoHeaderInterest: 'Rentedetaljer',
        voucherInfoText: 'Tekst',
        voucherInfoAmount: 'Beløb',
        voucherInfoCasePreview: 'Sag',
        voucherInfoMoveToCase: 'Postering flyttet til sag',
        voucherInfoCreditorName: 'Kreditor',
        voucherInfoAppendix: 'Bilag',
        voucherInfoRefVoucher: 'Referencepostering',
        voucherInfoInterestHis: 'Renteberegning',
        voucherInfoIfrom: 'Fra',
        voucherInfoITo: 'Til',
        voucherInfoIInterval: 'Interval',
        voucherInfoIRVA: 'Ref. posteringsbeløb',
        voucherInfoICompoundedAmount: 'Tilskrevet rente',
        voucherInfoIDays: 'dage',
        voucherInfoIReapplied: 'Genpålagt',
        voucherInfoIReason: 'Årsag',
        voucherInfoIPaid: 'Betalt',
        voucherInfoIAcknowledged: 'Anerkendt',
        voucherInfoInterestPeriods: 'Renteperioder',
        voucherInfoInterestPeriodFrozen: 'Rentefri',
        voucherInfoInterestPeriodVoided: 'Genpålagt den',
        voucherInfoInterestPeriodOpenEnded: 'Løbende',
        voucherInfoDistributedOnto: 'Fordelt på',
        voucherInfoDistributionsReceived: 'Dækket af',
        voucherInfoDistributionVoucher: 'Postering',
        voucherInfoDistributionAmount: 'Beløb',
        voucherInfoDistributionType: 'Type',
        voucherInfoDistributionFixed: 'Fastlåst',
        voucherInfoDistributionAutomatic: 'Automatisk',
        voucherInfoDistributionBilling: 'Fast (afregning)',
        voucherInfoDistributionRemaining: 'Udestående',
        voucherInfoDeleteFixedDistribution: 'Fjern fast fordeling',
        voucherInfoEditFixedDistribution: 'Rediger fast fordeling',
        voucherInfoConfirmDeleteFixedDistribution: 'Er du sikker på, at du vil fjerne denne faste fordeling?',
        voucherInfoFixedDistributionSave: 'Gem',
        voucherInfoFixedDistributionJointInfo: 'Denne ændring påvirker også tilknyttede betalinger på andre sager',
        voucherInfoAllocatePayment: 'Fordel betaling',
        voucherInfoAllocatePaymentTarget: 'Fordel på postering',
        voucherInfoDistributionDynamic: 'Beregnet',
        voucherInfoDistributionUnallocated: 'Ikke-fordelt',
        voucherInfoEditDistributions: 'Rediger fordelinger',
        voucherInfoDistributionDateFromOriginal: 'Dato fra original',
        voucherInfoDistributionDateFromApplied: 'Dato fra anvendt',
        voucherInfoCreateCounterEntry: 'Opret modpostering',
        voucherInfoConfirmCounterEntry: 'Er du sikker på, at du vil oprette en modpostering for denne postering?',
        voucherInfoCounterEntryAmount: 'Modposteringsbeløb',
        voucherInfoDeleteVoucher: 'Slet postering',
        voucherDeleteHasFixedDistributions: 'Denne postering har faste fordelinger. Vil du fjerne dem og slette posteringen?',
        voucherDeleteHasFixedDistributionsWithJoint: 'Denne postering har faste fordelinger. Sletning vil også fjerne tilknyttede betalinger på andre sager. Vil du fortsætte?',
        voucherInfoMarkVoucherExpired: 'Forældet',
        voucherInfoUnmarkVoucherExpired: 'Fjern forældelsesmarkering',
        voucherInfoMarkVoucherIrrecoverable: 'Uerholdelig',
        voucherInfoRestoreVoucher: 'Gendan postering',
        currency: 'Valuta',
        billingModel: 'Afregningsmodel',
        aggregation: 'Sammentælling',
        postings: 'Posteringer',
        bookkeepingMapping: 'Map bogføringskonti',
        bookkeepingMappingBase: 'Generelt',
        bookkeepingMappingFees: 'Honorarer',
        bookkeepingMappingDisbursements: 'Udlæg',
        bookkeepingMappingAccount: 'Konto',
        bookkeepingMappingAccountType: 'Kontotype',
        bookkeepingMappingReverse: 'Omvendt fortegn',
        bookkeepingMappingExclude: 'Ekskluder',
        bookkeepingMappingIncludeVat: 'Inkluder moms',
        bookkeepingMappingContraAccountOn: 'Modkonto',
        bookkeepingMappingContraAccount: 'Modposteringens konto',
        bookkeepingMappingContraAccountType: 'Modposteringens kontotype',
        bookkeepingMappingCreditorReferenceId: 'Kreditor reference-id',
        bookkeepingMappingBankOrPSP: 'Bank eller indløser',
    },
    economyAppendixHeaders: {
        type: 'Type',
        date: 'Dato',
        voucherId: 'Posterings-Id',
        voucherType: 'Posteringstype',
        text: 'Tekst',
        amount: 'Beløb',
        currency: 'Valuta',
    },
    caseVoucherTags: {
        [CaseVoucherTags.IMPOSEDBYCOLLECTOR]: 'Pålagt af inddriver',
        [CaseVoucherTags.IMPOSEDBYCREDITOR]: 'Pålagt af kreditor',
        [CaseVoucherTags.CREDITORTRANSACTION]: 'Kreditortransaktion',
        [CaseVoucherTags.ECONOMIC_IMPORT]: 'E-conomic import',
        [CaseVoucherTags.EXPIRED]: 'Forældet',
        [CaseVoucherTags.IRRECOVERABLE]: 'Uerholdelig',
    },
    caseTags: {
        [CaseTag.SURVEILLANCE]: 'Overvågning',
    },
    transactionImports: {
        transactionImportsHeader: 'Transaction imports',
        selectType: 'Vælg type af betaling',
    },
    caseVouchers: {
        source: 'Kilde',
        irrecoverableDate: 'Uerholdelig dato',
        expirationDate: 'Forældesesdato',
        expired: 'Forældet',
        case: 'Sag',
        map: 'Registrér',
        mapHeader: 'Registrér betaling på sag',
        deleteWarning: 'Er du sikker på at du vil slette denne indbetaling? Denne handling kan ikke fortrydes',
        exportFileName: 'case-vouchers',
        voucherId: 'Postering-id',
        voucherReferenceId: 'Posteringsreference',
        caseId: 'Sagsnummer',
        creditor: 'Kreditor',
        creditorReference: 'Kreditorreference',
        customerReference: 'Kundereference',
        account: 'Konto',
        accountId: 'Konto-id',
        bookingDate: 'Bogføringsdato',
        bookingDateDescription: 'Den dato indbetalingen bogføres i regnskabet. Betalingsdatoen afgør, hvordan renten beregnes; bogføringsdatoen afgør, hvilken regnskabsperiode indbetalingen hører til.',
        bookingDateFollowsDate: 'Følger betalingsdatoen',
        setBookingDate: 'Sæt bogføringsdato',
        setBookingDateDescription: 'Sæt den dato, de valgte indbetalinger bogføres i regnskabet. Brug den, når en afregning fra en indløser rammer banken senere end selve betalingerne.',
        clearBookingDate: 'Ryd, følg betalingsdatoen',
    },
    payouts: {
        caseReferenceId: 'Sagsreference',
        caseSeqId: 'Sagsid',
        billingId: 'Afregnings-id',
        court: 'Retskreds',
        creditorReference: 'Kreditorreference',
        type: 'Type',
        account: 'Konto',
        text: 'Tekst',
        state: 'Status',
        amount: 'Beløb',
        currency: 'Valuta',
        createdAt: 'Oprettet',
        updatedAt: 'Opdateret',
        complete: 'Udført',
        completeOnExport: 'Marker udført ved eksport',
        exportFileName: 'udbetalinger',
    },
    payoutState: {
        [PayoutState.Completed]: 'Udført',
        [PayoutState.Created]: 'Oprettet',
        [PayoutState.DataUpdated]: 'Data opdateret',
        [PayoutState.Failed]: 'Fejlet',
        [PayoutState.Initiated]: 'Igangsat',
    },
    payoutType: {
        [PayoutType.CourtFee]: 'Retsafgifter',
        [PayoutType.CreditorReceivables]: 'Kreditortilgodehavender',
        [PayoutType.Other]: 'Anden',
        [PayoutType.Overpayment]: 'Overindbetaling',
    },
    clientBilling: {
        clientBilling: 'Kreditorafregning',
        isAdjustment: 'Justering af afregning',
        billings: 'Afregninger',
        seeDetails: 'Se detaljer om kreditorafregning',
        seeDetailsCreditor: 'Se udførte afregninger',
        fetchingUpdatedEconomy: 'Henter nyeste information',
        caseSeqId: 'Sagsnummer',
        caseReferenceId: 'Sagsreference-id',
        deposits: 'Indbetalinger',
        fees: 'Honorarer',
        disbursements: 'Udlæg',
        showPerDeposit: 'Vis per indbetaling',
        voucherType: 'Posteringstype',
        original: 'Oprindelig',
        paid: 'Indbetalt',
        residue: 'Resterende',
        collector: 'Inddriver',
        creditor: 'Kreditor',
        overpayment: 'Overindbetaling',
        text: 'Tekst',
        addVoucher: 'Tilføj postering',
        otherPayments: 'af andre indbetalinger.',
        noVouchers: 'Ingen posteringer',
        hoursOf: 'timer á',
        hourOf: 'time á',
        hourlyRateOn: 'Timepris',
        hourlyRate: 'Timepris',
        hourlyRateHours: 'Timer',
        hourlyRateMinutes: 'Minutter',
    },
    search: {
        migratedId: 'Migreret j.nr.',
        noResults: 'Ingen resultater',
        voucherReferenceId: 'Posterings-id',
        cvr: 'CVR',
        cpr: 'CPR',
        phone: 'Telefonnr.',
    },
    deposits: {
        customizeExport: 'Tilpas eksport',
        selectedExportHint: 'Kun de markerede posteringer',
        filteredExportHint: 'Alle resultater fra tabellens filtre · maks. 10.000',
        exportEditorDescription: 'Vælg felter til venstre, og tilpas filens kolonner til højre.',
        exportFormat: 'Filformat',
        standardExportColumns: 'Standardfelter',
        availableExportColumns: 'Tilgængelige felter',
        searchExportColumns: 'Søg efter felt eller attribut…',
        exportColumnHint: 'Træk for at ændre rækkefølge. Klik på et navn for at omdøbe.',
        exportColumnName: 'Kolonnenavn',
        chooseExportColumns: 'Vælg felter til venstre for at opbygge din eksport.',
        resetExportColumns: 'Gendan standard',
        saveExportSettings: 'Gem opsætning',
        exportStoredLocally: 'Personlig opsætning · gemmes på denne enhed',
        exportSettings: 'Eksportér betalinger',
        exportFiltered: 'Filtrerede posteringer',
        exportSelected: 'Valgte posteringer',
        exportLimit: 'Eksportér op til 10.000 betalinger med tabellens filtre. Indsnævr filtrene, hvis der er flere resultater.',
        markAsExported: 'Markér posteringer som eksporteret',
        exportColumns: 'Eksportkolonner',
        addExportColumn: 'Tilføj kolonne',
        moveColumnUp: 'Flyt kolonne op',
        moveColumnDown: 'Flyt kolonne ned',
        removeExportColumn: 'Fjern kolonne',
        pickPaymentType: 'Vælg betalingstype',
        unknownDeposit: 'Uidentificérbar',
        unknownDepositSubHeader: 'Kunne ikke identificere betalingen',
        archive: 'Arkivér',
        exportDesc: 'Eksport af indbetalinger til bank eller via PSP (kortbetalinger osv.).',
        unknownDesc: 'Her kan du se en liste over uidentificérbare indbetalinger.',
        transactionLookUpDesc: 'Her kan du slå indbetalinger op baseret på posterings-id.',
        transactionLookUpPlaceholder: 'Indtast et posterings-id. (f.eks. 12341234)',
        transactionLookUpNotFound: 'Posteringen kunne ikke findes.',
        transactionLookUpNotDeposit: 'Denne postering er ikke en indbetaling.',
        transactionLookUpButton: 'Søg',
        transactionLookUpDeposit: 'Indbetaling',
        downloadSample: 'Hent eksempel',
        downloadSampleQuantity: 'Antal indbetalinger i eksemplet',
        linkBank: 'Tilknyt bankkonto',
        selectBankAccount: 'Vælg bankkonto',
        dropHere: 'Træk og slip indbetalingsfil her',
        upload: 'Registrer indbetalinger',
        deposits: 'Betalinger',
        map: 'Registrer betalinger',
        handleTransaction: 'Håndtér betaling',
        addSingleDepositHeader: 'Indtast indbetaling manuelt',
        addSingleDepositPaymentType: 'Betalingstype',
        addSingleDepositDate: 'Dato',
        addSingleDepositText: 'Tekst',
        addSingleDepositAmount: 'Beløb',
        addSingleDepositAddAndClose: 'Tilføj og luk',
        addSingleDepositAddAndClear: 'Tilføj og ryd',
    },
    depositsPaymentTypes: {
        [PaymentType.Mastercard]: 'MasterCard',
        [PaymentType.Swish]: 'Swish',
        [PaymentType.Vipps]: 'Vipps',
        [PaymentType.Visa]: 'Visa',
        [PaymentType.Dankort]: 'Dankort',
        [PaymentType.MobilePay]: 'MobilePay',
        [PaymentType.Betalingsservice]: 'Betalingsservice',
        [PaymentType.Leverandørservice]: 'Leverandørservice',
        [PaymentType.BankTransfer]: 'Bankoverførsel',
        [PaymentType.FIK]: 'FIK',
        [PaymentType.IBAN]: 'IBAN',
        [PaymentType.Creditor]: 'Kreditor',
        [PaymentType.PayPal]: 'PayPal',
        [PaymentType.ApplePay]: 'Apple Pay',
        [PaymentType.GooglePay]: 'Google Pay',
    },
    caseVoucherEvents: {
        header: 'Ændringer på indbetalinger',
        desc: 'Alt hvad der er sket med de indbetalinger, vi har modtaget på vores konti. Eksportér ændringerne for at bogføre dem — de markeres som eksporteret, så den samme ændring aldrig bogføres to gange.',
        eventId: 'Ændrings-id',
        eventType: 'Ændring',
        eventDate: 'Tidspunkt for ændring',
        performedByType: 'Udført af type',
        performedById: 'Udført af id',
        fromCase: 'Fra sag',
        toCase: 'Til sag',
        fromCreditor: 'Fra kreditor',
        fromCreditorReference: 'Fra kreditorreference',
        exported: 'Eksporteret',
    },
    caseVoucherEventTypes: {
        [CaseVoucherEventType.Created]: 'Oprettet',
        [CaseVoucherEventType.Booked]: 'Bogført på sag',
        [CaseVoucherEventType.Moved]: 'Flyttet til anden sag',
        [CaseVoucherEventType.Unbooked]: 'Afbogført fra sag',
        [CaseVoucherEventType.Deleted]: 'Slettet',
        [CaseVoucherEventType.Restored]: 'Gendannet',
    },
    billingReasons: {
        caseVoucherInlineDeleted: 'Postering (senere slettet)',
        caseVoucherPatchedCaseId: 'blev tilknyttet sagen',
        caseVoucherPatched: 'blev redigeret',
        caseVoucherCreated: 'tilføjet til sagen',
        caseVoucherDeleted: 'slettet fra sagen',
        billingModelChanged: 'Afregningsmodel ændret',
        billingStartDateChanged: 'Startdato for afregning ændret',
    },
    billing: {
        ongoingWork: 'Igangværende arbejde',
        bills: 'Afregninger',
        billingSequentialId: 'Id',
        case: 'Sag',
        date: 'Dato',
        type: 'Type',
        text: 'Tekst',
        customerReferenceId: 'Kunderef.',
        revenue: 'Honorarer',
        vat: 'Moms',
        payout: 'Udbetaling',
        disbursements: 'Udlæg',
        overpayments: 'Overindbetalinger',
        balance: 'Kreditorbevægelse',
        amount: 'Beløb',
        deposits: 'Indbetalinger',
        deposit: 'Indbetaling',
        depositShareTooLongForPDF: "Udspecificering af indbetalinger medtages ikke i PDF'en, da denne afregning har mere end 100 indbetalinger. Summen af indbetalingerne indgår fortsat.",
        bill: 'Afregn',
        delete: 'Fjern',
        deleteApproval: 'Er du sikker på, at du vil slette posteringerne fra afregningen? Handlingen kan ikke fortrydes.',
        adjustments: 'Justeringer',
        billingPrevented: 'Afventende afregninger',
        billingStartDate: 'Start afregning af indbetalinger fra',
        appendix: 'Bilag',
        readyForBilling: 'Klar til afregning',
        awaitingCaseEnd: 'Afventer sagsafslutning',
        appendixMissing: 'Mangler bilag',
        billSelected: 'Afregn valgte',
        addBillingVoucher: 'Tilføj postering',
        recipient: 'Modtager',
        billingSent: 'Afsendt',
        sendBilling: 'Afsend',
        information: 'Information',
        addedToPayouts: 'Tilføjet til udbetalinger',
        addToPayouts: 'Tilføj til udbetalinger',
        invoiceNo: 'Fakturanr.',
        specifiedByBankTransfer: 'bedes angivet ved bankoverførsel',
        paymentTerms: 'Betalingsbetingelser: Netto',
        daysAndBillingDate: 'dage - Forfaldsdato',
        billingAlreadySentAlert: 'Afregningen er allerede afsendt. Er du sikker på, at du vil sende afregningen igen?',
        amountWillBeWithdrawnToAccount: 'udbetales til bankkonto',
        amountShouldBePaidToAccount: 'indbetales på bankkonto',
        preview: 'Forhåndsvisning',
        PDFPreview: 'PDF',
        ExcelPreview: 'Excel',
        forPayout: 'Til udbetaling',
        collectionCommission: 'Inddrivelseshonorar',
        fees: 'Honorarer',
        otherVat: 'Anden moms',
        subtotal: 'Subtotal',
        total: 'Total',
        billingCollectionBillingSequentialId: 'Id',
        billingCollectionBillingDate: 'Dato',
        billingCollectionBillingAddedToPayouts: 'Tilføjet til udbetalinger',
        billingCollectionBillingSent: 'Afsendt',
        billingCollectionBillingBalance: 'Kreditorbevægelse',
        billingsAppendix: 'Bilag',
        billingsType: 'Type',
        billingsCreditor: 'Kreditor',
        billingsCases: 'Sager',
        billingsCurrency: 'Valuta',
        generateAppendix: 'Generér bilag',
        awaitingGeneration: 'Posteringer klar til bogføring',
        warnThisWillAffectBilling: 'Denne handling vil påvirke allerede afregnede indbetalinger. Er du sikker på, at du vil fortsætte?',
        deletionWarning: 'Er du sikker på, at du vil slette denne afregning? Denne handling kan ikke fortrydes. Vær opmærksom på, at sletningen ikke håndterer justeringer – disse skal du selv tage dig af manuelt. Desuden tages der ikke højde for, om afregningen allerede er udsendt eller bogført.',
    },
    creditorBilling: {
        newBillingFrom: 'Ny afregning fra',
        dear: 'Kære',
        herebyForwarded: 'Hermed fremsendes:',
        seeAttached: 'Se venligst vedhæftede.',
    },
    bookkeeping: {
        settleAll: 'Afregn alle kreditorer',
        preview: 'Forhåndsvisning',
        type: 'Type',
        date: 'Dato',
        text: 'Tekst',
        amount: 'Beløb',
        account: 'Konto',
        contraAccount: 'Modkonto',
        debtorVoucher: 'Debitorpostering',
        showMoreVouchers: 'Vis flere posteringer',
        showing: 'Viser',
        of: 'ud af',
        vouchers: 'posteringer',
        exportNdownload: 'Eksportér og download',
        history: 'Historie',
        noHistorical: 'Ingen historisk data',
        erpIntegrationHeader: 'Integration til bogføringssystem',
        accounts: 'Konti',
        revenuePlaceholder: 'Omsætning',
        outlayPlaceholder: 'Udlæg',
        erpVendor: 'ERP-leverandør:',
        makeSureThat: 'Sørg for at:',
        creditorReferenceIdsMatch: "Kreditorernes reference-id'er matcher kundernes i e-conomic",
        bankAccountReferenceIdsMatch: "Bank- og PSP-kontiernes reference-id'er matcher kontiene i e-conomic",
        activeAccountingYear: 'Der er et aktivt regnskabsår',
        connectEconomic: 'Forbind e-conomic',
    },
    blameLogs: {
        overview: 'Overblik',
        userVisits: 'Brugerbesøg',
        debtorUpdates: 'Debitorændringer',
        economy: 'Økonomi',
        interactions: 'Interaktioner',
        noEntries: 'Ingen handlinger',
        blameLog: 'Handlingslog',
        logged: 'Handling',
        ago: 'siden',
        type: 'Type',
        content: 'Indhold',
        subject: 'Emne',
        stepTitle: 'Step titel',
        chainTitle: 'Workflow titel',
        viewLetter: 'Se brev',
        phoneNumber: 'Telefon nummer',
        label: 'Label',
        workflow: 'Workflow',
        fromWorkflow: 'Skiftet fra workflow',
        toWorkflow: 'Til workflow',
        noLogs: 'Endnu ingen logs',
        settings: 'Indstillinger',
        toggled: 'Skiftet til',
        trueActivated: 'aktiveret',
        falseActivated: 'deaktiveret',
        key: 'Nøgle',
        code: 'Kode',
        username: 'Brugernavn',
        password: 'Adgangskode',
        trueChanged: 'Ændret',
        falseChanged: 'Uændret',
        experianClientId: 'Experian klientnummer',
        to: 'til',
        when: 'Hvornår',
        procedure: 'Genvej',
        removed: 'Fjernet',
        other: 'Andre handlinger',
        description: 'Beskrivelse',
        note: 'Note',
        createdAt: 'Oprettet',
        trueYes: 'Ja',
        falseNo: 'Nej',
        dunning: 'Dunning',
        connectorBillingModel: 'Afregningsmodel',
        cleared: 'Fjernet',
        newValue: 'Ny værdi',
        caseSeqId: 'Sagsnummer',
        previousStatus: 'Tidligere status',
        reason: 'Årsag',
        direction: 'Retning',
        mergedTo: 'Flettet til',
        mergedFrom: 'Flettet fra',
        fromCase: 'Fra sag',
        toCase: 'Til sag',
        fromVoucher: 'Fra postering',
        toVoucher: 'Til postering',
        fromStatus: 'Fra status',
        toStatus: 'Til status',
        entriesCount: 'Antal afdrag',
        activationTrigger: 'Aktiveret',
        tribunalType: 'Sagstype',
        jobType: 'Handling',
        documentType: 'Dokumenttype',
        fileName: 'Filnavn',
        signedAt: 'Signeret',
        signedBy: 'Signeret af',
        source: 'Kilde',
        successCount: 'Oprettet',
        updatedCount: 'Opdateret',
        failedCount: 'Fejlet',
        dateUpdated: 'Dato',
        fileUploaded: 'Fil uploadet',
        costsRegistered: 'Omkostninger',
        meetingStateChanged: 'Status',
        noteUpdated: 'Note opdateret',
        caseLifecycle: 'Sagsforløb',
        paymentPlans: 'Afdragsordninger',
        tribunal: 'Retten',
    },
    blameLogSimplfiedType: {
        [BlameLogType.CaseVisit]: 'Sagsbesøg',
        [BlameLogType.CaseVoucherCreate]: 'Postering oprettet',
        [BlameLogType.CaseVoucherDelete]: 'Postering slettet',
        [BlameLogType.CaseVoucherRestore]: 'Postering gendannet',
        [BlameLogType.UnknownCaseVoucherMapped]: 'Uidentificerbar indbetaling tilføjet',
        [BlameLogType.CaseVoucherPatch]: 'Postering opdateret',
        [BlameLogType.UserOnCustomerVisit]: 'Kundebesøg',
        [BlameLogType.CreditorVisit]: 'Kreditorbesøg',
        [BlameLogType.VisitedBy]: 'Besøg',
        [BlameLogType.CaseVoucherIrrecoverable]: 'Postering uerholdelig',
        [BlameLogType.CaseVoucherExpired]: 'Postering forældet',
        [BlameLogType.InteractionCreate]: 'Interaktion oprettet',
        [BlameLogType.InteractionDelete]: 'Interaktion slettet',
        [BlameLogType.WorkflowRollback]: 'Workflow tilbagerullet',
        [BlameLogType.InteractionHideFromClient]: 'Interaktion skjult for kreditor',
        [BlameLogType.InteractionMappedToCase]: 'Interaktion tilknyttet sag',
        [BlameLogType.InteractionUnmappedFromCase]: 'Interaktion fjernet fra sag',
        [BlameLogType.InteractionRollback]: 'Interaktion tilbagerullet',
        [BlameLogType.DebtorWebLoginEId]: 'Login på debitorweb med e-ID',
        [BlameLogType.DebtorUpdateName]: 'Navn ændret',
        [BlameLogType.DebtorUpdatePhone]: 'Telefon ændret',
        [BlameLogType.DebtorUpdateAddress]: 'Adresse ændret',
        [BlameLogType.DebtorUpdateEmail]: 'Email ændret',
        [BlameLogType.DebtorUpdateCourt]: 'Retskreds ændret',
        [BlameLogType.DebtorUpdateBirthdate]: 'Fødselsdag ændret',
        [BlameLogType.DebtorUpdateCVR]: 'CVR ændret',
        [BlameLogType.DebtorUpdateCPR]: 'CPR ændret',
        [BlameLogType.AKSConfiguration]: 'AKS-konfiguration',
        [BlameLogType.AutoDebtRegister]: 'Automatisk gældsregistrering',
        [BlameLogType.AutoRegisterInOpenRegistry]: 'Åbent register',
        [BlameLogType.AutoIgnoreUnresolvedOppositions]: 'Ignorer uafklarede indsigelser',
        [BlameLogType.AutoDeleteDebtRegistrationOnCaseEnd]: 'Slet automatisk gældsregistrering ved sagsafslutning',
        [BlameLogType.AKSClientID]: 'Experian klientnummer',
        [BlameLogType.RKIOveride]: 'Overskriv auto RKI',
        [BlameLogType.AKSActivated]: 'AKS aktiveret',
        [BlameLogType.PriceList]: 'Prisliste',
        [BlameLogType.UserPasswordUpdate]: 'Brugers kodeord ændret',
        [BlameLogType.TriggerShortcut]: 'Trigger-ændring',
        [BlameLogType.WorkflowChange]: 'Workflow-ændring',
        [BlameLogType.WorkflowChangeOnCase]: 'Workflow skiftet på sag',
        [BlameLogType.CaseCreate]: 'Sag oprettet',
        [BlameLogType.CaseDelete]: 'Sag slettet',
        [BlameLogType.CaseMerge]: 'Sag sammenlagt',
        [BlameLogType.CaseStatusChange]: 'Sagsstatus ændret',
        [BlameLogType.CaseJournalNumberChange]: 'Journalnummer ændret',
        [BlameLogType.CaseCostCeilingAmountChange]: 'Omkostningsloftbeløb ændret',
        [BlameLogType.CaseCostCeilingEnabledChange]: 'Omkostningsloft slået til/fra',
        [BlameLogType.PaymentPlanCreate]: 'Afdragsordning oprettet',
        [BlameLogType.PaymentPlanPatched]: 'Afdragsordning opdateret',
        [BlameLogType.PaymentPlanDelete]: 'Afdragsordning slettet',
        [BlameLogType.CaseVoucherMoved]: 'Postering rykket',
        [BlameLogType.TribunalCaseCreate]: 'Domstolssag oprettet',
        [BlameLogType.TribunalJobCreate]: 'Domstolsopgave oprettet',
        [BlameLogType.TribunalJobPatch]: 'Domstolsopgave opdateret',
        [BlameLogType.TribunalJobDelete]: 'Domstolsopgave slettet',
        [BlameLogType.DocumentUpload]: 'Dokument uploadet',
        [BlameLogType.DocumentDelete]: 'Dokument slettet',
        [BlameLogType.DocumentSigned]: 'Dokument underskrevet',
        [BlameLogType.ImportCreated]: 'Import oprettet',
        [BlameLogType.ImportRun]: 'Import kørt',
        [BlameLogType.DeleteUpdate]: 'Opgave slettet',
        [BlameLogType.ConnectorBillingUpdate]: 'Afregningsmodel ændret',
        [BlameLogType.CreditorSettingsUpdate]: 'Kreditorindstillinger ændret',
        [BlameLogType.BulkAction]: 'Massebehandling',
        [BlameLogType.FixedDistributionCreate]: 'Fordeling oprettet',
        [BlameLogType.FixedDistributionUpdate]: 'Fordeling ændret',
        [BlameLogType.FixedDistributionDelete]: 'Fordeling slettet',
    },
    caseTypes: {
        [CaseType.CLIENT]: 'Kreditorsag',
        [CaseType.TENANT]: 'Tenantsag',
    },
    cases: {
        case: 'Sag',
        customerReferenceId: 'Referencenr.',
        creditor: 'Kreditor',
        debt: 'Oprindelig',
        deposits: 'Indbetalt',
        balance: 'Gæld',
        status: 'Sagsstatus',
        caseVoucher: 'Postering',
        amount: 'Beløb',
        workflow: 'Workflow',
        responsible: 'Ansvarlig',
        showAll: 'Vis alle',
        caseInfo: 'Sagsinformation',
        cases: 'Sager',
        createNewCase: 'Opret sag',
        caseOverview: 'Alle sager',
        casesLeft: 'Sager tilbage',
        casePaused: 'Sag i bero',
        dueDateIsIn: 'Næste opgave udføres om',
        days: 'dage',
        pressCommandOrCtrlToContinue: 'Tryk command eller control for også at fortsætte sagen.',
        source: 'Kilde',
        sourceClient: 'Sagen oprinder fra denne dunning-sag',
        referenceId: 'Kreditors sagsreferencenummer (f.eks. et kundenummer eller et patientnummer)',
        createdAt: 'Oprettelsesdato',
        caseState: {
            [CaseState.ALL]: 'Alle sager',
            [CaseState.ACTIVE]: 'Aktive sager',
            [CaseState.CLOSED]: 'Lukkede sager',
        },
        caseStatus: {
            [CaseStatus.VERIFIED]: 'Godkendt',
            [CaseStatus.PENDING]: 'Ny sag',
            [CaseStatus.ENDED]: 'Afsluttet',
        },
        settings: 'Sagsindstillinger',
        caseSettings: {
            disableDebtorPaymentPlan: 'Deaktiver debitor afdragsordning',
        },
        VERIFIED: 'Godkendt',
        PENDING: 'Ny sag',
        ENDED: 'Afsluttet',
        verify: 'Godkend',
        end: 'Afslut',
        reVerify: 'Godkend igen',
        endCase: 'Afslut sag',
        choosEndReason: 'Vælg en afslutningsårsag',
        caseGroup: 'Sagsgruppe',
        pause: 'Pause',
        pauseCase: 'Sæt sag på pause',
        pauseReason: 'Pauseårsag',
        pauseComment: 'Eventuel kommentar',
        dunning: 'Dunning',
        debtCollection: 'Inkasso',
        blameLog: 'Handlingslog',
        logged: 'Handling',
        ago: 'siden',
        newCase: 'Opret sag',
        caseReferenceId: 'Kreditors sagsreferencenummer (f.eks. et kundenummer)',
        file: 'Fakturafil',
        debtorName: 'Navn',
        address: 'Adresse',
        phone: 'Telefonnummer',
        email: 'Email',
        cpr: 'CPR',
        cvr: 'CVR',
        debtorHaveObjections: 'Debitor har gjort indsigelse',
        isCompany: 'Debitor er en virksomhed',
        theDetails: 'Info',
        theDebt: 'Kravet',
        theDebtor: 'Debitor',
        manual: 'Manuel',
        fromFile: 'Fra fil',
        dropFile: 'Træk faktura herhen',
        clickHereToUpload: 'Eller upload',
        addDebt: 'Ny faktura',
        issueDate: 'Fakturadato',
        dueDate: 'Forfaldsdato',
        sendNoteToCollector: 'Send besked til inddriver',
        sendNoteToCollectorButton: 'Send besked',
        note: 'Note',
        caseHasBeenDeleted: 'Sagen er blevet slettet',
        missingCreateAccess: 'Aftalen er ophørt, og der kan derfor ikke oprettes nye sager. Kontakt os for nærmere information',
        newCaseCreate: 'Stamdata',
        newCaseEconomy: 'Økonomi',
        newCaseDone: 'Færdig',
        noDebts: 'Ingen krav',
        noDebtsExplainer: "Tilføj krav med '+' knappen",
        newCaseCreateExplainer: 'Du er nu i gang med at oprette en ny sag. Her kan du indsætte kundenummeret fra jeres system.',
        newCaseEconomyExplainer: 'Din sag er nu oprettet, og herunder skal sagens økonomi tilføjes.',
        newCaseCreationWarning: 'Når du klikker dig videre vil sagen være oprettet i systemet. Har du ikke alle informationer til at oprette sagen, anbefales det du ikke fortsætter før du har al information om gælden og skyldner',
        deleteCase: 'Slet sag',
        sureYouWantToDeleteCase: 'Er du sikker på at du vil slette denne sag?',
    },
    mergeCases: {
        header: 'Sammenlæg sagen med en anden',
        explanation: 'Sammenlæg denne sag med den forneden valgte sag. Posteringer vil blive flyttet til den valgte sag, og denne sag vil blive lukket med status "Sagen er lagt sammen med en anden".',
        searchPlaceholder: 'Søg efter sager på samme kreditor',
        mergeBtn: 'Sammenlæg sager',
        undoCaseMerge: 'Fortryd sammenlægning',
    },
    customers: {
        party: 'part',
        addParty: 'Tilføj part',
        contact: 'Kontaktperson',
        selectType: 'Vælg type',
        errorEmailValidation: 'Ugyldig email',
        errorCPRValidation: 'Ugyldigt CPR-nummer',
        errorCVRValidation: 'Ugyldigt CVR-nummer',
        noContactSelected: 'Ingen kontaktperson valgt',
        noContact: 'Ingen kontaktperson',
        noRelatedCases: 'Ingen relaterede sager',
        customer: 'Kunde',
        createdAt: 'Oprettet',
        casesOnCreditor: 'Sager på kreditor',
        thatIsRelatedTo: 'som er tilknyttet kundenummer',
        casesRelatedToCustomerDescription: 'Sager som er matchet på email, CPR, CVR eller via eksterne kilder.',
        information: 'Information',
        casesOnCustomer: 'Sager på kunden',
        relatedCases: 'Relaterede sager',
        caseStatus: 'Status',
        relationType: 'Relation',
        creditor: 'Kreditor',
        case: 'Sag',
        customerHasBeenDeleted: 'Kunden er blevet slettet',
        parties: 'Parter',
        customerReferenceId: 'Referencenummer (eksempelvis et kunde-, klient- eller patientnummer)',
        private: 'Privatperson',
        company: 'Virksomhed',
        existingCustomer: 'Eksisterende kunde',
        backToCase: 'Tilbage til sag',
        referenceId: 'Referencenummer',
        alternativeContactReferenceId: 'Repræsentantens journalnummer',
        secondaryEntityDisabled: 'Inaktiveret',
        addSecondaryEmails: 'Tilføj en eller flere sekundære emails',
        note: 'Evt. note',
        addSecondaryEmail: 'Tilføj sekundær email',
        addSecondaryPhones: 'Tilføj en eller flere sekundære telefonnumre',
        addSecondaryPhone: 'Tilføj sekundært telefonnummer',
        enabled: 'Aktiv',
        save: 'Gem',
        createNewCaseOnCustomer: 'Opret ny sag på kunden',
        copyCaseIds: 'Kopier sagsnumre',
        notes: {
            title: 'Noter',
            addNote: 'Tilføj note',
            noNotes: 'Ingen noter',
            edit: 'Rediger',
            save: 'Gem',
            cancel: 'Annuller',
            delete: 'Slet',
            deleteConfirm: 'Slet denne note?',
            editPlaceholder: 'Notetekst',
            noDebtor: 'Ingen debitor på denne kunde',
        },
    },
    assets: {
        note: 'Note',
        assets: 'Aktiver',
        realEstate: 'Fast ejendom',
        vehicles: 'Køretøjer',
        other: 'Andre aktiver',
        noAssets: 'Ingen aktiver registreret',
        addAsset: 'Tilføj aktiv',
        editAsset: 'Rediger aktiv',
        deleteAsset: 'Slet aktiv',
        confirmDelete: 'Er du sikker på, at du vil slette dette aktiv?',
        description: 'Beskrivelse',
        estimatedValue: 'Vurderet værdi',
        bfeNumber: 'BFE-nummer',
        address: 'Adresse',
        zipcode: 'Postnummer',
        city: 'By',
        registrationNumber: 'Registreringsnummer',
        brand: 'Mærke',
        model: 'Model',
        variant: 'Variant',
        year: 'Årgang',
        lienType: 'Hæftelsestype',
        source: 'Kilde',
        notSubscribed: 'Kunden er ikke tilmeldt Cosmo',
        type: 'Type',
        realEstateType: 'Fast ejendom',
        vehicleType: 'Køretøj',
        taxType: 'Skat',
        otherType: 'Andet',
        owners: 'Ejere',
        liens: 'Hæftelser',
        transactions: 'Transaktioner',
        currency: 'Valuta',
        save: 'Gem',
        cancel: 'Annuller',
        administrator: 'Administrator',
        creditor: 'Kreditor',
        date: 'Dato',
        amount: 'Beløb',
        totalLiens: 'Samlet hæftelse',
        noLiens: 'Ingen hæftelser registreret',
        noTransactions: 'Ingen transaktioner registreret',
        lienCountSuffix: 'hæftelser',
        assetCountSuffix: 'aktiver',
        thisCreditor: 'Denne kreditor',
        linkedCase: 'Sag',
        otherDistraints: 'Andre udlæg',
        transferDate: 'Overtagelsesdato',
        transferMethod: 'Overtagelsesmetode',
        purchaseSum: 'Købesum',
        conditional: 'Betinget',
        summary: 'Oversigt',
        netWorth: 'Estimeret nettoformue',
        totalEstimatedValue: 'Samlet estimeret værdi',
        loanToValue: 'Belåningsgrad',
        liensToThisCreditor: 'Hæftelser til denne kreditor',
        addLien: 'Tilføj hæftelse',
        editLien: 'Rediger hæftelse',
        registrationDate: 'Tinglysningsdato',
        priority: 'Prioritet',
        missingCreditorRegisterId: 'Denne kreditor har intet CVR-nummer — angiv det, før du tilføjer hæftelser.',
        interestRate: 'Rentesats (%)',
        interestType: 'Rentetype',
        contributionRate: 'Bidragsats (%)',
        totalTermYears: 'Samlet løbetid (år)',
        interestOnlyYears: 'Afdragsfri periode (år)',
        termShort: 'Løbetid',
        interestOnlyShort: 'Afdragsfri',
        yearsShort: 'år',
        outstandingBalances: 'Restgæld',
        outstandingBalance: 'Restgæld',
        outstandingBalanceDate: 'Restgæld opgjort dato',
        expectedOutstanding: 'Forventet restgæld',
        assumedTooltip: 'Antaget værdi',
        addOutstandingBalance: 'Tilføj restgæld',
        noOutstandingBalances: 'Ingen restgæld registreret',
        remove: 'Fjern',
        assetRegistrationNumber: 'Reg.nr.',
        assetModelYear: 'Årgang',
        ownershipShare: 'Ejerandel',
        ownershipNotConfirmed: 'Ejerskab ikke bekræftet',
        bfeAmbiguousOwner: 'Ejendomsdata utilgængelig',
        notSubscribedDescription: 'Kunden overvåges ikke længere, så disse aktiver er et øjebliksbillede fra dengang overvågningen stoppede og kan ikke redigeres.',
        bfeAmbiguousOwnerDescription: 'Flere personer med dette navn fundet i ejendomsregistret. Tilføj en fødselsdato på debitor for at løse problemet.',
        proportionalValue: 'Debitors andelsværdi',
        debtors: 'Debitorer',
        totalLabel: 'total',
        showHiddenLiens: 'Vis skjulte hæftelser',
        hideHiddenLiens: 'Skjul skjulte hæftelser',
        lienTypes: {
            [LienType.Attachment]: 'Udlæg',
            [LienType.Mortgage]: 'Pantebrev',
            [LienType.OwnerNote]: 'Ejerpantebrev',
            [LienType.PrivateNote]: 'Privat pantebrev',
            [LienType.PrivateIndexLinkedMortgage]: 'Privat indekspantebrev',
            [LienType.Other]: 'Andet',
            [LienType.Unknown]: 'Ukendt',
        },
        interestTypes: {
            [InterestType.Variable]: 'Variabel',
            [InterestType.Fixed]: 'Fast',
        },
        transferMethods: {
            FREE_SALE: 'Frit salg',
            FORCED_AUCTION: 'Tvangsauktion',
            INHERITANCE: 'Arv',
            GIFT: 'Gave',
            FAMILY_TRANSFER: 'Familieoverdragelse',
            EXCHANGE: 'Mageskifte',
            OTHER: 'Andet',
        },
        valuations: 'Vurderinger',
        assetOverview: 'Aktivoverblik',
        equity: 'Friværdi',
        viewAllAssets: 'Se alle aktiver',
        valuationSources: {
            [ValuationSource.PublicAssessment]: 'Offentlig vurdering',
            [ValuationSource.LastSale]: 'Seneste salg',
            [ValuationSource.Manual]: 'Manuel',
        },
    },
    customerCaseRelationType: {
        [RelationType.CPR]: 'CPR',
        [RelationType.CVR]: 'CVR',
        [RelationType.Cosmo]: 'Ekstern',
        [RelationType.CustomerReferenceId]: 'Kunderef.',
        [RelationType.Email]: 'Email',
        [RelationType.NameAddress]: 'Navn/adr.',
    },
    debtors: {
        private: 'Privat',
        company: 'Erhverv',
        addAlternativeContact: 'Tilføj repræsentant',
        alternativeContact: 'Repræsentant',
        debtor: 'Debitor',
        ownsCompany: 'Ejer virksomhed',
        ownsCompanies: 'Ejer virksomheder',
        movedAbroad: 'Flyttet udenlands',
        rkiRegistrations: 'RKI-registreringer',
        confirmDeleteUserFromCustomer: 'Er du sikker på at du vil slette denne bruger fra kunden?',
        companyStatus: 'Virksomhedsstatus',
        otherCasesOnDebtorTooltip: 'Debitor er associeret med flere sager',
        otherCasesOnDebtorPlural: 'Andre sager',
        otherCasesOnDebtor: 'Anden sag',
        movedTo: 'Flyttet til',
        debtors: 'Debitorer',
        aksFailed: 'AKS fejlede',
        cprStatus: 'CPR-status',
        status: {
            [PrivateStarCycle.Active]: 'Aktiv',
            [PrivateStarCycle.Dead]: 'Død',
            [PrivateStarCycle.Disappeared]: 'Forsvundet',
            [PrivateStarCycle.Homeless]: 'Hjemløs',
            [PrivateStarCycle.GoneAway]: 'Flyttet udenlands',
            [PrivateStarCycle.ForTaxReason]: 'Skattepersonnummer',
            [PrivateStarCycle.NotVerified]: 'Ikke verificeret',
            [CompanyStarCycle.Inactive]: 'Inaktiv',
            [CompanyStarCycle.OperationsCeased]: 'Ophørt',
            [CompanyStarCycle.ShelfCompany]: 'Skuffeselskab',
        },
        dissolvedStatus: {
            [DissolvedStatus.UnderLiquidation]: 'Trådt i likvidation',
            [DissolvedStatus.DissolvedAfterLiquidation]: 'Opløst efter likvidation',
            [DissolvedStatus.InvoluntaryDissolution]: 'Under tvangsopløsning',
            [DissolvedStatus.Dissolved]: 'Opløst',
            [DissolvedStatus.Unknown]: 'Ukendt opløsningsstatus',
            [DissolvedStatus.Voluntary]: 'Under frivillig likvidation',
            [DissolvedStatus.VoluntaryDeclaration]: 'Under frivillig likvidation (erklæring)',
            [DissolvedStatus.Forced]: 'Under tvangsopløsning',
            [DissolvedStatus.DissolvedAfterDeclaration]: 'Opløst efter erklæring',
            [DissolvedStatus.DissolvedAfterMerger]: 'Opløst efter fusion',
            [DissolvedStatus.DissolvedAfterDemerger]: 'Opløst efter spaltning',
            [DissolvedStatus.DissolvedAfterBankruptcy]: 'Opløst efter konkurs',
            [DissolvedStatus.Ceased]: 'Ophørt',
        },
        dissolutionStatus: 'Opløsningsstatus',
        addressProtection: 'Beskyttet navn og adresse',
        addressProtectionShort: 'Beskyttet',
        addDebtor: 'Tilføj debitor',
        guardian: 'Værge',
        relatedCases: 'relaterede sager',
        relatedCasesDescription: 'Antal relaterede sager som er godkendte / antal relaterede sager i alt',
        otherCases: 'andre sager',
        otherCasesDescription: 'Antal godkendte sager på kunden / antal sager i alt',
    },
    emailValidations: {
        risk: 'Risiko',
        emailRisk: 'Emailrisiko',
        didYouMean: 'Mente du',
        isDisposableAddress: 'Engangsemail',
        isRoleAddress: 'Er en fælles-email',
        high: 'Høj',
        medium: 'Medium',
        low: 'lav',
        unknown: 'Ukendt',
        no_mx: 'Ingen MX opsætning',
        unknown_provider: 'Ukendt mailudbyder',
        high_risk_domain: 'Højrisikodomæne',
        subdomain_mailer: 'Subdomæne mailadresse',
        immature_domain: 'Domænet er nyoprettet',
        tld_risk: 'Domænet er registreret som højrisiko',
        mailbox_does_not_exist: 'Emailen findes ikke',
        mailbox_is_disposable_address: 'Emailen er en engangsemail',
        mailbox_is_role_address: 'Er en fælles-email',
        catch_all: 'Catch all',
        long_term_disposable: 'Længerevarende engangsemail',
    },
    phoneValidation: {
        mobile: 'Mobil',
        landline: 'Fastnet',
        landline_premium: 'Fastnet',
        landline_tollfree: 'Fastnet',
        virtual: 'Virtuel',
        unknown: 'Ukendt',
        pager: 'Pager',
        roaming: 'Roaming',
    },
    debtorInfo: {
        debtorInfo: 'Debitor info',
        debtorCreatedAt: 'Debitor oprettet d.',
        company: 'Virksomhed',
        male: 'Mand',
        female: 'Kvinde',
        private: 'Privat',
        activated: 'Aktiveret',
        subscribed: 'tilmeldt',
        failed: 'Fejlede',
        movedTo: 'Flyttet til',
        description: 'Beskrivelse',
        addDescription: 'Tilføj beskrivelse',
        name: 'Navn',
        email: 'Email',
        noEmailAddr: 'Ingen emailadresse',
        phone: 'Telefon',
        noAddr: 'Ingen adresse',
        address: 'Adresse',
        letterReturned: 'Brev kunne ikke leveres på adressen',
        cannotReceive: 'Kan ikke modtage',
        deliverabilityFailedAt: 'Seneste levering fejlede',
        deliverabilityChannels: {
            eboks: 'e-Boks',
            letter: 'Brev',
            eInvoice: 'E-faktura',
        },
        deliverabilityVia: {
            eboksName: 'Kunne ikke leveres på navn og adresse',
            eboksRegisterId: 'Kunne ikke leveres på CPR/CVR',
            letter: 'Kunne ikke leveres på adressen',
            eInvoice: 'Kunne ikke leveres til',
        },
        cpr: 'CPR',
        cvr: 'CVR',
        registryIdentifier: 'Centralregister ID',
        addressProtection: 'Adresse- og navnebeskyttet',
        addressProtectionShort: 'Beskyttet',
        jurisdiction: 'Retskreds',
        noJurisdiction: 'Ingen retskreds',
        chooseJurisdiction: 'Vælg retskreds',
        status: {
            [PrivateStarCycle.Active]: 'Aktiv',
            [PrivateStarCycle.Dead]: 'Død',
            [PrivateStarCycle.Disappeared]: 'Forsvundet',
            [PrivateStarCycle.Homeless]: 'Hjemløs',
            [PrivateStarCycle.GoneAway]: 'Flyttet udenlands',
            [PrivateStarCycle.ForTaxReason]: 'Skattepersonnummer',
            [PrivateStarCycle.NotVerified]: 'Ikke verificeret',
            [CompanyStarCycle.Inactive]: 'Inaktiv',
            [CompanyStarCycle.OperationsCeased]: 'Ophørt',
            [CompanyStarCycle.ShelfCompany]: 'Skuffeselskab',
        },
        dissolvedStatus: {
            [DissolvedStatus.UnderLiquidation]: 'Trådt i likvidation',
            [DissolvedStatus.DissolvedAfterLiquidation]: 'Opløst efter likvidation',
            [DissolvedStatus.InvoluntaryDissolution]: 'Under tvangsopløsning',
            [DissolvedStatus.Dissolved]: 'Opløst',
            [DissolvedStatus.Unknown]: 'Ukendt opløsningsstatus',
            [DissolvedStatus.Voluntary]: 'Under frivillig likvidation',
            [DissolvedStatus.VoluntaryDeclaration]: 'Under frivillig likvidation (erklæring)',
            [DissolvedStatus.Forced]: 'Under tvangsopløsning',
            [DissolvedStatus.DissolvedAfterDeclaration]: 'Opløst efter erklæring',
            [DissolvedStatus.DissolvedAfterMerger]: 'Opløst efter fusion',
            [DissolvedStatus.DissolvedAfterDemerger]: 'Opløst efter spaltning',
            [DissolvedStatus.DissolvedAfterBankruptcy]: 'Opløst efter konkurs',
            [DissolvedStatus.Ceased]: 'Ophørt',
        },
        dissolutionStatus: 'Opløsningsstatus',
        save: 'Gem',
        remove: 'Fjern',
        birthdate: 'Fødselsdato',
        noBirthdate: 'Ingen fødselsdato',
        yearsOld: 'år gammel',
        companyForm: 'Virksomhedsform',
        industry: 'Branche',
        employees: 'Ansatte',
        companyStatus: 'Virksomhedsstatus',
        website: 'Hjemmeside',
        dateOfFoundation: 'Stiftelsesdato',
        quantifyOfPUnits: 'Antal P-Enheder',
        powerToBind: 'Tegningsregel',
        adProtected: 'Reklamebeskyttet',
        cars: 'Biler',
        from: 'Fra',
        liabilities: 'Hæftelser',
        priority: 'Prioritet',
        interest: 'Rente',
        properties: 'Ejendomme',
        toilet: 'Toilet',
        roof: 'Tag',
        bath: 'Bad',
        built: 'Bygget',
        rkiRegis: 'RKI-registreringer',
        administrator: 'Administrator',
        disclosureDate: 'Videregivelsesdato',
        deleted: 'slettet',
        toBedeleted: 'slettes',
        companyRelations: 'Virksomhedsrelationer',
        roles: 'Roller',
        accountableParticipant: 'Fuldt ansvarlig deltager',
        director: 'Direktør',
        executiveBoard: 'Direktion',
        beneficialOwner: 'Reel ejer',
        founder: 'Stifter',
        owner: 'Ejer',
        stakeholder: 'Interessent',
        chairperson: 'Bestyrelsesformand',
        managingDirector: 'Adm. direktør',
        boardMember: 'Bestyrelsesmedlem',
        equityTier: 'Kapitalklasse',
        viceChairperson: 'Næstformand',
        rightToVote: 'Stemmeret',
        audit: 'Revision',
        specialOwnership: 'Særlige Ejerforhold',
        previous: 'Tidligere',
        noPreviousToShow: 'Ingen tidligere at vise',
        backTo: 'Tilbage til',
        casesOnThisDebtor: 'Sager vedrørende denne debitor',
        guardianName: 'Værge navn',
        guardianAddress: 'Værge adresse',
        guardianStartDate: 'Værge startdato',
    },
    debtorWebHome: {
        dear: 'Kære',
        representative: 'Vi har registreret at du er indtrådt som repræsentant for debitor.',
        you: 'Du',
        debtor: 'Debitor',
        owe: 'skylder',
        to: 'til',
        youCanDoThisHere: 'Her kan du betale, anmode om en afdragsordning og ændre dine kontaktoplysninger. Du er også velkommen til at sende os en besked, hvis du har spørgsmål.',
        yourInfo: 'Dine informationer',
        name: 'Navn',
        informName: 'Oplys navn',
        email: 'Email',
        informEmail: 'Oplys email',
        phone: 'Telefon',
        informPhone: 'Oplys telefonnummer',
        address: 'Adresse',
        cpr: 'CPR',
        cvr: 'CVR',
        informAddress: 'Oplys adresse',
        confirmation: 'Jeg godkender at mine informationer er korrekte.',
        updateButton: 'Opdater information',
        confirm: 'Bekræft',
        faq: 'Ofte stillede spørgsmål',
        contactUs: 'Kontakt os',
        contactUsText: 'Du er altid velkommen til at kontakte os pr. email, telefon eller vha. nedenstående felt.',
        yourMessage: 'Din besked',
        enterEmail: 'Indtast email for at kunne sende en besked',
        send: 'Send',
        logout: 'Log ud',
        privacyPolicy: 'Privatlivspolitik',
        businessTerms: 'Forretningsbetingelser',
        paymentMethods: 'Betalingsmetoder',
        payWithFI: 'Betal med FIK-nummer',
        paySafeWithFI: 'Betal sikkert med dit FIK-nummer fra din bank:',
        payWithIBAN: 'Betal med IBAN',
        paySafeWithIBAN: 'Betal sikkert via IBAN fra din bank:',
        payWithSWIFT: 'Betal med SWIFT',
        paySafeWithSWIFT: 'Betal sikkert via SWIFT fra din bank:',
        payWithBankTransfer: 'Lav en bankoverførsel',
        payWithBankTransferText: 'Lav en bankoverførsel til vores bankkonto ved hjælp af informationerne herunder:',
        registrationNumber: 'Reg.nr.',
        accountNumber: 'Kontonr.',
        payWithBankTransferInfo: 'Husk at henvis til j.nr.',
        or: 'Eller',
        iApprove: 'Jeg godkender',
        theBusinessTerms: 'forretningsbetingelserne',
        pleaseAcceptBusinessTerms: 'Du skal godkende forretningsbetingelserne, før du kan gå til betalingssiden.',
        payWithCardButton: 'Gennemfør betaling',
        createAPaymentPlan: 'Opret afdragsordning',
        fullPayment: 'Fuld betaling',
        partialPayment: 'Delvis betaling',
    },
    debtorWebPaymentPlans: {
        backToCase: 'Tilbage til sagen',
        paymentPlanOn: 'Afdragsordning på sag',
        selectPlan: 'Vælg afdragsordning',
        chooseDifferentPlan: 'Vælg en anden afdragsordning',
        sign: 'Underskriv aftale',
        gatherInfo: 'Indtast informationer',
        paymentMethod: 'Vælg betalingsmetode',
        approval: 'Bekræftelse',
        info: 'Info',
        paymentPlan: 'Afdragsordning',
        firstPayment: 'Første afdrag',
        entry: 'afdrag',
        lastPayment: 'Sidste afdrag',
        signedDoc: 'Underskrevet dokument',
        needHelp: 'Brug for hjælp?',
        orPay: 'Eller betal hele gælden',
        pay: 'Betal hele gælden',
        months: 'Måneder',
        month: 'måned',
        total: 'Total tilbagebetaling',
        select: 'Vælg',
        noOptions: 'Vi kan desværre ikke indgå en afdragsordning.',
        signTextOne: 'For at indgå en afdragsordning med',
        signTextTwoAlternativeContact: 'skal debitor underskrive en aftale.',
        signTextTwoDebtor: 'skal du underskrive en aftale.',
        signTextThree: 'For at indgå afdragsordningen, har vi brug for nogle flere informationer.',
        agreement: 'Underskriv aftale',
        agreementTitle: 'Aftale',
        approvalText: 'Tillykke! Du har indgået en afdragsordning.',
        paymentMethodText: 'Vi passer godt på dine oplysninger og gør det nemt for dig at tilmelde automatisk betaling.',
        connectCard: 'Tilknyt betalingsmetode',
        automaticPaymentMethod: 'Automatisk betalingsmetode',
        manualBankTransferTitle: 'Betaling via bank',
        manualBankTransferHint: 'Du kan foretage en manuel bankoverførsel via nedenstående mulighed(er).',
        securePaymentHint: 'Sikker betaling',
        deleteCardToChange: 'Du kan fjerne/ændre det valgte kort ved at klikke på fjern kort knappen.',
        deleteCard: 'Fjern kort',
        paymentPlanEntries: 'Afdrag',
        progressTitle: 'Din afdragsordning',
        progressPaid: 'Betalt',
        progressRemaining: 'Tilbage',
        progressNext: 'Næste afdrag',
        progressComplete: 'Afdragsordning fuldført',
        progressOf: 'af',
        amount: 'Beløb',
        date: 'Dato',
        status: 'Status',
        statusCode: {
            [PaymentPlanEntryStatus.SETTLED]: 'Betalt',
            [PaymentPlanEntryStatus.CANCELED]: 'Misligholdt',
            [PaymentPlanEntryStatus.PENDING]: 'Afventer',
            [PaymentPlanEntryStatus.REMINDED]: 'Påmindet',
            [PaymentPlanEntryStatus.AWAITING]: 'Afventer',
            [PaymentPlanEntryStatus.OVERDUE]: 'Frist overskredet',
            [PaymentPlanEntryStatus.ERRORSETTLED]: 'Fejlslagen korttræk',
        },
    },
    paymentPlanEntryStatuses: {
        [PaymentPlanEntryStatus.SETTLED]: 'Betalt',
        [PaymentPlanEntryStatus.CANCELED]: 'Misligholdt',
        [PaymentPlanEntryStatus.PENDING]: 'Afventer',
        [PaymentPlanEntryStatus.REMINDED]: 'Påmindet',
        [PaymentPlanEntryStatus.AWAITING]: 'Afventer',
        [PaymentPlanEntryStatus.OVERDUE]: 'Frist overskredet',
        [PaymentPlanEntryStatus.ERRORSETTLED]: 'Fejlslagen korttræk',
    },
    chains: {
        nextStep: 'Næste skridt',
    },
    chainGroups: {
        dunningChain: 'Dunningworkflow',
        chain: 'Workflow',
        add: 'Tilføj',
        delete: 'Slet',
        configure: 'Konfigurer workflows for sagsgrupper',
        caseGroup: 'Sagsgruppe',
    },
    migration: {
        migrateData: 'Migrer data',
        modalHeader: 'Migrer data',
        uploadErrorMessage: 'Der skete en fejl, tjek at filen er korrekt og prøv igen',
    },
    creditorStateDescriptions: {
        [CreditorState.Lead]: 'Til kreditorer som er under opsætning, men endnu ikke har fået adgang til kreditorwebbet.',
        [CreditorState.SignedOn]: 'Til kreditorer som endnu ikke er kunder, men som gerne vil have en demo af kreditorwebbet.',
        [CreditorState.Active]: 'Til aktive kreditorer som uploader sager og har fuld adgang til kreditorwebbet.',
        [CreditorState.Ceased]: 'Til kreditorer som er opsagte, men som stadig skal kunne følge med i eksisterende sager.',
        [CreditorState.Cancelled]: 'Til kreditorer som er opsagte og som ikke længere skal have adgang til kreditorwebbet.',
    },
    creditors: {
        creditor: 'Kreditor',
        creditors: 'Kreditorer',
        creditorInfo: 'Kreditorinformation',
        allCreditors: 'Alle kreditorer',
        searchCreditors: 'Søg kreditorer',
        newCreditorInfo: 'Kreditorinformation',
        newCreditorEconomy: 'Økonomi',
        newCreditorChains: 'Workflows',
        newCreditorUsers: 'Brugere',
        newCreditorDone: 'Færdig',
        states: {
            [CreditorState.Active]: 'Aktiv',
            [CreditorState.Lead]: 'Lead',
            [CreditorState.SignedOn]: 'Registreret',
            [CreditorState.Cancelled]: 'Annulleret',
            [CreditorState.Ceased]: 'Ophørt',
        },
        downloadOverview: 'Download overblik',
        newCreditor: 'Ny kreditor',
        defaultBillingModelDescription: 'Vælg hvilken afregningsmodel nye sager skal oprettes i. Hver sag kan have hver sin afregningsmodel. Ved oprettelsen af en sag vil sagen blive tilknyttet standard afregningsmodellen.',
        tenantInheritedBillingModelDescription: 'Hvis ikke du vælger en afregningsmodel, vil nye sager blive oprettet med din tenant-standard',
        tenantInheritedDunningConnectorDescription: 'Hvis ikke du vælger en afregningsmodel, vil nye sager blive oprettet med din tenant-dunning-standard',
        chainsHeader: 'Valg af standardworkflows',
        chainsDescription: 'Vælg hvilket workflow nye sager skal oprettes i. Hver sag kan have hver sit workflow. Ved oprettelsen af en sag, vil sagen blive tilknyttet kreditorens standardworkflow.',
        usersNewHeader: 'Opret adgang til kreditor',
        usersCreditorHeader: 'Vælg ansvarlige',
        setCreditorState: 'Skift kreditors stadie',
        next: 'Næste',
        previous: 'Forrige',
        cvr: 'CVR',
        company: 'Virksomhed',
        person: 'Person',
        vatRegistered: 'Momsregistreret',
        notVatRegistered: 'Ikke momsregistreret',
        acquisitionResponsible: 'Akkvisitionsansvarlig',
        selectAcquiRespon: 'Vælg akkvisitionsansvarlig',
        contact: 'Kontaktperson hos kreditor',
        selectContact: 'Vælg kontaktperson hos kreditor',
        caseworkerContact: 'Sagsbehandlerkontakt',
        selectCaseworkerContact: 'Vælg Sagsbehandlerkontakt',
        none: 'Ingen',
        createCreditor: 'Opret kreditor',
        reference: 'Kreditorreference (f.eks. et kundenummer fra dit ERP-system)',
        name: 'Navn',
        selectDefaultCollector: 'Vælg standard inddriver',
        status: 'Status',
        active: 'Aktiv',
        lead: 'Lead',
        selectClientContact: 'Vælg kreditorkontakt',
        isCompany: 'Kreditor er en virksomhed',
        create: 'Opret',
        createdAt: 'Oprettelsesdato',
        quantityCases: 'Antal sager',
        referenceId: 'Nr.',
        wincentAvgPrediction: 'Wincent gennemsnitlig score',
        selectDefaultChain: 'Vælg standardworkflow',
        defaultChain: 'Workflow',
        selectDefaultClientChain: 'Vælg standard dunningworkflow',
        defaultClientChain: 'Dunningworkflow',
        mandates: 'Mandater',
        mandatesPlaceholder: 'Tom',
        experianClientId: 'Experian klientnummer',
        updateExperianClientId: 'Opdater klientnummer',
        requestClientIdExperian: 'Anmod Experian om klientnummer',
        requestClientIdExperianSuccess: 'Experian er nu anmodet og vil automatisk indtaste klientnummeret.',
        erpLink: 'Link til kreditors ERP-system',
        updateErpLink: 'Opdater link',
        aksEnabled: 'AKS aktiveret',
        advokatindestaaelse: 'Advokatindeståelse til åben RKI',
        debitorRegistretCreditorNumber: 'Kreditornummer i Debitor Registret',
        debitorRegistretCreateCreditor: 'Opret kreditor i Debitor Registret',
        debitorRegistretCreateCreditorDescription: 'Opretter kreditoren i Debitor Registret og gemmer kreditornummeret.',
        debitorRegistretCreateCreditorSuccess: 'Kreditoren blev oprettet i Debitor Registret.',
        debitorRegistretCreateCreditorSkipped: 'Kreditoren er allerede oprettet i Debitor Registret.',
        bankAccountDetails: 'Bankkontodetaljer',
        updateBankAccountDetails: 'Opdater konto',
        autoRKI: 'Auto gældsregistrering',
        automaticDebtRegister: 'Overskriv automatisk gældsregistrering',
        useAutomaticDebtRegister: 'Vælg automatisk gældsregistrering på kreditorniveau',
        useAutoRegisterInOpenRegistry: 'Vælg åbent register på kreditorniveau',
        useAutoIgnoreUnresolvedOppositions: 'Vælg ignorer uafklarede interaktioner (indsigelser) på kreditorniveau',
        selfCollection: 'Egeninkasso',
        useSelfCollectionOption: 'Vælg egeninkasso på kreditorniveau',
        outboundCall: 'Udgående opkald',
        useOutboundCallOption: 'Vælg udgående opkald på kreditorniveau',
        autoVerify: 'Automatisk godkendelse af sager',
        useAutoVerifyOption: 'Vælg automatisk godkendelse på kreditorniveau',
        paymentTerms: 'Kreditors betalingsbetingelser',
        paymentDays: 'Betalingsfrist',
        billingRecipients: 'Kreditors modtagere af afregninger',
        billingRecipientsDescription: 'Indtast flere emails på følgende måde',
        automaticExpireVouchers: 'Overskriv automatisk forældelse af posteringer',
        useAutomaticExpireVouchers: 'Vælg automatisk forældelse af posteringer på kreditorniveau',
        configurationOptions: 'Konfigurationer',
        debtRegisterConfig: 'Gældsregistrering',
        foundationExpiration: 'Forældelse med fundament',
        normalExpiration: 'Forældelse uden fundament',
        interestExpiration: 'Rente forældelse',
        courtSubmitConfig: 'Konfiguration af automatisk retslig indlevering',
        debtorFAQ: 'Ofte stillede spørgsmål (vises i debitorweb)',
        faqHeader: 'Brug for hjælp til at oprette en kreditor?',
        faqText: 'Vi har skrevet en artikel, som kan hjælpe dig i gang med at oprette kreditorer.',
        newUserDisabled: 'Nye brugere kan ikke oprettes med nuværende kreditor status',
        cancelledError: 'Adgang annulleret',
        cancelledErrorMessage: 'Din adgang er annulleret. Kontakt os for mere information.',
        eInvoice: {
            eInvoice: 'E-faktura',
            companyId: 'Firma id',
            identification: 'Identifikationsnummer',
            addChildCompany: 'Tilføj som child company',
        },
        creditorCreationDisabled: 'Opret kreditor er slået fra',
        creditorCreationDisabledDescription: 'Oprettelse af kreditorer kan ikke gøres via brugergrænsefladen',
        moveCasesToNewCreditor: 'Flyt sager til ny kreditor',
        moveCases: 'Flyt sager',
        noCreditors: 'Ingen kreditorer',
    },
    collectorTypes: {
        [CollectorType.CREDITOR]: 'Kreditor',
        [CollectorType.TENANT]: 'Inddriver',
    },
    collectors: {
        collector: 'Inddriver',
        updateEntity: 'Gem',
        masterData: 'Stamdata',
        layout: 'Layout',
        websites: 'Websites',
        legal: 'Juridisk',
        paymentOptions: 'Betalingsmuligheder',
        communicationChannels: 'Kommunikationskanaler',
        namePlaceholder: 'Navn',
        centralRegisterIdPlaceholder: 'CVR-nummer',
        nicknamePlaceholder: 'Kaldenavn',
        addressPlaceholder: 'Adresse',
        logoFileIdPlaceholder: 'Logo',
        letterFrontLogoFileIdPlaceholder: 'Logo til forsiden af breve',
        websitePlaceholder: 'Virksomhedens website',
        clientWebBasePlaceholder: 'Kreditorweb-base',
        debtorWebBasePlaceholder: 'Debitorweb-base',
        titlePlaceholder: 'Virksomhedstitel',
        privacyPolicyPlaceholder: 'Link til privatlivspolitik',
        businessTermsPlaceholder: 'Link til forretningsbetingelser',
        emailPlaceholder: 'Email',
        replyToPlaceholder: 'Reply-to email',
        phonePlaceholder: 'Telefonnummer',
        paymentOptionsPlaceholder: 'Betalingsmuligheder',
        themePlaceholder: 'Tema',
        hideEmail: 'Skjul email',
        secondaryCollector: 'Sekundær inddriver',
        addSecondaryCollector: 'Tilføj sekundær inddriver',
    },
    paymentPlans: {
        cannotOfferPaymentPlan: 'Vi kan desværre ikke tilbyde dig en afdragsordning online. Kontakt venligst inddriver.',
        paymentPlansDisabled: 'Afdragsordninger er slået fra',
        paymentPlanDisabledForDebtor: 'Debitor kan ikke oprette afdragsordninger. Se sagsindstillinger',
        paymentPlan: 'Afdragsordning',
        signing: 'Indgåelse af afdragsordninger',
        signedFoundation: 'Debitor underskriver en skylderklæring',
        signedFoundationDescription: 'Afdragsordningen bliver aktiv, når debitor har underskrevet i debitorwebbet.',
        noSignature: 'Ingen underskrift',
        noSignatureDescription: 'Afdragsordningen er aktiv, så snart den oprettes.',
        foundationTemplate: 'Skabelon til skylderklæring',
        defaultFoundation: 'Standardskylderklæring',
        skipTo: 'Udskyd til',
        editPaymentPlan: 'Rediger afdragsordning',
        editPaymentPlanDescription: 'Juster afdragenes størrelse, antal eller interval. Allerede betalte afdrag bevares.',
        editPaymentPlanHint: 'De {count} afdrag der allerede er betalt bevares. Kun fremtidige afdrag erstattes med den nye plan.',
        collapsedEntries: 'skjulte afdrag',
        deletePaymentPlan: 'Slet afdragsordning',
        progress: 'Trin',
        selectPaymentPlan: 'Vælg afdragsordning',
        signPaymentPlan: 'Underskriv afdragsordning',
        selectPaymentMethod: 'Vælg betalingsmetode',
        confirmation: 'Bekræftelse',
        createNewPaymentPlan: 'Opret ny afdragsordning',
        months: 'måneder',
        month: 'måned',
        totalPayment: 'I alt at betale',
        createCustomPlan: 'Opret tilpasset afdragsordning',
        createStandardPlan: 'Opret standardafdragsordning',
        byAmount: 'Ud fra beløb',
        byDuration: 'Ud fra antal afdrag',
        monthly: 'Månedligt',
        everyOtherMonth: 'To måneder',
        quarterly: 'Kvartalvist',
        yearly: 'Årligt',
        everyOtherWeek: 'To uger',
        weekly: 'Ugentligt',
        lastBankDayOfMonth: 'Sidste bankdag i måneden',
        rest: 'Restbetaling',
        generate: 'Generér',
        entries: 'Afdrag',
        entry: 'Afdrag',
        date: 'Dato',
        reminder: 'Påmindelse',
        lastChanceOfPayment: 'Sidste chance',
        addedInterests: 'Yderligere renter',
        cancelled: 'Misligholdt',
        amount: 'Beløb',
        confirmationCheckbox: 'Send bekræftelse når afdragsordningen er aktiveret',
        activate: 'Aktivér',
        cancel: 'Annullér',
        agreement: 'Aftaledokument',
        inputAmount: 'Indtast det ønskede beløb.',
        details: 'Detaljer',
        createPaymentPlan: 'Opret afdragsordning',
        activatePaymentPlanWithoutFoundation: 'Aktivér afdragsordning uden fundament.',
        errorCaseEnded: 'Kan ikke oprette afdragsordning: sagen er afsluttet',
        paymentEntryText: 'Indbetaling på',
        yearlyAPR: 'års ÅOP',
        before: 'inden',
        CREATED: 'Oprettet',
        ACTIVE: 'Aktiv',
        FINISHED: 'Afsluttet',
        CANCELED: 'Annulleret',
        DELETED: 'Slettet',
        errorInInput: 'Fejl i din indtastning',
        save: 'Gem',
        calculationFoundation: 'Beløb eller antal afdrag',
        calculationFoundationDescription: 'Vælg afdragsordningens beregningsgrundlag. Enten et beløb eller antallet af afdrag.',
        calculateByAmount: 'Beregn hvert afdrag ud fra et beløb',
        calculateByDuration: 'Beregn afdragene ud fra antallet af ønskede afdrag',
        addScheduledAmountChange: '+ Tilpas senere afdrag',
        scheduledAmountChangeFromDate: 'Fra dato',
        createdAt: 'Oprettet',
        startDate: 'Startdato',
        startDateDescription: 'Betalingsdatoen for første afdrag.',
        upfrontPayment: 'Førstegangsydelse',
        upfrontPaymentDescription: 'Ønskes der en førstegangsydelse for at vise betalingsvilje kan dette slås til her.',
        upfrontPaymentDate: 'Dato for førstegangsydelse',
        interval: 'Interval',
        intervalDescription: 'Vælg hvor langt der skal gå mellem hvert afdrag.',
        interestFree: 'Rentefri periode',
        interestFreeDescription: 'Ønskes en rentefri periode kan denne opsættes her.',
        interestFreeFrom: 'Fra',
        interestFreeTo: 'Til',
        interestFreeOnDefault: 'Hvis planen misligholdes',
        interestFreeOnDefaultKeepFrozen: 'Behold perioden rentefri, renten løber fra misligholdelsesdatoen',
        interestFreeOnDefaultReapply: 'Genpålæg den fritagne rente fra perioden',
        settlement: 'Akkord',
        settlementDescription: 'Skyldner betaler et aftalt nedsat beløb; resten eftergives, når ordningen er gennemført.',
        settlementEnable: 'Indgå akkord (betal mindre end den fulde gæld)',
        settlementAgreedTotal: 'Aftalt beløb',
        settlementPercentOfBalance: 'Procent af saldo',
        settlementAmountForgiven: 'Eftergivet beløb',
        settlementCurrentBalance: 'Aktuel saldo',
        settlementSettledSoFar: 'Betalt indtil nu',
        settlementRemainingToPay: 'Resterende af aftalt beløb',
        settlementForgivenOnCompletion: 'Eftergives ved gennemførelse',
        settlementSummary: 'Skyldner betaler {total} af {balance} ({percent} %)',
        settlementExceedsBalance: 'Det aftalte beløb skal være mindre end den aktuelle saldo',
        fees: 'Gebyrer',
        feesDescription: 'Tilføj valgfrie gebyrer til afdragsordningen.',
        initialFee: 'Startgebyr',
        initialFeeDescription: 'Tilføj et engangsgebyr når afdragsordningen starter.',
        perEntryFee: 'Gebyr pr. afdrag',
        perEntryFeeDescription: 'Tilføj et gebyr for hvert afdrag.',
        selectVoucherType: 'Vælg posteringstype',
        selectVoucherTypeRequired: 'Vælg en posteringstype for at anvende dette gebyr',
        defaultFees: 'Standardgebyrer',
        defaultFeesDescription: 'Konfigurer standardgebyrer der anvendes på nye afdragsordninger.',
        feesWillBeApplied: 'Gebyrer vil blive tilføjet',
        overrideFees: 'Overskriv gebyrer på kreditorniveau',
        moreSettings: 'Flere indstillinger',
        detailsWarning: 'Planen her viser sagens udvikling hvis planen følges. Der kan forekomme afvigelser hvis betalingsdatoer eksempelvis afviger fra afdragsordningen',
        debtAmount: 'Gældens størrelse',
        accumulatedInterest: 'Akkumulerede renter',
        planedAccumulatedPayments: 'Planlagte akkumulerede betalinger',
        disclaimerLastEntryVaries: 'Hvis afdragene ikke betales på den angivne dato, kan beløbet på sidste afdrag afvige.',
        disclaimerVariableInterest: 'Renten på sagen kan ændre sig over tid, hvilket også kan påvirke beløbet på sidste afdrag.',
        savedPaymentMethod: 'Tilknyttet betalingsmetode',
        removePaymentMethod: 'Fjern debitors betalingsmetode',
        areYouSureRemovePaymentMethod: 'Er du sikker på at du vil fjerne debitors betalingsmetode?',
        paymentMethodSection: 'Betalingsmetode',
        noPaymentMethodConnected: 'Ingen betalingsmetode tilknyttet',
        noPaymentMethodHint: 'Tilknyt en betalingsmetode, så afdragene automatisk kan trækkes på forfaldsdato.',
        connectPaymentMethod: 'Tilknyt betalingsmetode',
        connectCardOrBetalingsservice: 'Tilknyt kort eller Betalingsservice',
        noActiveCardOption: 'Der er ingen kort-betalingsmetode tilgængelig.',
        createBSMandate: 'Opret Betalingsservice-aftale',
        bsMandateDescription: 'Opret en Betalingsservice-aftale på vegne af debitor med deres CPR- og kontooplysninger.',
        bsMandateName: 'Navn',
        bsMandateCpr: 'CPR-nummer',
        bsMandateRegNo: 'Reg. nr.',
        bsMandateAccountNo: 'Kontonummer',
        bsMandateSubmit: 'Opret aftale',
        bsMandateCreated: 'Betalingsservice-aftale oprettet. Afventer bekræftelse fra banken.',
        recommendedBadge: 'Anbefalet',
        lastBankDayOfMonthDescription: 'Afdrag på lønningsdag — bedst chance for succesfuld betaling.',
        recalculate: 'Genberegn',
        recalculateDescription: 'Genberegning sletter alle entries som afventer og udregner planen igen.',
        daily: 'Dagligt',
    },
    debtRegistration: {
        registration: 'Gældsregistrering',
        tabGeneral: 'Generelt',
        tabRki: 'RKI',
        tabDebitorRegistret: 'Debitor Registret',
        createNewRegistration: 'Foretag ny indberetning',
        newRegistration: 'Ny gældsregistrering',
        chooseDebtor: 'Vælg debitor',
        amount: 'Beløb',
        withFoundation: 'Med fundament',
        chooseFoundationType: 'Vælg fundamentstype',
        dateFoundation: 'Dato for fundament',
        noFoundationsOnCase: 'Der er ikke noget fundament på sagen. Tilføj et fundament til sagen for at fortsætte.',
        status: 'Status',
        remark: 'Bemærkning',
        deleteReason: 'Sletteårsag',
        foundationCode: {
            [FoundationCode.betalingspåkrav1påtegning]: 'Betalingspåkrav 1. påtegning',
            [FoundationCode.betalingspåkrav2påtegning]: 'Betalingspåkrav 2. påtegning',
            [FoundationCode.stævning]: 'Stævning',
            [FoundationCode.fogedsag]: 'Fogedsag',
            [FoundationCode.dom]: 'Dom',
            [FoundationCode.insolvens]: 'Insolvenserklæring i anden sag',
            [FoundationCode.konkurs]: 'Konkurs',
            [FoundationCode.tvangsakkord]: 'Tvangsakkord, indledt',
            [FoundationCode.fogedretsrekv]: 'Fogedretsrekv',
            [FoundationCode.tvangsauktionudlæg]: 'Tvangsauktion - udlæg',
            [FoundationCode.skylderklæring]: 'Skylderklæring',
            [FoundationCode.forlig]: 'Frivilligt forlig',
        },
        state: {
            [DebtRegistrationState.ACTIVE]: 'AKTIV',
            [DebtRegistrationState.ERROR]: 'FEJLET',
            [DebtRegistrationState.DELETED]: 'SLETTET',
            [DebtRegistrationState.CONCLUDED]: 'AFSLUTTET',
        },
        registry: {
            [RegistryType.OPEN]: 'ÅBEN',
            [RegistryType.CLOSED]: 'LUKKET',
        },
        migrated: 'Migreret',
        latestWarningDate: 'Dato for sidste varsel',
        errors: {
            [DebtRegistrationError.AlreadyRegistered]: 'Debitor er allerede registreret',
            [DebtRegistrationError.MissingWarning]: 'Mangler varselbrev',
            [DebtRegistrationError.WrongCurrency]: 'Valuta er ikke DKK',
            [DebtRegistrationError.WarningLetterWasReturned]: 'Varselbrev blev returneret',
            [DebtRegistrationError.EmailWarningWasNeverDelivered]: 'Varsel (email) blev aldrig leveret',
            [DebtRegistrationError.WarningIsOlderThanOneYear]: 'Varsel er ældre end 1 år gammel',
            [DebtRegistrationError.FoundationCouldNotBeMapped]: 'Fundamentskode kunne ikke identificeres',
            [DebtRegistrationError.FoundationDateCouldNotFound]: 'Fundamentsdato kunne ikke findes',
            [DebtRegistrationError.UnresolvedOpposition]: 'Uafklaret om interaktion er indsigelse',
            [DebtRegistrationError.OppositionFound]: 'Indsigelse',
            [DebtRegistrationError.NoRegistryFound]: 'Opfylder ikke krav for at registrere i hverken åben eller lukket',
            [DebtRegistrationError.FoundationAmountCouldNotBeFound]: 'Beløb på fundament mangler',
            [DebtRegistrationError.FoundationAmountTooSmall]: 'Beløb på fundament er for småt til åbent register',
            [DebtRegistrationError.NameTooLong]: 'Gældsregistrering tillader maksimalt 60 tegn i navnet. Hvis det eksempelvis er en enkeltmandsvirksomhed, kan "v/" fjernes og alt efter "/v".',
            [DebtRegistrationError.OldestRegistrationIsTooOld]: 'Den ældste registrering er for gammel',
            [DebtRegistrationError.FoundationFileMissing]: 'Fundamentsdokumentet mangler en fil (kræves til åben registrering uden advokatindeståelse)',
            [DebtRegistrationError.FoundationMissing]: 'Der er ikke noget fundament på sagen, som kræves til åben registrering',
            [DebtRegistrationError.BalanceTooSmallForOpen]: 'Sagens saldo er for lav til åben registrering',
        },
        infobox: {
            herebyRegister: 'registrerer hermed',
            open: 'Åbne',
            closed: 'Lukkede',
            inThe: 'i det',
            debtorNotPaid: 'gældsregister, da debitor endnu ikke har betalt det forfaldne beløb af DKK',
            criteria: 'Sagen overholder følgende kriterier:',
            min18years: 'Debitor er min. 18 år',
            min3messages: 'Debitor har modtaget minimum 3 beskeder fra kreditor og/eller inddriver vedr. pågældende skyld',
            totalDebt: 'Total gæld inkl. renter og gebyrer min. DKK 1.000',
            hasFoundation: 'Har fundament',
            debtorWarning: 'Debitor er varslet for min. 15 dage siden og maks. 6 måneder siden',
            totalPrincipal: 'Total hovedstol min. DKK 200',
            noDemurral: 'Debitor har ikke gjort indsigelse',
            institutionsInfo: 'Forsikringsselskaber, penge – og realkreditinstitutter må ikke registrere debitorer i gældsregistre uden at sagen er behandlet i civilretten eller fogedretten',
            incoming: 'Interaktioner markeret som indsigelser og uafklaret interaktioner',
            specialCreditors: 'Forsikringsselskaber, penge – og realkreditinstitutter må ikke registrere debitorer i gældsregistre uden at sagen er behandlet i civilretten eller fogedretten',
            closedRegister: 'Lukket register',
            openRegister: 'Åbent register',
            foundationType: 'Registrering med den korrekte fundamentstype',
            registerButton: 'Registrér i gældsregister',
            finePrint: {
                NB: 'OBS: Det kan tage op til 10 minutter at behandle registreringer og ændringer. Udtages registreringen eller ændringen til manuel behandling, kan der gå op til flere hverdage.',
                letter: 'Debitor vil modtage en skrivelse efter at registreringen er publiceret.',
                expiration: 'Registrering i lukkede udløber efter 2 år. Kan forlænges med op til 5 år såfremt der overgår til det åbne register. Registrering i åbne udløber efter 5 år fra fundamentsdato.',
                faultyData: 'Ved fejl med dataen, kontakt venligst supporten.',
                newClient: 'Ved klientoprettelse, kontakt venligst supporten.',
            },
        },
    },
    RKI: {
        registration: 'RKI-registrering',
    },
    debitorRegistret: {
        registration: 'Debitor Registret-registrering',
    },
    financials: {
        debtExpiresWithinThreeMonths: 'Gæld forælder indenfor 3 måneder',
        debtExpired: 'Gæld forældet',
        principal: 'Hovedstol',
        interests: 'Renter',
        costs: 'Omkostninger',
        debt: 'Gæld',
        deposit: 'Indbetalt',
        balance: 'Balance',
        revenue: 'Omsætning',
        revenueBasedDepositOrder: 'Omsætningsmæssig betalingsrækkefølge',
        interestBasedDepositOrder: 'Rentemæssig betalingsrækkefølge',
        details: 'Detaljer',
        invoiceId: 'Fakturannummer',
        reminderFee: 'Rykkergebyr',
        overpayment: 'Overindbetaling',
        repayment: 'Tilbagebetaling',
        responsibleForRepayment: 'Ansavarlig for tilbagebetaling',
        sourceBankAccount: 'Fra bankkonto',
        registrationNumber: 'Registreringsnummer',
        accountNumber: 'Kontonummer',
        repaymentAmount: 'Beløb til tilbagebetaling',
        sendRepaymentRequest: 'Send anmodning om tilbagebetaling',
        currency: 'Valuta',
        moneyScaleSuffixes: {
            thousands: 't',
        },
        moneyCalculator: {
            sum: 'Sum',
            average: 'Gns.',
            count: 'antal',
        },
        imposedByCollector: 'Gæld pålagt af inddriver',
        imposedByCreditor: 'Gæld pålagt af kreditor',
    },
    ultimateCreditors: {
        notes: 'Noter',
        ultimateCreditor: 'Ultimativ kreditor',
        ultimateCreditors: 'Ultimative kreditorer',
        explanation: 'En ultimativ kreditor er den oprindelige kreditor bag kreditoren på sagen — for eksempel når et inkassoselskab sender sager videre på vegne af deres egen kunde. På sager med en ultimativ kreditor bruger kreditor-flettefelterne (navn, adresse og CVR) automatisk den ultimative kreditors oplysninger.',
        name: 'Navn',
        referenceId: 'Referencenummer',
        referenceIdAutoHint: 'Udfyldes automatisk, hvis feltet er tomt',
        registryIdentifier: 'Virksomhedsidentifikation',
        address: 'Adresse',
        newUltimateCreditor: 'Ny ultimativ kreditor',
        editUltimateCreditor: 'Rediger ultimativ kreditor',
        deleteUltimateCreditor: 'Slet ultimativ kreditor',
        confirmDelete: 'Er du sikker på, at du vil slette denne ultimative kreditor?',
        noUltimateCreditors: 'Der er endnu ikke oprettet ultimative kreditorer',
        none: 'Ingen ultimativ kreditor',
        setUltimateCreditor: 'Sæt ultimativ kreditor',
        removeUltimateCreditor: 'Fjern ultimativ kreditor',
        manageUltimateCreditor: 'Ultimativ kreditor',
    },
    sftp: {
        servers: 'SFTP-servere',
        explanation: 'Opret SFTP-servere til udveksling af filer med kreditorer og samarbejdspartnere. Hver server har sine egne brugere, som logger ind med en SSH-nøgle.',
        name: 'Navn',
        creditor: 'Kreditor',
        noCreditor: 'Ingen kreditor',
        created: 'Oprettet',
        newServer: 'Ny SFTP-server',
        createServer: 'Opret SFTP-server',
        deleteServer: 'Slet SFTP-server',
        deleteServerWarning: 'Sletning af SFTP-serveren fjerner alle dens brugere og deres adgang. Dette kan ikke fortrydes.',
        typeNameToConfirm: 'Skriv navnet på SFTP-serveren for at bekræfte',
        noServers: 'Der er endnu ikke oprettet SFTP-servere',
        connection: 'Forbindelse',
        host: 'Host',
        port: 'Port',
        users: 'Brugere',
        connectionExplanation: 'Brugere forbinder med en SFTP-klient til hosten nedenfor og logger ind med deres SSH-nøgle. Der bruges ingen adgangskode.',
        keyType: 'Nøgle',
        login: 'Login',
        deleteServerExplanation: 'Sletter SFTP-serveren og alle dens brugere. Allerede uploadede filer bliver i mappen.',
        newUser: 'Ny bruger',
        createUser: 'Opret bruger',
        username: 'Brugernavn',
        usernameHint: '3-100 tegn: bogstaver, tal, understreg, bindestreg, punktum og @',
        publicKey: 'Offentlig SSH-nøgle',
        publicKeyHint: 'Indsæt den offentlige nøgle, f.eks. "ssh-ed25519 AAAA... kommentar"',
        deleteUser: 'Slet bruger',
        confirmDeleteUser: 'Er du sikker på, at du vil slette denne bruger? Brugeren mister adgang med det samme.',
        noUsers: 'Der er endnu ikke oprettet brugere',
        backToServers: 'Alle SFTP-servere',
    },
    navigation: {
        overview: 'Overblik',
        home: 'Hjem',
        cases: 'Sager',
        views: 'Visninger',
        transactions: 'Transaktioner',
        economy: 'Økonomi',
        economyCaseVouchers: 'Sagsposteringer',
        economyBookkeeping: 'Bogføring',
        economyImposedDebt: 'Pålagt gæld',
        economyDeposits: 'Betalinger',
        economySetup: 'Indstillinger',
        economyBilling: 'Afregning',
        economyPayment: 'Betalinger',
        economyPayouts: 'Udbetalinger',
        economyChartOfAccounts: 'Kontoplan',
        economyIrrecoverableDebt: 'Uerholdelig gæld',
        economyExpiredDebt: 'Forældet gæld',
        communication: 'Kanaler',
        content: 'Indhold',
        economyUnknown: 'Uidentificérbare betalinger',
        bankAccounts: 'Konti',
        export: 'Eksportér',
        transactionLookup: 'Posteringsopslag',
        depositChanges: 'Ændringer',
        reports: 'Rapporter',
        creditors: 'Kreditorer',
        creditorEconomy: 'Økonomi',
        creditorInvoicing: 'Afregning',
        creditorCustomers: 'Kunder',
        creditorCases: 'Sager',
        creditorCollector: 'Inddriver',
        creditorIrrecoverableDebt: 'Uerholdelig gæld',
        creditorExpiredDebt: 'Forældet gæld',
        creditorEconomySetup: 'Opsætning',
        creditorTribunal: 'Domstolsmodul',
        creditorSetup: 'Indstillinger',
        creditorAISettings: 'AI',
        creditorWorkflows: 'Workflows',
        creditorUsers: 'Brugere',
        creditorUltimateCreditors: 'Ultimative kreditorer',
        creditorIntegrations: 'Integrationer',
        journalizer: 'Journalisering',
        interactionHistory: 'Interaktionshistorik',
        returnLetters: 'Returbreve',
        outbox: 'Udbakke',
        outboundCalls: 'Udgående opkald',
        import: 'Import',
        support: 'Hjælp',
        search: 'Søg...',
        settings: 'Indstillinger',
        settingsDesc: 'Indstillinger for kontoen',
        user: 'Min konto',
        userDesc: 'Dine indstillinger',
        homeOverview: 'Overblik',
        settingsGeneral: 'Generelt',
        settingsTemplates: 'Skabeloner',
        settingsDevelopers: 'Udviklere',
        settingsDevelopersDesc: 'Adgang til API m.m.',
        settingsSwitchAccount: 'Skift konto',
        settingsSwitchAccountDesc: 'Skift mellem konti',
        settingsTenantBilling: 'Fakturaer',
        settingsTenantBillingDesc: 'Få overblik over fakturaer',
        settingsProperties: 'Attributter',
        settingsCaseVoucherTables: 'Sagsposteringstabeller',
        settingsDocuments: 'Dokumenter',
        settingsCaseGroups: 'Sagsgrupper',
        settingsEndReasons: 'Afslutningsårsager',
        settingsCaseConfig: 'Sagsopsætning',
        settingsWebhooks: 'Webhooks',
        settingsSftp: 'SFTP',
        settingsEmbed: 'Embeds',
        settingsAPI: 'API',
        settingsCollectors: 'Inddrivere',
        settingsDebtRegister: 'Gældsregistrering',
        settingsIntegrateCalendar: 'Synkronisér opgaver med kalender',
        settingsEconomy: 'Økonomi',
        settingsPriceList: 'Prisliste',
        settingsBookkeeping: 'Bogføring',
        settingsBilling: 'Afregningsopsætning',
        settingsBankAccounts: 'Konti',
        settingsCaseVoucherTypes: 'Sagsposteringstyper',
        settingsBillingVoucherTypes: 'Afregningsposteringstyper',
        settingsUsers: 'Brugere',
        settingsTribunal: 'Domstolsmodul',
        settingsTeams: 'Teams',
        settingsTenant: 'Tenant',
        settingsUpdateTypes: 'Opgavetyper',
        settingsProcedures: 'Genveje',
        settingsWorkflowStages: 'Stadier',
        settingsApplications: 'Regelbaserede posteringer',
        settingsCaseMergeRules: 'Regler for sammenlægning',
        settingsPaymentPlansConfig: 'Opsætning af afdragsordninger',
        settingsJournalizerConfig: 'Journalisering',
        settingsAI: 'AI',
        settingsAIGeneral: 'Generelt',
        settingsAIReplies: 'Svar',
        settingsAICategories: 'Kategorier',
        reportsExorts: 'Filudtræk',
        reportsPaymentPlans: 'Afdragsordninger',
        reportsCourtMeetings: 'Retsmøder',
        reportsDistraints: 'Udlæg',
        reportsGeneralManagement: 'Ledelsesrapportering',
        reportsAI: 'AI',
        reportsPrevious: 'Tidligere rapporter',
        reportsSankey: 'Debbie flow-diagram',
        settingsWorkflows: 'Workflows',
        reportsPaymentDays: 'Betalingsdage-diagram',
        myAccount: 'Min konto',
        integrations: 'Integrationer',
        connect: 'Connect',
    },
    timespanUnits: {
        [TimespanUnit.Years]: 'År',
        [TimespanUnit.Quarters]: 'Kvartaler',
        [TimespanUnit.Months]: 'Måneder',
        [TimespanUnit.Weeks]: 'Uger',
        [TimespanUnit.Days]: 'Dage',
        [TimespanUnit.Hours]: 'Timer',
        [TimespanUnit.Minutes]: 'Minutter',
        [TimespanUnit.Seconds]: 'Sekunder',
        [TimespanUnit.MS]: 'Millisekunder',
    },
    paymentPlansConfig: {
        description: 'Opsæt hvilke muligheder debitor skal have, når de skal oprette en afdragsordning.',
        minEntryAmountPlaceholder: 'Minimumsbeløb per afdrag',
        daysBetweenEntriesPlaceholder: 'Dage i mellem',
        durationPlaceholder: 'Antal måneder',
        addOption: 'Tilføj',
        save: 'Gem',
        override: 'Overskriv opsætning på kreditorniveau',
        disablePaymentPlans: 'Slå afdragsordninger fra så hverken debitorer eller sagsbehandlere kan oprette afdragsordninger.',
        requireCentralRegisterId: 'Kræv CPR/CVR-nummer før underskrift',
        activationDeadlineDays: 'Annullér ikke-aktiverede afdragsordninger efter antal dage',
    },
    referenceIdFinders: {
        referenceIdFinding: 'Referencenummersøgning',
        description: 'Journaliser emails og match indbetalinger baseret på referencenumre som kundenummer eller sagsposteringsreference (fakturanummer eksempelvis).',
        length: 'Antal cifre i referencenummer',
        min: 'Mindste mulige referencenummer',
        max: 'Største mulige referencenummer',
        createNew: 'Opret ny referencenummersøgning',
        add: 'Tilføj',
        caseVoucherReference: 'Sagsposteringsreference',
        caseVoucherReferenceDescription: 'Sagsposteringsreference (eksempelvis fakturanummer)',
        customerReference: 'Kundereference',
        customerReferenceDescription: 'Kundereference (eksempelvis patient-, klient- eller medlemsnummer)',
    },
    caseMergeRules: {
        description: 'Beslut om nye posteringer vedrørende en kunde skal tilføjes til eksisterende sager eller om der skal oprettes en ny sag.',
        preventMerge: 'Undgå sammenlægning af alle sager',
        caseStatusVerified: 'Sammenlæg med godkendte sager',
        adjustVariableCaseVouchers: 'Genberegn eventuelle inkassoomkostninger ved sammenlægning af sager',
        caseStatusPending: 'Sammenlæg med afventende sager',
        hasFoundation: 'Sammenlæg med sager med fundament',
        caseVoucherConstraints: 'Posteringstyper med dubletkontrol',
        caseVoucherConstraintsDescription: 'Vælg hvilke sagsposteringstyper der ikke må optræde på begge sager, hvis de er oprettet inden for det angivne antal dage. Det er de nyeste sagsposteringer som vil blive fjernet.',
        caseVoucherConstraintsAllDays: 'Fjern alle',
        caseVoucherConstraintsDays: 'Dage',
        addCaseVoucherConstraint: 'Tilføj dubletkontrol',
        addCaseVoucherConstraintSelectVoucherType: 'Vælg posteringstype',
        addCaseVoucherConstraintUniqueInDays: 'Unik i antal dage (efterlad tom, hvis alle skal fjernes)',
        addCaseVoucherConstraintAddButton: 'Tilføj',
        doesNotHaveUpdateTypeIds: 'Sammenlæg ikke med sager med en af følgende opgaver',
        doesHaveUpdateTypeIds: 'Sammenlæg kun med sager med en af følgende opgaver',
        hasActivePaymentPlan: 'Sammenlæg med sager med aktiv afdragsordning',
    },
    workflows: {
        workflows: 'Workflows',
        customWorkflows: 'Oprettede workflows',
        standardWorkflow: 'Standardworkflows',
        creditorStandardWorkflowDescription: 'Opsæt hvilket workflow nye sager skal oprettes i. Ændrer du workflowet her, vil det altså ikke ændre allerede oprettede sager.',
        creditorInteraction: 'til kreditor',
        removeVouchers: 'Fjern',
        rollbackTask: 'Rul tilbage',
        rolledback: 'Tilbagerullet',
        runTask: 'Ryk sag til denne opgave',
        sureYouWantToDeleteTask: 'Er du sikker på, at du vil slette opgaven?',
        addRequirement: 'Tilføj krav',
        searchUpdates: 'Søg',
        noUpdatesToShow: 'Ingen opgaver at vise',
        manualSelection: 'Manuelt valg',
        changeWorkflowOnCase: 'Skift workflow',
        nextTaskASAP: 'Næste opgave udføres hurtigst muligt',
        workflowWillStartWhenCaseIsVerified: 'Workflowet går i gang, når sagen er godkendt',
        caseIsPaused: 'Sagen er pauset. Næste opgave udføres, når sagen fortsættes.',
        pausedBecauseOfPaymentPlan: 'Næste opgave udføres, hvis afdragsordningen misligholdes.',
        priority: 'Prioritet',
        priorityDescription: 'Hvis ikke der ikke kan anbefales en vej at gå, vil prioriteten følges. 1 er højeste prioritet.',
        timing: 'Tidshorisont',
        requirements: 'Krav',
        amount: 'Beløb',
        imposedByCreditor: 'Pålagt af kreditor',
        text: 'Tekst',
        addTodo: 'Tilføj handling',
        triggerAgent: {
            promptPlaceholder: "Brugerdefineret prompt til AI-agenten (fx 'Gennemgå denne sag og foreslå næste skridt').",
        },
        selectTemplate: 'Vælg skabelon',
        includeVoucherAttachments: 'Vedhæft posteringsbilag (for eksempel fakturaer).',
        attachFoundations: 'Vedhæft fundament',
        selectEmailPDFAttachment: 'Vælg brevskabelon som skal vedhæftes',
        sendImmediatelyDeviateFromSettings: 'Skal omgående afsendelse afvige fra generelle indstillinger på din konto?',
        sendImmediately: 'Send med det samme',
        doNotSendImmediately: 'Send ikke med det samme',
        endCaseIfThereIsNoPrincipalLeft: 'Afslut sag hvis der ikke er nogen hovedstol tilbage',
        endCaseReason: 'Hvis sagen skal afsluttes, hvilken afslutningsårsag skal der så bruges?',
        selectCollector: 'Vælg inddriver',
        useCreditorCollector: 'Benyt kreditors identitet',
        creditorCollector: 'Kreditors identitet',
        setAsPrincipalReferenceCaseVoucher: 'Sæt som referencepostering af hovedstolen',
        setMaxTotalAmount: 'Sæt maks.beløb',
        maxTotalAmount: 'Maks.beløb',
        selectCaseGroup: 'Vælg sagsgruppe',
        addNewTemplate: 'Tilføj skabelonen',
        addNewTemplateSubheading: 'Opret en ny tom skabelon',
        timespan: 'Tidshorisont',
        timespanUnit: 'Tidsenhed',
        timespanUnitQuantity: 'Antal tidsenheder',
        timeOfDay: 'Tidspunkt på dagen',
        updateIsActive: 'Opgaverne skal være aktive',
        onlySpecificDocumentTypes: 'Kun specifikke typer fundamenter',
        onlyOpenRegistries: 'Kun åbne registreringer',
        noSelectedRegistryNeverFulfilledWarning: 'Ingen registre valgt, dette krav vil aldrig blive opfyldt.',
        noSelectedRegistryAlwaysFulfilledWarning: 'Ingen registre valgt, dette krav vil altid være opfyldt.',
        propertySingleLineTextOneOfFollowingStrings: 'Skal have en af følgende værdier (kommasepareret)',
        propertyDropdownOneOfFollowingValues: 'Er en af følgende værdier',
        moreThan: 'Mere end',
        thresholdAmount: 'Beløb',
        caseGroup: 'Sagsgruppe',
        percentageSplitFrom: 'Procentsplit fra',
        percentageSplitTo: 'Procentsplit til',
        selectedCreditor: 'Kreditor',
        noSelectedCreditorWarning: 'Ingen kreditorer valgt, dette krav vil aldrig blive opfyldt.',
        onlySelectedVoucherCategories: 'Kun udvalgte posteringskategorier',
        noRequirements: 'Ingen krav',
        infoModalHeading: 'Indstillinger for workflow',
        title: 'Titel',
        description: 'Beskrivelse',
        endCaseIfThereIsNoDebt: 'Afslut sag hvis der ikke er nogen gæld',
        endCaseIfThereIsNoDebtDesc: 'Hvis ingen afslutningsårsag er valgt, vil sagen blot fortsætte i workflowet',
        selectEndReason: 'Afslutningsårsag',
        newWorkflow: 'Nyt workflow',
        createNewWorkflow: 'Opret workflow',
        duplicateWorkflow: 'Duplikér workflow',
        deleteWorkflow: 'Slet workflow',
        deleteWorkflowConfirm: 'Er du sikker på, at du vil slette workflowet?',
        endedCasesPercentage: 'sager afsluttet',
        casesInTask: 'sager i status',
        task: 'Opgave',
        remind: 'Påmind',
        remindCase: 'Skal opgaven sættes på sagen som påmindelse?',
        pause: 'Pause',
        pauseCase: 'Skal sagen pauses?',
        pauseUnlimited: 'Kræver manuel fortsættelse',
        remindNow: 'Påmind nu',
        stats: 'Statistik',
        endedCases: 'Afsluttede sager',
        sum: 'Sum',
        totalCases: 'Totalt antal sager som har været i denne opgave',
        currentCases: 'Sager som lige nu er i statussen',
        incomingInteractionsStats: 'Indkommende interaktioner',
        paymentPlansCreatedStats: 'Afdragsordninger oprettet',
        satisfactionStats: 'Omdømme',
        alternativePaths: 'Alternative stier',
        alternativePath: 'Alternativ sti',
        addAlternativePath: 'Tilføj alternativ sti',
        source: 'Fra opgave id',
        mergeCaseTodoDescription: 'Sagen vil blive forsøgt sammenlagt med andre sager på kreditor baseret på sammenlægningsreglerne. Det er også muligt, at sammenlægge sagen med relaterede sager baseret på relationstyper valgt nedenunder.',
        mergeWithRelatedCasesOfType: 'Mulighed for sammenlægning med relaterede sager af type',
        applyCustomMergeRules: 'Tilpas sammenlægningsregler',
        settings: {
            workflowSettings: 'Workflow indstillinger',
            tenantDefaultsDescription: 'Nye sager starter i dette workflow. Kan overstyres pr. sagsgruppe og hos den enkelte kreditor.',
            creditorDefaultsDescription: 'Nye sager hos denne kreditor starter i dette workflow. Tomme valg følger tenantens indstillinger.',
            caseGroupDefaults: 'Undtagelser pr. sagsgruppe',
            caseGroupDefaultsDescription: 'Brug et andet workflow til bestemte sagsgrupper. Det har forrang for standardworkflowet.',
            addCaseGroupDefault: 'Tilføj undtagelse',
            noAvailableCaseGroups: 'Ingen ledige sagsgrupper. Du kan vælge ét workflow pr. sagsgruppe. Opret flere sagsgrupper for at tilføje flere undtagelser.',
            newCaseGroupDefault: 'Ny undtagelse',
            newCasesOnly: 'Ændringer gælder kun nye sager.',
            executionSettings: 'Kørsel af workflows',
            defaultWorkflow: 'Standardworkflow',
            disableWorkflows: 'Slå workflows fra',
            disableWorkflowsWarning: 'Er du sikker på at du vil deaktivere ALLE workflows?',
            workflowsDisabled: 'Workflows er deaktiveret',
            limitExecutionInterval: 'Begræns tidsrummet hvor workflows må køre',
        },
    },
    workflowStages: {
        stage: 'Workflow stadie',
        stages: 'Stadier',
        selectStage: 'Vælg workflow stadie',
        createNewStage: 'Opret nyt workflow stadie',
        customStages: 'Oprettede stadier',
        standardStages: 'Standard stadier',
        addStage: 'Tilføj workflow stadie',
        editStage: 'Redigér workflow stadie',
        title: 'Titel',
        shortLabel: 'Kort label',
        shortLabelPlaceholder: 'Kort label som vises på sagen (fx "Ryk.")',
        save: 'Gem',
        deleteButton: 'Slet workflow stadie',
        deleteWarning: 'Er du sikker på, at du vil slette dette workflow stadie?',
        missingStageWarning: 'Denne opgave har ikke et workflow stadie',
        stageDescription: 'Stadiet bruges til at vise, hvor langt en sag er nået i workflowet.',
    },
    timingTypes: {
        [TimingType.Timespan]: 'Tidsrum',
        [TimingType.TimespanFromDueDate]: 'Tidsrum fra seneste forfaldsdato',
    },
    updatesEditor: {
        update: 'Opgave',
        information: 'Information',
        informationDescription: 'Workflows som opgaven er tilføjet til.',
        standardSettings: 'Generelt',
        standardSettingsDescription: 'Generelle indstillinger for en opgave.',
        label: 'Label',
        save: 'Gem',
        important: 'Vigtig',
        importantPlaceholder: 'Denne opgave er vigtig og skal fremhæves på sagen',
        pausing: 'Pausende',
        pausingPlaceholder: 'Denne opgave skal pause sagen',
        selectable: 'Valgbar',
        selectablePlaceholder: 'Denne opgave kan vælges på en sag',
        procedure: 'Procedure',
        procedureDescription: 'Proceduren som denne opgave skal eksekvere. Hvis slået til, vil proceduren eksekveres, hvis opgaven sættes i et workflow.',
        procedureOn: 'Skal der ske en automatisk handling?',
        procedurePlaceholder: 'Slå automatisk handling til',
        onCaseExit: 'Ved sagsafslutning',
        onCaseExitDescription: 'Afsluttes en sag som har denne status, kan du indstille, at sagen skal pause i en selvvalgt status.',
        onCaseExitContinueUpdates: 'Skal opgaver af denne type automatisk fortsættes når en sag afsluttes?',
        continueOnCaseExit: 'Fortsæt ved sagsafslutning',
        onCaseExitPauseWith: 'Ved sagsafslutning sæt sagen i følgende status',
        selectUpdateType: 'Opgavetype',
        roles: 'Roller',
        rolesDescription: 'Vælg her hvilken rolle som er ansvarlig for at løse opgaven.',
        responsibleRole: 'Ansvarlig rolle',
        hiddenForCreditors: 'Skjult for kreditorer',
        hiddenForCreditorsPlaceholder: 'Skal denne opgave være skjult for kreditorer',
        introduction: 'Introduktion',
        introductionDescription: 'Introduktion til opgaven med tekst og evt. et billede. Det er en fordel, hvis kreditor er ansvarlig, at lave en god introduktion.',
        introductionHeaderImage: 'Hero-billede til introduktionen',
        introductionHeaderImageDropText: 'Træk og slip et billede her',
        deleteButton: 'Slet opgavetype',
        deleteWarning: 'Du sletter både typen, men også alle opgaver af typen. Vil du fortsætte?',
    },
    workflowTodoTypes: {
        [TodoType.AddVoucher]: 'Tilføj sagspostering',
        [TodoType.AddBillingVoucher]: 'Tilføj afregningspostering (honorar)',
        [TodoType.RemoveVoucher]: 'Fjern sagspostering',
        [TodoType.CreateInteraction]: 'Send interaktion',
        [TodoType.CreateCreditorInteraction]: 'Send interaktion til kreditor',
        [TodoType.CreateOtherInteraction]: 'Send interaktion til anden modtager',
        [TodoType.SetCollector]: 'Skift inddriver',
        [TodoType.SetCaseGroup]: 'Skift sagsgruppe',
        [TodoType.MoveToTenant]: 'Overlevér til inddriver fra kreditor',
        [TodoType.ChangeCaseStatus]: 'Skift sagsstatus',
        [TodoType.OutboundCall]: 'Udgående opkald',
        [TodoType.SetCaseTag]: 'Tilføj tag på sag',
        [TodoType.RemoveCaseTag]: 'Fjern tag fra sag',
        [TodoType.DebtRegister]: 'Registrér i gældsregister',
        [TodoType.DebtRegisterSkip]: 'Klar til registrering i gældsregister?',
        [TodoType.SubmitToCourt]: 'Indlever betalingspåkrav',
        [TodoType.ReadyToSubmitToCourt]: 'Klar til indlevering af betalingspåkrav?',
        [TodoType.ConnectToDebtCollector]: 'Overdrag til en connect partner',
        [TodoType.ReturnToConnectSource]: 'Returnér sagen til connect partner',
        [TodoType.SwitchWorkflow]: 'Skift workflow',
        [TodoType.SwitchBackToPreviousWorkflow]: 'Skift tilbage til forrige workflow',
        [TodoType.MergeCase]: 'Sammenlæg sag hvis muligt',
        [TodoType.Bespoke]: 'Tilpasset handling',
        [TodoType.CreateProperties]: 'Opret attributter',
        [TodoType.SetResponsible]: 'Sæt ansvarlig på sag',
        [TodoType.MarkExpired]: 'Marker sagsposteringer som forældede',
        [TodoType.SetCaseSetting]: 'Sæt sagsindstilling',
        [TodoType.TriggerAgent]: 'Kør AI-agent',
    },
    workflowPathWarnings: {
        [PathWarning.ReadyForEboksRequirementRecommended]: 'Kravet "Klar til e-Boks" anbefales',
        [PathWarning.ValidEmailRequirementRecommended]: 'Kravet "Har gyldig email" anbefales',
        [PathWarning.ValidAddressRequirementRecommended]: 'Kravet "Har gyldig adresse" anbefales',
    },
    workflowRequirementTypes: {
        [RequirementType.MissingUpdate]: 'Mangler en af følgende opgavetyper',
        [RequirementType.HasUpdate]: 'Har en af følgende opgavetyper',
        [RequirementType.HasNoValidAddress]: 'Har ugyldig adresse',
        [RequirementType.HasValidCentralRegisterId]: 'Har gyldigt cvr-/cpr-nr.',
        [RequirementType.HasNoValidCentralRegisterId]: 'Har ugyldigt cvr-/cpr-nr.',
        [RequirementType.HasValidAddress]: 'Har gyldig adresse',
        [RequirementType.HasValidEmail]: 'Har gyldig email',
        [RequirementType.HasNoValidEmail]: 'Har ugyldig email',
        [RequirementType.IsCompany]: 'Er en virksomhed',
        [RequirementType.ReadyForEInvoice]: 'Klar til e-faktura',
        [RequirementType.ReadyForEboks]: 'Klar til e-Boks',
        [RequirementType.DebtRemarks]: 'RKI-anmærkninger',
        [RequirementType.HasValidPhone]: 'Har gyldigt telefonnummer',
        [RequirementType.HasNoValidPhone]: 'Har ugyldigt telefonnummer',
        [RequirementType.IsPrivate]: 'Er en privatperson',
        [RequirementType.AmountThreshold]: 'Beløbsgrænse',
        [RequirementType.CaseGroup]: 'Er en af følgende sagsgrupper',
        [RequirementType.PercentageSplit]: 'Procentdel sager',
        [RequirementType.HasFoundation]: 'Har fundament',
        [RequirementType.DoesNotHaveFoundation]: 'Har ikke fundament',
        [RequirementType.SpecificCreditor]: 'Specifik kreditor',
        [RequirementType.CustomerHasTag]: 'Kunde har tag',
        [RequirementType.CaseHasTag]: 'Sag har tag',
        [RequirementType.HasIncomingInteractions]: 'Har indkomne interaktioner',
        [RequirementType.CaseStatusIn]: 'Sagsstatus er en af',
        [RequirementType.Property]: 'Regel baseret på attribut',
        [RequirementType.InDebtRegister]: 'Registreret af os i gældsregister',
        [RequirementType.NotInDebtRegister]: 'Ikke registreret af os i gældsregister',
    },
    embeds: {
        embeds: 'Embed',
        embedTitle: 'Titel',
        embedURL: "URL'en som skal kaldes",
        embedPlacement: 'Placering',
        embedToken: 'Valideringstoken',
        embedCreatedAt: 'Oprettelsesdato',
        embedHeight: 'Højde på området i px',
        addEmbedArea: 'Tilføj embed-område',
        noAreasYet: 'Ingen embed-områder endnu',
        couldNotLoad: 'Kunne ikke indlæses',
        caseworkerNavMenuItemCategory: 'Eksterne',
        creditorNavMenuItemCategory: 'Eksterne',
        calledWithDescription: "URL'en kaldes med en GET-forespørgsel med følgende query-parametre og headers",
        header: 'Header',
    },
    embedPlacements: {
        [EmbedPlacement.CaseworkerWebCreditorPage]: 'Debbie Caseworker Web: Kreditorsiden øverst til højre',
        [EmbedPlacement.CaseworkerWebCasePage]: 'Debbie Caseworker Web: Sagssiden under økonomipanelet',
        [EmbedPlacement.CaseworkerWebMenuItem]: 'Debbie Caseworker Web: Fuld side med link i menuen til venstre',
        [EmbedPlacement.CreditorWebCasePage]: 'Debbie Creditor Web: Sagssiden under økonomipanelet',
        [EmbedPlacement.CreditorWebFrontPage]: 'Debbie Creditor Web: Forsiden i højre side',
        [EmbedPlacement.CreditorWebMenuItem]: 'Debbie Creditor Web: Fuld side med link i menuen til venstre',
    },
    webhookSettings: {
        noWebhooksYet: 'Endnu ingen webhooks',
        hookNotFound: 'Den tilknyttede webhook-konfiguration kunne ikke findes. Kontrollér venligst, at du er på den korrekte tenant.',
        failedToLoad: 'Kunne ikke indlæse webhook-detaljer. Prøv igen senere.',
        webhook: 'Webhook',
        webhooks: 'Webhooks',
        columnEvent: 'Hændelse',
        columnWebhook: 'Webhook',
        columnUrl: 'URL',
        columnDate: 'Dato',
        columnState: 'Status',
        stateAwaiting: 'Afventer',
        statePermanentlyFailed: 'Permanent fejlet',
        stateSucceeded: 'Gennemført',
        namePlaceholder: 'Navn på webhook',
        urlPlaceholder: 'Webhook-URL',
        emailPlaceholder: 'E-mail til fejlnotifikationer',
        requestHeaders: 'Request headers',
        otherSettings: 'Andre indstillinger',
        deepFlatten: 'Fladgør request body for at undgå indlejrede JSON-objekter',
        pullWebhooks: 'Pull webhooks',
        advancedSettings: 'AVANCEREDE INDSTILLINGER',
        addWebhook: 'Tilføj webhook',
        pullWebhook: 'Pull webhook',
        verificationToken: 'Verifikationstoken',
        headerKeyPlaceholder: 'Header-nøgle',
        headerValuePlaceholder: 'Header-værdi',
        addHeader: 'Tilføj header',
        eventDate: 'Hændelsesdato',
        headers: 'Headers',
        body: 'Body',
        bodyMapping: 'Body-mapping',
        resendWebhook: 'Gensend webhook',
        attempts: 'Forsøg',
        nextAttemptAt: 'Næste forsøg:',
        attemptSuccess: 'Gennemført',
        attemptFailed: 'Fejlet',
        copy: 'KOPIÉR',
        columnCreditor: 'Kreditor',
        allCreditors: 'Alle kreditorer',
    },
    userOverrideSettings: {
        label: 'Debitoroverskrivninger',
        description: 'Du kan bruge debitoroverskrivninger til automatisk at ændre oplysninger for kunder, der passer til bestemte kriterier. Når en kunde, der opfylder disse kriterier, bliver opdateret, vil de valgte felter automatisk blive erstattet med de indstillinger, du har lavet.',
        whenMatching: 'Når en debitor matcher',
        overrideFields: 'Overskriv felter',
        deleteEmail: 'Fjern email',
    },
    apiSettings: {
        documentation: 'API-dokumentation',
        keys: 'API-nøgler',
        noKeysYet: 'Der er endnu ikke udstedt nogen API-nøgler',
        newKeyButton: 'Opret API-nøgle',
        newKey: 'Ny API-nøgle',
        newKeyCreatedInfo: 'Det var det! Husk at opbevar din API-nøgle et sikkert sted. Notér nedenstående nøgle - det her er første og sidste gang, du kommer til at kunne få den fra Debbie.',
        closeModal: 'Forstået',
        keyName: 'Navn på din API-nøgle',
        createNewKey: 'Opret API-nøgle',
    },
    updateTypeSettings: {
        label: 'Label',
        responsibleRole: 'Ansvarlig rolle',
        isImportant: 'Vigtig',
        tenantSpecific: 'Tenant-specifik',
        isTenantSpecific: 'Er tenant-specifik',
        referenceType: 'Referencetype',
        onCaseExit: 'Ved sagsluk sæt i status',
        isPausing: 'Pauser sagen',
        hiddenForRoles: 'Skjul for rolle',
        knowledgeBaseLink: 'Knowledge base',
        deadlineTitle: 'Deadline',
        deadlineDescription: 'Antal dage en opgave af denne type må ligge på opgavelisten før den markeres som over deadline. Lad feltet være tomt for ingen deadline.',
        deadlinePlaceholder: 'Fx 7',
        deadlineSave: 'Gem',
    },
    overview: {
        todoList: 'Todo-liste',
        noDescription: 'Ingen beskrivelse',
        noPauseStatus: 'Ingen pause status',
        settlementTime: 'Afviklingstid i måneder',
        instalmentAgreement: 'Afdragsordninger',
        statistics: 'Statistik',
        averageIntro: 'Det tager i gennemsnit',
        averageOutro: 'dage for en sag at blive afviklet.',
        quantityCases: 'Antal sager',
        quantifyCustomers: 'Antal kunder',
        statusDistribution: 'Statusfordeling',
        chartStatuses: {
            Godkendt: 'Godkendt',
            'Afventer Godkendelse': 'Afventer Godkendelse',
            Afsluttet: 'Afsluttet',
            Annuleret: 'Annulleret',
            Afslutningsårsag: 'Afslutningsårsag',
        },
    },
    endReason: {
        [SystemEndReason.ErrorCreditor]: 'Fejl fra kreditors side',
        [SystemEndReason.ErrorUs]: 'Fejloprettelse',
        [SystemEndReason.Expiration]: 'Sagen er forældet',
        [SystemEndReason.Departed]: 'Debitor er udrejst',
        [SystemEndReason.Unidentified]: 'Debitor kan ikke valideres',
        [SystemEndReason.AddressUnknown]: 'Adresse på debitor ukendt',
        [SystemEndReason.Paid]: 'Debitor har betalt hele gælden',
        [SystemEndReason.Transferred]: 'Sagen er overdraget',
        [SystemEndReason.Dead]: 'Debitor er afgået ved døden',
        [SystemEndReason.Objection]: 'Lukket pga. indsigelse',
        [SystemEndReason.Withdrawn]: 'Kreditor har tilbagekaldt sagen',
        [SystemEndReason.OfferFromUs]: 'Betalt efter akkordtilbud fra os',
        [SystemEndReason.OfferFromDebtor]: 'Betalt efter akkordtilbud fra debitor',
        [SystemEndReason.DebtRelief]: 'Debitor har opnået gældssanering',
        [SystemEndReason.Bankruptcy]: 'Debitor er gået konkurs',
        [SystemEndReason.ForcedDissolved]: 'Debitor er tvangsopløst',
        [SystemEndReason.ConflictOfInterest]: 'Interessekonflikt med debitor og os',
        [SystemEndReason.NegativePayoff]: 'Negativ payoff for kreditor',
        [SystemEndReason.Overpayment]: 'Debitor har betalt for meget',
        [SystemEndReason.Minor]: 'Debitor er umyndig',
        [SystemEndReason.Irrecoverable]: 'Sagen er uerholdelig',
        [SystemEndReason.PartiallyPaid]: 'Delvist betalt',
        [SystemEndReason.CreditorUnresponsive]: 'Uden svar fra kreditor',
        [SystemEndReason.Merged]: 'Sagen er lagt sammen med en anden',
        [SystemEndReason.FireAndForget]: 'Fire & forget',
        [SystemEndReason.SmallCaseNotWanted]: 'Småsag ej ønsket',
        [SystemEndReason.NoDebt]: 'Ingen gæld på sagen',
        [SystemEndReason.Deleted]: 'Slettet',
        [SystemEndReason.NoCourt]: 'Sagen er igennem udenretlig forløb',
        [SystemEndReason.Other]: 'Anden årsag',
    },
    endReasonCategory: {
        [EndReasonCategory.Success]: 'Løst',
        [EndReasonCategory.Unresolved]: 'Forgæves',
        [EndReasonCategory.NotPossible]: 'Ej mulig',
        [EndReasonCategory.Error]: 'Afbrudt',
    },
    endReasonCategoryDescription: {
        [EndReasonCategory.Success]: 'Sager hvor vi har inddrevet penge til kreditor – helt eller delvist – via betaling eller akkord. Det er den kategori vi forsøger at maksimere.',
        [EndReasonCategory.Unresolved]: 'Reelle sager som ikke blev løst, men hvor det heller ikke var en ydre umulighed: gælden forældede, blev erklæret uerholdelig, eller sagen blev henlagt fordi den ikke kunne svare sig at føre videre.',
        [EndReasonCategory.NotPossible]: 'Sager hvor inddrivelse blev umulig pga. ydre omstændigheder ved debitor – fx konkurs, dødsfald, gældssanering eller ukendt adresse. Tæller med i statistikken, men kan ikke betragtes som vores fejl.',
        [EndReasonCategory.Error]: 'Sager der trækkes ud af statistikken (også ud af netto-løsningsgraden), fordi de aldrig burde have ligget hos os: fejloprettelse, duplikater (sammenlagt), kreditor har tilbagekaldt, eller debitor er umyndig.',
    },
    resolutionRate: {
        title: 'Løsningsgrad',
        description: 'Andelen af sager der er afsluttet som løst, samt hvor hurtigt de er blevet løst.',
        headerEnded: 'Afsluttede sager',
        headerSuccess: 'Løste sager',
        headerNotPossible: 'Ej mulige',
        headerUnresolved: 'Ikke løst',
        headerError: 'Fejl (ekskl. statistik)',
        headerPending: 'Igangværende',
        headerVerified: 'Verificeret',
        grossRate: 'Brutto-løsningsgrad',
        grossRateInfo: 'Andelen af alle afsluttede sager der er løst (betalt, delvist betalt eller akkord).',
        netRate: 'Netto-løsningsgrad',
        netRateInfo: 'Andelen af løste sager ud af alle afsluttede sager — eksklusive sager der er trukket ud af statistikken som fejl (fejloprettelse, tilbagekaldt, sammenlagt, m.v.).',
        grossMoneyRate: 'Brutto-løsningsgrad',
        grossMoneyRateInfo: 'Indbetalte kroner i forhold til den samlede hovedstol på alle afsluttede sager i perioden.',
        collectedAmount: 'Inddrevet',
        totalPrincipalEnded: 'Hovedstol afsluttet',
        avgDaysToResolution: 'Gns. tid til løsning',
        avgDaysToResolutionInfo: 'Gennemsnitlig antal dage fra oprettelsen af sagen til den er afsluttet som løst.',
        medianDaysToResolution: 'Median tid til løsning',
        speedHeader: 'Løsningstid',
        speedInfo: 'Hvor stor en andel af de løste sager der er løst inden for hver tidsramme. Akkumuleret andel.',
        speedWithinDays: 'Inden for {days} dage',
        byMonthHeader: 'Afsluttede sager per måned',
        byEndReasonHeader: 'Fordeling på afslutningsårsag',
        legendHeader: 'Forklaring af kategorier',
        legendIntro: 'Hver afslutningsårsag hører hjemme i én af fire kategorier. Kategorien afgør om sagen tæller som løst, ikke løst eller trækkes ud af statistikken.',
        columnEndReason: 'Afslutningsårsag',
        columnCategory: 'Kategori',
        columnCount: 'Antal',
        columnPrincipal: 'Hovedstol',
        columnCollected: 'Inddrevet',
        daysSuffix: 'dage',
        explainCategories: 'Forklaring af løsningskategorier',
        excludingErrors: (count) => `${count} ekskl. fejl`,
        percentOfAll: (percent) => `${percent} af alle`,
        medianPrefix: 'Median',
    },
    courtSubmitErrors: {
        [SubmitToCourtError.IsNotWarned]: 'Sagen er ikke varslet',
        [SubmitToCourtError.CurrencyNotDKK]: 'Valutaen er ikke DKK',
        [SubmitToCourtError.WarningWasReturned]: 'Varslet er ikke leveret',
        [SubmitToCourtError.AlreadyHasFoundation]: 'Der er allerede et fundament registreret på sagen',
        [SubmitToCourtError.MoreThanOneDebtor]: 'Der er mere end en debitor på sagen, og derfor kan sagen ikke indleveres automatisk',
        [SubmitToCourtError.HasAlternativeContact]: 'Sagen har en repræsentant registreret, og derfor kan sagen ikke indleveres automatisk',
        [SubmitToCourtError.EconomyContactMissing]: 'Der mangler en ansvarlig for håndtering af udbetalingsrekvisition',
        [SubmitToCourtError.CreditorNameMissing]: 'Kreditors navn mangler',
        [SubmitToCourtError.CreditorAddressMissing]: 'Kreditor har ingen adresse',
        [SubmitToCourtError.CompanyFullResponsibleParticipantMissing]: 'Fuldt ansvarlig deltager kunne ikke findes',
        [SubmitToCourtError.CompanyDirectorNameMissing]: 'Direktørens navn kunne ikke findes',
        [SubmitToCourtError.CompanyDirectorAddressMissing]: 'Direktørens adresse kunne ikke findes',
        [SubmitToCourtError.JurisdictionMissing]: 'Kunne ikke finde værneting',
        [SubmitToCourtError.EconomicalSubmitThreshold]: 'Sagens udestående er under kreditors grænseværdi for indlevering af betalingspåkrav',
        [SubmitToCourtError.SagsfremstillingMissing]: 'Mangler sagsfremstilling på kreditorniveau',
        [SubmitToCourtError.CaseHasExceededMaxDebtRegistrationsThreshold]: 'Antal RKI-registreringer på sagen overstiger kreditors grænseværdi for indlevering af betalingspåkrav',
        [SubmitToCourtError.AlreadyInCourt]: 'Allerede indleveret til foged- eller civilretten',
        [SubmitToCourtError.AddressNotInDK]: 'Debitors adresse er ikke dansk',
        [SubmitToCourtError.DebtorMovedAbroad]: 'Debitor er udrejst',
        [SubmitToCourtError.CaseHasDeposits]: 'Sagen har indbetalinger og er derfor udtaget til manuel behandling',
        [SubmitToCourtError.DebtorBankrupt]: 'Debitors virksomhed er inaktiv',
        [SubmitToCourtError.DebtorCompanyCeased]: 'Debitor er ophørt',
        [SubmitToCourtError.DebtorDead]: 'Debitor er død',
        [SubmitToCourtError.DebtorHomeless]: 'Debitor er hjemløs',
        [SubmitToCourtError.ExcessiveReminderFeeImposed]: 'Der er pålagt for mange rykkergebyrer',
        [SubmitToCourtError.ExcessiveCollectionFeeImposed]: 'Der er pålagt for meget i inkassogebyr',
        [SubmitToCourtError.ExcessiveCollectionCostImposed]: 'Inkassoomkostningerne afviger fra det beregnede beløb',
        [SubmitToCourtError.ExcessivePrincipal]: 'Hovedstolen overstiger beløbsgrænsen på DKK 100.000,00',
        [SubmitToCourtError.IsNotDebtor]: 'Sagens kontaktperson er en repræsentant',
    },
    templateTags: {
        [TemplateTag.BPKWarning]: 'Betalingspåkravsvarsel',
        [TemplateTag.DebtRegistrationWarning]: 'RKI varsel',
    },
    templates: {
        allTemplates: 'Alle skabeloner',
        searchTemplates: 'Søg skabeloner',
        customTemplates: 'Oprettede skabeloner',
        standardTemplates: 'Standardskabeloner',
        confirmDelete: 'Er du sikker på at du vil slette denne skabelon?',
        delete: 'Slet',
        updateTypesUsingThisTemplate: 'Opgavetyper som bruger denne skabelon',
        newTemplate: 'Ny skabelon',
        selectType: 'Vælg type',
        letter: 'Brev',
        name: 'Navn',
        create: 'Opret',
        quantityTemplates: 'Antal skabeloner',
        singleOwner: 'Vælg en enkelt ejer',
        standard: 'Standard',
        alternativeContact: 'Repræsentant',
        saveDraft: 'Gem udkast',
        saveAndPublish: 'Gem og publicér',
        preview: 'Forhåndsvisning',
        versions: 'Versioner',
        publish: 'Publicér',
        copy: 'Kopier skabelon',
        copyOtherTemplate: 'Kopier eksisterende skabelon',
        settings: 'Indstillinger',
        lastChangedOn: 'Sidst ændret',
        by: 'af',
        WIP: 'Igangværende arbejde',
        versionPublished: 'Denne version er udgivet',
        selectTestCase: 'Vælg test-sag',
        collector: 'Inddriver',
        ifCollectorSelected: 'Hvis dette er valgt vises denne skabelon kun med sager hvor valgte inddriver er tilknyttet',
        selectCollector: 'Vælg inddriver',
        creditor: 'Kreditor',
        ifCreditorSelected: 'Hvis dette er valgt, vises denne skabelon kun med sager, hvor valgte kreditor er tilknyttet.',
        selectCreditor: 'Vælg kreditor',
        letterTheme: 'Brevets tema',
        ifThemeSelected: 'Brevets tema definerer designet af skabelonen.',
        selectTheme: 'Vælg skabelontema',
        fileName: 'Filnavn',
        docxTemplate: 'Word-skabelon (.docx)',
        docxTemplateDescription: 'Upload et Word-dokument, som dokumentet skal genereres ud fra. Indsæt {~~body} der hvor indholdet fra editoren skal flettes ind. Andre felter (f.eks. {debtor.name}) udfyldes ud fra sagens data.',
        uploadDocxTemplate: 'Upload .docx',
        removeDocxTemplate: 'Fjern .docx-skabelon',
        docxTemplateUploaded: 'Word-skabelon uploadet',
        docxTemplateUploadFailed: 'Kunne ikke uploade Word-skabelon',
        docxAvailableTags: 'Tilgængelige skabelonfelter',
        docxAvailableTagsDescription: 'Klik på et felt for at kopiere det. Indsæt det i Word-skabelonen der hvor værdien skal vises.',
        docxTag: 'Felt',
        docxBodyTagDescription: 'Indsæt indholdet fra editoren i Word-dokumentet.',
        docxConditionalBadge: 'Betinget',
        docxConditionalIfTrue: 'Hvis sand',
        docxConditionalIfFalse: 'Hvis falsk',
        docxConditionalDescription: 'Brug den første blok til at vise indhold når feltet er sandt og den anden blok når det er falsk. Kopiér kun den blok du har brug for — du kan bruge begge sammen hvis du vil have forskelligt indhold i begge tilfælde.',
        docxHtmlDescription: 'Værdien indeholder HTML og indsættes som formateret tekst (linjeskift, fed osv. bevares).',
        state: 'Tilstand',
        type: 'Type',
        savedAt: 'Gemt',
        firstName: 'Fornavn',
        lastName: 'Efternavn',
        view: 'Se',
        confirmDeleteItem: 'Er du sikker på at du vil slette denne entitet?',
        confirmPublish: 'Ændringerne er ikke gemt. Du er ved at udgive den senest gemte version of denne skabelon. Er du sikker?',
        validations: {
            missing: 'Mangler',
            invalidOrder: 'Ugyldig rækkefølge',
            inSubject: 'i emne',
            inBody: 'i brødtekst',
        },
        addTag: 'Tilføj tag',
        selectTag: 'Vælg tag',
    },
    templateTypes: {
        [TemplateType.AUTOCALL]: 'Autokald',
        [TemplateType.EBOKS]: 'e-Boks',
        [TemplateType.KIVRA]: 'Kivra',
        [TemplateType.DIGIPOST]: 'Digipost',
        [TemplateType.EMAIL]: 'E-mail',
        [TemplateType.LETTER]: 'Brev',
        [TemplateType.SMS]: 'SMS',
        [TemplateType.CREDITOR_MESSAGE]: 'Kreditorbesked',
        [TemplateType.DEBTOR_MESSAGE]: 'Debitorbesked',
        [TemplateType.NOTE]: 'Note på sag',
    },
    integrations: {
        chooseCreditor: 'Vælg kreditor for integrationer',
        active: 'Aktiv',
        activeIntegrations: 'Aktive integrationer',
        available: 'Integrationer tilgængelige for kreditor',
        unavailable: 'Integrationer utilgængelige for kreditor',
        isAvailable: 'Giv kreditor adgang til selv at administrere integrationen',
        connect: 'Forbind',
        deactivate: 'Sæt på pause',
        reactivate: 'Genaktiver',
        integrationOptions: 'integrationsmuligheder',
        importAllText: 'Importer fakturaer før forfald',
        updateCustomers: 'Opdater kundedata når det ændres i e-conomic',
        cutoffDateText: 'Cutoff dato (Importer kun fakturaer efter denne dato, hvis ikke sat, bliver alle importeret)',
        runsOut: '',
        turnsDue: '',
        invoiceDate: 'Antal dage efter fakturadato posteringerne skal overføres',
        dueDate: 'Antal dage efter forfaldsdato posteringerne skal overføres',
        notChangable: 'Mulighederne kan ikke ændres senere',
        all: 'Alle',
        recommended: 'Anbefalede',
        essential: 'Vigtige',
        additionalCustomers: 'yderligere kunder',
    },
    eConomicTypeName: {
        creditNote: 'Kredit nota',
        invoice: 'Faktura',
        payment: 'Betaling',
        reminder: 'Påmindelse',
    },
    integrationMapper: {
        voucherNumber: 'Voucher nummer',
        invoiceNumber: 'Fakturanummer',
        amountLeftToMap: 'Beløb tilbage at kortlægge',
        totalAmount: 'Posteringsbeløb',
        noMoreEntries: 'Der er ikke flere poster til kortlægning',
        selectEntries: 'Vælg en postering for at starte kortlægning',
        customerId: 'Kunde id',
        map: 'Kortlæg beløb',
        notAvailable: 'E-conomic mapping er ikke tilgængeligt, kontakt Debbie support for hjælp med mapping',
        selectedEntryLabel: 'Valgte postering',
        potentialMatches: 'Potentielle matches',
    },
    createdBy: {
        createdBy: 'Oprettet af',
        goToImport: 'Gå til import',
    },
    createdByType: {
        [PerformedByType.Connect]: 'connect',
        [PerformedByType.Import]: 'import',
        [PerformedByType.Integration]: 'integration',
        [PerformedByType.Key]: 'API nøgle',
        [PerformedByType.User]: 'bruger',
        [PerformedByType.Workflow]: 'workflow',
        [PerformedByType.Trigger]: 'trigger',
        [PerformedByType.VoucherApplication]: 'regelbaserede posteringer',
        [PerformedByType.BulkAction]: 'massehandling',
        [PerformedByType.UpdateTypeOnCaseEnd]: 'opgavetype ifm. sagsafslutning',
        [PerformedByType.InteractionCategory]: 'interaktionskategori',
        [PerformedByType.AI]: 'AI',
        [PerformedByType.PaymentPlan]: 'afdragsordning',
        [PerformedByType.System]: 'system',
    },
    createdByTypeLabel: {
        [PerformedByType.PaymentPlan]: 'ao',
    },
    journalizer: {
        update: 'Opdatér',
        deleteInteraction: 'Slet interaktion',
        unknownEntityInteraction: 'Anmod om j.nr.',
        recentlyJournalized: 'NYLIGT JOURNALISERET',
        unmap: 'FJERN TILKNYTNING',
        suggested: 'FORESLÅET',
        noInteractions: 'Der er i øjeblikket ingen interaktioner',
        searchCreditors: 'Søg efter kreditorer...',
        journalizeOnCase: 'Journaliser på sag',
        journalizeOnCreditor: 'Journaliser på kreditor',
    },
    returnLetter: {
        unknownAtAddress: 'Ubekendt på adressen',
        addressNotAdequate: 'Adressen er utilstrækkelig/upræcis',
        nameNotVisible: 'Modtagerens navn står ikke på postkassen',
        recipientMoved: 'Modtageren er flyttet, og den nye adresse er ukendt, eller flytteservice er udløbet',
        recipientNoExist: 'Modtageren findes ikke',
        letterCantBeDelivered: 'Forsendelsen kan ikke afleveres',
        cantFindStreet: 'Gadenavn/husnummer findes ikke',
        mailboxIssue: 'Postkassen er fyldt/mangler/er i stykker',
        emptyPlace: 'Boligen er ubeboet/tomt hus/lejlighed',
        noHouseOrConstruction: 'Der er intet hus, eller det er et byggeri under opførelse',
        otherIssues: 'Der er ikke ryddet sne, en bidsk hund eller andet, der forhindrer adgang',
        deliveryRejected: 'Modtagelse nægtet',
        recipientRejectsLetter: 'Modtageren nægter at tage imod forsendelsen',
    },
    returnLetterReasons: {
        [ReturnReason.DENIED]: 'Modtagelse nægtet',
        [ReturnReason.NOTDELIVERABLE]: 'Kan ikke afleveres ',
        [ReturnReason.UNKNOWNRECIPIENT]: 'Ubekendt på adressen',
    },
    outbox: {
        verifyInteraction: 'Afsend',
        editTemplate: 'Redigér skabelon',
        deleteInteraction: 'Slet interaktion',
        rollbackChain: 'Tilbagerul',
        goToCase: 'Gå til sag',
        envelope: 'Kuvert',
        nextLetterSending: 'Næste brevafsending er planlagt til',
        filters: 'Filtre',
        includeInteractionsPaused: 'Inkludér interaktioner fra pausede sager',
        aiFilterHeader: 'AI',
        aiFilterAll: 'Alle',
        aiFilterAi: 'AI',
        aiFilterNoAi: 'Uden AI',
        filterOnInteractionType: 'Filtrér på typer af interaktioner',
        filterOnCreditor: 'Filtrér på kreditor',
        filterOnTemplate: 'Filtrér på skabelon',
        autoSendModalHeader: 'Opsæt automatisk afsendelse',
        autoSendDescription: 'Angiv hvor mange manuelle afsendelser der skal foretages fra udbakken af hver skabelonversion, før beskeder bliver afsendt automatisk. Hvis du sætter værdien til 0, bliver alle beskeder sendt automatisk uden behov for godkendelse. Dette giver fleksibilitet til både fuld automatisering og manuel kontrol – afhængigt af dine behov.',
        configureAutoSend: 'Opsæt automatisk afsendelse',
        autoSendOn: 'Når {{autoSendQuantity}} beskeder af denne skabelonversion er afsendt, vil alle fremtidige automatisk blive afsendt.',
    },
    inputs: {
        creditorSelect: 'Vælg kreditor',
        from: 'Fra',
        to: 'Til',
        max: 'Maks.',
        min: 'Min.',
        phoneNumber: 'Telefonnummer',
        phoneLocale: 'Landekode',
        searchForCompany: 'Søg efter virksomhed',
        search: 'Søg',
        noResults: 'Ingen resultater',
        recentlyUsed: 'Senest brugte',
        clear: 'Ryd',
        searchAddress: 'Søg efter adresse',
        manual: 'Manuel',
        address: 'Adresse',
        noAddress: 'Indtast adresse',
        co: 'C/O',
        zipcode: 'Postnummer',
        city: 'By',
        country: 'Land',
        done: 'Færdig',
        removeAddress: 'Fjern adresse',
        remove: 'Slet',
        save: 'Gem',
        saved: 'Gemt',
        dropToUpload: 'Slip fil for at uploade',
        uploadFailed: 'Upload fejlede',
        overrideDefault: 'Overskriv standardindstilling',
        overrideTenantSetting: 'Overskriv tenant-indstilling',
    },
    paymentOptions: {
        addNew: 'Tilføj ny betalingsmulighed',
        currencies: 'Valutaer',
        bankName: 'Bankens navn',
        registrationNumber: 'Registreringsnummer',
        accountNumber: 'Kontonummer',
        fi: 'FIK-kreditornummer',
        fikSyntax: 'Brug hovedstolsposteringens referencenummer som id i stedet for sagsnummer',
        useAlternativeCreditorNumberInCaseVoucherTables: 'Brug alternativt kreditornummer i sagsposteringstabeller',
        iban: 'IBAN kreditornummer',
        swift: 'SWIFT kreditornummer',
        reepayPrivateKey: 'Frisbii privat API-nøgle',
        farpayPrivateKey: 'Farpay privat API-nøgle',
        dankort: 'Dankort',
        visa: 'Visa',
        mastercard: 'Mastercard',
        currencySpecific: 'Kun til udvalgte valutaer',
        mobilepay: 'MobilePay',
        swish: 'Swish',
        vipps: 'Vipps',
        betalingsservice: 'Betalingsservice',
        leverandorservice: 'Leverandørservice',
        isActive: 'Aktiv betalingsgateway',
        confirmChangeOfPaymentGateway: 'Er du sikker på at du vil ændre din betalingsgateway?',
        mobilePeopleHmac: 'MobilePeople HMAC nøgle',
        mobilePeopleClientRef: 'MobilePeople klient reference',
        url: 'Link til betalingsgateway',
        titleToDebtor: 'Debitorweb titel',
        descriptionToDebtor: 'Debitorweb beskrivelse',
        hideOnDebtorweb: 'Skjul på debitorweb',
    },
    paymentOptionTypes: {
        [PaymentOptionType.BANKTRANSFER]: 'Bankoverførsel',
        [PaymentOptionType.FI]: 'FIK-linje',
        [PaymentOptionType.SWIFT]: 'SWIFT',
        [PaymentOptionType.REEPAY]: 'Frisbii Betalingsgateway',
        [PaymentOptionType.FARPAY]: 'Farpay Betalingsgateway',
        [PaymentOptionType.MOBILE_PEOPLE]: 'MobilePeople betalingsgateway',
        [PaymentOptionType.LINK_TO_OWN_PAYMENT]: 'Link til egen betalingsgateway',
    },
    todoPanel: {
        searchTodos: 'Søg',
        overdueTooltip: (count) => `${count} ${count === 1 ? 'opgave er' : 'opgaver er'} over deadline`,
    },
    support: {
        imgsrc: 'https://storage.googleapis.com/debbie-public-files/help-ad-da.svg',
        readMore: 'Læs mere',
    },
    sites: {
        caseworkerWeb: 'Caseworkerweb',
        clientWeb: 'Kreditorweb',
        detiorWeb: 'Debitorweb',
    },
    home: {
        welcome: 'Velkommen',
        todos: 'Opgaver',
        caseworkerTodo: 'Opgaver til sagsbehandlere',
        todoPlaceholder: 'Ingen opgaver at vise',
        clientTodo: 'Opgaver til kreditorer',
        clientTodoPlaceholder: 'Intet at vise',
        noResponsibleTodo: 'Opgaver uden ansvarlig',
        noResponsibleTodoPlaceholder: 'Intet at vise',
        pendingCases: 'Nye sager',
        pendingCasesPlaceholder: 'Ingen nye sager',
        pendingDunningCases: 'Nye dunning-sager',
        pendingDunningCasesPlaceholder: 'Nye nye dunning-sager',
        topCases: 'Top 150 sager med størst gæld',
        topCasesPlaceholder: 'Ingen sager at vise',
        unassigned: 'Ikke tildelt',
        today: 'I dag',
        yesterday: 'I går',
        thisMonth: 'Denne måned',
        lastMonth: 'Sidste måned',
        deposits: 'Indbetalinger',
        depositsSmall: 'indbetalinger',
        depositsToClient: 'Indbetalinger til kreditor',
        depositsToCollector: 'Indbetalinger til inddriver',
        depositCount: 'Antal indbetalinger',
        paymentPlans: 'Afdragsordninger',
        totalPlans: 'Afdragsordninger i alt',
        totalActivePlans: 'Aktive afdragsordninger',
        totalSettledAmount: 'Indbetalt i alt',
        settledAmountLastMonth: 'Indbetalt sidste måned',
        settledAmountThisMonth: 'Indbetalt denne måned',
        plannedAmountNextMonth: 'Forventet næste måned',
        cases: 'Sager',
        interactions: 'Interaktioner',
        foundations: 'Fundamenter',
        totalFoundations: 'Fundamenter i alt',
    },
    autoCall: {
        called: 'Til',
        from: 'Fra',
        with: 'med',
        withVoice: 's stemme',
        call: 'Ring',
        addAction: 'Tilføj handling',
        selectAction: 'Vælg handling',
    },
    autoCallEvents: {
        started: 'Startet',
        ringing: 'Ringer op',
        answered: 'Besvaret',
        completed: 'Afsluttet',
        inbound: 'Indgående',
        busy: 'Optaget',
        timeout: 'Ikke besvaret',
        rejected: 'Afvist',
        machine: 'Telefonsvarer',
    },
    interactionTypes: {
        [InteractionType.AutoCall]: 'Autokald',
        [InteractionType.ClientNote]: 'Kreditorbesked',
        [InteractionType.DebtorNote]: 'Debitorbesked',
        [InteractionType.Eboks]: 'e-Boks',
        [InteractionType.Kivra]: 'Kivra',
        [InteractionType.Digipost]: 'Digipost',
        [InteractionType.Email]: 'Email',
        [InteractionType.Letter]: 'Brev',
        [InteractionType.Note]: 'Note',
        [InteractionType.Other]: 'Andre',
        [InteractionType.Personal]: 'Personlig henvendelse',
        [InteractionType.Phone]: 'Opkald',
        [InteractionType.SMS]: 'SMS',
        [InteractionType.EInvoice]: 'E-faktura',
    },
    interactions: {
        interaction: 'interaktion',
        replyPrefix: 'Sv:',
        metadata: 'Metadata',
        removingPhoneNumberOnSubmit: 'Ved registrering af opkald fjernes nummeret fra debitor',
        events: 'Handlinger',
        send: 'Send',
        sendLetter: 'Send brev',
        addTemplate: 'Tilføj fra skabelon',
        sendEBoks: 'Send besked',
        from: 'Fra',
        to: 'Til',
        subject: 'Emne',
        sent: 'Sendt',
        selectTemplate: 'Vælg skabelon',
        contact: 'Kontaktperson',
        preview: 'Forhåndsvisning',
        mention: 'Flettefelt',
        explanation: 'Forklaring',
        example: 'Eksempel',
        message: 'Besked',
        addDebtorDocuments: 'Tilføj debitordokumenter',
        addIntent: 'Tilføj hensigt',
        sendEmail: 'Send email',
        reply: 'Svar',
        replyingTo: 'Svarer på',
        thread: 'Se tråd',
        emailThread: 'Email tråd',
        note: 'Note',
        addNote: 'Tilføj note',
        sendNoteToDebtor: 'Send besked til debitor',
        sendNoteToClient: 'Send besked til kreditor',
        recipients: 'Modtagere',
        addRecipient: 'Tilføj modtager',
        removeRecipient: 'Fjern modtager',
        noClientUsersOnCreditor: 'Der er ingen kreditorbrugere på denne kreditor. Inviter en bruger, så vedkommende kan få besked via e-mail.',
        noRecipientsSelected: 'Ingen får besked via e-mail',
        inviteClientUser: 'Inviter kreditorbruger',
        selectRecipient: 'Vælg modtager',
        selectMinimumOneTag: 'Vælg minimum ét tag',
        addFiles: 'Tilføj filer',
        remindingDescription: 'Påmidelse',
        remindingDate: 'Påmindelsesdato',
        setReminder: 'Sæt påmindelse',
        download: 'Hent PDF',
        downloadDocx: 'Hent Word',
        phoneNumber: 'Telefonnummer',
        phoneNotes: 'Note',
        registerPhoneCall: 'Registrér opkald',
        sendSMS: 'Send SMS',
        smsMultipleDeliveriesWarning: 'Flere leveringshændelser indikerer en lang SMS, der er blevet opdelt i dele.',
        unlikelyToReceive: 'Tidligere interaktioner gennem denne kanal fejlede',
        removeMarking: 'Fjern markering',
        attachment: 'vedhæftet fil',
        other: 'Anden',
        debtorInteraction: 'Besked',
        messageFromCreditor: 'Besked fra kreditor',
        messageToCreditor: 'Besked til kreditor',
        messageFromDebtor: 'Besked fra debitor',
        messageToDebtor: 'Besked til debitor',
        messageFromCollector: 'Besked fra inddriver',
        messageToCollector: 'Besked til inddriver',
        newInteractions: 'Nye interaktioner',
        courtEmailSubject: 'Sag hos {{collector.name}}: {{tribunal.latestReferenceId}} [j.nr.: {{journalNumber}}]',
        emailSubjectMessageFrom: 'Besked fra',
        areYouSureProcedure: 'Er du sikker på at du vil udføre denne genvej?',
        procedures: 'Genveje',
        reminder: 'Påmindelse',
        OUTGOING: 'Udgående',
        INCOMING: 'Indgående',
        UNMAPPED: 'Ujournaliseret',
        MAPPED: 'Journaliseret',
        HANDLED: 'Behandlet',
        DELETED: 'Slettet',
        PENDING: 'Afventer',
        CANCELLED: 'Annulleret',
        SENT: 'Afsendt',
        QUEUED: 'I kø',
        delete: 'Slet',
        verify: 'Afsend',
        transacted: 'Afsendt',
        journalizedAt: 'Journaliseret den',
        at: 'Tidspunkt',
        journaled: 'Interaktionen blev journaliseret',
        unjournaled: 'Interaktionen blev afjournaliseret',
        journaledBy: 'Journaliseret af',
        unjournaledBy: 'Afjournaliseret af',
        onCase: 'På sag',
        copiedBy: 'Kopieret af',
        toCase: 'Til sag',
        fromCase: 'Fra sag',
        rollback: 'Tilbagerul',
        unmap: 'Afjournalisér',
        editTemplate: 'Redigér skabelon',
        envelope: 'Kuvert',
        readMore: 'Læs mere',
        readLess: 'Læs mindre',
        downloadFailed: 'Download fejlede',
        downloadSuccessful: 'Forhåndsvisning af PDF er downloadet',
        opposition: 'Indsigelse',
        notOpposition: 'Ikke-indsigelse',
        optionalNote: 'Eventuel note',
        visibilityCheckText: 'Synlig for kreditor',
        hideFromClient: 'Skjul for kreditor',
        hiddenFromClient: 'Skjult for kreditor',
        showToClient: 'Vis til kreditor',
        printPDF: 'Hent PDF',
        seeDocument: 'Se dokument',
        clone: 'Kopier til anden sag',
        cloned: 'Interaktion kopieret',
        generateReply: 'Generer AI-svar',
        generatingReply: 'Genererer svar...',
        aiGenerated: 'AI-genereret',
        replyGenerated: 'Svar genereret og tilføjet til udbakke',
        replyBlocked: 'Svar blokeret til manuel gennemgang',
        deliveredAt: 'Leveringstidspunkt',
        failedAt: 'Fejltidspunkt',
        eBoksMessageId: 'e-Boks besked-id',
        reason: 'Årsag',
        recipientDomain: 'Modtagerdomæne',
        recipient: 'Modtager',
        recipientIpAddress: 'Modtagers IP-adresse',
        deliveryMethod: 'Leveringsmetode',
        routingDomain: 'Routing domain',
        openedAt: 'Åbningstidspunkt',
        emailOpenedWarning: 'Bemærk: Email åbningsstatistik kan være upræcis. Falske positiver kan opstå hvis email-klienten automatisk indlæser billeder. Falske negativer kan opstå hvis modtageren har deaktiveret billeder i deres email-klient.',
        emailDelayed: 'Email kunne ikke leveres - prøver igen senere',
        delayedAt: 'Forsinkelsestidspunkt',
        delayReason: 'Forsinkelsesårsag',
        bounceCode: 'Bounce code',
        errorCode: 'Fejlkode',
        complainedAt: 'Klagetidspunkt',
        complaintType: 'Klagetype',
        letterReturned: 'Brev returneret',
        operator: 'Operatør',
        clickedLink: 'Klikket link',
        referer: 'Referer',
        userAgent: 'Brugeragent',
        duration: 'Varighed',
        network: 'Netværk',
        subState: 'Undertilstand',
        digits: 'Indtastet tal',
        timedOut: 'Udløbet',
        timedOutDescription: 'Brugeren afsluttede ikke med firkant.',
        actions: 'Handlinger',
        template: 'Skabelon',
        eInvoiceEvents: {
            created: 'Oprettet',
            transmissionStarted: 'Forsendelse startet',
            transmissionCompleted: 'Forsendelse fuldført',
            sent: 'Afsendt',
            received: 'Modtaget',
            endpointNotFound: 'Fejl',
            error: 'Fejl',
            documentId: 'Dokument-ID',
            statusCode: 'Statuskode',
            statusMessage: 'Statusbesked',
            deliveryType: 'Leveringstype',
            receiver: 'Modtager',
            receiverCvr: 'Modtagers CVR',
        },
    },
    interactionEventTypes: {
        [InteractionEventType.Journaled]: 'Journaliseret',
        [InteractionEventType.Copied]: 'Kopieret',
        [InteractionEventType.Clicked]: 'Link åbnet',
        [InteractionEventType.Complained]: 'Markeret som spam',
        [InteractionEventType.Delivered]: 'Modtaget',
        [InteractionEventType.Failed]: 'Fejlet',
        [InteractionEventType.Opened]: 'Åbnet',
        [InteractionEventType.Delayed]: 'I kø',
        [InteractionEventType.Answered]: 'Besvaret',
        [InteractionEventType.HumanAnswered]: 'Person detekteret',
        [InteractionEventType.Cancelled]: 'Annulleret',
        [InteractionEventType.Started]: 'Startet',
        [InteractionEventType.Ringing]: 'Ringer',
        [InteractionEventType.Completed]: 'Afsluttet',
        [InteractionEventType.Voicemail]: 'Telefonsvarer',
        [InteractionEventType.DigitsEntered]: 'Tal indtastet',
        [InteractionEventType.Inbound]: 'Indgående opkald',
        [InteractionEventType.Sent]: 'Sendt',
        [InteractionEventType.TransmissionStarted]: 'Transmission startet',
        [InteractionEventType.Created]: 'Oprettet',
        [InteractionEventType.Received]: 'Modtaget',
        [InteractionEventType.SendingApproved]: 'Afsendelse godkendt',
        [InteractionEventType.TransferredToPrintAndDistribution]: 'Sendt til print og distribution',
    },
    outboundPhone: {
        noCasesLeft: 'Ingen sager at vise',
        priority: 'Prioritet',
        nextCase: 'Næste sag',
    },
    outgoingPhoneCallTags: {
        [PhoneOutgoingTag.FullPayment]: 'Fuld betaling',
        [PhoneOutgoingTag.IncorrectNumber]: 'Nummeret findes ikke',
        [PhoneOutgoingTag.NoAnswer]: 'Intet svar',
        [PhoneOutgoingTag.WrongNumber]: 'Forkert nummer',
        [PhoneOutgoingTag.Opposition]: 'Indsigelse',
        [PhoneOutgoingTag.Other]: 'Anden årsag',
        [PhoneOutgoingTag.OtherAgreement]: 'Anden aftale',
        [PhoneOutgoingTag.PaymentPlan]: 'Afdragsordning',
    },
    incomingPhoneCallTags: {
        [PhoneIncomingTag.FullPayment]: 'Fuld betaling',
        [PhoneIncomingTag.Opposition]: 'Indsigelse',
        [PhoneIncomingTag.Other]: 'Anden årsag',
        [PhoneIncomingTag.OtherAgreement]: 'Anden aftale',
        [PhoneIncomingTag.PaymentPlan]: 'Afdragsordning',
        [PhoneIncomingTag.Billing]: 'Afregning',
        [PhoneIncomingTag.Terms]: 'Aftaleforhold',
        [PhoneIncomingTag.Caseworking]: 'Sagsbehandling',
    },
    procedures: {
        procedure: 'Genvej',
        customProcedures: 'Oprettede genveje',
        standardProcedures: 'Standardgenveje',
        deleteProcedure: 'Slet genvej',
        confirmDeleteProcedure: 'Er du sikker på, at du vil slette denne genvej?',
        general: 'Generelt',
        generalDescription: 'Generelle indstillinger for genvejen.',
        showOnCase: 'Vis på sag',
        save: 'Gem',
        selectedProcedure: 'Genveje',
        createProcedure: 'Opret genvej',
        title: 'Titel',
        description: 'Beskrivelse',
        triggers: 'Triggers',
        defaultToSystemStandard: 'Hvis ingen genvej valgt:',
        emptyTrigger: 'Ingen genvej valgt',
        deleteConfirmation: 'Du er ved at fjerne denne genvej fra en trigger. Er du sikker på at du vil fortsætte?',
        associatedWithCollector: 'Vis kun på sager med følgende inddriver',
        selectCollector: 'Vælg inddriver',
        selectSetting: 'Vælg indstilling',
        associatedWithCreditor: 'Vis kun på sager med følgende kreditor',
        selectCreditor: 'Vælg kreditor',
        tasks: 'Opgavetyper',
        tasksDescription: 'Opgaver som kan udføres.',
        automaticTask: 'Automatisk handling',
        selectUpdate: 'Vælg opgave',
        add: 'Tilføj',
        taskOrderExplainer: 'Opgaverne gennemgås oppefra og ned – den første opgave, hvis krav er opfyldt, bliver udført. Træk i opgaverne for at ændre rækkefølgen.',
        noTasksYet: 'Ingen opgaver endnu – tilføj den første nedenfor.',
        otherwise: 'ellers',
        untilManualContinuation: 'indtil manuel fortsættelse',
        addTask: 'Tilføj opgave',
        removeTask: 'Fjern opgave',
        economyProcedureTriggers: 'Betalinger',
        paymentPlansProcedureTriggers: 'Afdragsordninger',
        debtExpiredProcedureTriggers: 'Forældelse',
        CosmoProcedureTriggers: 'Debitor-events',
        interactionProcedureTriggers: 'Interaktioner',
        otherProcedureTriggers: 'Andre',
        timeBeforeExpiration: 'Tid før forældelse',
        atExpiration: 'Ved forældelse',
        beforeExpiration: 'før forældelse',
        proceduresToRun: 'Procedurer der køres',
        foundationFilter: 'Fundamentskrav',
        foundationFilterAny: 'Med eller uden fundament',
        foundationFilterWithFoundation: 'Kun med fundament',
        foundationFilterWithoutFoundation: 'Kun uden fundament',
        addTriggerConfiguration: 'Tilføj konfiguration',
        duplicateProcedure: 'Du kan ikke tilføje den samme procedure to gange',
        deleteTriggerConfigurationConfirmation: 'Er du sikker på, at du vil slette denne konfiguration?',
        emailJournalizedWithCategories: 'Når en e-mail journaliseres på en sag og ingen kategori har håndteret den',
        courtEmailJournalizedWithCategories: 'Når en e-mail fra retten journaliseres på en sag og ingen kategori har håndteret den',
    },
    triggers: {
        [SystemProcedure.CreditorEndedCase]: 'Når kreditor afslutter en sag',
        [SystemProcedure.EndCase]: 'Ved fuld betaling',
        [SystemProcedure.Overpayment]: 'Ved overindbetaling',
        [SystemProcedure.RemainderReminder]: 'Ved delbetaling',
        [SystemProcedure.EndCaseAccord]: 'Ved akkord sagsafslutning',
        [SystemProcedure.PrincipalPayment]: 'Ved delbetaling svarende til hovedstolen',
        [SystemProcedure.PaymentOnCourtCase]: 'Ved betaling på sag i retten',
        [SystemProcedure.Update]: 'Ved sagsopdatering',
        [SystemProcedure.InteractionSentToDebtor]: 'Ved afsendelse af manuel interaktion til debitor',
        [SystemProcedure.CaseStatusChange]: 'Når en sag skifter status',
        [SystemProcedure.ObjectionOnRelatedCase]: 'Når en ny sag oprettes på en debitor, der har gjort indsigelse på en anden sag',
        [SystemProcedure.PaymentPlanInitial]: 'Ved aktivering af afdragsordning',
        [SystemProcedure.PaymentPlanDocumentSigned]: 'Ved underskrift af skylderklæring i forbindelse med indgåelse af en afdragsordning',
        [SystemProcedure.PaymentPlanReminder]: 'Ved påmindelse om afdrag',
        [SystemProcedure.PaymentPlanPayment]: 'Ved betaling af afdrag',
        [SystemProcedure.PaymentPlanAutoPaymentFailure]: 'Ved fejlslagen træk fra kort ifm. betaling af afdrag',
        [SystemProcedure.PaymentPlanBSLSSubmitFailed]: 'Ved fejlslagen indsendelse af afdrag til betalingsservice',
        [SystemProcedure.PaymentPlanBSLSRejected]: 'Ved afvist afdrag via betalingsservice',
        [SystemProcedure.PaymentPlanBSLSAgreementCancelled]: 'Ved annuleret betalingsserviceaftale',
        [SystemProcedure.PaymentPlanDeadline]: 'Ved deadline for betaling af afdrag',
        [SystemProcedure.PaymentPlanCanceled]: 'Ved misligholdelse af afdragsordning',
        [SystemProcedure.PaymentPlanTwoHourActivationReminder]: 'To timer efter, at der er valgt en afdragsordning, som aldrig er blevet aktiveret',
        [SystemProcedure.PaymentPlanOneDayActivationReminder]: 'En dag efter, at der er valgt en afdragsordning, som aldrig er blevet aktiveret',
        [SystemProcedure.PaymentPlanThreeDayActivationReminder]: 'Tre dage efter, at der er valgt en afdragsordning, som aldrig er blevet aktiveret',
        [SystemProcedure.CancelUnactivatedPaymentPlansAfterActivationDeadline]: 'Annuller afdragsordninger, som ikke er aktiveret efter deadline',
        [SystemProcedure.PaymentPlanCreationByCaseworker]: 'Når en sagsbehandler opretter en afdragsordning',
        [SystemProcedure.BankAccountDetailsApprovalRefund]: 'Bekræftelse på indtastning af kontooplysninger for udbetaling tilgodehavende',
        [SystemProcedure.DebtExpires]: 'Når en postering forældes',
        [SystemProcedure.DebtorCanBeRegisteredInDebtRegister]: 'Når debitor kan registreres i et åbent gældsregister, men dette endnu ikke er sket',
        [SystemProcedure.DebtorIsUnderage]: 'Når debitor registreres som umyndig',
        [SystemProcedure.Address]: 'Når debitors adresse opdateres',
        [SystemProcedure.Active]: 'Når debitor registreres aktiv',
        [SystemProcedure.Dead]: 'Når debitor går bort',
        [SystemProcedure.Disappeared]: 'Når debitor registreres forsvundet',
        [SystemProcedure.MovedAbroad]: 'Når debitor rejser ud af landet',
        [SystemProcedure.Homeless]: 'Når debitor registreres som hjemløs',
        [SystemProcedure.CompanyActive]: 'Når virksomheder registreres aktive',
        [SystemProcedure.Inactive]: 'Når en virksomhed registreres inaktiv',
        [SystemProcedure.OperationsCeased]: 'Når virksomheders drift ophører',
        [SystemProcedure.AddressProtection]: 'Når adresse- eller navnebeskyttelsesstatus ændres',
        [SystemProcedure.NewRKIRegristration]: 'Når en ny ekstern RKI-registrering tilføjes',
        [SystemProcedure.DeletedRKIRegistration]: 'Når en ekstern RKI-registrering slettes',
        [SystemProcedure.DeletedRKIRegistrationWillingnessToPay]: 'Når en ekstern RKI-registrering slettes med indikation på betalingsvilje',
        [SystemProcedure.GuardianStatus]: 'Når værge-status ændres',
        [SystemProcedure.DissolutionStatus]: 'Når en virksomhed går i opløsning',
        [SystemProcedure.AKSFailed]: 'Hvis AKS-tilmelding fejler',
        [SystemProcedure.BOBEHANDLING]: 'Når der skal bobehandles',
        [SystemProcedure.EmailJournalized]: 'Når en e-mail journaliseres på en sag',
        [SystemProcedure.CourtEmailJournalized]: 'Når en e-mail fra retten journaliseres på en sag',
        [SystemProcedure.NewAsset]: 'Når et nyt aktiv registreres',
        [SystemProcedure.NewLien]: 'Når en ny hæftelse registreres',
        [SystemProcedure.AssetChanged]: 'Når et aktiv opdateres',
        [SystemProcedure.LienChanged]: 'Når en hæftelse opdateres',
        [SystemProcedure.AssetRemoved]: 'Når et aktiv fjernes',
        [SystemProcedure.LienRemoved]: 'Når en hæftelse fjernes',
    },
    procedureTitles: {
        [SystemProcedureId.CreditorEndedCase]: 'Kreditor afslutter en sag',
        [SystemProcedureId.EndCase]: 'Sag fuldt betalt',
        [SystemProcedureId.Overpayment]: 'Overindbetaling',
        [SystemProcedureId.RemainderReminder]: 'Sag delvist betalt',
        [SystemProcedureId.EndCaseAccord]: 'Akkord betaling',
        [SystemProcedureId.PrincipalPayment]: 'Sag delvist betalt',
        [SystemProcedureId.PaymentOnCourtCase]: 'Betaling på sag i retten',
        [SystemProcedureId.Update]: 'Sag opdateret',
        [SystemProcedureId.PaymentPlanInitial]: 'Aktivering af afdragsordning',
        [SystemProcedureId.PaymentPlanReminder]: 'Påmindelse om afdrag',
        [SystemProcedureId.PaymentPlanPayment]: 'Betaling af afdrag',
        [SystemProcedureId.PaymentPlanAutoPaymentFailure]: 'Fejlslagen træk fra kort ifm. betaling af afdrag',
        [SystemProcedureId.PaymentPlanBSLSSubmitFailed]: 'Fejlslagen indsendelse af afdrag til BS/LS',
        [SystemProcedureId.PaymentPlanBSLSRejected]: 'Afvisning af afdrag via BS/LS',
        [SystemProcedureId.PaymentPlanBSLSAgreementCancelled]: 'BS/LS-aftale annulleret',
        [SystemProcedureId.PaymentPlanDeadline]: 'Deadline for afdrag',
        [SystemProcedureId.PaymentPlanCanceled]: 'Afdragsordning afsluttet',
        [SystemProcedureId.PaymentPlanTwoHourActivationReminder]: 'To timers aktiveringspåmindelse af afdragsordning',
        [SystemProcedureId.PaymentPlanOneDayActivationReminder]: 'En dags aktiveringspåmindelse af afdragsordning',
        [SystemProcedureId.PaymentPlanThreeDayActivationReminder]: 'Tre dages aktiveringspåmindelse af afdragsordning',
        [SystemProcedureId.PaymentPlanCreationByCaseworker]: 'Manuel afdragsoprettelelsestilbud',
        [SystemProcedureId.DebtExpired]: 'Gæld forældet',
        [SystemProcedureId.DebtExpiresWithinThreeMonths]: 'Gælden forældes indenfor 3 måneder',
        [SystemProcedureId.DebtExpiresWithinThreeMonthsWithFoundation]: 'Gælden forældes indenfor 3 måneder med fundament',
        [SystemProcedureId.DebtorCanBeRegisteredInDebtRegister]: 'Når debitor kan registreres i et åbent gældsregister, men dette endnu ikke er sket',
        [SystemProcedureId.DebtorIsUnderage]: 'Debitor er umyndig',
        [SystemProcedureId.Address]: 'Adresse',
        [SystemProcedureId.Active]: 'Aktiv',
        [SystemProcedureId.Dead]: 'Død',
        [SystemProcedureId.Disappeared]: 'Forsvundet',
        [SystemProcedureId.MovedAbroad]: 'Udrejst',
        [SystemProcedureId.Homeless]: 'Hjemløs',
        [SystemProcedureId.CompanyActive]: 'Virksomhed aktiv',
        [SystemProcedureId.Inactive]: 'Inaktiv',
        [SystemProcedureId.OperationsCeased]: 'Driftophør',
        [SystemProcedureId.AddressProtection]: 'Adresse- eller navnebeskyttelsesstatus',
        [SystemProcedureId.NewRKIRegristration]: 'Ny ekstern RKI-registrering',
        [SystemProcedureId.DeletedRKIRegistration]: 'Ekstern RKI-registrering slettet',
        [SystemProcedureId.DeletedRKIRegistrationWillingnessToPay]: 'Ekstern RKI-registrering slettet med indikation på betalingsvilje',
        [SystemProcedureId.GuardianStatus]: 'Værge-status',
        [SystemProcedureId.DissolutionStatus]: 'Virksomhedsopløsning',
        [SystemProcedureId.AKSFailed]: 'AKS-tilmelding fejlet',
        [SystemProcedureId.BOBEHANDLING]: 'Bobehandles',
        [SystemProcedureId.AgentEscalatedToHuman]: 'Agent eskaleret til menneske',
        [SystemProcedureId.EmailJournalized]: 'E-mail journaliseret',
        [SystemProcedureId.CourtEmailJournalized]: 'E-mail fra retten journaliseret',
    },
    procedureDescriptions: {
        [SystemProcedureId.CreditorEndedCase]: 'Kreditor afslutter en sag gennem API',
        [SystemProcedureId.EndCase]: 'Luk sagen og giv kontaktperson besked',
        [SystemProcedureId.Overpayment]: 'Der er betalt mere end der er opkrævet',
        [SystemProcedureId.RemainderReminder]: 'Sag delvist betalt. Giv kontaktperson besked',
        [SystemProcedureId.PrincipalPayment]: 'Sag delvist betalt. Giv kontaktperson besked',
        [SystemProcedureId.PaymentOnCourtCase]: 'Betaling på sag i retten. Giv retten besked',
        [SystemProcedureId.EndCaseAccord]: 'Afslut sag med akkord betaling',
        [SystemProcedureId.Update]: 'Sagens krav er opdateret',
        [SystemProcedureId.PaymentPlanInitial]: 'Send bekræftelse ved nyoprettet ordning',
        [SystemProcedureId.PaymentPlanReminder]: 'Send påmindelse inden betalingsfrist',
        [SystemProcedureId.PaymentPlanPayment]: 'Når en afdragsordning bliver afregnet korrekt',
        [SystemProcedureId.PaymentPlanAutoPaymentFailure]: 'Når en afdragsordning afregning fejler',
        [SystemProcedureId.PaymentPlanBSLSSubmitFailed]: 'Når en afdragsordning med BS eller LS fejler at planlægge en betaling',
        [SystemProcedureId.PaymentPlanBSLSRejected]: 'Når en afdragsordning med BS eller LS får afvist en betaling efter den første i måneden',
        [SystemProcedureId.PaymentPlanBSLSAgreementCancelled]: 'Når en afdragsordning med BS eller LS får annulleret en betalingsserviceaftale',
        [SystemProcedureId.PaymentPlanDeadline]: 'Når en afdragsordning ikke er betalt før frist',
        [SystemProcedureId.PaymentPlanCanceled]: 'Når en afdragsordning ikke er betalt efter at være givet en ekstra chance',
        [SystemProcedureId.PaymentPlanTwoHourActivationReminder]: 'Når en oprettet afdragsordning ikke er aktiveret efter to timer',
        [SystemProcedureId.PaymentPlanOneDayActivationReminder]: 'Når en oprettet afdragsordning ikke er aktiveret efter en dag',
        [SystemProcedureId.PaymentPlanThreeDayActivationReminder]: 'Når en oprettet afdragsordning ikke er aktiveret efter tre dage',
        [SystemProcedureId.PaymentPlanCreationByCaseworker]: 'Send tilbud for manuelt oprettet afdragsordning af en sagsbehandler',
        [SystemProcedureId.DebtExpired]: 'Gælden er forældet',
        [SystemProcedureId.DebtExpiresWithinThreeMonths]: 'Gælden forældes indenfor 3 måneder',
        [SystemProcedureId.DebtExpiresWithinThreeMonthsWithFoundation]: 'Gæld med fundament forældes indenfor 3 måneder',
        [SystemProcedureId.DebtorCanBeRegisteredInDebtRegister]: 'Når debitor kan registreres i et åbent gældsregister, men dette endnu ikke er sket',
        [SystemProcedureId.DebtorIsUnderage]: 'Debitor er umyndig',
        [SystemProcedureId.Address]: 'Når debitors adresse opdateres',
        [SystemProcedureId.Active]: 'Når debitor registreres aktiv',
        [SystemProcedureId.Dead]: 'Når debitor går bort',
        [SystemProcedureId.Disappeared]: 'Når debitor registreres forsvundet',
        [SystemProcedureId.MovedAbroad]: 'Når debitor rejser ud af landet',
        [SystemProcedureId.Homeless]: 'Når debitor registreres som hjemløs',
        [SystemProcedureId.CompanyActive]: 'Når virksomheder registreres aktive',
        [SystemProcedureId.Inactive]: 'Når en virksomhed registreres inaktiv',
        [SystemProcedureId.OperationsCeased]: 'Når virksomheders drift ophører',
        [SystemProcedureId.AddressProtection]: 'Når adresse- eller navnebeskyttelsesstatus ændres',
        [SystemProcedureId.NewRKIRegristration]: 'Når en ny ekstern RKI-registrering tilføjes',
        [SystemProcedureId.DeletedRKIRegistration]: 'Når en ekstern RKI-registrering slettes',
        [SystemProcedureId.DeletedRKIRegistrationWillingnessToPay]: 'Når en ekstern RKI-registrering slettes med indikation på betalingsvilje',
        [SystemProcedureId.GuardianStatus]: 'Når værge-status ændres',
        [SystemProcedureId.DissolutionStatus]: 'Når en virksomhed går i opløsning',
        [SystemProcedureId.AKSFailed]: 'Hvis AKS-tilmelding fejler',
        [SystemProcedureId.BOBEHANDLING]: 'Når der skal bobehandles',
        [SystemProcedureId.AgentEscalatedToHuman]: 'Når en AI-agent eskalerer en sag til et menneske',
        [SystemProcedureId.EmailJournalized]: 'Opretter opgaven "Ny e-mail journaliseret" på sagen, som sætter den på pause indtil en sagsbehandler håndterer e-mailen',
        [SystemProcedureId.CourtEmailJournalized]: 'Opretter opgaven "Ny e-mail fra retten" på sagen, som sætter den på pause indtil en sagsbehandler håndterer e-mailen',
    },
    panels: {
        filters: 'Filtre',
        selectAll: 'Vælg alt',
        totalDebt: 'Gæld i alt',
        clickToQueueText: 'Klik for at sætte de valgte sager i kø',
        queue: 'Gå til kø',
    },
    misc: {
        selectAll: 'Vælg alle',
        notChosen: 'Ikke valgt',
        showMore: 'vis mere',
        showLess: 'vis mindre',
        copiedToClipboard: 'Kopieret til udklipsholder!',
        cosmoActivated: 'Aktiveret',
        searchForAccount: 'Søg efter bruger',
        create: 'Opret',
        createdAt: 'Oprettet',
        createdBy: 'Oprettet af',
        updatedAt: 'Opdateret',
        updatedBy: 'Opdateret af',
        approve: 'Godkend',
        cancel: 'Annuller',
        areYouSure: 'Er du sikker?',
        cannotBeUndone: 'Handlingen kan ikke fortrydes.',
        confirm: 'Bekræft',
        close: 'Luk',
        okay: 'Okay',
        submit: 'Indsend',
        save: 'Gem',
        saved: 'Gemt',
        edit: 'Rediger',
        update: 'Opdater',
        errorCreating: 'Fejl under oprettelse af',
        errorUpdating: 'Fejl under opdatering af',
        errorDeleting: 'Fejl under sletning af',
        errorPerforming: 'Fejl under udførsel i forbindelse med',
        successCreating: 'oprettet',
        successUpdating: 'opdateret',
        successDeleting: 'slettet',
        language: 'Sprog',
        chooseFile: 'Vælg fil',
        yes: 'Ja',
        no: 'Nej',
        all: 'Alle',
        add: 'Tilføj',
        enabled: 'Aktiveret',
        search: 'Søg',
        contactSupport: 'Kontakt vores support',
        error: 'Fejl',
        errorOccured: 'Der er opstået en fejl',
        days: 'Dage',
        date: 'Dato',
        loadingError: 'Kunne ikke loade dataen',
        export: 'Eksportér',
        exported: 'Eksporteret',
        goToCase: 'Gå til sag',
        after: 'efter',
        skip: 'Spring over',
        value: 'Værdi',
        delete: 'Slet',
        apply: 'Anvend',
        unnamed: 'Ikke navngivet',
        name: 'Navn',
        description: 'Beskrivelse',
        learnMore: 'Lær mere',
        ascending: 'Stigende',
        descending: 'Faldende',
        and: 'og',
        or: 'eller',
        id: 'Id',
        type: 'Type',
        text: 'Tekst',
        state: 'Status',
        limitReached: 'Maks grænse opnået',
        accept: 'Acceptér',
        loading: 'Indlæser...',
        logo: 'Logo',
    },
    table: {
        selectedOptions: 'Valgte',
        next: 'Næste',
        previous: 'Forrige',
        first: 'Første',
        last: 'Sidste',
        showing: 'Viser',
        outOf: 'ud af',
        loadMore: 'Load flere',
        from: 'Fra',
        to: 'Til',
        search: 'Søg',
        noData: 'Ingen data',
        clearFilters: 'Ryd alle filtre',
    },
    history: {
        paymentPlanCreated: 'Afdragsordning oprettet',
        tribunalCaseCreated: 'Retssag oprettet',
        documentAdded: 'Dokument tilføjet',
        history: 'Historik',
        searchHistory: 'Søg i historik',
        filterHistory: 'Filtrér historik',
        filterEconomy: 'Økonomi',
        filterBilling: 'Afregning',
        filterUpdates: 'Opgaver',
        filterInteractions: 'Interaktioner',
        filterDebts: 'Gæld',
        filterDebtorTransactions: 'Transaktioner',
        filterNotifications: 'Notifikationer',
        filterCaseStatus: 'Sagsstatus',
        filterType: 'Type',
        filterTags: 'Tags',
        resetFilter: 'Nulstil',
        hideAll: 'Skjul alle',
        caseCreated: 'Sag oprettet',
        creditorDisbursement: 'Kreditorudlæg',
        creditorVat: 'Kreditormoms',
        creditorFee: 'Kreditorhonorar',
        deposit: 'Afregning af indbetaling',
    },
    connect: {
        fromConnectPartner: 'Kommer fra en connect partner',
        connection: 'Forbindelse',
        connections: 'Forbindelser',
        product: 'Produkt',
        products: 'Produkter',
        updates: 'Opdateringer',
        mappedCases: 'Forbundne sager',
        noConnections: 'Ingen forbindelser endnu',
        noProducts: 'Ingen produkter endnu',
        productLogo: 'Logo',
        editProduct: 'Rediger produkt',
        saveProduct: 'Gem produkt',
        productUpdatedTitle: 'Produkt opdateret',
        productCreatedTitle: 'Produkt oprettet',
        invitations: 'Invitationer',
        newInvitation: 'Ny invitation',
        noInvitations: 'Ingen invitationer endnu',
        statusPending: 'Afventer',
        statusAccepted: 'Accepteret',
        statusRejected: 'Afvist',
        statusCancelled: 'Annulleret',
        statusExpired: 'Udløbet',
        receivingCreditor: 'Modtagende kreditor',
        selectCreditor: 'Vælg en kreditor',
        recipientEmail: 'Modtagerens e-mail',
        invitationMessage: 'Besked (valgfri)',
        sendInvitation: 'Send invitation',
        invitationSentTitle: 'Invitation sendt',
        productToUse: 'Produkt',
        selectProduct: 'Vælg et produkt',
        createNewProduct: 'Opret et nyt produkt',
        productName: 'Produktnavn',
        productDescription: 'Kort beskrivelse',
        productContent: 'Aftaledetaljer',
        service: 'Ydelse',
        serviceCollection: 'Inkasso',
        serviceCourtHandling: 'Retslig behandling',
        workflow: 'Workflow',
        caseGroup: 'Sagsgruppe',
        billingModel: 'Afregningsmodel',
        none: 'Ingen',
        invitationFrom: 'Invitation fra',
        invitationIntro: 'ønsker at modtage sager fra din organisation.',
        invitationUnavailable: 'Denne invitation er ikke længere tilgængelig.',
        invitationNotPending: 'Denne invitation er allerede behandlet.',
        sendingCreditor: 'Afsendende kreditor',
        allCreditors: 'Alle kreditorer',
        searchProducts: 'Søg produkter',
        searchWorkflows: 'Søg workflows',
        propertyTypesToSend: 'Attributter som modtager får adgang til',
        caseProperties: 'Sagsattributter',
        caseVoucherProperties: 'Sagsposteringsattributter',
        noPropertyTypes: 'Ingen tilgængelige attributter',
        sendInteractionsLabel: "Send interaktioner (emails, SMS'er, breve, noter osv.) med hver sag",
        acceptInvitation: 'Accepter og forbind',
        invitationAcceptedTitle: 'Forbundet',
        receivedPropertyTypes: 'Modtagne attributter',
        receivedPropertyTypesDesc: 'Vælg hvilke af de tilbudte attributter der skal importeres med hver sag.',
        noOfferedPropertyTypes: 'Afsenderen tilbød ingen attributter.',
        saveReceivedTypes: 'Gem',
        loading: 'Indlæser',
        mapPropertyTypes: 'Map attributter',
        mapPropertyTypesDesc: 'Kortlæg hver attribut afsenderen sender til en af dine. Ikke-kortlagte typer modtages ikke.',
        doNotReceive: 'Modtag ikke',
        createMatchingType: 'Opret matchende attribut',
        searchProperties: 'Søg attributter',
        receivesAs: 'Modtag som',
        newBadge: 'Ny',
        mappedSummary: 'attributter modtages',
        connectionSettings: 'Opsætning',
        connectionSettingsDesc: 'Hvordan sager deles på denne forbindelse.',
        optionOn: 'Til',
        optionOff: 'Fra',
        sendInteractionsDesc: "Interaktioner (emails, SMS'er, breve, noter osv.) sendes med hver sag.",
        filterNonContactUsersLabel: 'Del kun kontaktpersoner',
        filterNonContactUsersDesc: 'Brugere der ikke er markeret som kontaktperson på sagen udelades ved deling.',
        alwaysCreateNewCustomerLabel: 'Opret altid en ny kunde',
        alwaysCreateNewCustomerDesc: 'Hver modtaget sag opretter en ny kunde i stedet for at matche en eksisterende.',
        sharedProperties: 'Delte attributter',
        propertiesShare: 'attributter delt',
        updatedBy: 'Opdateret af ',
        partner: 'connect partner',
        us: 'denne tenant',
        thirdParty: 'en tredjepart',
        sendsToConn: 'Forbindelse sender sager til',
        sendsFromConn: 'Forbindelse modtager sager fra',
        histItemHeader: 'Connect -',
        histItemExported: 'Sendt til partner',
        histItemRetracted: 'Tilbagetrukket',
        histItemCompleted: 'Opgave afsluttet',
        histItemDataUpdated: 'Data opdateret',
        completedWithReason: 'Afsluttet med årsag',
        createdDocuments: 'Oprettede dokumenter',
        createdSatisfaction: 'Oprettet andmeldelse',
        goToConnection: 'Gå til forbindelse',
        goToCreditorWeb: 'Gå til kreditor web',
        goToProduct: 'Gå til produkt',
        goToCreditor: 'Gå til modtagende kreditor',
        goToCase: 'Gå til sag',
        creditorWebLinkError: 'Der skete en fejl da vi prøvede at finde linket til kreditor web',
        case: 'Sag',
        state: 'Status',
        exportedDate: 'Afsendelsesdato',
        completedDate: 'Afslutningsdato',
        connectStateCompleted: 'Afsluttet',
        connectStateInProgress: 'I gang',
    },
    connectConnectionUpdate: {
        [ConnectConnectionStatus.Active]: 'Aktiv',
        [ConnectConnectionStatus.Paused]: 'Sat på pause',
        [ConnectConnectionStatus.Disabled]: 'Deaktiveret',
    },
    connectCaseMappingUpdate: {
        [ConnectCaseMappingStatus.Exported]: 'Afsendt',
        [ConnectCaseMappingStatus.Retracted]: 'Tilbagekaldt',
        [ConnectCaseMappingStatus.Completed]: 'Afsluttet',
        [ConnectCaseMappingStatus.DataUpdated]: 'Data opdateret',
    },
    connectRetractionReason: {
        [RetractionReason.Collected]: 'Gæld indrevet',
        [RetractionReason.ConnectionDisabled]: 'Connect forbindelse deaktiveret',
        [RetractionReason.Rollback]: 'Rullet tilbage',
        [RetractionReason.Other]: 'Anden årsag',
    },
    product: {
        productHandles: 'Produktet udbyder',
    },
    productService: {
        [ProductService.Collection]: 'inddrivelse',
        [ProductService.CourtHandling]: 'retshåndtering',
    },
    documents: {
        documents: 'Dokumenter',
        noDocuments: 'Ingen dokumenter',
        deleteDocument: 'Slet dokument',
        saveDocument: 'Gem dokument',
        autoRKIAddFoundation: 'Auto-RKI er slået til og vil forsøge at flytte RKI registreringen til det åbne register efter tilføjelse af dette fundament',
        autoRKIUpdateFoundation: 'Auto-RKI er slået til og vil forsøge at flytte RKI registreringen til det åbne register efter opdateringen af dette fundament',
        file: 'File',
        signedFile: 'Underskrevet fil',
        createdBy: 'Oprettet af',
        docId: 'Doc ID',
        type: 'Type',
        signingLink: 'Link til underskrift',
        generateSigningLink: 'Generér link til underskrift',
        createdAt: 'Oprettet',
        date: 'Dato',
        signedAt: 'Dato for signering',
        addDocument: 'Tilføj dokument',
        fromFile: 'Fra fil',
        fromTemplate: 'Fra skabelon',
        selectCourt: 'Retskreds',
        documentSignedCheckbox: 'Er dokumentet signeret?',
        visibleForDebtor: 'Tilgængeligt for debitor',
        uploadDocument: 'Overfør dokument',
        createDocument: 'Opret dokument',
        preview: 'Forhåndsvisning',
        sendToCourt: 'Send direkte til retten',
        paidCourtFee: 'Samlet indbetalt afgift',
        createDate: 'Oprettelsesdato',
        interestDates: 'Rentedatoer',
        interestAmount: 'Renter',
        totalAmount: 'Beløb i alt',
        amount: 'Beløb',
        note: 'Note',
        procesinterest: 'Procesrente',
        interestFromSubmitOfBPK: 'Renter fra indlevering af betalingspåkrav',
        caseinterest: 'Sagsrenteprocent',
        preventForkyndt: 'Ønsker du betalingspåkravet forkyndt, hvis skyldner har afgivet insolvenserklæring i fogedretten, eller er under rekonstruktion, konkurs eller gældssanering og derfor er beskyttet mod udlæg?',
        preventAutDistress: 'Ønsker du, at fogedretten automatisk skal iværksætte udlæg, hvis skyldner ikke kommer med indsigelser (protester) mod dit krav?',
        preventAutCivilCourt: 'Ønsker du, at retssag automatisk skal indledes i civilretten på grundlag af betalingspåkravet, hvis skyldner kommer med indsigelser (protester) mod dit krav?',
        selectBPKWarningDate: 'Rykkerbrev er sendt den',
        directorNameAddress: 'Direktørens/formandens navn og adresse',
        directorNameAddressDescription: 'Hvis skyldner er et selskab/forening – skriv om muligt direktørens/formandens navn og adresse:',
        selectDebtors: 'Vælg skyldnere',
        selectDebtorsDescription: 'Vælg hvilke skyldnere der skal medtages i betalingspåkravet.',
        selectAll: 'Vælg alle',
        deselectAll: 'Fravælg alle',
        debtorsSelected: 'skyldnere valgt',
        court: 'Retskreds',
        selectType: 'Vælg dokumenttype',
        sureYouWantToDelete: 'Er du sikker på at du vil slette',
        sureYouWantToSave: 'Er du sikker på at du vil gemme ændringerne?',
        documentSigned: 'Dokument signeret',
        generateLinkForSigning: 'Generér link til digital signatur',
        addCourtDisbursementToClientBilling: 'Tilføj udlæg til kreditorafregning',
        addCourtFeeToClientBilling: 'Tilføj honorar til kreditorafregning',
        addCourtFeeToCase: 'Tilføj omkostning til sagen',
        sendInfoAboutRequisitionToRes: 'Send information om udbetalingsrekvisition til ansvarlig',
        responsible: 'Ansvarlig',
        isFoundation: 'Er fundament',
        [DocumentTypes.COURT]: 'Retsligt',
        [DocumentTypes.FOUNDATION]: 'Fundament',
        [DocumentTypes.OTHER]: 'Anden',
    },
    documentTypes: {
        [DocumentTypes.COURT]: 'Retsligt',
        [DocumentTypes.FOUNDATION]: 'Fundament',
        [DocumentTypes.OTHER]: 'Anden',
        [DocumentTypes.SKYLDERKLAERING]: 'Skylderklæring',
        [DocumentTypes.COURTOPGJORTOGFREMLAGT]: 'Opgjort og fremlagt i fogedretten',
        [DocumentTypes.FORLIG]: 'Forlig',
        [DocumentTypes.DOM]: 'Dom',
        [DocumentTypes.PAATEGNING]: 'Påtegning',
        [DocumentTypes.GAELDSBREV]: 'Gældsbrev',
    },
    files: {
        fileName: 'Filnavn',
        downloadFailed: 'Download fejlede',
    },
    updates: {
        pauseNow: 'Pause nu',
        continueCase: 'Fortsæt opgave',
        continueCaseRemove: 'Fjern',
        setRemindedAt: 'Angiv påmindelsesdato',
        remindDate: 'Påmind den',
        remindNow: 'Påmind nu',
        pauseUntilReminding: 'Pause d.',
        pauseContinueAt: 'Fortsæt d.',
        dateSelectorTooltip: 'Vælg den dato pausen skal træde i kraft',
        updateWillBeShownIn: 'Pauses om',
        paused: 'Pauset',
        reminded: 'påmindet',
        pausedAndReminded: 'Pauses og påmindes om',
        pausedUntil: 'Pauset indtil om',
        pausedAndRemindedPast: 'Pauset og påmindet for',
        ago: 'siden',
        pausedPast: 'Pauset for',
        andReminded: 'og påmindes om',
        andRemindedPast: 'og påmindet for',
        expedientAKSActivated: 'Experian AKS aktiveret',
        chooseMoreThanTwoBulkActions: 'Vælg venligst to eller flere for at lave en massebehandling.',
        bulkActions: 'Massebehandling',
        selectAll: 'Vælg alle',
    },
    integrateCalendar: {
        name: 'Abonnementets navn',
        newSubscription: 'Nyt kalenderabonnement',
        create: 'Opret kalenderlink',
        save: 'Gem indstillinger',
        edit: 'Rediger',
        cancel: 'Annuller',
        delete: 'Slet abonnement',
        confirmDelete: 'Slet dette abonnement? Kalenderlinket vil ikke længere virke.',
        courtMeetings: 'Retsmøder i domstolsmodulet',
        updateTypes: 'Opgavetyper',
        empty: 'Ingen kalenderabonnementer endnu.',
        description: 'Opret et kalenderabonnement for denne organisation. Vælg retsmødetyper og opgavetyper nedenfor. Kun valgte typer synkroniseres, fra en måned tilbage til et år frem.',
        privacy: 'Kalenderaftaler indeholder kun generiske titler og tidspunkter. Navne, noter, adresser og sagsoplysninger medtages ikke. Alle med linket kan læse kalenderen, indtil du sletter abonnementet.',
        noTypes: 'Ingen typer valgt: abonnementet er sat på pause.',
        subscription: 'kalenderabonnement',
        namePlaceholder: 'Fx Fogedmøder',
        nameHint: 'Bruges kun til at kende abonnementet fra andre i Debbie.',
        courtMeetingsHelp: 'Vælg de mødetyper, der skal med i kalenderen. Hvert retsmøde fra domstolsmodulet vises i kalenderen på sin mødedato.',
        updateTypesHelp: 'Vælg de opgavetyper, der skal med i kalenderen. Hver opgave vises i kalenderen på sin påmindelsesdato.',
        selected: 'valgt',
        selectAll: 'Vælg alle',
        clearSelection: 'Ryd',
        paused: 'Sat på pause',
        meetingTypesCount: 'retsmødetyper',
        updateTypesCount: 'opgavetyper',
        link: 'Kalenderlink',
        copyLink: 'Kopiér link',
        created: 'Oprettet',
        connectToOffice365: 'Synkronisér med Office 365',
        selectUpdateTypes: 'Vælg opgaver',
    },
    auth: {
        account: 'Konto',
        logout: 'Log ud',
        accountInactive: 'Din konto er inaktiv',
        chooseBetweenAccounts: 'Vælg mellem konti',
    },
    rightNav: {
        creditors: 'Kreditorer',
    },
    login: {
        email: 'Emailadresse',
        password: 'Kodeord',
        login: 'Log ind',
        twoFactorExplainer: 'Vi har sendt en sekscifret kode til din mail. Indtast den herunder for at logge ind.',
        twoFactorPlaceholder: 'Kode',
        reset: 'Nulstil',
        resetTokenExplainer: 'Du vil modtage en kode per mail, som du skal indtaste her for at nulstille din kode.',
        resetTokenPlaceholder: 'Kode',
        newPasswordExplainer: 'Indtast dit nye password',
        newPasswordPlaceholder: 'Dit nye password',
        updatePassword: 'Opdater',
        couldNotIdentifyYou: 'Vi kunne ikke identificere dig. Kontakt venligst',
        mitIdDescription: 'Log ind med MitID for at få adgang til dine data.',
        loginWithMitId: 'Log ind med MitID',
    },
    passwordResetEmail: {
        title: 'Nulstil kode',
        body: 'Du har anmodet om at ændre din kode. For at ændre din kode, skal du skrive følgende ind på siden du har anmodet fra:',
    },
    onboarding: {
        welcome: 'Velkommen',
        passwordCreatorExplainer: 'For at opsætte din konto, skal du vælge et kodeord.',
    },
    users: {
        userSettings: 'Brugerindstillinger',
        userCreated: 'Bruger oprettet',
        userUpdated: 'Bruger opdateret',
        updateFailed: 'Opdatering af bruger fejlede',
        createUser: 'Invitér bruger',
        inviteUser: 'Invitér bruger',
        developEmailWarning: 'Du er i develop- (staging-)miljøet. Invitations-, nulstil adgangskode- og 2FA-mails sendes til modtagerens rigtige indbakke her – de mockes ikke. Invitér kun rigtige personer.',
        name: 'Navn',
        role: 'Rolle',
        firstName: 'Fornavn',
        lastName: 'Efternavn',
        email: 'Email',
        phone: 'Telefon',
        username: 'Brugernavn',
        password: 'Password',
        users: 'Brugere',
        noUsers: 'Ingen brugere',
        newUser: 'Ny bruger',
        search: 'Søg brugere',
        passwordConfirmation: 'Bekræft password',
        creditors: 'Kreditorer',
        tenants: 'Tenants',
        todoNotifications: 'Modtag en email hver morgen om nye opgaver',
        creditorMessageNotifications: 'Modtag en email når du modtager en ny besked på en sag',
        selectCreditors: 'Vælg kreditorer',
        selectTenants: 'Vælg tenants',
        selectRole: 'Vælg rolle',
        selectUser: 'Vælg bruger',
        passwordTooShort: 'Password er for kort',
        passwordsDontMatch: 'Passwords er ikke ens',
        sendInvite: 'Send email invitation',
        sureYouWantToDeleteUser: 'Er du sikker på at du vil slette denne bruger permanent?',
        deleteUser: 'Slet bruger',
        deleteUserPermanently: 'Slet bruger permanent',
        archiveUser: 'Arkivér bruger',
        sureYouWantToArchiveUser: 'Er du sikker på at du vil arkivere denne bruger?',
        archiveUserDescription: 'Ved arkivering fjernes brugerens adgang til platformen, men navn og email bevares, så historiske logs og aktivitet stadig kan læses.',
        archiveUserWarning: 'Brugeren logges ud alle steder og mister sin adgangskode. Hvis brugeren senere genaktiveres, skal en ny invitation accepteres.',
        reactivateUser: 'Genaktivér bruger',
        sureYouWantToReactivateUser: 'Er du sikker på at du vil genaktivere denne bruger?',
        reactivateUserDescription: 'Brugeren får sine tidligere roller og adgange tilbage og modtager en invitation på email for at vælge en ny adgangskode. Brugeren kan ikke logge ind, før invitationen er accepteret.',
        userReactivated: 'Brugeren er genaktiveret og inviteret på email',
        userReactivatedInviteFailed: 'Brugeren er genaktiveret, men invitationen kunne ikke sendes. Brug "Gensend invitation" for at prøve igen.',
        archivedUsers: 'Arkiverede brugere',
        activeUsers: 'Aktive brugere',
        stateActive: 'Aktiv',
        stateInvited: 'Inviteret',
        invitedUsers: 'Inviterede brugere',
        resendInvite: 'Gensend invitation',
        inviteResent: 'Invitationen er sendt igen',
        inviteResendFailed: 'Invitationen kunne ikke sendes igen',
        inviteLinkExpired: 'Dette invitationslink er udløbet',
        inviteLinkExpiredDescription: 'Invitationslinks er gyldige i 30 dage. Anmod om et nyt, så sender vi et friskt link til din email.',
        inviteLinkAlreadyUsed: 'Dette invitationslink er allerede brugt',
        inviteLinkAlreadyUsedDescription: 'Du har allerede oprettet en adgangskode. Log venligst ind med din email og adgangskode.',
        inviteLinkInvalid: 'Dette invitationslink er ugyldigt',
        inviteLinkInvalidDescription: 'Linket kunne ikke genkendes. Sørg for, at du har åbnet den nyeste invitationsmail.',
        requestNewInvite: 'Anmod om ny invitation',
        inviteRequestSent: 'En ny invitation er sendt. Tjek venligst din email.',
        changeRole: 'Skift brugers rolle',
        changeRoleNotAdmin: 'Ændring af roller kan udføres af en administrator',
        cantChangeClientRole: 'Kreditores rolle kan ikke ændres',
    },
    rolesDescription: {
        [PermissionLevels.admin]: 'Denne rolle er til virksomhedens administrator/superbruger, som har adgang til alle funktioner, samt kan konfigurere alle tilgængelige indstillinger.',
        [PermissionLevels.caseworker]: 'Denne rolle er til medarbejderen, der skal have adgang til alle nødvendige funktioner på sagsniveau. Der er desuden adgang til alt på kreditorniveau, og under indstillinger har rollen adgang til skabeloner.',
    },
    teams: {
        team: 'Team',
        user: 'Bruger',
        namePlaceholder: 'Team navn',
        saveName: 'Gem',
        searchNewTeamMember: 'Søg efter bruger som skal tilføjes til teamet',
        createTeam: 'Opret team',
        assignedTasks: 'Ansvarlige for opgaver',
        catchAll: 'Catch all',
        responsibleForUpdateTypes: 'Ansvarlige for opgaver',
        addUpdateType: 'Tilføj opgavetype',
        selectTeam: 'Team',
        selectUser: 'Bruger',
        responsibleForCase: 'Ansvarlig for sag',
    },
    invite: {
        subject: 'Invitation til at få adgang',
        body: `Hej \${firstName},

Du er blevet inviteret til at bruge \${platform}. For at logge ind, skal du trykke på følgende link.
\${url}?nu_token=\${token}`,
        html: `<p>Hej \${firstName},</p><p>Du er blevet inviteret til at bruge \${platform}. For at logge ind, skal du trykke på følgende link.</p>`,
        linkText: 'Log ind',
        creditorWeb: 'kreditorwebbet fra',
    },
    roles: {
        'super-admin': 'Super admin',
        admin: 'Administrator',
        caseworker: 'Sagsbehandler',
        client: 'Kreditor',
        debtor: 'Debitor',
        'alternative-contact': 'Repræsentant',
        unauthorized: 'Uautoriseret',
    },
    mentionsConditional: {
        if: 'Hvis',
        endIf: 'Slut hvis',
    },
    mentions: {
        [TemplateMention.PaymentPlanAmortisation]: 'Amortiseringsplan',
        [TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Generisk emnefelt',
        [TemplateMention.FINANCIALS_PRICIPAL]: 'Hovedstol',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: 'Inkassogebyr',
        [TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: 'Administrationsomkostninger',
        [TemplateMention.FINANCIALS_COMPENSATION_FEES]: 'Kompensationsgebyrer',
        [TemplateMention.FINANCIALS_INTERESTS]: 'Renter',
        [TemplateMention.FINANCIALS_INTEREST_RATE]: 'Renteprocent',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: 'Inkassoomkostninger',
        [TemplateMention.PRINCIPAL_REFERENECE_IDS]: 'Hovedstolens referencenumre',
        [TemplateMention.CURRENCY]: 'Valuta',
        [TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: 'Afdragsordning første beløb',
        [TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: 'Afdragsordning første deadline',
        [TemplateMention.PAYMENT_PLAN_FIRST_DATE]: 'Afdragsordning første dato',
        [TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: 'Afdragsordning sidste beløb',
        [TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: 'Afdragsordning sidste deadline',
        [TemplateMention.PAYMENT_PLAN_LAST_DATE]: 'Afdragsordning sidste dato',
        [TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: 'Afdragsordning beløb pr. afdrag',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: 'Afdragsordning deadline for afdrag',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: 'Afdragsordning dato for afdrag',
        [TemplateMention.PAYMENT_PLAN_CREATION_DATE]: 'Afdragsordning oprettet dato',
        [TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: 'Afdragsordningens længde i dage',
        [TemplateMention.PaymentPlanApr]: 'ÅOP',
        [TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: 'ÅOP per år',
        [TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'Hvis sag har renter p.a.',
        [TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: 'Afdragsordning min. afdrag',
        [TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: 'Afdragsordning maks. afdrag',
        [TemplateMention.TOTAL_DEBT]: 'Total gæld',
        [TemplateMention.OVERPAYMENT]: 'Tilgodehavende',
        [TemplateMention.ACCORD_TEN_PERCENT]: 'Akkord: 10 %',
        [TemplateMention.ACCORD_TWENTY_PERCENT]: 'Akkord: 20 %',
        [TemplateMention.ACCORD_THIRTY_PERCENT]: 'Akkord: 30 %',
        [TemplateMention.ACCORD_FORTY_PERCENT]: 'Akkord: 40 %',
        [TemplateMention.ACCORD_FIFTY_PERCENT]: 'Akkord: 50 %',
        [TemplateMention.ACCORD_SIXTY_PERCENT]: 'Akkord: 60 %',
        [TemplateMention.ACCORD_SEVENTY_PERCENT]: 'Akkord: 70 %',
        [TemplateMention.ACCORD_EIGHTY_PERCENT]: 'Akkord: 80 %',
        [TemplateMention.ACCORD_NINETY_PERCENT]: 'Akkord: 90 %',
        [TemplateMention.IF_IS_COMPANY]: 'Hvis sagen er erhverv',
        [TemplateMention.IF_DEBTOR_IS_DEBT_REGISTERED]: 'Hvis inddriver har registreret debitor i RKI',
        [TemplateMention.IF_CASE_HAS_MULTIPLE_PRINCIPALS]: 'Hvis sagen har flere hovedstole',
        [TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'Hvis sagen har rykkergebyrer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'Hvis sagen har inkassogebyrer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'Hvis sagen har inkassoomkostninger',
        [TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'Hvis sagen har kompensationsomkostninger',
        [TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'Hvis sagen har procesrente',
        [TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'Hvis sagen har fast rente',
        [TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'Hvis sagen har årlig rente i procent',
        [TemplateMention.IF_CASE_HAS_DEPOSIT]: 'Hvis sagen har indbetaling',
        [TemplateMention.DOCUMENTATION]: 'Dokumentation',
        [TemplateMention.DATE]: 'Dato',
        [TemplateMention.DATE_IN_THREE_DAYS]: 'Dato om 3 dage',
        [TemplateMention.DATE_IN_SIX_DAYS]: 'Dato om 6 dage',
        [TemplateMention.DATE_IN_TEN_DAYS]: 'Dato om 10 dage',
        [TemplateMention.DATE_IN_ELEVEN_DAYS]: 'Dato om 11 dage',
        [TemplateMention.DATE_IN_TWELVE_DAYS]: 'Dato om 12 dage',
        [TemplateMention.DATE_IN_FOURTEEN_DAYS]: 'Dato om 14 dage',
        [TemplateMention.DATE_IN_SEVENTEEN_DAYS]: 'Dato om 17 dage',
        [TemplateMention.DATE_IN_THIRTY_DAYS]: 'Dato om 30 dage',
        [TemplateMention.PREVIOUS_THREE_YEARS]: 'Tre foregående årstal',
        [TemplateMention.DEPOSIT]: 'Indbetalt',
        [TemplateMention.DEPOSITS_TO_CREDITOR]: 'Indbetalt til kreditor',
        [TemplateMention.DEPOSITS_TO_COLLECTOR]: 'Indbetalt til inddriver',
        [TemplateMention.INTEREST_PAID_LAST_YEAR]: 'Betalte renter sidste år',
        [TemplateMention.CONTACT_NAME]: 'Kontaktpersons navn',
        [TemplateMention.DEBTOR_NAME]: 'Debitornavn',
        [TemplateMention.DEBTOR_FIRST_NAME]: 'Debitorfornavn',
        [TemplateMention.CONTACT_ADDRESS]: 'Kontaktpersons adresse',
        [TemplateMention.CONTACT_COADDRESS]: 'Kontaktpersons c/o',
        [TemplateMention.CONTACT_ZIPCODE]: 'Kontaktpersons postnummer',
        [TemplateMention.CONTACT_CITY]: 'Kontaktpersons by',
        [TemplateMention.CONTACT_COUNTRY]: 'Kontaktpersons land',
        [TemplateMention.DEBTOR_ADDRESS]: 'Debitors vej',
        [TemplateMention.DEBTOR_COADDRESS]: 'Debitors c/o',
        [TemplateMention.DEBTOR_ZIPCODE]: 'Debitors postnummer',
        [TemplateMention.DEBTOR_CITY]: 'Debitors by',
        [TemplateMention.DEBTOR_COUNTRY]: 'Debitors land',
        [TemplateMention.DEBTOR_EMAIL]: 'Debitors email',
        [TemplateMention.DEBTOR_PHONE]: 'Debitors telefonnummer',
        [TemplateMention.LAST_PAYMENT_DATE]: 'Dato for seneste betaling',
        [TemplateMention.LAST_PAYMENT_AMOUNT]: 'Beløb af seneste betaling',
        [TemplateMention.DEBTOR_SEQ_ID]: 'Debitor Sek ID',
        [TemplateMention.DEBTOR_CVR_AND_OR_CPR]: 'Debitor CVR og/eller CPR',
        [TemplateMention.CREDITOR_NAME]: 'Kreditornavn',
        [TemplateMention.CASE_ID]: 'Sags-id',
        [TemplateMention.CASE_REFERENCE_ID]: 'Sagsreferencenummer',
        [TemplateMention.CREDITOR_ADDRESS]: 'Kreditors adresse',
        [TemplateMention.CREDITOR_IF_IS_COMPANY]: 'Hvis kreditor er en virksomhed',
        [TemplateMention.CREDITOR_IF_IS_VAT_REGISTERED]: 'Hvis kreditor er momsregistreret',
        [TemplateMention.IF_ULTIMATE_CREDITOR]: 'Hvis ultimativ kreditor',
        [TemplateMention.CASE_CREDITOR_NAME]: 'Sagens kreditor - navn',
        [TemplateMention.CASE_CREDITOR_ADDRESS]: 'Sagens kreditor - adresse',
        [TemplateMention.CASE_CREDITOR_ZIPCODE]: 'Sagens kreditor - postnummer',
        [TemplateMention.CASE_CREDITOR_CITY]: 'Sagens kreditor - by',
        [TemplateMention.CASE_CREDITOR_COMPANY_IDENTIFIER]: 'Sagens kreditor - CVR',
        [TemplateMention.USER_NAME]: 'Brugerens navn',
        [TemplateMention.USER_FIRST_NAME]: 'Brugerens fornavn',
        [TemplateMention.IF_USER]: 'Hvis brugeren er tilgængelig',
        [TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'Hvis inddriver tillader bankoverførsler',
        [TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'Hvis inddriver tillader FIK-betalinger',
        [TemplateMention.REMINDER_FEES]: 'Rykkergebyrer',
        [TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Betalingsmuligheder',
        [TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: 'Inddrivers kontonr.',
        [TemplateMention.COLLECTOR_REGISTER_NUMBER]: 'Inddrivers reg.nr.',
        [TemplateMention.COLLECTOR_PHONE]: 'Inddrivers telefonnummer',
        [TemplateMention.COLLECTOR_COURT_PHONE]: 'Inddrivers retstelefonnummer',
        [TemplateMention.COLLECTOR_EMAIL]: 'Inddrivers email',
        [TemplateMention.COLLECTOR_NICKNAME]: 'Inddrivers kaldenavn',
        [TemplateMention.COLLECTOR_NAME]: 'Inddrivers navn',
        [TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Inddrivers adresse',
        [TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Inddrivers by',
        [TemplateMention.COLLECTOR_ADDRESS_ZIP]: 'Inddrivers postnummer',
        [TemplateMention.COLLECTOR_CVR]: 'Inddrivers CVR',
        [TemplateMention.CREDITOR_ZIPCODE]: 'Kreditors postnummer',
        [TemplateMention.CREDITOR_CITY]: 'Kreditors by',
        [TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: 'Kreditors CVR',
        [TemplateMention.PAYMENT_ID]: 'Betalings-ID',
        [TemplateMention.JOURNAL_NUMBER]: 'Journalnummer',
        [TemplateMention.COURT_NAME]: 'Rettens navn',
        [TemplateMention.COURT_ADDRESS]: 'Rettens adresse',
        [TemplateMention.COURT_CITY]: 'Rettens by',
        [TemplateMention.COURT_ZIP]: 'Rettens postnummer',
        [TemplateMention.COURT_EMAIL]: 'Rettens email',
        [TemplateMention.COURT_PHONE]: 'Rettens telefonnummer',
        [TemplateMention.COURT_EAN]: 'Rettens EAN',
        [TemplateMention.REG_NO]: 'Rettens reg.nr',
        [TemplateMention.ACCOUNT_NO]: 'Rettens kontonr.',
        [TemplateMention.PAYMENT_PLAN_HTML]: 'Afdragsordning oversigt over afdrag',
        [TemplateMention.CONTACT_ADDRESS_INLINE]: 'Konktaktpersons adresse inline',
        [TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Konktaktpersons adresse formateret',
        [TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Repræsentantens journalnummer',
        [TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Hvis repræsentant har journalnummer',
        [TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Debitors adresse inline',
        [TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Debitors adresse formateret',
        [TemplateMention.DEBTOR_TABLE]: 'Debitoroversigt',
        [TemplateMention.SIGN_FIELDS]: 'Underskriftsfelter',
        [TemplateMention.DK_BPK]: 'Betalingspåkrav',
        [TemplateMention.GL_BPK]: 'GL Betalingspåkrav',
        [TemplateMention.PAGE_BREAK]: 'Sideskift',
        [TemplateMention.PAYMENT_LINK]: 'Link betaling',
        [TemplateMention.DEBTOR_WEB_LINK]: 'Link debitorweb',
        [TemplateMention.DEBTOR_WEB_LONG_LINK]: 'Langt link debitorweb',
        [TemplateMention.PAYMENT_PLAN_LINK]: 'Link til valgmuligheder for afdragsordning',
        [TemplateMention.OVERPAYMENT_LINK]: 'Link udbetaling',
        [TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'Link til udbetaling QR-kode',
        [TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'Link til udbetaling',
        [TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Afdragsordningens afdrag i tabel',
        [TemplateMention.PAYMENT_PLAN_STATUS_TAG]: 'Afdragsordningens status',
        [TemplateMention.SATISFACTION_BUTTONS]: 'Tilfredshedsundersøgelsesknapper',
        [TemplateMention.PAYMENT_LINK_A_TAG]: 'Link til betaling',
        [TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'Link til valgmuligheder for afdragsordning',
        [TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'Link til debitorweb',
        [TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'Link til debitorweb med langt link',
        [TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'Link til debitorweb QR-kode',
        [TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'QR-kode til valgmuligheder for afdragsordning',
        [TemplateMention.PAYMENT_LINK_QR_CODE]: 'Link til betaling QR-kode',
        [TemplateMention.CONDITIONAL_ELSE]: 'Ellers',
        [TemplateMention.CONDITIONAL_END_IF]: 'Slut hvis',
        [TemplateMention.BANK_CREDITOR_NUMBER]: '',
        [TemplateMention.FOUNDATION_TYPE]: 'Fundamentstype',
        [TemplateMention.FOUNDATION_DATE]: 'Fundamentsdato',
        [TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'Nyeste FS-nummer',
    },
    mentionsExplanation: {
        [TemplateMention.PaymentPlanAmortisation]: 'Oprindelig afdragsplan med hovedstol, omkostninger, renter og restgæld. Uden betalingsstatus.',
        [TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Tekst til emnefeltet på email',
        [TemplateMention.FINANCIALS_PRICIPAL]: 'Sagens samlede hovedstol',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: 'Sagens samlede inkassogebyr',
        [TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: 'Sagens samlede administrationsomkostninger',
        [TemplateMention.FINANCIALS_COMPENSATION_FEES]: 'Sagens samlede kompensationsomkostninger',
        [TemplateMention.FINANCIALS_INTERESTS]: 'Sagens samlede renter',
        [TemplateMention.FINANCIALS_INTEREST_RATE]: 'Den laveste aktuelle renteprocent på sagen',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: 'Sagens samlede inkassoomkostninger',
        [TemplateMention.PRINCIPAL_REFERENECE_IDS]: 'Hovedstolens referencenumre',
        [TemplateMention.CURRENCY]: 'Valuta for sagens økonomi',
        [TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: 'Beløbet på første afdrag',
        [TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: 'Forfaldsdato for første afdrag',
        [TemplateMention.PAYMENT_PLAN_FIRST_DATE]: 'Dato for første afdrag',
        [TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: 'Beløbet på sidste afdrag',
        [TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: 'Forfaldsdato for sidste afdrag',
        [TemplateMention.PAYMENT_PLAN_LAST_DATE]: 'Dato for sidste afdrag',
        [TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: 'Beløbet på seneste afdrag',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: 'Forfaldsdato for seneste afdrag',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: 'Dato for seneste afdrag',
        [TemplateMention.PAYMENT_PLAN_CREATION_DATE]: 'Oprettelsesdato for afdragsordningen',
        [TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: 'Afdragsordningens længde i dage',
        [TemplateMention.PaymentPlanApr]: 'Afdragsordningens ÅOP som ét tal i procent, beregnet efter kreditaftalelovens bilag 1',
        [TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: 'Omkostninger i procent af hovedstolen opgjort år for år i afdragsordningen',
        [TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'Hvis sag har renter p.a.',
        [TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: 'Afdragsordning min. afdrag per måned',
        [TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: 'Afdragsordning maks. afdrag per måned',
        [TemplateMention.TOTAL_DEBT]: 'Beløbet på den totale gæld',
        [TemplateMention.OVERPAYMENT]: 'Beløbet af tilgodehavende',
        [TemplateMention.ACCORD_TEN_PERCENT]: 'Beløbet på den totale gæld fratrukket 10%',
        [TemplateMention.ACCORD_TWENTY_PERCENT]: 'Beløbet på den totale gæld fratrukket 20 %',
        [TemplateMention.ACCORD_THIRTY_PERCENT]: 'Beløbet på den totale gæld fratrukket 30 %',
        [TemplateMention.ACCORD_FORTY_PERCENT]: 'Beløbet på den totale gæld fratrukket 40 %',
        [TemplateMention.ACCORD_FIFTY_PERCENT]: 'Beløbet på den totale gæld fratrukket 50 %',
        [TemplateMention.ACCORD_SIXTY_PERCENT]: 'Beløbet på den totale gæld fratrukket 60 %',
        [TemplateMention.ACCORD_SEVENTY_PERCENT]: 'Beløbet på den totale gæld fratrukket 70 %',
        [TemplateMention.ACCORD_EIGHTY_PERCENT]: 'Beløbet på den totale gæld fratrukket 80 %',
        [TemplateMention.ACCORD_NINETY_PERCENT]: 'Beløbet på den totale gæld fratrukket 90 %',
        [TemplateMention.IF_IS_COMPANY]: 'Hvis sagen er erhverv',
        [TemplateMention.IF_DEBTOR_IS_DEBT_REGISTERED]: 'Hvis inddriver har registreret debitor i RKI',
        [TemplateMention.IF_CASE_HAS_MULTIPLE_PRINCIPALS]: 'Hvis sagen har flere hovedstole',
        [TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'Hvis sagen har rykkergebyrer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'Hvis sagen har inkassogebyrer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'Hvis sagen har inkassoomkostninger',
        [TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'Hvis sagen har kompensationsomkostninger',
        [TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'Hvis sagen har procesrente',
        [TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'Hvis sagen har fast rente',
        [TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'Hvis sagen har årlig rente i procent',
        [TemplateMention.IF_CASE_HAS_DEPOSIT]: 'Hvis sagen har indbetaling',
        [TemplateMention.DOCUMENTATION]: 'Dokumentation',
        [TemplateMention.DATE]: 'Dags dato',
        [TemplateMention.DATE_IN_THREE_DAYS]: 'Dato om 3 dage',
        [TemplateMention.DATE_IN_SIX_DAYS]: 'Dato om 6 dage',
        [TemplateMention.DATE_IN_TEN_DAYS]: 'Dato om 10 dage',
        [TemplateMention.DATE_IN_ELEVEN_DAYS]: 'Dato om 11 dage',
        [TemplateMention.DATE_IN_TWELVE_DAYS]: 'Dato om 12 dage',
        [TemplateMention.DATE_IN_FOURTEEN_DAYS]: 'Dato om 14 dage',
        [TemplateMention.DATE_IN_SEVENTEEN_DAYS]: 'Dato om 17 dage',
        [TemplateMention.DATE_IN_THIRTY_DAYS]: 'Dato om 30 dage',
        [TemplateMention.PREVIOUS_THREE_YEARS]: 'De tre årstal der ligger forud for indeværende år',
        [TemplateMention.DEPOSIT]: 'Beløbet der er indbetalt',
        [TemplateMention.DEPOSITS_TO_CREDITOR]: 'Beløbet indbetalt til kreditor',
        [TemplateMention.DEPOSITS_TO_COLLECTOR]: 'Beløbet indbetalt til inddriver',
        [TemplateMention.INTEREST_PAID_LAST_YEAR]: 'Beløb betalt i renter i det foregående kalenderår',
        [TemplateMention.CONTACT_NAME]: 'Kontaktpersons navn',
        [TemplateMention.DEBTOR_NAME]: 'Debitornavn',
        [TemplateMention.DEBTOR_FIRST_NAME]: 'Debitorfornavn',
        [TemplateMention.CONTACT_ADDRESS]: 'Kontaktpersons adresse',
        [TemplateMention.CONTACT_COADDRESS]: 'Kontaktpersons c/o',
        [TemplateMention.CONTACT_ZIPCODE]: 'Kontaktpersons postnummer',
        [TemplateMention.CONTACT_CITY]: 'Kontaktpersons by',
        [TemplateMention.CONTACT_COUNTRY]: 'Kontaktpersons land',
        [TemplateMention.DEBTOR_ADDRESS]: 'Debitors vej',
        [TemplateMention.DEBTOR_COADDRESS]: 'Debitors c/o',
        [TemplateMention.DEBTOR_ZIPCODE]: 'Debitors postnummer',
        [TemplateMention.DEBTOR_CITY]: 'Debitors by',
        [TemplateMention.DEBTOR_COUNTRY]: 'Debitors land',
        [TemplateMention.DEBTOR_EMAIL]: 'Debitors email',
        [TemplateMention.DEBTOR_PHONE]: 'Debitors telefonnummer',
        [TemplateMention.LAST_PAYMENT_DATE]: 'Dato for seneste indbetaling',
        [TemplateMention.LAST_PAYMENT_AMOUNT]: 'Beløb af seneste indbetaling',
        [TemplateMention.DEBTOR_SEQ_ID]: 'Debitors ID',
        [TemplateMention.DEBTOR_CVR_AND_OR_CPR]: 'Debitors CVR og/eller CPR',
        [TemplateMention.CREDITOR_NAME]: 'Kreditornavn',
        [TemplateMention.CASE_ID]: 'Sags-id',
        [TemplateMention.CASE_REFERENCE_ID]: 'Sagsreferencenummer',
        [TemplateMention.REMINDER_FEES]: 'Sagens samlede rykkergebyr',
        [TemplateMention.CREDITOR_ADDRESS]: 'Kreditors adresse',
        [TemplateMention.USER_NAME]: 'Debbie-brugerens navn',
        [TemplateMention.USER_FIRST_NAME]: 'Debbie-brugerens fornavn',
        [TemplateMention.IF_USER]: 'Hvis Debbie-brugeren er tilgængelig',
        [TemplateMention.CREDITOR_IF_IS_COMPANY]: 'Hvis kreditor er en virksomhed',
        [TemplateMention.CREDITOR_IF_IS_VAT_REGISTERED]: 'Hvis kreditor er momsregistreret',
        [TemplateMention.IF_ULTIMATE_CREDITOR]: 'Hvis sagen har en ultimativ kreditor. Kreditor-flettefelterne (navn, adresse og CVR) bruger automatisk den ultimative kreditors oplysninger på sager, hvor en ultimativ kreditor er valgt',
        [TemplateMention.CASE_CREDITOR_NAME]: 'Navnet på kreditoren på sagen. Erstattes aldrig af den ultimative kreditors oplysninger',
        [TemplateMention.CASE_CREDITOR_ADDRESS]: 'Adressen på kreditoren på sagen. Erstattes aldrig af den ultimative kreditors oplysninger',
        [TemplateMention.CASE_CREDITOR_ZIPCODE]: 'Postnummeret på kreditoren på sagen. Erstattes aldrig af den ultimative kreditors oplysninger',
        [TemplateMention.CASE_CREDITOR_CITY]: 'Byen på kreditoren på sagen. Erstattes aldrig af den ultimative kreditors oplysninger',
        [TemplateMention.CASE_CREDITOR_COMPANY_IDENTIFIER]: 'CVR-nummeret på kreditoren på sagen. Erstattes aldrig af den ultimative kreditors oplysninger',
        [TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'Hvis inddriver tillader bankoverførsler',
        [TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'Hvis inddriver tillader FIK-betalinger',
        [TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Betalingsmuligheder',
        [TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: 'Inddrivers kontonr.',
        [TemplateMention.COLLECTOR_REGISTER_NUMBER]: 'Inddrivers reg.nr.',
        [TemplateMention.COLLECTOR_PHONE]: 'Inddrivers telefonnummer',
        [TemplateMention.COLLECTOR_COURT_PHONE]: 'Inddrivers retstelefonnummer',
        [TemplateMention.COLLECTOR_EMAIL]: 'Inddrivers email',
        [TemplateMention.COLLECTOR_NICKNAME]: 'Inddrivers kaldenavn',
        [TemplateMention.COLLECTOR_NAME]: 'Inddrivers navn',
        [TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Inddrivers adresse',
        [TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Inddrivers by',
        [TemplateMention.COLLECTOR_ADDRESS_ZIP]: 'Inddrivers postnummer',
        [TemplateMention.COLLECTOR_CVR]: 'Inddrivers CVR',
        [TemplateMention.CREDITOR_ZIPCODE]: 'Kreditors postnummer',
        [TemplateMention.CREDITOR_CITY]: 'Kreditors by',
        [TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: 'Kreditors CVR',
        [TemplateMention.PAYMENT_ID]: 'Betalings-ID / FIK nummer',
        [TemplateMention.JOURNAL_NUMBER]: 'Journalnummer',
        [TemplateMention.COURT_NAME]: 'Rettens navn',
        [TemplateMention.COURT_ADDRESS]: 'Rettens adresse',
        [TemplateMention.COURT_CITY]: 'Rettens by',
        [TemplateMention.COURT_ZIP]: 'Rettens postnummer',
        [TemplateMention.COURT_EMAIL]: 'Rettens email',
        [TemplateMention.COURT_PHONE]: 'Rettens telefonnummer',
        [TemplateMention.COURT_EAN]: 'Rettens EAN',
        [TemplateMention.REG_NO]: 'Rettens reg.nr',
        [TemplateMention.ACCOUNT_NO]: 'Rettens kontonr.',
        [TemplateMention.PAYMENT_PLAN_HTML]: 'Oversigt over afrdag',
        [TemplateMention.CONTACT_ADDRESS_INLINE]: 'Konktaktpersons fulde adresse på én linje',
        [TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Konktaktpersons fulde adresse på flere linjer',
        [TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Repræsentantens journalnummer',
        [TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Hvis repræsentant har journalnummer',
        [TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Debitors fulde adresse på én linje',
        [TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Debitors fulde adresse på flere linjer',
        [TemplateMention.DEBTOR_TABLE]: 'Tabel med information om debitorer',
        [TemplateMention.SIGN_FIELDS]: 'Underskriftsfelter',
        [TemplateMention.DK_BPK]: 'PDF for betalingspåkrav',
        [TemplateMention.GL_BPK]: 'PDF for GL Betalingspåkrav',
        [TemplateMention.PAGE_BREAK]: 'Sideskift',
        [TemplateMention.PAYMENT_LINK]: 'Link til at betale hele gælden',
        [TemplateMention.DEBTOR_WEB_LINK]: 'Link til debitor web',
        [TemplateMention.DEBTOR_WEB_LONG_LINK]: 'Link til debitor web med langt link',
        [TemplateMention.PAYMENT_PLAN_LINK]: 'Link til debitors side for afdragsordning. Hvis der ikke findes ' +
            'en afdragsordning, kan debitor vælge mellem de tilgængelige ' +
            'foruddefinerede muligheder.',
        [TemplateMention.OVERPAYMENT_LINK]: 'Link udbetaling',
        [TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'Link til udbetaling QR-kode',
        [TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'Link til udbetaling',
        [TemplateMention.PAYMENT_LINK_A_TAG]: 'Link til at betale hele gælden',
        [TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Tabel over alle adrag, dato og status',
        [TemplateMention.PAYMENT_PLAN_STATUS_TAG]: 'Statuskort med fremgang, betalt beløb, restbeløb og næste afdrag',
        [TemplateMention.SATISFACTION_BUTTONS]: 'Tilfredshedsundersøgelsesknapper',
        [TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'HTML-link til debitors side for afdragsordning. Hvis der ikke ' +
            'findes en afdragsordning, kan debitor vælge mellem de ' +
            'tilgængelige foruddefinerede muligheder.',
        [TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'Link til debitorweb',
        [TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'Link til debitor web med langt link',
        [TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'Link til debitorweb (QR-kode)',
        [TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'QR-kode til debitors side for afdragsordning. Hvis der ikke ' +
            'findes en afdragsordning, kan debitor vælge mellem de ' +
            'tilgængelige foruddefinerede muligheder.',
        [TemplateMention.PAYMENT_LINK_QR_CODE]: 'Link til betaling (QR-kode)',
        [TemplateMention.CONDITIONAL_ELSE]: 'Ellers',
        [TemplateMention.CONDITIONAL_END_IF]: 'Slut hvis',
        [TemplateMention.BANK_CREDITOR_NUMBER]: '',
        [TemplateMention.FOUNDATION_TYPE]: 'Fundamentstype',
        [TemplateMention.FOUNDATION_DATE]: 'Fundamentsdato',
        [TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'Nyeste FS-nummer',
    },
    mentionsExample: {
        [TemplateMention.PaymentPlanAmortisation]: 'Dato | Hovedstol | Omkostn. | Renter | Akk. rente | Total | Ydelse | Restgæld',
        [TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Vedrørende din gæld til Testkreditor ApS [j.nr.: 171001-171533]',
        [TemplateMention.FINANCIALS_PRICIPAL]: '8.570,14 ',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: '100,00',
        [TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: '175,00',
        [TemplateMention.FINANCIALS_COMPENSATION_FEES]: '310,00',
        [TemplateMention.FINANCIALS_INTERESTS]: '26,70 ',
        [TemplateMention.FINANCIALS_INTEREST_RATE]: '10%',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: '700,00',
        [TemplateMention.PRINCIPAL_REFERENECE_IDS]: '123, 124 og 125',
        [TemplateMention.CURRENCY]: 'DKK',
        [TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: '200,00',
        [TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: '20. oktober 2021',
        [TemplateMention.PAYMENT_PLAN_FIRST_DATE]: '15. oktober 2021',
        [TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: '170,14',
        [TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: '20. august 2024',
        [TemplateMention.PAYMENT_PLAN_LAST_DATE]: '15. august 2024',
        [TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: '200,00',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: '20. november 2021',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: '15. november 20211',
        [TemplateMention.PAYMENT_PLAN_CREATION_DATE]: '17. september 2021',
        [TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: '1035',
        [TemplateMention.PaymentPlanApr]: '12,34',
        [TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: '* 1. års ÅOP: 1,33',
        [TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'Hvis sag har renter p.a.',
        [TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: '55,00',
        [TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: '550,00',
        [TemplateMention.TOTAL_DEBT]: '6.770,14',
        [TemplateMention.OVERPAYMENT]: '123,23',
        [TemplateMention.ACCORD_TEN_PERCENT]: '6.093,13',
        [TemplateMention.ACCORD_TWENTY_PERCENT]: '5.416,11',
        [TemplateMention.ACCORD_THIRTY_PERCENT]: '4.739,10',
        [TemplateMention.ACCORD_FORTY_PERCENT]: '4.062,08',
        [TemplateMention.ACCORD_FIFTY_PERCENT]: '3.385,07',
        [TemplateMention.ACCORD_SIXTY_PERCENT]: '2.708,06',
        [TemplateMention.ACCORD_SEVENTY_PERCENT]: '2.031,04',
        [TemplateMention.ACCORD_EIGHTY_PERCENT]: '1.354,03',
        [TemplateMention.ACCORD_NINETY_PERCENT]: '677,01',
        [TemplateMention.IF_IS_COMPANY]: 'Logik hvis sagen er en virksomhed',
        [TemplateMention.IF_DEBTOR_IS_DEBT_REGISTERED]: 'Logik hvis inddriver har registreret debitor i gældsregister',
        [TemplateMention.IF_CASE_HAS_MULTIPLE_PRINCIPALS]: 'Logik hvis sagen har flere hovedstole',
        [TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'Logik hvis sagen har rykkergebyrer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'Logik hvis sagen har inkassogebyr',
        [TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'Logik hvis sagen har inkassoomkostninger',
        [TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'Logik hvis sagen har kompensationsomkostninger',
        [TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'Logik hvis sagen har procesrente',
        [TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'Logik hvis sagen har fast rente',
        [TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'Logik hvis sagen har årlig rente',
        [TemplateMention.IF_CASE_HAS_DEPOSIT]: 'Logik hvis sagen har indbetaling',
        [TemplateMention.DOCUMENTATION]: 'Dokumentation',
        [TemplateMention.DATE]: '23. november 2027',
        [TemplateMention.DATE_IN_THREE_DAYS]: '26. november 2027',
        [TemplateMention.DATE_IN_SIX_DAYS]: '29. november 2027',
        [TemplateMention.DATE_IN_TEN_DAYS]: '3. december 2027',
        [TemplateMention.DATE_IN_ELEVEN_DAYS]: '4. december 2027',
        [TemplateMention.DATE_IN_TWELVE_DAYS]: '5. december 2027',
        [TemplateMention.DATE_IN_FOURTEEN_DAYS]: '7. december 2027',
        [TemplateMention.DATE_IN_SEVENTEEN_DAYS]: '10. december 2027',
        [TemplateMention.DATE_IN_THIRTY_DAYS]: '23. december 2027',
        [TemplateMention.PREVIOUS_THREE_YEARS]: '2026, 2027 og 2028',
        [TemplateMention.DEPOSIT]: '400,00',
        [TemplateMention.DEPOSITS_TO_CREDITOR]: '200,00',
        [TemplateMention.DEPOSITS_TO_COLLECTOR]: '200,00',
        [TemplateMention.INTEREST_PAID_LAST_YEAR]: '1.234,56',
        [TemplateMention.CONTACT_NAME]: 'Debbie Contactsen',
        [TemplateMention.DEBTOR_NAME]: 'Debbie Debtorsen',
        [TemplateMention.DEBTOR_FIRST_NAME]: 'Debbie',
        [TemplateMention.CONTACT_ADDRESS]: 'Applebys Pl. 7',
        [TemplateMention.CONTACT_COADDRESS]: 'Emil Brandt',
        [TemplateMention.CONTACT_ZIPCODE]: '1411',
        [TemplateMention.CONTACT_CITY]: 'Copenhagen',
        [TemplateMention.CONTACT_COUNTRY]: 'Denmark',
        [TemplateMention.DEBTOR_ADDRESS]: 'Applebys Pl. 7',
        [TemplateMention.DEBTOR_COADDRESS]: 'Emil Brandt',
        [TemplateMention.DEBTOR_ZIPCODE]: '1411',
        [TemplateMention.DEBTOR_CITY]: 'Copenhagen',
        [TemplateMention.DEBTOR_COUNTRY]: 'Denmark',
        [TemplateMention.DEBTOR_EMAIL]: 'debitor@example.com',
        [TemplateMention.DEBTOR_PHONE]: '88888888',
        [TemplateMention.LAST_PAYMENT_DATE]: '12. oktober 2021',
        [TemplateMention.LAST_PAYMENT_AMOUNT]: '200,00',
        [TemplateMention.DEBTOR_SEQ_ID]: '111111',
        [TemplateMention.DEBTOR_CVR_AND_OR_CPR]: '12345678',
        [TemplateMention.CREDITOR_NAME]: 'Testkreditor A/S',
        [TemplateMention.CASE_ID]: '12345678',
        [TemplateMention.CASE_REFERENCE_ID]: '123456789',
        [TemplateMention.CREDITOR_ADDRESS]: 'Applebys Pl. 7',
        [TemplateMention.REMINDER_FEES]: '300,00',
        [TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Betalingsmuligheder',
        [TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: '12345678',
        [TemplateMention.COLLECTOR_REGISTER_NUMBER]: '1234',
        [TemplateMention.COLLECTOR_PHONE]: '11223344',
        [TemplateMention.COLLECTOR_COURT_PHONE]: '11223345',
        [TemplateMention.COLLECTOR_EMAIL]: 'collector@debbie.dk',
        [TemplateMention.COLLECTOR_NICKNAME]: 'Testcollector',
        [TemplateMention.COLLECTOR_NAME]: 'Testcollector A/S',
        [TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Applebys Pl. 7',
        [TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Copenhagen',
        [TemplateMention.COLLECTOR_ADDRESS_ZIP]: '1411',
        [TemplateMention.COLLECTOR_CVR]: '88776655',
        [TemplateMention.CREDITOR_ZIPCODE]: '1411',
        [TemplateMention.CREDITOR_CITY]: 'Copenhagen',
        [TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: '66554433',
        [TemplateMention.CREDITOR_IF_IS_COMPANY]: 'Logik hvis kreditor er en virksomhed',
        [TemplateMention.CREDITOR_IF_IS_VAT_REGISTERED]: 'Logik hvis kreditor er momsregistreret',
        [TemplateMention.IF_ULTIMATE_CREDITOR]: 'Logik hvis sagen har en ultimativ kreditor',
        [TemplateMention.CASE_CREDITOR_NAME]: 'Testkreditor A/S',
        [TemplateMention.CASE_CREDITOR_ADDRESS]: 'Applebys Pl. 7',
        [TemplateMention.CASE_CREDITOR_ZIPCODE]: '1411',
        [TemplateMention.CASE_CREDITOR_CITY]: 'Copenhagen',
        [TemplateMention.CASE_CREDITOR_COMPANY_IDENTIFIER]: '66554433',
        [TemplateMention.USER_NAME]: 'Peter Petersen',
        [TemplateMention.USER_FIRST_NAME]: 'Peter',
        [TemplateMention.IF_USER]: 'Logik hvis brugeren er tilgængelig',
        [TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'Logik hvis inddriver tillader bankoverførsler',
        [TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'Logik hvis inddriver tillader FIK-betalinger',
        [TemplateMention.PAYMENT_ID]: '+71<000000001111111 + 12345678<',
        [TemplateMention.JOURNAL_NUMBER]: '12345678-111111',
        [TemplateMention.COURT_NAME]: 'Københavns Byret',
        [TemplateMention.COURT_ADDRESS]: 'Hestemøllestræde 6',
        [TemplateMention.COURT_CITY]: 'København K',
        [TemplateMention.COURT_ZIP]: '1464',
        [TemplateMention.COURT_EMAIL]: 'foged.kbh@domstol.dk',
        [TemplateMention.COURT_PHONE]: '99687000',
        [TemplateMention.COURT_EAN]: '5798000161252',
        [TemplateMention.REG_NO]: '0216',
        [TemplateMention.ACCOUNT_NO]: '4069134793',
        [TemplateMention.PAYMENT_PLAN_HTML]: '* 1. Indbetaling på DKK 200,00 inden 15. oktober 2021',
        [TemplateMention.CONTACT_ADDRESS_INLINE]: 'Applebys Plads 7, 1411 København K',
        [TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Applebys Plads 7,\n 1411 København K',
        [TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: '123-123',
        [TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Logik hvis repræsentant har journalnummer',
        [TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Applebys Plads 7, 1411 København K',
        [TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Applebys Plads 7,\n 1411 København K',
        [TemplateMention.DEBTOR_TABLE]: 'Debitor 1|Debitor 2|...',
        [TemplateMention.SIGN_FIELDS]: 'Dato\n_______________________\nUnderskrift',
        [TemplateMention.DK_BPK]: 'PDF',
        [TemplateMention.GL_BPK]: 'PDF',
        [TemplateMention.PAGE_BREAK]: 'Sideskift',
        [TemplateMention.PAYMENT_LINK]: 'debtorweb.dk/r/fuldegæld',
        [TemplateMention.DEBTOR_WEB_LINK]: 'debtorweb.dk',
        [TemplateMention.DEBTOR_WEB_LONG_LINK]: 'debtorweb.dk',
        [TemplateMention.PAYMENT_PLAN_LINK]: 'debtorweb.dk/r/afdragsordning',
        [TemplateMention.OVERPAYMENT_LINK]: 'debtorweb.dk/r/udbetaling',
        [TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'QR-kode',
        [TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'debtorweb.dk/r/udbetaling',
        [TemplateMention.PAYMENT_LINK_A_TAG]: 'debtorweb.dk/r/fuldegæld',
        [TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Beløb | Dato | Status',
        [TemplateMention.PAYMENT_PLAN_STATUS_TAG]: '3 af 8 afdrag · Næste 31.05.26',
        [TemplateMention.SATISFACTION_BUTTONS]: '(:D) (:|) (:C)',
        [TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'debtorweb.dk/r/afdragsordning',
        [TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'debtorweb.sk',
        [TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'debtorweb.dk',
        [TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'QR-kode',
        [TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'QR-kode',
        [TemplateMention.PAYMENT_LINK_QR_CODE]: 'QR-kode',
        [TemplateMention.CONDITIONAL_ELSE]: 'Ellers',
        [TemplateMention.CONDITIONAL_END_IF]: 'Slut hvis',
        [TemplateMention.BANK_CREDITOR_NUMBER]: 'N/A',
        [TemplateMention.FOUNDATION_TYPE]: 'Dom',
        [TemplateMention.FOUNDATION_DATE]: '23. november 2021',
        [TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'FS 11-1111/1111',
    },
    import: {
        result: {
            description: 'Dine data er importeret. Her kan du se resultatet og arbejde videre med sagerne.',
            finishedWithErrors: 'Import afsluttet med fejl',
            errorsDescription: 'Importen er afsluttet, men nogle rækker kunne ikke importeres.',
            processedSheets: 'Importerede ark',
            processedRows: 'rækker behandlet',
            sheet: 'Ark',
            viewCases: 'Se oprettede sager',
            failedTitle: 'Disse rækker kræver opmærksomhed',
            failedDescription: 'Download de fejlede rækker, ret fejlene og importér kun de rettede rækker i en ny import.',
            viewFailedRows: 'Se fejlede rækker',
            nextStep: 'Klar til næste skridt',
            approveDescription: 'Godkend de oprettede sager, der afventer godkendelse, når du har gennemgået resultatet.',
            actionStarted: 'Handlingen er sat i kø. Du modtager en e-mail, når den er færdig.',
            noCreatedCases: 'Importen har ingen oprettede sager.',
            endTitle: 'Afslut de oprettede sager',
            endDescription: 'Dette afslutter de oprettede sager, som afventer godkendelse eller er godkendt, med årsagen Fejl fra vores side. Vil du fortsætte?',
        },
        progress: {
            linking: 'Tilknytter kontaktpersoner',
            title: 'Importerer dine data',
            description: 'Du kan forlade siden. Importen fortsætter i baggrunden, og fremdriften bliver gemt løbende.',
            preparing: 'Forbereder importen',
            rows: 'rækker importeret',
            pending: 'Afventer',
            running: 'Importerer',
            completed: 'Færdig',
            failed: 'Stoppet',
            pausedTitle: 'Importen kræver opmærksomhed',
            pausedDescription: 'En opgave fejlede efter flere forsøg. Ret årsagen og genoptag importen. Allerede importerede data bliver ikke oprettet igen.',
            retry: 'Genoptag import',
            finishing: 'Afslutter importen',
            legacy: 'Denne import blev startet uden gemt fremdrift. Status opdateres, når den er afsluttet.',
        },
        workbook: {
            otherCaseGroup: 'Anden sagsgruppe · gemmes, men bruges ikke i denne import',
            otherCaseGroupMappings: 'Mappingen indeholder attributter til andre sagsgrupper. De bevares og bruges, når du importerer til den relevante sagsgruppe.',
            unavailableField: 'Utilgængeligt felt',
            unavailableMappings: 'Nogle mappings bruger utilgængelige felter',
            unavailableMappingsDescription: 'Et valgt felt findes ikke længere eller kan ikke importeres i dette ark. Åbn kolonnens feltvalg, og fjern eller erstat det utilgængelige felt. Attributter til andre sagsgrupper bevares og udløser ikke denne advarsel.',
            selectField: 'Vælg felt',
            reuploadForHeaders: 'Upload filen igen for at kunne ændre overskriftsrækken.',
            fields: {
                accountNumber: 'Bankkontonummer',
                address: 'Adresse',
                administrationCost: 'Administrationsgebyr',
                alternativeContactAddress: 'Alternativ kontakt: adresse',
                alternativeContactCity: 'Alternativ kontakt: by',
                alternativeContactCoAddress: 'Alternativ kontakt: c/o-adresse',
                alternativeContactCountry: 'Alternativ kontakt: land',
                alternativeContactEmail: 'Alternativ kontakt: e-mail',
                alternativeContactName: 'Alternativ kontakt: navn',
                alternativeContactPhone: 'Alternativ kontakt: telefonnummer',
                alternativeContactType: 'Alternativ kontakt: type',
                alternativeContactZipcode: 'Alternativ kontakt: postnummer',
                amount: 'Beløb',
                bailifsFee: 'Betalingspåkravsgebyr',
                bailifsSalary: 'Sagsomkostninger',
                birthdate: 'Fødselsdato',
                bpkWarnedAt: 'BPK varslingsdato',
                caseCreatedAt: 'Sagsoprettelsesdato',
                caseGroup: 'Sagsgruppe',
                caseReferenceId: 'Sagsreferencenummer',
                caseSeqId: 'Sagsnummer',
                caseStatus: 'Sagsstatus',
                caseTags: 'Sagsmærkater',
                centralRegisterId: 'CVR-/registreringsnummer',
                city: 'By',
                clientContactUserEmail: 'Kontaktpersons e-mail',
                coAddress: 'C/o-adresse',
                collectionCost: 'Inkassoomkostninger',
                collectionFee: 'Inkassogebyrer',
                compensationCost: 'Kompensationsgebyrer',
                compoundInterestRate: 'Renters rente',
                continuedAt: 'Genoptagelsesdato',
                controlFee: 'Kontrolafgift',
                country: 'Land',
                countryCode: 'Landekode',
                cpr: 'CPR',
                createdAt: 'Oprettet',
                createdByUserWithEmail: 'Oprettet af bruger med e-mail',
                creditNote: 'Kreditnota',
                creditorReferenceId: 'Kreditorreferencenummer',
                currency: 'Valuta',
                customerReferenceId: 'Kundereferencenummer',
                customerTerminated: 'Kundeforhold ophørt',
                cvr: 'CVR',
                date: 'Dato',
                debtDescription: 'Beskrivelse af postering',
                debtReferenceId: 'Fakturanummer',
                defaultBillingModelId: 'Standardafregningsmodel',
                defaultWorkflowId: 'Standardworkflow',
                deposit: 'Indbetaling',
                dueDate: 'Forfald',
                economyBillingModelId: 'Afregningsmodel',
                email: 'E-mail',
                endReason: 'Afslutningsårsag',
                experianClientId: 'Kundenummer hos Experian',
                expirationFromDate: 'Forældelses startdato',
                fiPaymentIdRaw: 'FIK-betalingslinje',
                fileId: 'Fil-ID',
                fileName: 'Filnavn',
                fileNote: 'Filnote',
                finalSettlement: 'Opgørelse',
                finalStatement: 'Endeligt opgjort',
                firstName: 'Fornavn',
                fixedInterest: 'Fast rente',
                fogedRekvisitionsFee: 'Fogedrekvisitionsgebyr',
                from: 'Afsender',
                html: 'Indhold (HTML)',
                imposedByCreditor: 'Pålagt af kreditor',
                interestEndDate: 'Renteslutdato',
                interestRate: 'Rente',
                interestStartDate: 'Rentestartdato',
                interval: 'Interval',
                isCompany: 'Er virksomhed',
                issueDate: 'Dato',
                lang: 'Sprog',
                lastName: 'Efternavn',
                loan: 'Gældsbrev',
                migratedId: 'Migreret journalnummer',
                migratedStepId: 'Migreret opgave-ID',
                name: 'Navn',
                newUserToken: 'Invitationstoken til ny bruger',
                note: 'Note',
                notes: 'Noter',
                onAccount: 'Acontobeløb',
                pausedAt: 'Pausedato',
                phone: 'Telefonnr.',
                phoneLocale: 'Telefonlandekode',
                phoneNumber: 'Telefonnummer',
                policePresentationFee: 'Politifremstillingsgebyr',
                principal: 'Hovedstol',
                referenceId: 'Referencenummer',
                referenceVoucherReferenceId: 'Relateret posteringsreference',
                referenceVoucherTypeId: 'Relateret posteringstype',
                refund: 'Refusion',
                registrationNumber: 'Bankregistreringsnummer',
                registryIdentifierScheme: 'Identifikationstype',
                registryIdentifierValue: 'Virksomhedsidentifikation',
                remindedAt: 'Påmindelsesdato',
                reminderFee: 'Rykkergebyrer',
                reminderFeeCollector: 'Rykkergebyrer fra inddriver',
                rkiWarnedAt: 'RKI varslingsdato',
                role: 'Rolle',
                settlement: 'Frivilligt forlig',
                signedAt: 'Underskriftsdato',
                startDate: 'Startdato',
                state: 'Status',
                subject: 'Emne',
                text: 'Tekst',
                to: 'Modtager',
                type: 'Type',
                udtraeksgebyr: 'Udtræksgebyr',
                ultimateCreditorReferenceId: 'Ultimativ kreditors referencenummer',
                update: 'Opdatering',
                updateTypeId: 'Opdateringstype',
                vatRegistered: 'Momsregistreret',
                visibleForDebtor: 'Synlig for debitor',
                voucherReferenceId: 'Posteringsreferencenummer',
                writFee: 'Stævningsgebyr',
                writSalary: 'Stævningssalær',
                zipcode: 'Postnummer',
            },
            mappedFromColumn: 'Kolonne i filen',
            mappedColumns: 'mappede kolonner',
            columnHint: 'Klik på feltet under en kolonneoverskrift for at vælge, hvor værdierne skal bruges.',
            missingFields: 'Påkrævede felter uden kolonne',
            emptySheet: 'Arket har ingen datarækker. Vælg et andet ark, eller ret overskriftsrækken.',
            mappingHint: 'Vælg et eller flere felter til kolonnen. Et felt kan kun hente værdier fra én kolonne ad gangen.',
            sheets: 'ark',
            skipped: 'Importeres ikke',
            importAs: 'Importér som',
            skipSheet: 'Spring arket over',
            headerRow: 'Overskriftsrække',
            skippedDescription: 'Dette ark er ikke med i importen. Du kan stadig se indholdet.',
            sourcePreview: 'Data fra filen',
            searchFields: 'Søg efter felter…',
            searchTypes: 'Søg efter arktype…',
            addFixedValue: 'Tilføj fast værdi',
            fixedValue: 'Fast værdi',
            mappingSaving: 'Gemmer opsætning…',
            mappingSaved: 'Opsætningen er gemt',
            mappingSaveFailed: 'Opsætningen kunne ikke gemmes. Dine ændringer er stadig på siden.',
            retryMappingSave: 'Prøv igen',
            unsavedMapping: 'Dine ændringer er ikke gemt endnu. Vil du forlade siden?',
            attachmentNotUploaded: 'Bilaget er ikke uploadet',
            fixedFileHint: 'Upload bilaget under Upload bilag, og vælg derefter filen her.',
            fixedValueHint: 'Gælder alle rækker og erstatter feltets mapping til en Excel-kolonne.',
            removeFixedValue: 'Fjern',
            imposedBy: 'Pålagt af',
            creditor: 'Kreditor',
            collector: 'Inddriver',
            attribute: 'Attribut',
            createAttribute: 'Opret ny attribut',
            mappingSettings: 'Indstillinger',
            invertSign: 'Vend fortegn',
            voucherSignHint: 'Beløbene i tabellen skal have disse fortegn:',
            voucherDebtSign: 'Gæld, renter og omkostninger: negativt beløb, fx −1.000,00. Det øger gælden.',
            voucherCreditSign: 'Kreditnotaer og indbetalinger: positivt beløb, fx +250,00. Det nedbringer gælden.',
            invertSignDescription: 'Positive værdier bliver negative, og negative bliver positive. Tabellen viser værdierne med dine indstillinger.',
            duplicateHeaders: 'Kolonnenavne skal være unikke. Vælg den rigtige overskriftsrække, eller omdøb dubletter i filen.',
            missingColumns: 'Nogle gemte kolonner mangler. Vælg en ny kolonne, eller fjern mappingen.',
            types: {
                cases: 'Sager',
                customers: 'Kunder',
                vouchers: 'Sagsposteringer',
                creditors: 'Kreditorer',
                ultimateCreditors: 'Ultimative kreditorer',
                users: 'Brugere',
                billingVouchers: 'Afregningsposteringer',
                notes: 'Noter',
                emails: 'E-mails',
                letters: 'Breve',
                sms: 'SMS',
                steps: 'Opgaver',
                updates: 'Opdateringer',
                documents: 'Dokumenter',
                paymentPlans: 'Afdragsordninger',
            },
        },
        importedData: 'Importeret data',
        downloadInvoiceExampleHeader: 'Fakturakrav',
        downloadInvoiceExampleText: 'Download import-ark med eksempler på fakturakrav.',
        downloadFinancialExampleHeader: 'Bankfordringer',
        downloadFinancialExampleText: 'Download import-ark med eksempler på bankfordringer.',
        downloadAcontoExampleHeader: 'Acontofakturering',
        downloadAcontoExampleText: 'Download import-ark med eksempler på acontofakturering.',
        downloadMigrationExampleHeader: 'Migrering',
        downloadMigrationExampleText: 'Download migrerings-ark med eksempler på indhold.',
        download: 'Download eksempel',
        import: 'Import',
        backToImports: 'Tilbage til import',
        newImport: 'Ny import',
        noImports: 'Endnu ingen importeringer at vise',
        casesCreated: 'Sager oprettet',
        casesUpdated: 'Sager opdateret',
        companyStatuses: 'Virksomhedsstatusser',
        noStatus: 'Ingen status',
        caseUpdates: 'Sagsopdateringer',
        migration: 'Migrering',
        createdAt: 'Oprettet',
        state: 'Status',
        [ImportState.CANCELED]: 'Annulleret',
        [ImportState.CREATED]: 'Oprettet',
        [ImportState.DELETED]: 'Slettet',
        [ImportState.IMPORTED]: 'Importeret',
        [ImportState.IMPORTING]: 'Importerer',
        [ImportState.SHEETADDED]: 'Excelark tilføjet',
        create: 'Opret',
        uploadFile: 'Tilføj excelark',
        uploadedAppendicies: 'Tilføjede bilag',
        mapColumns: 'Map kolonner',
        imported: 'Importeret',
        dropFileHereOr: 'Træk og slip en fil her eller',
        dropAnotherFileHereOr: 'Træk og slip en tilrettet fil her eller',
        uploadFileBtn: 'upload her',
        deleteImport: 'Slet import',
        importFinished: 'Import færdig',
        dropAppendixHereOr: 'Træk og slip et bilag her eller',
        uploadImport: 'Upload import-ark',
        uploadAppendix: 'Upload bilag',
        workbookGuide: {
            title: 'Upload dit Excel-ark',
            description: 'Saml dine data i en Excel-fil, og forbind kolonnerne med felterne i Debbie.',
            dropFile: 'Træk og slip dit Excel-ark her',
            fileFormats: 'Vælg en Excel-fil i formatet .xlsx eller .xls.',
            replaceFile: 'En ny fil erstatter det nuværende import-ark.',
            chooseFile: 'Vælg fil',
            uploadTitle: 'Upload import-arket',
            uploadDescription: 'Vælg Excel-filen med de data, du vil importere. Filen kan indeholde flere ark.',
            sheetsTitle: 'Vælg indholdet i hvert ark',
            sheetsDescription: 'Angiv, om arket indeholder f.eks. sager, kunder eller posteringer. Spring ark over, der ikke skal importeres.',
            mappingTitle: 'Map kolonnerne, og kontrollér data',
            mappingDescription: 'Forbind kolonnerne med felterne i Debbie, og ret eventuelle fejl, før du importerer.',
        },
        appendixGuide: {
            title: 'Knyt bilag til dine rækker i Excel',
            description: 'Upload dine filer her, og brug filnavnene i Excel til at forbinde hvert bilag med den rigtige række.',
            dropFiles: 'Træk og slip dine bilag her',
            multipleFiles: 'Du kan uploade flere filer på én gang.',
            chooseFiles: 'Vælg filer',
            uploadTitle: 'Upload bilagene',
            uploadDescription: 'Vælg de filer, der skal med i importen, f.eks. fakturaer eller aftaler.',
            referenceTitle: 'Skriv filnavnet i Excel',
            referenceDescription: 'Tilføj en kolonne med filnavnet på den række, bilaget hører til. Brug hele filnavnet, inklusive f.eks. .pdf.',
            mappingTitle: 'Map kolonnen til et filfelt',
            mappingDescription: 'Upload det opdaterede Excel-ark under “Upload import-ark”. Map kolonnen til “Filnavn” eller en filegenskab, før du importerer.',
        },
        appendixUploaded: 'Bilag uploadet',
        withRKIRegistrations: 'med RKI-registreringer',
        endAll: 'Afslut alle',
        approveAll: 'Godkend alle sager',
        createdCases: 'oprettede sager.',
        startedEnding: 'Påbegyndt at afslutte alle',
        cases: 'sager.',
        found: 'Fandt',
        rows: 'rækker',
        and: 'og',
        debtors: 'debitorer',
        chain: 'Workflow',
        billingModel: 'Afregningsmodel',
        tenantStandard: 'Kontostandard',
        creditorStandard: 'Kreditorstandard',
        systemStandard: 'Systemstandard',
        importCases: 'Importér',
        more: 'flere.',
        showMore: 'Vis flere',
        youWillreceiveAnEmailWhenItIsDone: 'Du vil modtage en email når importen er færdig',
        importHasStarted: 'Importen er i gang',
        see: 'Se',
        seeMore: 'Se mere',
        here: 'her',
        file: 'filens',
        asWell: 'eller læs mere i vores',
        notMappedColumns: 'Følgende kolonner blev ikke mappet',
        errors: 'fejl',
        error: 'Fejl',
        row: 'Række',
        column: 'Kolonne',
        columnNotFound: 'Kolonne ikke fundet',
        noErrorsFound: 'Ingen fejl fundet',
        rowsHeader: 'Rækker',
        columnsHeader: 'Kolonner',
        failedRows: 'Fejlet rækker',
        failedImportRows: 'Fejlede import-rækker',
        referenceId: 'Kundereferencenummer',
        creditorReferenceId: 'Kreditorreferencenummer',
        ultimateCreditorReferenceId: 'Ultimativ kreditor referencenummer',
        isCompany: 'Er virksomhed',
        caseCreatedAt: 'Sagsoprettelsesdato',
        caseStatus: 'Sagsstatus',
        endReason: 'Afslutningsårsag',
        caseGroup: 'Sagsgruppe',
        migratedId: 'Migreret journalnummer',
        name: 'Navn',
        birthdate: 'Fødselsdato',
        cpr: 'CPR',
        cvr: 'CVR',
        email: 'Email',
        phone: 'Telefonnr.',
        lang: 'Sprog',
        address: 'Adresse',
        coAddress: 'C/O-Adresse',
        zipcode: 'Postnummer',
        city: 'By',
        country: 'Land',
        fiPaymentIdRaw: 'FIK-betalingslinje',
        caseTags: 'Economy tags',
        economyBillingModelId: 'Afregningsmodel',
        debtReferenceId: 'Fakturanummer',
        fileName: 'Filnavn',
        issueDate: 'Dato',
        dueDate: 'Forfald',
        expirationFromDate: 'Forældelses startdato',
        currency: 'Valuta',
        debtDescription: 'Beskrivelse af postering',
        principal: 'Hovedstol',
        controlFee: 'Kontrolafgift',
        loan: 'Gældsbrev',
        settlement: 'Frivilligt forlig',
        fixedInterest: 'Fast rente',
        udtraeksgebyr: 'Udtræksgebyr',
        administrationCost: 'Administrationsgebyr',
        onAccount: 'Acontobeløb',
        finalSettlement: 'Opgørelse',
        deposit: 'Indbetaling',
        reminderFee: 'Rykkergebyrer',
        reminderFeeCollector: 'Rykkergebyrer fra inddriver',
        refund: 'Refusion',
        compensationCost: 'Kompensationsgebyrer',
        collectionCost: 'Inkassoomkostninger',
        collectionFee: 'Inkassogebyrer',
        writFee: 'Stævningsgebyr',
        writSalary: 'Stævningssalær',
        policePresentationFee: 'Politifremstillingsgebyr',
        fogedRekvisitionsFee: 'Fogedrekvisitionsgebyr',
        bailifsSalary: 'Sagsomkostninger',
        bailifsFee: 'Betalingspåkravsgebyr',
        creditNote: 'Kreditnota',
        interestStartDate: 'Rentestartdato',
        interestRate: 'Rente',
        finalStatement: 'Endeligt opgjort',
        customerTerminated: 'Kundeforhold ophørt',
        rkiWarnedAt: 'RKI varslingsdato',
        bpkWarnedAt: 'BPK varslingsdato',
        errorWarning: 'Dit excel-ark indeholder fejl, der forhindrer importen',
        faqHeader: 'Brug for hjælp til at importere sager?',
        faqText: 'Vi har i vores hjælp-sektion skrevet en artikel om vores import-modul. Her finder du blandt andet forklaringer på typiske fejl og meget mere.',
        newCase: 'Ny sag',
        selectColumn: '-- Vælg kolonne --',
        debtorMessages: 'Debitorbeskeder',
        importDebtorMessages: 'Importer debitorbeskeder',
    },
    updateTypesSettings: {
        addUpdateType: 'Opret opgavetype',
        title: 'Opgavens titel',
        editUpdateType: 'Redigér opgavetype',
        createNewUpdateType: 'Opret opgavetype',
        customUpdateTypes: 'Oprettede opgavetyper',
        standardUpdateTypes: 'Standardopgavetyper',
        allUpdateTypes: 'Alle opgavetyper',
        filterAutomatic: 'Automatiske',
        filterPause: 'Pause',
        filterInfo: 'Info',
    },
    updateTypes: {
        // TODO
        ['d508ccc2-7b38-4561-99b8-e3e1516281a9']: 'KYC / AML gennemført',
        ['b3a86e9e-37ce-42d4-9c57-4906b298d218']: 'Til rykkerforløb',
        ['2850ea55-e7e4-4d77-aa81-1b60fcdc1d46']: 'Stævning',
        ['46ad9f0c-3e23-4d6d-bcf1-3c0846c78a9a']: 'Betalingspåkrav',
        ['7f272584-75a9-4deb-ae0a-9876c061cc70']: 'Fogedrekvisition',
        [UpdateType.CreditorEndedCase]: 'Kreditor har afsluttet sagen',
        [UpdateType.AKSStatus]: 'AKS-status',
        [UpdateType.AKSFailed]: 'AKS-tilmelding mislykket',
        [UpdateType.EXITREQUEST]: 'Afslutningsanmodning fra kreditor',
        [UpdateType.CASESTATUSMOVE]: 'Sagsstatus ændret',
        [UpdateType.SOP]: 'Endeligt opgjort',
        [UpdateType.UPDATE]: 'Opdatering',
        [UpdateType.NOCONTACTINFORMATION]: 'Manglende kontaktinformation',
        [UpdateType.DEPOSIT]: 'Indbetaling',
        [UpdateType.NEWDEBT]: 'Ny gæld',
        [UpdateType.NEWINTERACTION]: 'Ny e-mail journaliseret',
        [UpdateType.eBoksFailed]: 'e-Boks-besked kunne ikke leveres',
        [UpdateType.TECHNICALINVESTIGATION]: 'Undersøges af en tekniker',
        [UpdateType.TERMINATIONREQUEST]: 'Anmodning om afbrydelse sendt til kreditor',
        [UpdateType.PENDINGTERMINATION]: 'Afventer afbrydelse af sagsbehandler',
        [UpdateType.CANCELTERMINATION]: 'Annullering af afbrydelse',
        [UpdateType.CASECONTINUED]: 'Sag fortsat',
        [UpdateType.POSTPONECASEWORKING]: 'Udskyd sagsbehandling',
        [UpdateType.RETURNLETTER]: 'Brev returneret',
        [UpdateType.BOBEHANDLING]: 'Bobehandle',
        [UpdateType.BOBEHANDLET]: 'Bobehandlet',
        [UpdateType.NotSureCourtSubmit]: 'Betalingspåkrav: Afventer manuel håndtering',
        [UpdateType.YesCourtSubmit]: 'Betalingspåkrav: Klar til automatisk indlevering',
        [UpdateType.NoCourtSubmit]: 'Betalingspåkrav: Ikke udtaget til indlevering',
        [UpdateType.AWAITINGSTAEVNING]: 'Afventer stævning',
        [UpdateType.AFDRAGSORDNINGER]: 'Afdragsordninger',
        [UpdateType.ApprovedByCreditor]: 'Godkendt af kreditor',
        [UpdateType.ApprovedByDatahub]: 'Godkendt af DataHub',
        [UpdateType.CancelApprovedByDatahub]: 'Annullering godkendt af DataHub',
        [UpdateType.REMOVEFROMRKI]: 'Fjern fra RKI',
        [UpdateType.AUTOREMOVEFROMRKI]: 'Automatisk sletning af RKI-registrering',
        [UpdateType.CancelRejectedByDatahub]: 'Annullering afvist af DataHub',
        [UpdateType.CancelRequestedBecauseOfPaymentToCreditor]: 'Annullering anmodet, grundet betaling til kreditor',
        [UpdateType.RejectedByCreditor]: 'Afvist af kreditor',
        [UpdateType.RejectedByDatahub]: 'Afvist af DataHub',
        [UpdateType.PAYMENTPLANINITIAL]: 'Ny afdragsordning oprettet',
        [UpdateType.NEWCLIENTINTERACTION]: 'Ny kreditorbesked',
        [UpdateType.NEWDEBTORINTERACTION]: 'Ny debitorbesked',
        [UpdateType.DEBTORPERSONALDATAREQUEST]: 'Anmodning om opdatering af debitorinformation',
        [UpdateType.AWAITINGCLIENTANSWER]: 'Afventer svar fra kreditor',
        [UpdateType.DEFAULTEDPAYMENTPLAN]: 'Misligholdt afdragsordning',
        [UpdateType.OVERPAYPAYMENTPLAN]: 'Overbetalt afdragsordning',
        [UpdateType.RKIApprovalRequest]: 'RKI: Anmodning til sagsbehandler',
        [UpdateType.RKIApproved]: 'RKI: Godkendt til registrering',
        [UpdateType.RKIDenied]: 'RKI: Registrering afvist',
        [UpdateType.RKIREGISTRATION]: 'Håndtér registrering i RKI',
        [UpdateType.DOCSIGNED]: 'Dokument underskrevet',
        [UpdateType.COSMOSUBSCRIBED]: 'Tilmeldt Cosmo',
        [UpdateType.COSMOUNSUBSCRIBED]: 'Afmeldt Cosmo',
        [UpdateType.AWAITINGFOGEDREKVISITION]: 'Afventer fogedrekvisition',
        [UpdateType.ISINFOGEDRETTEN]: 'Er i fogedretten',
        [UpdateType.ISINCIVILCOURT]: 'Er i civilretten',
        [UpdateType.PAYMENTONCASEINCOURT]: 'Betaling på sag i retten',
        [UpdateType.RECEIVEDCOURTFOUNDATION]: 'Modtaget Dom',
        [UpdateType.POLITIFREMSTILLING]: 'Politifremstilling',
        [UpdateType.DECIDECOURT]: 'Vurdér eventuelle retslige skridt',
        [UpdateType.RKISTATUS]: 'RKI-status',
        [UpdateType.AWAITINGPOWERTERMINATION]: 'Afventer strømluk',
        [UpdateType.RKIAPPROVEDBYCLIENT]: 'RKI godkendt af kreditor',
        [UpdateType.REQUESTCLIENTRKI]: 'Anmodning om godkendelse af at RKI-betingelserne er opfyldt',
        [UpdateType.TERMINATEDCUSTOMER]: 'Opsagt kunde',
        [UpdateType.FOGEDREVISITIONCLIENTREQUEST]: 'Anmodning om fogedrekvisition til kreditor',
        [UpdateType.TICKETRESOLVED]: 'Ticket løst',
        [UpdateType.MIGRATIONNOTE]: 'Migreringsnote',
        [UpdateType.TILJURIDISKBEHANDLING]: 'Til juridisk behandling',
        [UpdateType.COURTEVENTS]: 'Retsfrister',
        [UpdateType.AFTEROFFICEHOURS]: 'Behandles efter telefontid',
        [UpdateType.AWAITINGPAYMENTAFTERCONCILIATION]: 'Afventer betaling ifm. forlig',
        [UpdateType.PHONEMEETING]: 'Indkaldt til fogedmøde',
        [UpdateType.INSOLVENS]: 'Insolvens',
        [UpdateType.DEBTEXPIRESWITHINTHREEMONTHS]: 'Gæld forælder indenfor 3 måneder',
        [UpdateType.DEBTEXPIRED]: 'Gæld forældet',
        [UpdateType.EMAILFAILED]: 'Email fejlet permanent',
        [UpdateType.EINVOICEFAILED]: 'E-faktura fejlet',
        [UpdateType.AWAITINGCIVILCOURT]: 'Afventer civilretten',
        [UpdateType.AWAITINGFINALSTATEMENT]: 'Afventer endelig opgørelse',
        [UpdateType.MIGRATEDJOURNALNUMBER]: 'Migreret journalnummer',
        [UpdateType.RKIREGISTRATIONOPEN]: 'RKI-registrering (Åben)',
        [UpdateType.RKIREGISTRATIONCLOSED]: 'RKI-registrering (Lukket)',
        [UpdateType.AUTORKIREGISTRATIONOPEN]: 'Auto-RKI registrering (Åben)',
        [UpdateType.AUTORKIREGISTRATIONCLOSED]: 'Auto-RKI registrering (Lukket)',
        [UpdateType.DEBTREGISTRATIONWARNED]: 'Gældsregister-varslet',
        [UpdateType.STAEVNINGREQUSTCLIENT]: 'Kreditor, skal debitor stævnes?',
        [UpdateType.UDLAEG]: 'Udlæg',
        [UpdateType.UDLAEGCIVIL]: 'Udlæg',
        [UpdateType.NEWCOURTINTERACTION]: 'Ny e-mail fra retten',
        [UpdateType.REMINDER]: 'Påmindelse',
        [UpdateType.OUTBOUNDCALL]: 'Udgående opkald',
        [UpdateType.UDLAEGAFLYSES]: 'Udlæg skal aflyses',
        [UpdateType.OPPOSITION]: 'Indsigelse',
        [UpdateType.NOTOPPOSITION]: 'Ikke-indsigelse',
        [UpdateType.FSNUMMER]: 'FS-nummer',
        [UpdateType.OVERDRAGESTILINKASSOPARTNER]: 'Skal overdrages til ekstern inkassopartner',
        [UpdateType.AKSUpdateName]: 'AKS Opdateret: Navn',
        [UpdateType.AKSUpdateAddress]: 'AKS Opdateret: Adresse',
        [UpdateType.AKSUpdateStatus]: 'AKS Opdateret: Status',
        [UpdateType.AKSUpdateProtection]: 'AKS Opdateret: Navn/Adresse-beskyttelse',
        [UpdateType.AKSUpdateNewRKI]: 'AKS Opdateret: Ny RKI-registrering',
        [UpdateType.AKSUpdateDeletedRKI]: 'AKS Opdateret: Fjernet RKI-registrering',
        [UpdateType.AKSUpdateCreditWarning]: 'AKS Opdateret: Kreditadvarsel',
        [UpdateType.AKSUpdateAdvertisementPreference]: 'AKS Opdateret: Reklamepreference',
        [UpdateType.AKSUpdateGuardianStatus]: 'AKS Opdateret: Værge Status',
        [UpdateType.AKSUpdateRKI]: 'AKS Opdateret: RKI-bemærkning',
        [UpdateType.COURTREMINDER]: 'Retslig påmindelse',
        [UpdateType.DEPARTED]: 'Udrejst',
        [UpdateType.DECIDECONTINUE]: 'Vurder om sagen skal fortsættes',
        [UpdateType.Dead]: 'Debitor er død',
        [UpdateType.MovedAbroad]: 'Debitor er udrejst',
        [UpdateType.Disappeared]: 'Debitor er forsvundet',
        [UpdateType.Homeless]: 'Debitor er nu hjemløs',
        [UpdateType.Inactive]: 'Virksomheden er nu inaktiv',
        [UpdateType.OperationsCeased]: 'Virksomheden er ophørt',
        [UpdateType.GuardianStatus]: 'Værge-status opdateret',
        [UpdateType.DeletedRKIRegistration]: 'RKI-registrering fra anden kreditor slettet',
        [UpdateType.DeletedRKIRegistrationWillingnessToPay]: 'RKI-registrering fra anden kreditor slettet - indikation på betalingsvilje',
        [UpdateType.NewRKIRegristration]: 'Ny RKI-registrering fra anden kreditor',
        [UpdateType.Address]: 'Adresse opdateret',
        [UpdateType.AddressProtection]: 'Navne/Adresse-beskyttelse',
        [UpdateType.RKIRemark]: 'RKI-bemærkning opdateret',
        [UpdateType.Active]: 'Debitor er nu aktiv',
        [UpdateType.CompanyActive]: 'Virksomheden er nu aktiv',
        [UpdateType.DissolutionStatus]: 'Opløsningsstatus',
        [UpdateType.PAYMENTPLANCANCLED]: 'Afdragsordning annulleret',
        [UpdateType.INTERNALREMARK]: 'Intern bemærkning',
        [UpdateType.MOVETOOPENRKI]: 'Flyt til åben RKI',
        [UpdateType.DebtorIsUnderage]: 'Debitor er under 18 år',
        [UpdateType.SentToConnectPartner]: 'Sendt til connect partner',
        [UpdateType.ReturnedToConnectPartner]: 'Returneret til connect partner',
        [UpdateType.DebtorCanBeRegisteredInDebtRegister]: 'Debitor kan registreres i det åbne RKI-register',
        [UpdateType.PAYMENTREVOKED]: 'Betaling tilbagetrukket',
        [UpdateType.CaseMergedFrom]: 'En sag blev sammenlagt med denne',
        [UpdateType.CaseMergedTo]: 'Sagen blev sammenlagt med',
    },
    updateTypesClient: {
        [UpdateType.AWAITINGCLIENTANSWER]: 'Ny besked fra inddriver',
        ['21cfbb48-a135-4ef2-af83-d6b87bfe5f63']: 'Er betingelser for at vi kan registrere i RKI opyldt?',
        ['71ea44ac-9b03-48b8-9bea-54354e1fa74d']: 'Ønskes sagen i retten?',
        ['9036d745-349c-40a0-b54e-ca5d718962d0']: 'Ønskes en fogedrekvisition udarbejdet?',
    },
    caseFilter: {
        moreFilters: 'Filtre',
        advancedFilters: 'Avancerede filtre',
        casesSelected: 'valgte sager',
        aggregationSum: 'Sum',
        unknownEndReason: 'Ukendt afslutningsårsag',
        orderCaseOverview: 'Bestil sagsoverblik',
        creditorsGroup: 'Kreditorer',
        contactsGroup: 'Kontaktpersoner',
        maxRkiRegistrations: 'Maks. RKI-registreringer',
        maxRkiRegistrationsSub: 'Vælg antallet af RKI-registreringer debitor maksimalt skal have.',
        maxRkiRegistrationsBadge: 'RKI maks.',
        minRkiRegistrations: 'Min. RKI-registreringer',
        minRkiRegistrationsSub: 'Vælg antallet af RKI-registreringer debitor minimum skal have.',
        minRkiRegistrationsBadge: 'RKI min.',
        rkiRegisteredByCollector: 'Er RKI-registreret af inddriver',
        isRegisteredByCollector: 'Er registreret',
        isNotRegisteredByCollector: 'Er ikke registreret',
        contactHasEmail: 'Kontaktperson har en email',
        contactHasEmailBadge: 'Har email',
        contactHasPhone: 'Konktaktperson har et telefonnummer',
        contactHasPhoneBadge: 'Har telefonnummer',
        contactHasAddress: 'Kontaktperson har en adresse',
        contactHasAddressBadge: 'Har adresse',
        contactPersonIs: 'Kontaktperson er',
        debtor: 'Debitor',
        debtorBadge: 'Debitor er kontaktperson',
        alternativeContact: 'Repræsentant',
        alternativeContactBadge: 'Repræsentant er kontaktperson',
        company: 'Virksomhed',
        companyBadge: 'Er virksomhed',
        person: 'Privatperson',
        personBadge: 'Er privatperson',
        paymentMethod: 'Betalingsmetode',
        hasCard: 'Har betalingskort',
        doNotHaveCard: 'Har ikke betalingskort',
        companyStatus: 'Virksomhedsstatus',
        selectCompanyStatus: 'Vælg virksomhedsstatus',
        court: 'Retskreds',
        courtBadge: 'Retskreds valgt',
        selectCourt: 'Vælg retskreds',
        companyBranch: 'Branche for virksomhed',
        selectCompanyBranch: 'Vælg branche',
        companyTypes: 'Virksomhedsformer',
        selectCompanyTypes: 'Vælg virksomhedsformer',
        gender: 'Køn',
        [Gender.MALE]: 'Mand',
        [Gender.FEMALE]: 'Kvinde',
        [Gender.BOTH]: 'Begge',
        zipcode: 'Postnummer',
        selectZipcode: 'Vælg postnumre',
        satisfactions: 'Tilfredshedssvar',
        aiGroup: 'AI',
        casesGroup: 'Sager',
        caseStatus: 'Sagsstatus',
        selectCaseStatus: 'Vælg sagsstatus',
        endReasons: 'Afslutningsårsag',
        selectEndReasons: 'Vælg afslutningsårsag',
        caseGroup: 'Sagsgruppe',
        selectCaseGroup: 'Vælg sagsgruppe',
        caseImport: 'Sagsimport',
        selectCaseImport: 'Vælg sagsimport',
        caseCreatedAfter: 'Sag oprettet efter',
        caseCreatedAfterPlaceholder: 'Efter',
        caseCreatedBefore: 'Sag oprettet før',
        caseCreatedBeforePlaceholder: 'Før',
        caseEndedAfter: 'Sag afsluttet efter',
        caseEndedAfterPlaceholder: 'Efter',
        caseEndedBefore: 'Sag afsluttet før',
        caseEndedBeforePlaceholder: 'Før',
        caseSeqIds: 'Sagsnumre',
        exceptCaseSeqIds: 'Undtag sagsnumre',
        caseSeqIdsDescription: 'Sagsnumre i tekstform separeret med linjeskift, mellemrum, komma eller semikolon',
        caseSeqIdFilterBadge: 'Efter sagsnumre',
        updatesGroup: 'Opgaver',
        caseIsCurrently: 'Sager som lige nu er',
        caseIsCurrentlyPaused: 'Pausede sager',
        caseIsCurrentlyNotPaused: 'Sager som ikke er pauset',
        paused: 'Pauset',
        notPaused: 'Ikke pauset',
        selectStatus: 'Vælg status',
        hasFollowingStatus: 'Har følgende status',
        hasFollowingStatusSub: 'Har denne status nu eller har haft den tidligere.',
        hasFollowingStatusBadge: 'Har status',
        doNotHaveFollowingStatus: 'Har ikke følgende status',
        doNotHaveFollowingStatusSub: 'Har hverken denne status nu eller haft den tidligere.',
        doNotHaveFollowingStatusBadge: 'Har ikke status',
        isPausedFollowingStatus: 'Er pauset med status',
        isPausedFollowingStatusSub: 'Er pauset med en af følgende status lige nu.',
        isPausedFollowingStatusBadge: 'Er pauset med status',
        isNotPausedFollowingStatus: 'Er ikke pauset status',
        isNotPausedFollowingStatusSub: 'Er ikke pauset med en af følgende status lige nu.',
        isNotPausedFollowingStatusBadge: 'Er ikke pauset status',
        economyFilter: {
            postingsGroup: 'Sagsposteringer',
            billingStatus: 'Afregningsstatus',
            amountMode: 'Beløbet gælder',
            individualAmount: 'En enkelt postering',
            totalAmount: 'Posteringerne til sammen',
            totalAmountLabel: 'Samlet beløb for valgte posteringer',
            individualExample: '200–200 finder sager med mindst én postering på 200, også hvis sagen har flere posteringer på 200.',
            totalExample: '200–200 finder fx 100 + 100, men ikke 200 + 200.',
            totalHint: 'Kun posteringer, der matcher dine valg, tæller med i summen. Modposteringer trækkes fra.',
            paymentType: 'Betalingsmetode',
            allPaymentTypes: 'Alle betalingsmetoder',
            voucherState: 'Betalingsstatus',
            allVoucherStates: 'Alle betalingsstatusser',
            paymentHint: 'Betalingsmetode og status skal matche de samme posteringer som beløbet.',
            postings: 'Posteringer',
            postingsHint: 'Find sager med mindst én postering, der matcher.',
            types: 'Posteringstype',
            anyType: 'Alle posteringstyper',
            typesHint: 'Vælger du flere typer, skal blot én af dem matche.',
            amount: 'Beløb pr. postering',
            amountHint: 'Skriv beløb uden minus — både for gæld, indbetalinger og kreditnotaer.',
            debt: 'Samlet gæld',
            debtHint: 'Det, der er tilbage at betale på sagen, efter indbetalinger og kreditnotaer.',
            debtNote: 'Gælden beregnes fra alle sagens posteringer, uanset hvilke typer du vælger ovenfor.',
            billing: 'Afregning',
            billingHint: 'Find sager ud fra deres afregningsposteringer.',
            allCases: 'Alle sager',
            allCasesHint: 'Uanset afregningsstatus',
            pending: 'Har igangværende',
            pendingHint: 'Mindst én postering afventer afregning',
            billed: 'Har afregnede',
            billedHint: 'Mindst én postering er afregnet',
            both: 'Har begge dele',
            bothHint: 'Både igangværende og afregnede posteringer',
            overlapHint: 'En sag kan have begge dele. Den findes derfor også under både “Har igangværende” og “Har afregnede”.',
            minimum: 'Fra og med',
            maximum: 'Til og med',
            noLimit: 'Ingen grænse',
            rangeError: 'Fra-beløbet må ikke være større end til-beløbet. Ret intervallet for at anvende det.',
            currencyHint: 'Beløb angives i sagens valuta. Udfyld ét eller begge beløbsfelter.',
            anyAmount: 'Alle beløb',
            combinedHint: 'De udfyldte filtre kombineres: sagen skal opfylde dem alle.',
        },
        economyGroup: 'Økonomi',
        economyOnlyVoucherTypeIds: 'Kun udvalgte posteringstyper',
        economyMinAmount: 'Min.-balance',
        economyMaxAmount: 'Maks.-balance',
        economyBillingModels: 'Sager med afregningsmodel',
        economyBillingAppendixSetups: 'Sager med bilagsopsætning',
        billingModels: 'Afregningsmodeller',
        economyMin: 'Min.',
        economyMax: 'Maks.',
        economySelectedBillingModels: 'Valgte afregningsmodeller',
        economySelectedBillingAppendixSetups: 'Valgte bilagsopsætninger',
        workflowsGroup: 'Workflows',
        inSelectedWorkflows: 'Valgte workflows',
        isInWorkflows: 'Er i workflow',
        selectWorkflows: 'Vælg workflows',
        selectNextTaskIds: 'Vælg opgaver',
        nextTaskIds: 'Næste opgave i workflow',
        selectCurrentTaskIds: 'Vælg opgaver',
        currentTaskIds: 'Nuværende opgave i workflow',
        noNextTask: 'Ingen næste opgave',
        documentsGroup: 'Dokumenter',
        hasDocumentOfType: 'Har dokument af typen',
        hasDocumentOfTypeBadge: 'Har dokument af type',
        selectDocumentTypes: 'Vælg dokumenttyper',
        documentsIsSigned: 'Valgte dokumenter er signeret',
        hasFoundation: 'Har fundament',
        hasNoFoundation: 'Har ikke fundament',
        paymentPlansGroup: 'Afdragsordninger',
        paymentPlanStatuses: 'Afdragsordninger med status',
        selectPaymentPlanStatus: 'Vælg status',
        paymentPlanIsNotHavingStatuses: 'Vælg kun sager med afdragsordniger uden ovenstående',
        paymentPlanIsNotHavingStatusesBadge: 'Afdragsordniger uden statusser',
        interactionsGroup: 'Interaktioner',
        interactionType: 'Interaktionstype',
        selectInteractionType: 'Vælg interaktionstype',
        interactionState: 'Interaktionsstatus',
        selectInteractionState: 'Vælg interaktionsstatus',
        interactionDirection: 'Interaktionsretning',
        selectInteractionDirection: 'Vælg interaktionsretning',
        noneOfTheAboveBadge: 'Interaktioner uden valgte muligheder',
        noneOfTheAbove: 'Interaktioner er det modsatte af ovenstående',
        properties: 'Attributter',
        property: 'Attribut',
        propertyExplanation: '',
        accountsGroups: 'Brugere',
        selectedCreditors: 'kreditor(er) valgt',
        caseVisitedBy: 'Sag besøgt af',
        selectAccount: 'Vælg bruger',
        caseVisitedBefore: 'Sag besøgt før',
        to: 'Til',
        caseVisitedAfter: 'Sag besøgt efter',
        from: 'Fra',
        offset: 'Start fra x antal sag',
        offsetExplanation: 'Vælg hvor mange sager der skal springes over',
        limit: 'Begrænsning',
        limitExplanation: 'Vælg maksimum-antallet af sager som skal vælges',
        pagination: 'Begræns antal sager',
    },
    aggregations: {
        aggregate: 'Aggreger sager',
    },
    aggregationTypes: {
        [AggregationType.CountAll]: 'Antal sager',
        [AggregationType.ByCaseGroup]: 'Sagsgruppe',
        [AggregationType.ByBillingModel]: 'Afregningsmodel',
        [AggregationType.ByBillingAppendixSetup]: 'Bilagsopsætning',
        [AggregationType.ByWorkflow]: 'Workflow',
        [AggregationType.ByCaseStatus]: 'Sagsstatus',
        [AggregationType.ByCreditor]: 'Kreditor',
        [AggregationType.ByMigratedWorkflowTaskId]: 'Alternativ workflow-sti',
    },
    bulkActions: {
        runBulkAction: 'Kør massebehandling',
        bulkActionStarted: 'Massebehandling igangsat. Du vil modtage en email når den er færdig.',
        bulkActions: 'Massebehandling',
        bulkActionsConfirm: 'Er du sikker på, at du vil køre den valgte massebehandling på de valgte sager?',
        bulkActionBillingModelPlaceholder: 'Afregningsmodel',
        bulkActionWorkflowPlaceholder: 'Workflow',
        bulkActionMoveToTaskInWorkflowPlaceholder: 'Vælg opgave i workflow',
        bulkActionChangeCaseGroup: 'Vælg sagsgruppe',
        pleaseSelectAWorkflow: 'Vælg et workflow i sagsfilteret',
    },
    bulkActionTypes: {
        [BulkActionType.MoveCaseStatus]: 'Skift sagsstatus',
        [BulkActionType.PauseCases]: 'Paus med opgave på valgte sager',
        [BulkActionType.ContinueCases]: 'Fortsæt opgave på valgte sager',
        [BulkActionType.RunProcedure]: 'Kør genvej for valgte sager',
        [BulkActionType.ChangeBillingModel]: 'Skift afregningsmodel',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Skift bilagsopsætning',
        [BulkActionType.ChangeWorkflow]: 'Skift workflow',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Ryk til workflow opgave',
        [BulkActionType.RollbackOneTask]: 'Tilbagerul senest kørte workflow-opgave',
        [BulkActionType.RollbackAllTasks]: 'Tilbagerul alle kørte workflow-opgaver',
        [BulkActionType.RunBillingModel]: 'Kør afregningsmodel',
        [BulkActionType.ResubscribeCosmo]: 'Gentilmeld Cosmo',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'Slet RKI-registreringer på afsluttede sager',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'Flyt RKI-registreringer til sammenflettede sager',
        [BulkActionType.ChangeCaseGroup]: 'Skift sagsgruppe',
        [BulkActionType.ResyncCosmo]: 'Synkroniser cosmo',
    },
    bulkActionDescriptions: {
        [BulkActionType.MoveCaseStatus]: 'Skift sagsstatus til',
        [BulkActionType.PauseCases]: 'Paus med opgave på valgte sager',
        [BulkActionType.ContinueCases]: 'Fortsæt opgave på valgte sager',
        [BulkActionType.RunProcedure]: 'Kør genvej for valgte sager',
        [BulkActionType.ChangeBillingModel]: 'Skift afregningsmodel',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Skift bilagsopsætning',
        [BulkActionType.ChangeWorkflow]: 'Skift workflow',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Ryk til workflow opgave',
        [BulkActionType.RollbackOneTask]: 'Tilbagerul senest kørte workflow-opgave',
        [BulkActionType.RollbackAllTasks]: 'Tilbagerul alle kørte workflow-opgaver',
        [BulkActionType.RunBillingModel]: 'Kør afregningsmodel',
        [BulkActionType.ResubscribeCosmo]: 'Gentilmeld Cosmo',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'Slet RKI-registreringer på afsluttede sager',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'Flyt RKI-registreringer til sammenflettede sager',
        [BulkActionType.ChangeCaseGroup]: 'Skift sagsgruppe',
        [BulkActionType.ResyncCosmo]: 'Synkroniser cosmo',
    },
    bulkActionsEmailConfirmationSubject: {
        [BulkActionType.MoveCaseStatus]: 'Sager har nu skiftet status',
        [BulkActionType.PauseCases]: 'Sager pauset',
        [BulkActionType.ContinueCases]: 'Sager fortsat',
        [BulkActionType.RunProcedure]: 'Genvej eksekveret',
        [BulkActionType.ChangeBillingModel]: 'Afregningsmodeller skiftet',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Bilagsopsætninger skiftet',
        [BulkActionType.ChangeWorkflow]: 'Workflows skiftet',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Sager er nu rykket til workflow opgave',
        [BulkActionType.RollbackOneTask]: 'Workflow-opgaver er nu tilbagerullet',
        [BulkActionType.RollbackAllTasks]: 'Workflow-opgaver er nu tilbagerullet',
        [BulkActionType.RunBillingModel]: 'Afregningsmodel er nu kørt',
        [BulkActionType.ResubscribeCosmo]: 'Gentilmelding til Cosmo er nu kørt',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'RKI-registreringer på afsluttede sager er nu slettet',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'RKI-registreringer er nu flyttet til sammenflettede sager',
        [BulkActionType.ChangeCaseGroup]: 'Sagsgrupper er nu ændret',
        [BulkActionType.ResyncCosmo]: 'Cosmo synkroniseret',
    },
    bulkActionsEmailConfirmationBody: {
        [BulkActionType.MoveCaseStatus]: 'Din massebehandling er nu kørt, og de valgte sager er har skiftet status.',
        [BulkActionType.PauseCases]: 'Din massebehandling er nu kørt, og de valgte sager er pauset.',
        [BulkActionType.ContinueCases]: 'Din massebehandling er nu kørt, og de valgte sager er fortsat.',
        [BulkActionType.RunProcedure]: 'Din massebehandling er nu kørt, og de valgte sager har fået genvejen eksekveret.',
        [BulkActionType.ChangeBillingModel]: 'Din massebehandling er nu kørt, og de valgte sager har fået skiftet afregningsmodel.',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Din massebehandling er nu kørt, og de valgte sager har fået skiftet bilagsopsætning.',
        [BulkActionType.ChangeWorkflow]: 'Din massebehandling er nu kørt, og de valgte sager har fået skiftet workflow.',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Din massebehandling er nu kørt, og de valgte sager er rykket til workflow opgaven.',
        [BulkActionType.RollbackOneTask]: 'Din massebehandling er nu kørt, og de valgte sagers workflow-opgaver er rullet tilbage.',
        [BulkActionType.RollbackAllTasks]: 'Din massebehandling er nu kørt, og de valgte sagers workflow-opgaver er rullet tilbage.',
        [BulkActionType.RunBillingModel]: 'Din massebehandling er nu kørt, og de valgte sagers afregningsmodel er nu kørt.',
        [BulkActionType.ResubscribeCosmo]: 'Din massebehandling er nu kørt, og de valgte sager er nu blevet gentilmeldt Cosmo.',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'Din massebehandling er nu kørt, og RKI-registreringer på afsluttede sager er nu slettet.',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'Din massebehandling er nu kørt, og RKI-registreringer på sammenflettede sager er nu flyttet.',
        [BulkActionType.ChangeCaseGroup]: 'Din massebehandling er nu kørt, og de valgte sagers sagsgrupper er nu ændret.',
        [BulkActionType.ResyncCosmo]: 'Din massebehandling er nu kørt, og de valgte sager er nu blevet gensynkroniseret med Cosmo.',
    },
    paymentPlansInsights: {
        paymentPlans: 'Afdragsordninger',
        quantityEntries: 'Antal afdrag',
        amountEntries: 'Beløb for afdrag',
        funnelHeader: 'Livscyklus',
        totalCreated: 'Oprettet',
        activated: 'Aktiveret',
        inProgress: 'I gang',
        completed: 'Gennemført',
        defaulted: 'Misligholdt',
        deletedAfterActivation: 'Slettet',
        awaitingActivation: 'Afventer aktivering',
        neverActivated: 'Aldrig aktiveret',
        ofCreated: (share) => `${share}% af oprettede`,
        ofActivated: (share) => `${share}% af aktiverede`,
        churnHeader: 'Frafald',
        churnRate: 'Frafaldsrate',
        churnRateInfo: 'Andel af aktiverede afdragsordninger der endte i misligholdelse.',
        defaultedPlans: 'Misligholdte ordninger',
        churnedBeforeFirstPayment: 'Før første betaling',
        churnedAfterFirstPayment: 'Efter første betaling',
        ofDefaulted: (share) => `${share}% af misligholdte`,
        neverActivatedHeader: 'Oprettet men aldrig aktiveret',
        neverActivatedInfo: 'Afdragsordninger der blev oprettet men aldrig aktiveret, fordelt på hvem der oprettede dem.',
        createdByDebtor: 'Oprettet af debitor',
        createdByCaseworker: 'Oprettet af sagsbehandler',
        paymentMethodsHeader: 'Betalingsmetoder',
        methodColumn: 'Metode',
        plansColumn: 'Afdragsordninger',
        activationRateColumn: 'Aktiveringsrate',
        defaultRateColumn: 'Misligholdelsesrate',
        methodBetalingsservice: 'Betalingsservice',
        methodLeverandorservice: 'Leverandørservice',
        methodVisa: 'Visa',
        methodMastercard: 'Mastercard',
        methodDankort: 'Dankort',
        methodCard: 'Kort',
        methodMobilePay: 'MobilePay',
        methodVipps: 'Vipps',
        methodSwish: 'Swish',
        methodOther: 'Andet',
        methodNone: 'Ingen betalingsmetode',
        creditorsHeader: 'Kreditorer med flest afdragsordninger',
        creditorColumn: 'Kreditor',
        finishedColumn: 'Gennemført',
        defaultedColumn: 'Misligholdt',
        vintageHeader: 'Kohorteanalyse',
        vintageInfo: 'Hver række er den måned ordningerne blev oprettet, fulgt efter alder. Læs ned ad en kolonne (samme alder) for at se, om nyere kohorter misligholder mere eller mindre end ældre. Celler er tomme, indtil en kohorte er gammel nok til at kunne observeres ved den alder.',
        vintageCohortColumn: 'Oprettet',
        vintageAgeAxis: 'Måneder siden oprettelse',
        vintageActivatedShort: (n) => `${n} aktiveret`,
        vintageLegendLabel: 'Akkumuleret misligholdelsesrate',
        vintageLow: 'lavere',
        vintageHigh: 'højere',
        vintageCellInfo: (rate, defaults, activated) => `${rate}% akkumuleret misligholdelse (${defaults} af ${activated} aktiverede)`,
    },
    insights: {
        showingNewest: 'Viser de {count} nyeste.',
        lastDays: 'Seneste {days} dage',
        fromDate: 'Fra dato',
        toDate: 'Til dato',
        getReport: 'Hent rapport',
        powerbi: {
            title: 'Dine data. Din indsigt.',
            intro: 'Vælg datakilderne til din rapport. Hent et Power BI-projekt (.pbip), pakket med de nødvendige mapper, forespørgsler og databeskrivelser i én ZIP-fil.',
            openInstructions: 'Pak ZIP-filen ud, og åbn Debbie.pbip i Power BI Desktop til Windows. Aktivér Power BI Project og det udvidede rapportformat (PBIR) under prøveversionsfunktioner, hvis din version kræver det. Vælg Anonym som godkendelse for webkilden: API-nøglen sendes allerede i forespørgslens header. Opdatér for at indlæse data.',
            dataSources: 'Datakilder',
            selectSources: 'Vælg mindst én datakilde, og acceptér advarslen om API-nøglen.',
            selectAll: 'Vælg alle datakilder',
            includeSource: 'Medtag i projekt',
            downloadProject: 'Opret nøgle og hent Power BI-projekt (.pbip)',
            downloadAgain: 'Hent samme projekt igen',
            securityWarning: 'Når du downloader, oprettes en API-nøgle med læseadgang til de valgte datakilder. Nøglen ligger i klartekst i projektet og forespørgselsfilerne. Alle med filerne kan benytte adgangen. Opbevar dem sikkert, og del dem kun med betroede modtagere. Deler du dem med andre personer eller eksterne tjenester, deler du også nøglen og adgangen til data. Du kan altid tilbagekalde API-nøgler under fanen API-nøgler.',
            acceptWarning: 'Jeg forstår, at der oprettes en API-nøgle, som medtages i filerne.',
            keyCreated: 'API-nøglen er udstedt og vises nedenfor. Henter du projektet igen, bruges samme nøgle. Ændrer du valget eller nøglens navn, oprettes en ny nøgle ved næste download.',
            noAccess: 'Du skal have adgang til at udstede API-nøgler for at oprette et projekt. Vælg først en kreditor i kreditorportalen.',
            extendTitle: 'Tilføj datakilder til en eksisterende rapport',
            manualInstructions: 'Vælg de ekstra kilder her, og hent et projekt. I din eksisterende Power BI-rapport vælger du Transformér data → Ny kilde → Tom forespørgsel → Avanceret editor. Indsæt indholdet fra den tilhørende fil i queries/, giv forespørgslen kildens navn, og vælg Luk og anvend. Dermed tilføjes kilden med sin nye nøgle, mens eksisterende forespørgsler, visualiseringer og målinger bevares. Tilføj relationer i modelvisningen med hjælp fra data-dictionary.json. Erstat ikke dit eksisterende projekt med det downloadede projekt.',
            manualConnection: 'API / tilføj manuelt',
            manualKeyInstructions: 'Ved manuel opsætning kopierer du forespørgslen nedenfor og erstatter PASTE_API_KEY_HERE med en API-nøgle med det viste scope. Du kan udstede en nøgle ved at vælge denne kilde og hente et projekt eller under API-indstillinger. Eksisterende nøgler får ikke automatisk adgang til nye kilder.',
            copyQuery: 'Kopiér Power Query',
            keysDescription: 'Udstedte nøgler med adgang til rapportdata, inklusive nøgler oprettet under API-indstillinger. Den hemmelige nøgle kan ikke hentes igen. Tilbagekaldelse stopper fremtidig adgang for alle rapporter og integrationer, der bruger nøglen; allerede indlæste data bliver i Power BI.',
            issuedAt: 'Udstedt',
            revoke: 'Tilbagekald nøgle',
            revokeWarning: 'Vil du tilbagekalde denne API-nøgle? Alle rapporter og integrationer, der bruger den, mister adgang ved deres næste forespørgsler, når den korte godkendelsescache udløber. Allerede hentede data bliver i deres filer.',
            refreshInstructions: 'API’et begrænser forespørgsler pr. kilde til én gang i døgnet. Undgå hyppige forhåndsvisninger og opdateringer. Ved planlagt opdatering i Power BI Service skal webforbindelsen godkendes som Anonym; nøglen ligger fortsat i forespørgslen. Opdatering og godkendelse i Service skal konfigureres særskilt efter publicering.',
            modelNotes: 'Forbind tabeller med stabile id’er som caseId, customerId og creditorId; cases.id og referenceId er visnings-/eksterne referencer, ikke globale relationsnøgler. Hver kildes rækkegranularitet beskrives nedenfor. Relationer filtrerer én vej fra én-siden til mange-siden; kun relationer mellem valgte tabeller medtages. Andre nyttige relationer: cases.creditorId → creditors.creditorId, cases.workflowId → workflows.id, workflow-tasks.updateTypeId → update-types.updateTypeId, billing-vouchers.caseVoucherId → case-vouchers.caseVoucherId og payment-plans.documentId → documents.documentId. Tilføj dem omhyggeligt for at undgå tvetydige filterveje. Updates.referenceId kan pege på forskellige entiteter: kontrollér update-types.referenceType; interactions og documents har referenceType, og properties har ref. Filtrér på referencetypen før sammenkobling med sager eller kunder. Antag ikke, at alle referencer er sager. Beløb bevarer API’ets enhed (mindste valutaenhed, fx øre); dividér med 100 for DKK/SEK/NOK/EUR, og aggregér hver valuta separat. Payment-plan-entries har ingen valutakolonne; find valutaen i den relevante sagskontekst, og antag ikke én valuta i blandede porteføljer. Posteringer har fortegn; beregn ikke saldi ved ukritisk at summere alle posteringstyper. Undgå dobbelttælling ved sammenkobling af flere detaljetabeller. Status- og typetekster følger det valgte sprog. Tidsstempler med tidszone konverteres til UTC; rene datoer bevares ved midnat. Indlejrede objekter og lister gemmes som JSON-tekst. Tomme kilder bevarer kolonnerne; manglende valgfrie felter bliver null. Modellen omfatter standardfelterne, ikke valgfrie detaljefelter. Den indeholder ingen indlæste kundedata før opdatering.',
            shortIntro: 'Forbind Debbie til Power BI, og byg rapporter med de data, du har brug for.',
            help: 'Sådan kommer du i gang',
            chooseSources: 'Vælg dine datakilder',
            chooseHint: 'Markér kilder til Power BI, eller brug </> til at forbinde manuelt.',
            clearSelection: 'Ryd valg',
            groupCases: 'Sager og kunder',
            groupEconomy: 'Økonomi og betalinger',
            groupActivity: 'Aktivitet og dokumenter',
            groupOrganisation: 'Organisation og workflows',
            yourProject: 'Dit Power BI-projekt',
            projectContents: 'Dataforbindelser, relationer og databeskrivelser — klar til din rapport.',
            selectedSources: 'datakilder valgt',
            emptySelection: 'Vælg kilder til venstre for at sammensætte dit projekt.',
            downloadLabel: 'Hent Power BI-projekt',
            downloadFormat: '.pbip-projekt · Leveres som ZIP · Power BI Desktop',
            shortSecurity: 'En ny API-nøgle følger med projektet. Du gennemgår adgangen før download og kan altid tilbagekalde den.',
            confirmTitle: 'Opret adgang til dine data',
            projectReady: 'Dit projekt er klar',
            manageKeys: 'Se og administrér API-nøgler',
            openProject: 'Åbn projektet i Power BI',
            refreshTitle: 'Hold din rapport opdateret',
            extendHint: 'Brug </>-knappen på en datakilde for en trinvis guide til at tilføje den i din eksisterende Power BI-rapport. Dine nuværende visualiseringer og målinger bevares.',
            guideKeyTitle: 'Opret en API-nøgle i Debbie',
            guideKey: 'Åbn Indstillinger → Udviklere → API, og vælg Opret API-nøgle. Giv den et navn, du kan genkende, og vælg adgangen vist nedenfor. Opret nøglen, og gem den sikkert — den vises kun én gang. Har du allerede en nøgle med denne adgang, kan du genbruge den.',
            guideWebTitle: 'Tilføj en webkilde i Power BI',
            guideWeb: 'Åbn din eksisterende rapport i Power BI Desktop. Vælg Hjem → Hent data → Web og derefter Avanceret. Kopiér adressen nedenfor ind i det første URL-felt.',
            guideAuthTitle: 'Indsæt din API-nøgle',
            guideAuth: 'Under HTTP-anmodningsheaderparametre vælger du Authorization. I feltet ved siden af skriver du Bearer, efterfulgt af et mellemrum og din API-nøgle. På billedet erstatter du <your URL> med adressen ovenfor og <your token> med din nøgle. Tryk OK. Bliver du spurgt om godkendelse, vælger du Anonym — nøglen er allerede indsat i headeren.',
            guideImageAlt: 'Power BI-webforbindelse: URL øverst og Authorization med Bearer efterfulgt af API-nøglen nederst.',
            guideLoadTitle: 'Indlæs data i din rapport',
            guideLoad: 'Viser Power Query en liste, vælger du Til tabel og accepterer standardindstillingerne. Udvid derefter kolonnen med ikonet med to pile, og vælg de ønskede felter. Giv forespørgslen datakildens navn, og vælg Luk og anvend. Den nye tabel vises sammen med dine eksisterende data. Du kan forbinde den til andre tabeller i modelvisningen via matchende id’er, fx caseId. Din eksisterende rapport bevares.',
            advancedQuery: 'Avanceret: brug Power Query-kode',
            dictionaryInstructions: 'data-dictionary.json beskriver de valgte kilder, kolonner og relationer uden at indeholde API-nøglen. Brug den som opslagsværk, når du bygger eller udvider rapporter. Projektet indeholder også tabelbeskrivelser og foruddefinerede relationer.',
            sourceDescriptions: {
                cases: 'Én række pr. ikke-slettet sag med kunde, kreditor, status og workflowreferencer.',
                creditors: 'Én række pr. kreditor med identitet, status og kontaktreferencer.',
                satisfactions: 'Én række pr. tilfredshedssvar på en sag med score (1–5) og kommentar.',
                'case-vouchers': 'Én række pr. ikke-slettet sagspostering med fortegnet beløb, valuta, kategori og datoer.',
                'billing-vouchers': 'Én række pr. ikke-slettet afregningspostering. Kreditorer ser kun afregnede posteringer.',
                users: 'Én række pr. bruger i organisationen med rolle og kontaktoplysninger. Slettede brugere udelades.',
                updates: 'Én række pr. opgave. referenceId kan pege på forskellige entiteter; kontrollér opgavetypen.',
                'update-types': 'Én række pr. opgavetype med navn, referencetype og adfærdsflag.',
                workflows: 'Én række pr. workflow. Nøglen hedder id.',
                'workflow-tasks': 'Én række pr. opgave i et workflow med workflowId og updateTypeId.',
                'case-statuses': 'Én række pr. statusskift på en sag. En sag kan have flere rækker.',
                interactions: 'Én række pr. interaktion med kanal, retning, status og referencetype.',
                documents: 'Én række pr. dokument med referencetype, datoer og filmetadata; uden filindhold.',
                'payment-plans': 'Én række pr. afdragsordning på en sag med status og påmindelsesflag.',
                'payment-plan-entries': 'Én række pr. afdrag på en afdragsordning med beløb, frister og status. Intet valutafelt.',
                customers: 'Én række pr. ikke-slettet kunde hos en kreditor. En kunde kan have flere sager.',
                'users-on-customers': 'Én række pr. relation mellem kontakt og kunde. Kontaktoplysninger er JSON, ikke et userId i organisationen.',
                properties: 'Én række pr. aktuel attributværdi. ref angiver entitetstypen for refId; data er JSON.',
            },
            sourceSummaries: {
                cases: 'Status, kunder og workflows',
                creditors: 'Kreditoroplysninger og kontakter',
                satisfactions: 'Bedømmelser og feedback på sager',
                'case-vouchers': 'Beløb, valutaer og posteringstyper',
                'billing-vouchers': 'Afregninger, fakturering og moms',
                users: 'Medarbejdere og roller',
                updates: 'Opgaver, datoer og fremdrift',
                'update-types': 'Opgavekategorier og adfærd',
                workflows: 'Definitioner af workflows',
                'workflow-tasks': 'Trinene i hvert workflow',
                'case-statuses': 'Historik over sagernes statusskift',
                interactions: 'Kanaler, retning og leveringsstatus',
                documents: 'Dokumenttyper, datoer og underskrifter',
                'payment-plans': 'Aftaler og status på afdragsordninger',
                'payment-plan-entries': 'Afdrag, beløb og betalingsfrister',
                customers: 'Kundeoplysninger og referencer',
                'users-on-customers': 'Kontakter og deres kunderelationer',
                properties: 'Tilpassede attributter og værdier',
            },
        },
        connectToApi: 'Opret forbindelse til din data via et API.',
        downloadLimit: 'Der er en grænse på anmodninger til datakilden på én gang per døgn.',
        apiTypes: {
            ['cases']: 'Sager',
            ['users']: 'Brugere',
            ['satisfactions']: 'Tilfredshedssvar',
            ['case-vouchers']: 'Sagsposteringer',
            ['billing-vouchers']: 'Afregningsposteringer',
            ['creditors']: 'Kreditorer',
            ['updates']: 'Opgaver',
            ['update-types']: 'Opgavetyper',
            ['workflows']: 'Workflows',
            ['workflow-tasks']: 'Workflow-opgaver',
            ['case-statuses']: 'Sagsstatus-log',
            ['interactions']: 'Interaktioner',
            ['documents']: 'Dokumenter',
            ['payment-plans']: 'Afdragsordninger',
            ['payment-plan-entries']: 'Afdrag',
            ['users-on-customers']: 'Brugere på kunder',
            ['customers']: 'Kunder',
            ['properties']: 'Attributter',
        },
        connectGuide: {
            description: 'Du kan tilgå din data igennem et API for ekstern brug.',
            liIntroStep1: 'Gå til Indstillinger og vælg "Udviklere"',
            liIntroStep2: 'Opret ny API-Nøgle',
            liIntroStep3: 'Giv nøglen et passende navn og vælg det tilsvarende scope',
            liIntroStep4: 'Det tilsvarende scope er i dette tilfælde',
            liIntroStep5: "Du kan dernæst bruge din oprettede API-nøgle til at forbinde til url'en",
            powerbiDescription: 'Hvis du vil forbinde til Power BI, kan du se en gennemgang forneden',
            liPowerbiStep1: "Forbind til en ny 'Web' datakilde i Power BI",
            liPowerbiStep2: 'Udfyld som på nedenstående billede, hvor du erstatter',
            liPowerbiStep3: "med url'en fra punkt 5 og",
            liPowerbiStep4: 'med din nyoprettet API-nøgle',
            liPowerbiStep5: 'Tryk dernæst OK og du er klar',
            understood: 'Modtaget',
        },
        connect: 'Forbind',
        download: 'Hent',
        orderReport: 'Bestil rapport',
        billingFile: 'Fil med betalinger',
        billingFileDesc: 'Fil med indbetalinger i det valgte tidsinterval.',
        reportOrdered: 'Rapport bestilt',
        reportOrderedText: 'Du vil modtage en mail inden længe med din rapport.',
        reportOrderedCloseButton: 'Luk',
        interactionsReports: 'Interaktionsrapport',
        interactionsReportsDesc: 'Rapport over indgående og udgående kommunikation.',
        interactionsReportsCreatedAt: 'Oprettet d.',
        interactionsReportsState: 'Status',
        interactionsReportsType: 'Type',
        interactionsReportsDirection: 'Retning',
        interactionsReportsCreditorSeqId: 'Kreditornummer',
        interactionsReportsCreditor: 'Kreditor',
        interactionsReportsCaseSeqId: 'Sagsnummer',
        interactionsReportsAddress: 'Adresse',
        interactionsReportsZipcode: 'Postnummer',
        interactionsReportsCity: 'By',
        interactionsReportsCountry: 'Land',
        creditorsReportSeqId: 'Kreditornummer',
        creditorsReportName: 'Kreditornavn',
        creditorsReportCentralRegisterId: 'CVR / CPR',
        creditorsReportStatus: 'Status',
        creditorsReportAddress: 'Adresse',
        creditorsReportZipcode: 'Postnummer',
        creditorsReportCity: 'By',
        creditorsReportContactPerson: 'Kontaktperson hos kreditor',
        creditorsReportAcquisitionResponsible: 'Akkvisitionsansvarlig',
        creditorsReportCaseworkerContact: 'Sagsbehandlerkontakt',
        creditorsReportDefaultWorkflow: 'Standard workflow',
        creditorsReportCatchAllResponsible: 'Catch-all ansvarlig for opgaver',
        creditorsReportExperianClientNumber: 'Experian klientnummer',
        creditorsReportCaseCount: 'Antal sager',
        creditorsReportLatestCaseCreatedAt: 'Dato for seneste sagoprettelse',
        creditorsReportCollectorName: 'Inddrivernavn',
        creditorsReportDefaultBillingModel: 'Standard afregningsmodel',
        creditorsReportDefaultBillingAppendixSetup: 'Standard bilagsopsætning',
        creditorsReportBillingEmailTo: 'Afregningsemail to',
        creditorsReportBillingEmailCc: 'Afregningsemail cc',
        creditorsReportBillingEmailBcc: 'Afregningsemail bcc',
        creditorsReportPaymentDays: 'Betalingsdage',
        creditorsReportMinimumBillingThreshold: 'Minimumsgrænse for sagsafregning',
        creditorsReportCreatedAt: 'Oprettet',
        caseOverview: 'Sagsoverblik',
        caseOverviewDesc: 'Overblik over alle sager per kreditor indeholdende info om debitor, sagsstatus og finansiel data.',
        includeDocuments: 'Inkludér dokumenter',
        includeVouchers: 'Inkludér sagsposteringer',
        includeRki: 'Inkludér RKI rapporteringer',
        documents: 'Dokumenter',
        steps: 'Steps',
        vouchers: 'Posteringer',
        cases: 'Sager',
        collector: 'Inddriver',
        creditor: 'Kreditor',
        rki: 'RKI',
        downloadsYourExportIsReady: 'Din rapport er klar',
        downloadsYourExportIsReadyBody: '<p>Hej</p><p>Din rapport er nu klar.</p>',
        downloadsYourExportIsReadyButton: 'Hent rapport',
        caseOverviewHeaderDocumentId: 'Doc ID',
        caseOverviewHeaderFileLink: 'Link til fil',
        caseOverviewHeaderType: 'Type',
        caseOverviewHeaderSignedAt: 'Dato for underskrift',
        caseOverviewHeaderCreatedAt: 'Dato for oprettelse',
        caseOverviewHeaderDate: 'Dato',
        caseOverviewHeaderDueDate: 'Forfaldsdato',
        caseOverviewHeaderCategory: 'Kategori',
        caseOverviewHeaderImposedBy: 'Pålagt af',
        caseOverviewHeaderText: 'Tekst',
        caseOverviewHeaderInterest: 'Rentesats',
        caseOverviewHeaderInterestStartDate: 'Rentestartdato',
        caseOverviewHeaderInterestEndDate: 'Renteslutdato',
        caseOverviewHeaderAmount: 'Beløb',
        caseOverviewHeaderExpirationDate: 'Forældelsesdato',
        caseOverviewHeaderExpired: 'Forældet',
        caseOverviewCompany: 'Virksomhed',
        caseOverviewPrivate: 'Person',
        caseOverviewHeaderCreditor: 'Kreditor',
        caseOverviewHeaderCreditorSeqId: 'Kreditornummer',
        caseOverviewHeaderCaseGroup: 'Sagsgruppe',
        caseOverviewHeaderImportedAt: 'Importdato',
        caseOverviewHeaderCaseSeqId: 'Sagsnummer',
        caseOverviewHeaderMigratedJournalNumber: 'Migreret j.nr.',
        caseOverviewHeaderReferenceId: 'Referencenummer',
        caseOverviewHeaderDebtorSeqId: 'Debitornummer',
        caseOverviewHeaderDebtorName: 'Navn',
        caseOverviewHeaderDebtorEmail: 'Email',
        caseOverviewHeaderDebtorPhone: 'Telefonnr.',
        caseOverviewHeaderDebtorSatisfaction: 'Tilfredshed',
        caseOverviewHeaderDebtorSatisfactionComment: 'Tilfredshedskommentar',
        caseOverviewHeaderDebtorRKICount: 'Alle RKI-registreringer',
        caseOverviewHeaderDebtorCompanyStatus: 'Virksomhedsstatus',
        caseOverviewHeaderDebtorCVR: 'CVR',
        caseOverviewHeaderDebtorBirthdate: 'Fødselsdato',
        caseOverviewHeaderDebtorAddressProtection: 'Adressebeskyttet',
        caseOverviewHeaderDebtorCountry: 'Land',
        caseOverviewHeaderDebtorZipCode: 'Postnummer',
        caseOverviewHeaderDebtorCity: 'By',
        caseOverviewHeaderDebtorAddress: 'Adresse',
        caseOverviewHeaderDebtorCoAddress: 'CoAdresse',
        caseOverviewHeaderDebtorType: 'Debitortype',
        caseOverviewHeaderDebtorCount: 'Antal debitorer',
        caseOverviewHeaderCreditScore: 'Kreditscore',
        caseOverviewHeaderCurrency: 'Valuta',
        caseOverviewHeaderPrincipal: 'Indleveret hovedstol',
        caseOverviewHeaderPrincipalPaid: 'Indbetalt hovedstol',
        caseOverviewHeaderPrincipalLeft: 'Rest hovedstol',
        caseOverviewHeaderReminderFeeCreditor: 'Indleveret rykkergebyr fra kreditor',
        caseOverviewHeaderReminderFeeCreditorPaid: 'Indbetalt rykkergebyr fra kreditor',
        caseOverviewHeaderReminderFeeCreditorLeft: 'Rest rykkergebyr fra kreditor',
        caseOverviewHeaderReminderFeeCollector: 'Pålagte rykkergebyrer fra inddriver',
        caseOverviewHeaderReminderFeeCollectorPaid: 'Indbetalt pålagte rykkergebyrer',
        caseOverviewHeaderReminderFeeCollectorLeft: 'Rest pålagte rykkergebyrer',
        caseOverviewHeaderCompensationCostCreditor: 'Indleveret kompensationsgebyr fra kreditor',
        caseOverviewHeaderCompensationCostCreditorPaid: 'Indbetalt kompensationsgebyr fra kreditor',
        caseOverviewHeaderCompensationCostCreditorLeft: 'Rest kompensationsgebyr fra kreditor',
        caseOverviewHeaderCompensationCostCollector: 'Pålagte kompensationsgebyrer fra inddriver',
        caseOverviewHeaderCompensationCostCollectorPaid: 'Indbetalt kompensationsgebyrer fra inddriver',
        caseOverviewHeaderCompensationCostCollectorLeft: 'Rest kompensationsgebyrer fra inddriver',
        caseOverviewHeaderCollectionCostCreditor: 'Indleveret inkassoomkostning fra kreditor',
        caseOverviewHeaderCollectionCostCreditorPaid: 'Indbetalt inkassoomkostning fra kreditor',
        caseOverviewHeaderCollectionCostCreditorLeft: 'Rest inkassoomkostning fra kreditor',
        caseOverviewHeaderCollectionCostCollector: 'Pålagte inkassoomkostninger fra inddriver',
        caseOverviewHeaderCollectionCostCollectorPaid: 'Indbetalt inkassoomkostninger fra inddriver',
        caseOverviewHeaderCollectionCostCollectorLeft: 'Rest inkassoomkostninger fra inddriver',
        caseOverviewHeaderCollectionFeeCreditor: 'Indleveret inkassogebyr fra kreditor',
        caseOverviewHeaderCollectionFeeCreditorPaid: 'Indbetalt inkassogebyr fra kreditor',
        caseOverviewHeaderCollectionFeeCreditorLeft: 'Rest inkassogebyr fra kreditor',
        caseOverviewHeaderCollectionFeeCollector: 'Pålagte inkassogebyrer fra inddriver',
        caseOverviewHeaderCollectionFeeCollectorPaid: 'Indbetalt inkassogebyrer fra inddriver',
        caseOverviewHeaderCollectionFeeCollectorLeft: 'Rest inkassogebyrer fra inddriver',
        caseOverviewHeaderCourtCostCollector: 'Retslige omkostninger fra inddriver',
        caseOverviewHeaderCourtCostCollectorPaid: 'Indbetalt retslige omkostninger fra inddriver',
        caseOverviewHeaderCourtCostCollectorLeft: 'Rest retslige omkostninger fra inddriver',
        caseOverviewHeaderCourtCostCreditor: 'Retslige omkostninger fra kreditor',
        caseOverviewHeaderCourtCostCreditorPaid: 'Indbetalt retslige omkostninger fra kreditor',
        caseOverviewHeaderCourtCostCreditorLeft: 'Rest retslige omkostninger fra kreditor',
        caseOverviewHeaderInterestCreditor: 'Indleveret renter fra kreditor',
        caseOverviewHeaderInterestCreditorPaid: 'Indbetalt renter fra kreditor',
        caseOverviewHeaderInterestCreditorLeft: 'Rest renter fra kreditor',
        caseOverviewHeaderInterestCollector: 'Pålagte renter fra inddriver',
        caseOverviewHeaderInterestCollectorPaid: 'Indbetalt renter fra inddriver',
        caseOverviewHeaderInterestCollectorLeft: 'Rest renter fra inddriver',
        caseOverviewHeaderCreditorTotal: 'Indleveret i alt fra kreditor',
        caseOverviewHeaderCreditorTotalPaid: 'Indbetalt i alt fra kreditor',
        caseOverviewHeaderCreditorTotalLeft: 'Rest i alt fra kreditor',
        caseOverviewHeaderCreditorTotalDepositsToCreditor: 'Indbetalt til kreditor i alt',
        caseOverviewHeaderCollectorTotal: 'Pålagte i alt fra inddriver',
        caseOverviewHeaderCollectorTotalPaid: 'Indbetalt i alt til inddriver',
        caseOverviewHeaderCollectorTotalLeft: 'Rest i alt fra inddriver',
        caseOverviewHeaderTotal: 'Total',
        caseOverviewHeaderTotalPaid: 'Indbetalt total',
        caseOverviewHeaderTotalLeft: 'Rest total',
        caseOverviewHeaderLastDepositDate: 'Seneste indbetaling importeret d.',
        caseOverviewHeaderCurrentWorkflow: 'Workflow',
        caseOverviewHeaderCurrentWorkflowTask: 'Nuværende opgave',
        caseOverviewHeaderCurrentWorkflowTaskTime: 'Nuværende opgaves tidspunkt',
        caseOverviewHeaderNextWorkflowTask: 'Næste opgave',
        caseOverviewHeaderNextWorkflowTaskTime: 'Næste opgaves tidspunkt',
        caseOverviewHeaderFoundation: 'Fundament',
        caseOverviewHeaderPaymentPlan: 'Afdragsordning',
        caseOverviewHeaderPaidPaymentPlanEntries: 'Betalte afrag',
        caseOverviewHeaderTotalPaymentPlanEntries: 'Afdrag i alt',
        caseOverviewHeaderCaseStatus: 'Sagsstatus',
        caseOverviewHeaderEndReason: 'Afslutningskode',
        caseOverviewHeaderExitDate: 'Afslutningsdato',
        caseOverviewHeaderStepTitle: 'Step-titel',
        caseOverviewHeaderStepCategory: 'Step-kategori',
        caseOverviewHeaderNextStepTitle: 'Næste step-titel',
        caseOverviewHeaderNextStepCategory: 'Næste step-kategori',
        caseOverviewHeaderSignedFoudations: 'Underskrevede fundamenter',
        caseOverviewHeaderPaymentPlans: 'Afdragsordninger oprettet',
        caseOverviewHeaderFoundationDate: 'Fundamentsdato',
        caseOverviewHeaderFoundationCode: 'Fundamentskode',
        caseOverviewHeaderFoundationType: 'Fundamentstype',
        caseOverviewHeaderRkiRegistry: 'Register',
        caseOverviewHeaderState: 'Status',
        caseOverviewHeaderReportedAt: 'Raporteringsdato',
        caseOverviewHeaderError: 'Fejlbesked',
        caseOverviewHeaderRKIReference: 'RKI Referencenummer',
        caseOverviewHeaderClientNumber: 'Kreditornummer',
        caseOverviewHeaderSurveillance: 'Overvågning',
        caseOverviewHeaderSurveillanceDate: 'Overvågningsdato',
        paymentPlansOverview: 'Afdragsordningsoversigt',
        paymentPlansOverviewTabPaymentPlans: 'Afdragsordninger',
        paymentPlansOverviewTabPaymentPlanEntries: 'Afdrag',
        paymentPlansOverviewHeaderPaymentPlanId: 'Afdragsordnings id.',
        paymentPlansOverviewHeaderCaseSequentialId: 'Sagsnummer',
        paymentPlansOverviewHeaderCaseStatus: 'Sagsstatus',
        paymentPlansOverviewHeaderCreditorName: 'Kreditornavn',
        paymentPlansOverviewHeaderStatus: 'Status',
        paymentPlansOverviewHeaderCreatedAt: 'Oprettelsesdato',
        paymentPlansOverviewHeaderSettledEntries: 'Betalte afdrag',
        paymentPlansOverviewHeaderTotalEntries: 'Antal afdrag',
        paymentPlansOverviewHeaderAmount: 'Afdragsbeløb',
        paymentPlansOverviewHeaderFromDate: 'Fra dato',
        paymentPlansOverviewHeaderToDate: 'Til dato',
        paymentPlansOverviewEntriesHeaderPaymentPlanId: 'Afdragets id.',
        paymentPlansOverviewEntriesHeaderCaseSequentialId: 'Sagsnummer',
        paymentPlansOverviewEntriesHeaderCaseStatus: 'Sagsstatus',
        paymentPlansOverviewEntriesHeaderCreditorName: 'Kreditornavn',
        paymentPlansOverviewEntriesHeaderAmount: 'Beløb',
        paymentPlansOverviewEntriesHeaderEntryStatus: 'Status',
        paymentPlansOverviewEntriesHeaderReminderDate: 'Påmindelsesdato',
        paymentPlansOverviewEntriesHeaderDate: 'Dato for afdrag',
        paymentPlansOverviewEntriesHeaderDeadlineDate: 'Sidste chance',
        paymentPlansOverviewEntriesHeaderCancelDate: 'Afdrag misligholdt',
        dailyDeposits: 'Daglige indbetalinger',
        dailyDepositsDesc: 'Daglige indbetalinger per kreditor',
        paymentPlanReport: 'Afdragsordninger',
        paymentPlanReportDesc: 'Rapport vedrørende status på afdragsordninger.',
        dailyDepositsEconomic: 'Daglige indbetalinger (e-conomic)',
        dailyDepositsEconomicDesc: 'Daglige indbetalinger per kreditor til e-conomic uden Frisbii',
        invoiceAppendix: 'Fakturabilag',
        invoiceAppendixDesc: 'Faktura bilag med afregningstal.',
        employeePerformance: 'Medarbejderstatistik',
        employeePerformanceDesc: 'Statistik om medarbejdernes bedrifter i systemet.',
        phoneCalls: 'Oversigt over telefonopkald',
        phoneCallsDesc: 'Overblik over ind- og udgående opkald.',
        phoneCallsDays: 'Vælg antal dage efter opkald indbetalingerne skal være faldet',
        depositAmount: 'Indbetalt beløb',
        depositCount: 'Indbetalinger i antal',
        selectCreditor: 'Vælg kreditor',
        quarter: 'Kvartal',
        optional: 'valgfri',
        noDownloads: 'Der er ingen rapporter til download.',
    },
    tribunal: {
        tribunal: 'Domstolsmodul',
        couldNotCreateTribunalCase: 'Kunne ikke oprette domstolssag',
        createTribunalCase: 'Opret',
        noTribunalCases: 'Endnu ingen sager',
        addTribunalCase: 'Tilføj domstolssag',
        fsNo: 'FS-nummer',
        editFsNo: 'Rediger FS-nummer',
        FsNoUpdated: 'FS-nummer opdateret',
        document: 'Dokument',
        date: 'Dato',
        meetingLocation: 'Mødested',
        meetingDate: 'Mødedato',
        courtCaseCosts: 'Tilkendte sagsomkostninger',
        notRegistered: 'Ikke registreret',
        assignee: 'Mødeansvarlig',
        closedObjection: 'Indsigelse efter 1.-påtegning',
        addDocument: 'Tilføj dokument',
        insolvency: 'Insolvenserklæring',
        insolvencyDate: 'Dato for insolvenserklæring',
        phoneCourtMeeting: 'Retsmøde (eks. telefonisk fogedmøde)',
        register: 'Registrér',
        createFogedrekvisition: 'Opret fogedrekvisition',
        selectDistraintType: 'Vælg udlægstype',
        registerDistraint: 'Registrer udlæg',
        distraintType: 'Udlægstype',
        amount: 'Beløb',
        comment: 'Kommentar',
        address: 'Adresse',
        licenseplate: 'Nummerplade',
        vin: 'VIN',
        distraintDate: 'Dato for tinglysning',
        distraintReferenceId: 'Tinglysningsnummer',
        distraintUpdated: 'Udlæg opdateret',
        distraintCancelled: 'Udlæg annulleret',
        distraintCancelledDate: 'Dato for annullering af udlæg',
        registerPolicePresentation: 'Registrer politifremstilling',
        register1Paategning: 'Registrér 1.-påtegning',
        foerstePaategningDate: 'Dato for 1.-påtegning',
        register2Paategning: 'Registrér 2.-påtegning',
        andenPaategningDate: 'Dato for 2.-påtegning',
        resendBPK: 'Genfremsend revideret betalingspåkrav',
        editBPK: 'Redigér betalingspåkrav',
        debtorSentToPolicePresentation: 'Debitor sendt til politifremstilling',
        resendStaevning: 'Genfremsend stævning',
        editStaevning: 'Redigér stævning',
        resendFogedbegaering: 'Genfremsend fogedbegæring',
        editFogedbegaering: 'Redigér fogedbegæring',
        courtMeetingType: 'Mødetype',
        previousMeetingTypes: 'Tidligere mødetyper',
        unknownMeetingType: 'Ukendt mødetype',
        noMeetingDate: 'Ingen dato',
        meetingDocumentFileName: 'dokument.pdf',
        bailiffInvoice: {
            bailiffInvoice: 'Fogedfaktura',
            client: 'Kreditor',
            debt: 'Gæld',
            paymentFee: 'Betalingspåkravshonorar',
            distress: 'Udlæg',
            yesStartDistress: 'Ja til iværksættelse af udlæg',
            yesAutoCase: 'Ja til automatisk indledning af sag i civilretten',
            createInvoice: 'Opret faktura',
        },
        noFoundation: 'Intet fundament fundet. Tilføj venligst et til sagen for at sende en fogedrekvisition.',
        foundation: 'Fundament',
        economy: 'Økonomi',
        jurisdiction: 'Værneting',
        addFoundation: 'Tilføj fundament',
        requisition: 'Udbetalingsrekvisition',
        court: 'Retskreds',
        responsible: 'Ansvarlig',
        sendRequisition: 'Send udbetalingsrekvisition',
        debt: 'Gæld',
        noCourt: 'Ingen retskreds at finde',
        typeOfRequisituion: 'Type af udbetalingsrekvisition',
        types: {
            [UdbetalingsRekvisitioner.Politifremstilling]: 'Politifremstilling',
            [UdbetalingsRekvisitioner.Betalingspåkrav]: 'Betalingspåkrav',
            [UdbetalingsRekvisitioner.Fogedrekvisition]: 'Fogedrekvisition',
        },
        claim: 'Påstand',
        sendToCourt: 'Send til domstol',
        smallCase: 'Småsag',
        commonCivilCase: 'Almindelig civil sag',
        shortDescription: 'Kort beskrivelse',
        statementClaim: 'Sagsfremstilling og synspunkter',
        addAppendix: 'Tilføj bilag',
        additionalInformation: 'Yderligere information',
        caseCreation: 'Opretter sag',
        caseCreationDescription: `Sagen bliver nu oprettet i domstolens system. Det tager lidt tid, men
    sagen bliver opdateret i Debbie når den er oprettet.`,
        keyCodeTitle: 'Skriv nøglekode til',
        keyCodeDescription: 'Brug NemID nøglekortet til at finde nøglen som svarer til',
        sessionCreation: 'Opretter session',
        sessionCreationFailure: 'Session oprettelse fejlede',
        keySubmittedExplainer: `Nøglekoden bliver nu brugt til at logge ind.`,
        sessionCreationExplainer: `For at sende en sag til domstolen, skal der oprettes session i tribunal. Til det skal vi bruge en nøgle fra jeres NemID nøglekort.`,
        keycode: 'NemID nøglekode',
        authKey: 'Nøgle',
        missingKeyTitle: 'Mangler tribunal nøgle',
        missingKeyExplainer: 'For at kunne sende retssager til domstolen, skal du bruge en nøgle til tribunal.',
        meetings: 'Møder',
    },
    courtMeetingState: {
        [CourtMeetingState.Accepted]: 'Møde accepteret',
        [CourtMeetingState.Concluded]: 'Færdig',
        [CourtMeetingState.NeedsApproval]: 'Venter på godkendelse',
        [CourtMeetingState.NeedsRevision]: 'Venter på revision',
        [CourtMeetingState.NotesSent]: 'Noter modtaget',
        [CourtMeetingState.ReadyForMeeting]: 'Venter på mødenoter',
        [CourtMeetingState.Rejected]: 'Afvist af mødetager',
        [CourtMeetingState.Canceled]: 'Aflyst',
    },
    debtorWeb: {
        overpaymentHeader: 'Du har penge til gode',
        overpaymentSuccessHeader: 'Dine kontooplysninger er modtaget',
        overpaymentSuccessTextHeader: 'Dit tilgodehavende vil blive udbetalt hurtigst muligt. Har du lavet en fejl i din indtastning, kan du opdatere dine oplysninger nedenfor.',
        overpaymentPreAmount: 'Du har',
        overpaymentPostAmount: 'til gode. Anfør dine kontooplysninger nedenfor, og du vil få dit tilgodehavende udbetalt.',
        userInfoUpdateSuccess: 'Du har nu anmodet om at opdatere dine oplysninger, tak.',
        userInfoUpdateNoDataChanged: 'Ingen ændringer registreret',
        congratsNoDebt: 'Du har ingen gæld på denne sag.',
        congratsDeposit: 'Tak for din indbetaling på denne sag.',
        congratsCaseEnd: 'Din sag er afsluttet',
        satisfactionOne: 'Vi vil meget gerne høre om din oplevelse. Tryk',
        satisfactionTwo: 'her',
        satisfactionThree: 'for at indsende den.',
        documentation: 'Dokumentation',
        goToPayment: 'Gå til betaling',
        signingPageSigned: 'Dokumentet er underskrevet',
        signingPageDeclinedSigning: 'Du har afslået at underskrive dokumentet',
        seeMore: 'Se mere',
        noCasesFound: 'Ingen sager fundet',
    },
    associateCases: {
        associateCase: 'Solidarisk hæftelse',
        associateWithCase: 'Find sag med den solidarisk hæftende debitor.',
        associateWithCaseSearch: 'Søg efter sag',
        associateCaseVoucher: 'Vil du synkronisere denne postering med de andre sager?',
        caseVoucherIsAssociated: 'Denne sagspostering er synkroniseret med andre sager i den solidariske hæftelse.',
        joinExistingCase: 'Forbind med eksisterende sag',
        createNewAssociatedCase: 'Opret ny solidarisk sag',
        selectVouchers: 'Vælg posteringer',
        selectVouchersDescription: 'Vælg hvilke posteringer der skal kopieres til den nye sag.',
        createAssociatedCaseButton: 'Opret solidarisk sag',
        noVouchersAvailable: 'Ingen posteringer tilgængelige at kopiere',
    },
    caseGroups: {
        caseGroups: 'Sagsgrupper',
        createCaseGroup: 'Opret sagsgruppe',
        addCaseGroup: 'Tilføj sagsgruppe',
        editCaseGroup: 'Rediger sagsgruppe',
        selectCaseGroup: 'Vælg sagsgruppe',
        searchCaseGroups: 'Søg sagsgrupper',
        confirmDelete: 'Er du sikker på, at du vil slette sagsgruppen? Alle sager i sagsgruppen, vil blive fjernet fra sagsgruppen.',
        deleteCaseGroup: 'Slet',
        caseGroup: 'Sagsgruppe',
        label: 'Navn',
        categorisedDebtOverview: 'Tilføj attributter til sagsposteringstabeller',
        showPropertyLabel: 'Navn',
        addShowProperty: 'Tilføj attribut',
        aiSettings: 'AI Indstillinger',
        aiSettingsDescription: 'Instrukser her vil blive brugt for alle sager i denne sagsgruppe.',
    },
    costCeiling: {
        failedToLoad: 'Noget gik galt. Prøv igen senere.',
        costCeiling: 'Omkostningsloft',
        customAmount: 'Tilpasset omkostningsloft (standard er hovedstolen)',
        defaultForNewCases: 'Omkostningsloft på nye sager',
        caseGroupDefaultDescription: 'Om omkostningsloft er aktiveret på nye sager oprettet i denne sagsgruppe. Hvis der ikke er angivet en sagsgruppeindstilling, bruges indstillingen fra kreditor eller virksomheden.',
        noCreditorSetting: 'Ingen kreditorindstilling',
        noCaseGroupSetting: 'Ingen sagsgruppeindstilling',
        enabled: 'Aktiveret',
        disabled: 'Deaktiveret',
    },
    createTenantContent: {
        defaultCaseGroupLabel: 'Sager til inddrivelse',
        defaultBankAccountName: 'Bankkonto',
    },
    tenants: {
        tenantDetails: 'Tenantoplysninger',
        status: 'Status',
        goLive: 'Sæt live',
        disableTenant: 'Deaktiver tenant',
        disableTenantWarning: 'Er du sikker på, at du vil deaktivere denne tenant? Brugerne mister adgang, og handlingen kan ikke fortrydes i Lighthouse.',
        tenantTypeNotSet: 'Ikke angivet',
        prices: 'Priser',
        identityCollector: 'Inddriver',
        invoicePipeFilter: 'Standard afregningsopsætning',
        defaultBillingModel: 'Standard afregningsmodel',
        defaultBillingAppendixSetup: 'Standard bilagsopsætning',
        configurationOptions: 'Konfigurationer',
        depositBankAccountForCreditors: 'Indbetalingskonto til kreditorer',
        depositBankAccountForCreditorsName: 'Bankens navn',
        billingCustomText: {
            title: 'Brugerdefinerede tekstfelter på afregningsbilag',
            underCreditorName: 'Under kreditors navn',
            endWhenReceivingPayment: 'Under betalingsinformation når kreditor skal betale',
            endWhenSendingPayment: 'Under betalingsinformation når kreditor skal have noget udbetalt',
        },
        collectionCommission: 'Inddrivelseshonorar',
        depositOrder: 'Betalingsrækkefølge',
        date: 'Dato',
        voucherFrom: 'Postering pålagt af',
        voucherType: 'Posteringstype',
        voucherCategory: 'Posteringskategori',
        newestFirst: 'Nyeste først',
        oldestFirst: 'Ældste først',
        caseCloseFee: 'Sagsafslutningshonorarer',
        clientCaseCreationFee: 'Sagsopstartshonorarer kreditor',
        tenantCaseCreationFee: 'Sagsopstartshonorarer tenant',
        debtRegisterRegistrationFee: 'Gældsregister-registreringshonorarer',
        paymentDemandFee: 'Betalingspåkravshonorarer',
        folkeregisteropslagsFee: 'Folkeregisteropslag',
        anmeldelseAfKravFee: 'Anmeldelse af krav',
        legalAdviceHourlyRate: 'Timepris for juridisk bistand',
        afslysningAfUdlaeg: 'Aflysning af udlæg',
        automaticDebtRegister: 'Automatisk gældsregistrering',
        autoRegisterInOpenRegistry: 'Åbent register',
        autoIgnoreUnresolvedOppositions: 'Ignorer uafklarede interaktioner (indsigelser)',
        autoDebtRegisterHeader: 'Auto gældsregistrering',
        autoDeleteDebtRegistrationOnCaseEnd: 'Slet automatisk gældsregistrering ved sagsafslutning',
        autoDebtRegisterInfoTip: 'Klik her for mere info',
        areYouSureAutoDebtRegister: 'Er du sikker?',
        autoDebtRegisterRKI: {
            headline: 'Automatisk registrering i gældsregistre.',
            info: 'Denne funktion tager højde for følgende:',
            exclude: 'Der tages IKKE højde for følgende: ',
            endingInfo: 'Slå derfor kun denne funktion til hvis du/I ved at jeres sager overholder ovenstående.',
            note: 'Bemærk at denne funktions også kan slås til/fra på kreditorniveau.',
        },
        autoImposeCompensationCost: 'Pålæg automatisk ét kompensationsgebyr pr. faktura på erhvervssager',
        autoSendInteractionsAfterXVerifications: 'Antal godkendelser før automatisk afsendelse',
        preventSendingLetters: 'Undlad at sende breve (webhooks kan hjælpe til at sende på anden vis)',
        selfCollection: 'Egeninkasso (pålægger egeninkassoomkostninger)',
        twoFactorRequired: 'Two-faktor-godkendelse for brugere',
        outboundCall: 'Udgående opkald',
        autoExpireVouchers: 'Automatisk forældelse af posteringer',
        hideDocumentsFromCreditors: 'Skjul dokumenter for kreditorer',
        allowDebtorSelfOverwrite: 'Tillad skyldnere at overskrive egne oplysninger uden godkendelse',
        costCeilingEnabledByDefault: 'Aktivér omkostningsloft på nye sager som standard',
        deleteCaseDataAfterYears: 'Slet sagsdata x år efter sagen er afsluttet',
        enableGdprDataDeletion: 'Aktivér automatisk GDPR-datasletning',
        gdprDataDeletionWarning: 'Sagsdata slettes automatisk, når den valgte periode er gået efter sagen er afsluttet. Slettede data kan ikke gendannes.',
        gdprYearsRange: 'Vælg mellem 5 og 99 år',
        dangerZone: 'Farezonen',
        fogedrekvisitionFee: 'Fogedrekvisitionshonorarer',
        AKSSettings: 'RKI indstillinger',
        rkiEnabled: 'Aktivér RKI',
        AKSKey: 'AKS nøgle',
        AKSCode: 'AKS kode',
        AKSUsername: 'AKS brugernavn',
        AKSPassword: 'AKS adgangskode',
        manglerAdvokatindestaaelse: 'Mangler advokatindeståelse',
        debitorRegistretEnabled: 'Aktivér Debitor Registret',
        debitorRegistretClientId: 'Client ID',
        debitorRegistretClientSecret: 'Client Secret',
        debitorRegistretCredentialsRequired: 'Udfyld både Client ID og Client Secret for at gemme adgangsoplysningerne',
        debitorRegistretSetupCreditors: 'Opret kreditorer i Debitor Registret',
        debitorRegistretSetupCreditorsDescription: 'Opretter alle aktive kreditorer i Debitor Registret og gemmer deres kreditornummer.',
        debitorRegistretSetupCreditorsSuccess: 'Kreditorer oprettet i Debitor Registret',
        debitorRegistretSetupCreditorsSkipped: 'Allerede oprettet',
        debitorRegistretSetupCreditorsFailed: 'Fejl ved oprettelse af kreditorer i Debitor Registret',
        affiliatePartners: 'Affiliate partnere',
        createNewTenant: 'Opret ny konto',
        createNewTenantAsAffiliatePartner: 'Opret ny konto som affiliate partner',
        disableAi: 'Deaktiver AI',
        disableCreditorCreationFromUi: 'Deaktiver oprettelse af kreditorer fra brugergrænsefladen',
        autoVerifyCases: 'Verificer sager automatisk',
    },
    intents: {
        intent: 'Hensigt',
        days: 'Dage',
        discount: 'Rabat',
        type: 'Type',
        percentDiscount: 'Procent rabat',
        noDiscount: 'Ingen rabat',
    },
    intentDiscountTypes: {
        [DiscountType.Amount]: 'Beløb',
        [DiscountType.Fraction]: 'Procent',
    },
    intentTypes: {
        [IntentType.Unknown]: 'Ukendt',
        [IntentType.Deposit]: 'Indbetaling',
    },
    errors: {
        notFound: 'Siden du forsøger at besøge findes ikke.',
        caseNotFound: 'Sagen kan ikke findes',
        pleaseCreateTicket: 'Opret venligst et ticket hvis dette er en fejl.',
        unknownError: 'Der opstod en fejl.',
        authError: 'Din bruger har ikke adgang.',
        meError: 'Der var et problem med at få din bruger info. Hvis det ikke er forventet, så prøv igen.',
        unauthorizedError: 'Du har ikke tilladelse til at udføre denne handling',
        invalid: 'ugyldigt',
        missing: 'Mangler',
        loadingError: 'Fejl under indlæsning',
    },
    letterTemplates: {
        journalNumber: 'J.nr.:',
        caseReferenceId: 'Reference:',
        caseVoucherReferenceIds: 'Referencer:',
        returnAddress: 'Returadresse:',
        w: 'W',
        e: 'E',
        t: 'T',
        centralRegisterId: 'CVR',
    },
    mentionContent: {
        amortisationRemainingAfterFinalPayment: 'Restgæld efter sidste afdrag',
        amortisationForgivenOnCompletion: 'Eftergives ved overholdelse af aftalen',
        amortisationDebtAfterSettlement: 'Restgæld efter overholdt akkordaftale',
        amortisationPaymentDate: 'Betalingsdato',
        amortisationAddedFees: 'Tilskrevne gebyrer',
        amortisationRemainingAfterPayment: 'Restgæld efter betaling',
        amortisationRemainingDebt: 'Restgæld',
        amortisationPrincipal: 'Hovedstol',
        amortisationCosts: 'Omkostn.',
        amortisationInterest: 'Renter',
        amortisationAccruedInterest: 'Tilskrevne renter',
        amortisationPayment: 'Ydelse',
        amortisationCurrentBalance: 'Nuværende saldo',
        reminderFeeRow: 'Rykkergebyr jf. rentelovens § 9b, stk. 2',
        debtCollectionFeeRow: 'Inkassogebyr jf. rentelovens § 9b, stk. 3',
        debtCollectionCostRow: 'Udenretlige inkassoomkostninger jf. rentelovens § 9a, stk. 1',
        compensationFeeRow: 'Kompensationsgebyr jf. rentelovens § 9a, stk. 3',
        fixedInterestRow: 'Tidligere påløbne renter',
        processInterestRow: 'Påløbne renter fra forfaldsdato',
        yearlyInterestRow: 'Påløbne renter',
        otherCosts: 'Yderligere omkostninger',
        sum: 'Udestående i alt',
        subTotal: 'Subtotal',
        paid: 'Indbetalt i alt',
        invoice: 'Faktura',
        caseVoucher: 'Postering',
        currency: 'Valuta',
        date: 'Dato',
        dueDate: 'Forfaldsdato',
        amount: 'Beløb',
        deposited: 'Indbetalt',
        residue: 'Rest',
        text: 'Tekst',
        appliedToPrincipal: 'Afdrag hovedstol',
        appliedToInterest: 'Afdrag rente',
        appliedToCosts: 'Afdrag omkostninger',
        principalBalance: 'Rest hovedstol',
        interestBalance: 'Rest rente',
        costsBalance: 'Rest omkostninger',
        expiredSince: 'Heraf forældet',
        total: 'Total',
        email: 'Email',
        phone: 'Telefonnr.',
        signature: 'Underskrift',
        journalNumber: 'j.nr.:',
        genericEmailSubjectPre: 'Vedrørende din gæld til',
        genericEmailSubjectForAlternativeContactPre: 'Sag hos',
        satisfactionsOrClick: 'eller klik',
        satisfactionsHere: 'her',
        principalReferenceIdsAnd: ' og ',
        previousYearsAnd: ' og ',
        nameAndAddressProtectedPerson: 'Person med navne- og adressebeskyttelse',
    },
    emailSignature: {
        privacyPolicyText: 'Behandling af persondata. Vi behandler persondata om dig, som vi bl.a. har indsamlet fra andre. Du kan se vores persondatapolitik her:',
        regards: 'Med venlig hilsen',
    },
    notificationEmail: {
        newPendingMessages: 'Nye afventende beskeder',
        from: 'fra',
        regarding: 'vedr.',
        goToApp: 'Gå til webapp',
        newNotifications: 'Nye notifikationer',
        newTodos: 'Nye opgaver',
    },
    newNoteEmail: {
        dear: 'Kære',
        newMessageFromCollector: 'Du har modtaget en ny besked fra',
        subjectNewMessageFrom: 'Ny besked fra',
        clickHereToAnswer: 'Tryk på nedenstående knap for at læse mere eller besvare henvendelsen.',
        answerAndReadMore: 'Besvar eller læs mere',
        sentTo: 'Sendt til',
    },
    invoice: {
        deposit: 'Indbetaling',
        overpayment: 'Overindbetaling',
        inclVat: 'inkl. moms',
        deposits: 'Indbetalinger',
        creditorSeqId: 'Id',
        period: 'Periode',
        description: 'Beskrivelse',
        amount: 'Beløb',
        ofVoucher: 'Af postering',
        subTotal: 'Subtotal',
        customerReferenceId: 'Kundenummer',
        imposedBy: 'Pålagt af',
        vat: 'Moms',
        total: 'Total',
        date: 'Dato',
        number: 'Nummer',
        appendix: 'Bilag',
        voucher: 'Postering',
        voucherReferenceId: 'Posteringsreference',
        text: 'Tekst',
        disbursements: 'Udlæg',
        fees: 'Honorarer',
        collectionCommission: 'Inddrivelseshonorar',
        creditorName: 'Kreditor',
        creditorReference: 'Kreditorreferencenummer',
        ultimateCreditor: 'Ultimativ kreditor',
        ultimateCreditorName: 'Ultimativ kreditor navn',
        ultimateCreditorReference: 'Ultimativ kreditor referencenummer',
        caseGroup: 'Sagsgruppe',
        caseSeqId: 'Sagsnummer',
        caseReferenceId: 'Sagsref.nr.',
        debtorName: 'Debitornavn',
        depositId: 'Indbetalings-id',
        paidToClient: 'Indbetalt til kreditor',
        economicMovement: 'Kreditorbevægelse',
        creditorDeposit: 'Kreditorindbetaling',
        previous: 'Tidl.',
        credited: 'Tilbageført fra nota',
        currency: 'Valuta',
    },
    properties: {
        selectProperty: 'Vælg en attribut',
        searchProperties: 'Søg attributter',
        properties: 'Attributter',
        createNewPropertyType: 'Opret ny attribut',
        infoGuideMentions: 'For at indsætte feltets data i en skabelon, skal du bruge flettefeltet',
        infoGuideAPI: 'For at berige attributten via API, skal du bruge følgende',
        infoGuideImport: 'For at importere data til flettefeltet kan du indsætte en kolonne i dit excel-import-ark med følgende overskrift',
        newProperty: 'Ny attribut',
        newPropertyFor: 'Opret en ny attribut for',
        label: 'Label',
        description: 'Beskrivelse',
        searchable: 'Søgbar',
        handle: 'Handle',
        type: 'Type',
        selectType: 'Vælg en type',
        ref: 'Reference',
        scope: 'Tilknytning',
        addedToAllCases: 'Attributten tilføjes til alle sager',
        required: 'Påkrævet',
        usage: 'Brug',
        historical: 'Historisk data',
        create: 'Opret attributten',
        defaultDropdownOptions: 'Valgmulighed 1\nValgmulighed 2',
        dropdownOptions: 'Dropdown valgmuligheder',
        cases: 'Sager',
        caseVouchers: 'Sagsposteringer',
        creditors: 'Kreditorer',
        delete: 'Slet',
        or: 'eller',
        deleteAreYouSure: 'Hvis denne attribut slettes, vil den blive slettet fra alle sager og evt. skabeloner. Er du sikker?',
        option: 'Valgmulighed',
    },
    entities: {
        [Entity.Billing]: 'Afregning',
        [Entity.Case]: 'Sag',
        [Entity.Creditor]: 'Kreditor',
        [Entity.Customer]: 'Kunde',
        [Entity.TribunalCase]: 'Domstolssag',
        [Entity.Debtor]: 'Debitor',
        [Entity.Collector]: 'Inddriver',
        [Entity.BillingVoucher]: 'Afregningspostering',
        [Entity.CaseVoucher]: 'Sagspostering',
        [Entity.Template]: 'Template',
        [Entity.Workflow]: 'Workflow',
    },
    filterType: {
        [FilterType.Exact]: 'Filtrer på præcis værdi',
        [FilterType.Containing]: 'Filtrer på indeholdt værdi',
    },
    propertyDataTypes: {
        [PropertyDataType.checkbox]: 'Ja/nej',
        [PropertyDataType.datePicker]: 'Dato',
        [PropertyDataType.dropdown]: 'Dropdown',
        [PropertyDataType.singleLineText]: 'Tekst',
        [PropertyDataType.multiLineText]: 'Lang tekst',
        [PropertyDataType.number]: 'Tal',
        [PropertyDataType.file]: 'Fil',
        [PropertyDataType.address]: 'Adresse',
        [PropertyDataType.money]: 'Beløb',
    },
    propertyDataTypeDescriptions: {
        [PropertyDataType.checkbox]: 'Et afkrydsningsfelt der kan være markeret eller ej',
        [PropertyDataType.datePicker]: 'En dato valgt fra en kalender',
        [PropertyDataType.dropdown]: 'Ét valg fra en foruddefineret liste af muligheder',
        [PropertyDataType.singleLineText]: 'En kort tekst på én linje',
        [PropertyDataType.multiLineText]: 'Længere tekst over flere linjer',
        [PropertyDataType.number]: 'En numerisk værdi',
        [PropertyDataType.file]: 'En uploadet fil',
        [PropertyDataType.address]: 'En struktureret adresse med vej, postnummer og by',
        [PropertyDataType.money]: 'Et beløb med valuta',
    },
    propertyRefDescriptions: {
        [Entity.Customer]: 'Attributten udfyldes på kunden og deles på tværs af kundens sager',
        [Entity.Case]: 'Attributten tilføjes på sagsniveau',
        [Entity.CaseVoucher]: 'Attributten tilføjes på sagsposteringsniveau',
        [Entity.Creditor]: 'Attributten tilføjes på kreditorniveau',
    },
    propertyTypeDescriptions: {
        ['Name of the alternative contact person.']: 'Repræsentantens navn.',
        ['Address for the alternative contact person.']: 'Repræsentantens adresse.',
        ['Phone to the alternative contact person.']: 'Repræsentantens telefonnummer.',
        ['Email to the alternative contact person.']: 'Repræsentantens email.',
        ['Type of the alternative contact person.']: 'Repræsentantens type.',
        ['Company where the alternative contact person works.']: 'Repræsentantens arbejdsplads/virksomhed.',
    },
    alternativeContactTypes: {
        [AlternativeContactType.Lawyer]: 'Advokat',
        [AlternativeContactType.Proprietorship]: 'Boligadministrator',
        [AlternativeContactType.Owner]: 'Ejer',
        [AlternativeContactType.Guardian]: 'Værge',
        [AlternativeContactType.Curator]: 'Kurator',
        [AlternativeContactType.Landlord]: 'Udlejer',
        [AlternativeContactType.FinancialAdvisor]: 'Økonomisk rådgiver',
        [AlternativeContactType.TaxAuthority]: 'SKAT',
        [AlternativeContactType.PowerOfAttorney]: 'Fuldmagtshaver',
        [AlternativeContactType.Administrator]: 'Administrator',
        [AlternativeContactType.Police]: 'Politi',
        [AlternativeContactType.Guarantor]: 'Kautionist',
        [AlternativeContactType.Other]: 'Anden',
    },
    voucherApplications: {
        header: 'Regler',
        createError: 'Der opstod en fejl under oprettelsen. Tjek at du ikke laver cirkulære referencer.',
        creditorCustomApplicationList: 'Kreditorspecifikke regler',
        noCustomApplications: 'Ingen regler',
        textSelector1: 'Når en ny ',
        textSelector2: ' oprettes, hvor sagens type er ',
        textSelector3: ', oprettes følgende postering.',
        forCreditor: 'Når kreditor er',
        addCreditor: 'Vælg kreditor',
    },
    voucherApplicationTypeLabels: {
        [VoucherApplicationType.Case]: 'sag',
        [VoucherApplicationType.VoucherCategory]: 'postering med kategorien',
        [VoucherApplicationType.VoucherType]: 'postering af typen',
    },
    voucherApplicationTargetLabels: {
        [VoucherApplicationTarget.Both]: 'privat eller erhverv',
        [VoucherApplicationTarget.Person]: 'privat',
        [VoucherApplicationTarget.Company]: 'erhverv',
    },
    creditScore: {
        estimated: 'Estimeret',
        estimateZero: 'sandsynlighed for inddrivelse',
        estimate: 'sandsynlighed for inddrivelse af restgælden',
        paid: 'Gælden er betalt',
    },
    interestFromLabels: {
        [InterestFrom.Date]: 'fra oprettelsesdato',
        [InterestFrom.DueDate]: 'fra forfaldsdato',
    },
    todoQueue: {
        sorting: 'Sortering',
        oldest: 'Ældste',
        creditScore: 'Kreditscore',
        creditorTodosNotSupported: 'Opgaver håndteres endnu ikke for kreditorer',
    },
    views: {
        associated: 'Solidarisk',
        notAssociated: 'Ikke solidarisk',
        filter: 'Filtrér',
        view: 'visning',
        name: 'Navn på visning',
        introHeader: 'Ingen visninger her',
        introDescription: 'Du kan oprette en visning ved at klikke på knappen oppe i højre hjørne.',
        clear: 'Ryd',
        collapse: 'Se færre',
        expand: 'Se flere',
        noData: 'Siden er tom',
        is: 'er',
        oneOf: 'er en af',
        before: 'før',
        after: 'efter',
        values: 'værdier',
        isNot: 'er ikke',
        noneOf: 'er ikke en af',
        localChanges: 'Visning ændret lokalt',
        resetLocalChanges: 'Nulstil ændringer',
        invalidNumberError: ' er ikke et validt tal',
        displayOptions: 'Værdier',
        orderedBy: 'Sorter baseret på',
        orderedByDirection: 'Sorteringsretning',
        primaryLabel: 'Primære label',
        secondaryLabel: 'sekundære label',
        betaDisclaimer: 'Visninger er en beta-funktion. Der kan forekomme ændringer eller opdateringer, som potentielt kan påvirke tidligere oprettede visninger. Vi arbejder løbende på at forbedre funktionen og sætter pris på din tålmodighed',
        commaSeparated: 'Komma-separeret',
    },
    viewFilterTypeLabels: {
        isAssociatedCase: 'Hæftelse',
        caseStatus: 'Sagsstatus',
        creditorId: 'Kreditor',
        creditorState: 'Kreditor status',
        interactionDirection: 'Interaktionsretning',
        interactionType: 'Interaktionstype',
        caseVoucherState: 'Posteringsstatus',
        caseVoucherSource: 'Posteringskilde',
        caseVoucherCurrency: 'Posteringsvaluta',
        caseVoucherType: 'Posteringstype',
        pausedWithUpdates: 'Pauset opgave',
        historicallyPausedUpdates: 'Historisk pauset opgave',
        creditorCreatedAt: 'Kreditor oprettet',
        updatePausedAt: 'Opgave pauset',
        updateContinuedAt: 'Opgave fortsat',
        updateRemindedAt: 'Opgave påmindet',
        caseCreatedAt: 'Sag oprettet',
        caseVoucherDate: 'Posteringsdato',
        caseVoucherExpirationDate: 'Posterings forældelsesdato',
        caseVoucherIrrecoverableDate: 'Posterings uerholdelig dato',
        caseVoucherCreatedAt: 'Postering oprettet',
        satisfactionCreatedAt: 'Anmeldelse oprettet',
        interactionCreatedAt: 'Interaktion oprettet',
        endReasonId: 'Afslutningsårsag',
        caseGroupId: 'Sagsgruppe',
        billingModelId: 'Afregningsmodel',
        documentType: 'Dokument type',
        caseWorkflow: 'Sags workflow',
        currentCaseWorkflowTask: 'Sags nuværende workflow opgave',
        nextCaseWorkflowTask: 'Sags næste workflow opgave',
        caseStatusTime: 'Sags status tidspunkt',
        caseNumbers: 'Sags-id',
        properties: 'Attribut',
        caseTags: 'Sags tags',
        isCompany: 'Debitor type',
        agentNotice: 'Agentnotifikationstype',
        agentProposalState: 'Agent-forslags status',
        agentProposalProposedAt: 'Agent-forslags dato',
        agentProposalDecidedAt: 'Beslutningsdato for agentforslag',
        agentProposalTool: 'Agent-forslags handling',
    },
    viewLabels: {
        'cases.id': 'Sags-id',
        'cases.status': 'Sagsstatus',
        'cases.createdAt': 'Sags oprettelsesdato',
        'cases.createdBy': 'Sag oprettet af',
        'creditors.name': 'Kreditor navn',
        'creditors.id': 'Kreditor id',
        'billingModels.name': 'Afregningsmodel',
        'caseGroups.label': 'Sagsgruppe',
        'workflows.title': 'Workflow',
        'caseVouchers.amount': 'Posterings beløb',
        caseVoucherProperties: 'Posteringsattributter',
        caseProperties: 'Sagsattributter',
        contactName: 'Kontaktpersons navn',
        'voucherTypes.label': 'Posteringstype',
        caseResponsible: 'Sagsansvarlig',
        caseEndReason: 'Sags afslutningsårsag',
        caseUpdates: 'Pausede sagsopgaver',
        agentProposals: 'Agent-forslag',
    },
    interactionCategories: {
        title: 'Interaktionskategorier',
        createCategory: 'Opret kategori',
        interactionCategory: 'interaktionskategori',
        interactionCategories: 'interaktionskategorier',
        sectionProposed: 'Foreslåede',
        sectionExisting: 'Eksisterende',
    },
    categoryDiscovery: {
        title: 'Kategori-opdagelse',
        description: 'Gennemgå nylige interaktioner og foreslå nye kategorier. Kører normalt automatisk om natten — brug denne knap til at trigge det manuelt.',
        runButton: 'Kør opdagelse nu',
        running: 'Starter…',
        started: 'Opdagelse startet',
        skipped: 'En opdagelseskørsel er allerede i gang',
        completed: 'Opdagelse fuldført',
        error: 'Kunne ikke starte opdagelse',
        proposalsTitle: 'Foreslåede kategorier',
        proposalsEmpty: 'Ingen foreslåede kategorier endnu.',
        supportingCount: 'understøttende interaktioner',
        acceptButton: 'Acceptér',
        rejectButton: 'Afvis',
        acceptSuccess: 'Kategori oprettet og anvendt på understøttende interaktioner',
        rejectSuccess: 'Forslag afvist',
        settingsTitle: 'Indstillinger',
        settingsEnabled: 'Aktivér kategori-opdagelse',
        settingsAutomaticComingSoon: 'Når aktiveret kører kategori-opdagelse automatisk hver nat.',
        debugRerunTitle: 'Debug: kør aggregering igen',
        debugRerunPlaceholder: 'Run ID',
        debugRerunButton: 'Kør igen',
        debugRerunSuccess: 'Aggregering færdig',
    },
    ai: {
        suggestion: 'AI forslag',
        qualityScore: 'Kvalitetsscore',
        safetyScore: 'Sikkerhedsscore',
        manipulationDetected: 'Manipulation opdaget',
        sensitivityFlags: 'Følsomhedsflag',
        reasoning: 'Begrundelse',
    },
    autoReply: {
        title: 'AI Auto-svar',
        description: 'Generer automatisk svar på indgående e-mails ved hjælp af AI',
        enabled: 'Aktiver auto-svar',
        enabledDescription: 'Når aktiveret, genererer AI svarkladder til indgående e-mails, der er mappet til sager',
        mode: 'Tilstand',
        modeOutbox: 'Udbakke (Gennemgang)',
        modeOutboxDescription: 'Genererede svar gemmes som kladder til manuel gennemgang før afsendelse',
        modeAutoSend: 'Auto-send',
        modeAutoSendDescription: 'Svar, der opfylder kvalitetskrav, sendes automatisk',
        qualityThreshold: 'Kvalitetstærskel',
        qualityThresholdDescription: 'Minimum kvalitetsscore (0-1) krævet for auto-afsendelse',
        safetyThreshold: 'Sikkerhedstærskel',
        safetyThresholdDescription: 'Minimum sikkerhedsscore (0-1) krævet. Under dette blokeres svar',
        sensitivityFlags: 'Følsomhedsblokliste',
        sensitivityFlagsDescription: 'Emner der kræver manuel gennemgang når de opdages',
        customFlags: 'Brugerdefinerede følsomhedsflag',
        customFlagsDescription: 'Definer brugerdefinerede emner, der skal udløse manuel gennemgang',
        addCustomFlag: 'Tilføj brugerdefineret flag',
        flagId: 'Flag-ID',
        flagName: 'Navn',
        flagDescription: 'Beskrivelse (hvad skal AI kigge efter)',
        noCustomFlags: 'Ingen brugerdefinerede flag defineret',
        generationModel: 'Genereringsmodel',
        judgeModel: 'Bedømmelsesmodel',
        flags: {
            COURT_LEGAL: 'Ret / Juridisk',
            POLICE: 'Politi',
            FINANCIAL_HARDSHIP: 'Økonomiske vanskeligheder',
            DISPUTE: 'Tvist',
            THREAT_HOSTILE: 'Trusler / Fjendtlig',
            MEDICAL_HEALTH: 'Medicinsk / Helbred',
        },
        blockedReasons: {
            auto_reply_disabled: 'Auto-svar er deaktiveret',
            manipulation_detected: 'Manipulation opdaget i indgående besked',
            safety_threshold: 'Sikkerhedsscore under grænseværdi',
            blocklist_match: 'Matchede følsomhedsblokeringsliste',
            custom_flag_match: 'Matchede brugerdefineret følsomhedsflag',
            case_reassigned: 'Sagen blev omfordelt',
        },
        customInstructions: 'Brugerdefinerede AI-instrukser',
        customInstructionsDescription: 'Disse instrukser vil blive inkluderet i alle AI-genererede svar. Brug dette til at definere tone, specifikke regler eller information der altid skal medtages.',
        customInstructionsPlaceholder: 'F.eks.: Henvis altid til vores hjemmeside for betalingsoplysninger. Brug altid kundens fornavn.',
        creditorAISettings: 'AI Indstillinger',
        creditorAISettingsDescription: 'Instrukser her vil blive brugt for alle sager tilhørende denne kreditor.',
        usageTitle: 'AI-forbrug',
        usageSuggestions: 'Forslag',
        usageCategorizations: 'Kategoriseringer',
        usageAutoReplies: 'Auto-svar',
        usageAgent: 'Agent-kørsler',
        usageLimitReached: 'AI-kreditpuljen for denne måned er opbrugt',
        creditsRemaining: 'credits tilbage denne måned',
        creditsUsed: 'credits brugt denne måned',
        usageBreakdown: 'Brugt på',
        generateSuggestion: 'Generér AI forslag',
    },
    // https://github.com/cospired/i18n-iso-languages/blob/main/langs/da.json
    languages: {
        aa: 'Afar',
        ab: 'Abkhasisk',
        ae: 'Avestisk',
        af: 'Afrikaans',
        ak: 'Akan',
        am: 'Amharisk',
        an: 'Aragonisk',
        ar: 'Arabisk',
        as: 'Assamesisk',
        av: 'Avarisk',
        ay: 'Aymara',
        az: 'Aserbajdsjansk',
        ba: 'Basjkirsk',
        be: 'Hviderussisk',
        bg: 'Bulgarsk',
        bh: 'Bihari',
        bi: 'Bislama',
        bm: 'Bambara',
        bn: 'Bengali',
        bo: 'Tibetansk',
        br: 'Bretonsk',
        bs: 'Bosnisk',
        ca: 'Katalansk',
        ce: 'Tjetjensk',
        ch: 'Chamorro',
        co: 'Korsikansk',
        cr: 'Cree',
        cs: 'Tjekkisk',
        cu: 'Kirkeslavisk',
        cv: 'Tsjuvansk',
        cy: 'Walisisk',
        da: 'Dansk',
        de: 'Tysk',
        dv: 'Dhivehi',
        dz: 'Dzongkha',
        ee: 'Ewe',
        el: 'Græsk',
        en: 'Engelsk',
        eo: 'Esperanto',
        es: 'Spansk',
        et: 'Estisk',
        eu: 'Baskisk',
        fa: 'Persisk',
        ff: 'Fulfulde',
        fi: 'Finsk',
        fj: 'Fijisk',
        fo: 'Færøsk',
        fr: 'Fransk',
        fy: 'Frisisk',
        ga: 'Irsk',
        gd: 'Skotsk gælisk',
        gl: 'Galicisk',
        gn: 'Guaraní',
        gu: 'Gujarati',
        gv: 'Mansk',
        ha: 'Hausa',
        he: 'Hebraisk',
        hi: 'Hindi',
        ho: 'Hiri motu',
        hr: 'Kroatisk',
        ht: 'Haitisk kreolsk',
        hu: 'Ungarsk',
        hy: 'Armensk',
        hz: 'Herero',
        ia: 'Interlingua',
        id: 'Indonesisk',
        ie: 'Interlingue',
        ig: 'Ibo',
        ii: 'Yi',
        ik: 'Inupiak',
        io: 'Ido',
        is: 'Islandsk',
        it: 'Italiensk',
        iu: 'Inuittisk',
        ja: 'Japansk',
        jv: 'Javanesisk',
        ka: 'Georgisk',
        kg: 'Congolesisk',
        ki: 'Gikuyu',
        kj: 'Kwanyama',
        kk: 'Kasakhisk',
        kl: 'Kalaallisut',
        km: 'Khmer',
        kn: 'Kannada',
        ko: 'Koreansk',
        kr: 'Kanuri',
        ks: 'Kashmirisk',
        ku: 'Kurdisk',
        kv: 'Komi',
        kw: 'Kornisk',
        ky: 'Kirgisisk',
        la: 'Latin',
        lb: 'Letzeburgsk',
        lg: 'Luganda',
        li: 'Limburgisk',
        ln: 'Lingala',
        lo: 'Laotisk',
        lt: 'Litauisk',
        lu: 'Luba-katanga',
        lv: 'Lettisk',
        mg: 'Gassisk',
        mh: 'Marshallesisk',
        mi: 'Maoriski',
        mk: 'Makedonsk',
        ml: 'Malayalam',
        mn: 'Mongolsk',
        mr: 'Marathi',
        ms: 'Malajisk',
        mt: 'Maltesisk',
        my: 'Burmesisk',
        na: 'Naurisk',
        nb: 'Norsk bokmål',
        nd: 'Nord-ndebele',
        ne: 'Nepali',
        ng: 'Ndonga',
        nl: 'Hollandsk',
        nn: 'Nynorsk',
        no: 'Norsk',
        nr: 'Syd-ndebele',
        nv: 'Navajo',
        ny: 'Chichewa',
        oc: 'Occitansk',
        oj: 'Ojibwa',
        om: 'Oromo',
        or: 'Oriya',
        os: 'Ossetisk',
        pa: 'Punjabi',
        pi: 'Pali',
        pl: 'Polsk',
        ps: 'Pashto',
        pt: 'Portugisisk',
        qu: 'Quechua',
        rm: 'Rætoromansk',
        rn: 'Kirundi',
        ro: 'Rumænsk',
        ru: 'Russisk',
        rw: 'Kinyarwanda',
        sa: 'Sanskrit',
        sc: 'Sardisk',
        sd: 'Sindhi',
        se: 'Nordsamisk',
        sg: 'Sango',
        si: 'Singalesisk',
        sk: 'Slovakisk',
        sl: 'Slovensk',
        sm: 'Samoansk',
        sn: 'Shona',
        so: 'Somali',
        sq: 'Albansk',
        sr: 'Serbisk',
        ss: 'Swati',
        st: 'Sesotho',
        su: 'Sundanesisk',
        sv: 'Svensk',
        sw: 'Swahili',
        ta: 'Tamilsk',
        te: 'Telugu',
        tg: 'Tadtjikkisk',
        th: 'Thai',
        ti: 'Tigrinya',
        tk: 'Turkmensk',
        tl: 'Tagalog',
        tn: 'Tswana',
        to: 'Tonganesisk',
        tr: 'Tyrkisk',
        ts: 'Tsonga',
        tt: 'Tatarsk',
        tw: 'Twi',
        ty: 'Tahitisk',
        ug: 'Uighur',
        uk: 'Ukrainsk',
        ur: 'Urdu',
        uz: 'Usbekisk',
        ve: 'Venda',
        vi: 'Vietnamesisk',
        vo: 'Volapük',
        wa: 'Vallonsk',
        wo: 'Wolof',
        xh: 'Xhosa',
        yi: 'Jiddisch',
        yo: 'Yoruba',
        za: 'Zhuang',
        zh: 'Kinesisk',
        zu: 'Zulu',
    },
    weekdays: {
        0: 'Mandag',
        1: 'Tirsdag',
        2: 'Onsdag',
        3: 'Torsdag',
        4: 'Fredag',
        5: 'Lørdag',
        6: 'Søndag',
    },
    cosmo: {
        [ProviderName.DEBBIE]: {
            title: 'Debbie',
            description: 'Holder Cosmo opdateret med data fra Debbie',
        },
        [ProviderName.LEGACY]: {
            title: 'Legacy [DO NOT ENABLE]',
            description: 'Migrering fra legacy cosmo til cosmoV2',
        },
        [ProviderName.MIGRATION]: {
            title: 'Migrering [DO NOT ENABLE]',
            description: 'Historisk kontaktdata migreret fra andre systemer under importer',
        },
        [ProviderName.AKS]: {
            title: 'Experian Aktiv KreditSikring (AKS)',
            description: 'Aktiv KreditSikring giver dig opdaterede og detaljerede kreditoplysninger om dine kunder. Tjenesten indeholder seneste stamdata, finansielle nøgletal, anmærkninger og andre væsentlige informationer, der hjælper dig med at vurdere en virksomheds økonomiske sundhed',
        },
        [ProviderName.CVR]: {
            title: 'CVR',
            description: 'Få adgang til officielle virksomhedsdata direkte fra CVR. Indeholder information om virksomheders navn, adresse, CVR-nummer, selskabsform, startdato, ejere og andre nøgledata',
        },
        [ProviderName.CPR]: {
            title: 'CPR',
            description: 'Få adgang til den danske stats officielle personnummer register. Her kan man få person information baseret på CPR nummer eller navn/adresse søgning.',
        },
        [ProviderName.TINGBOGEN]: {
            title: 'Tingbogen',
            description: 'Få adgang til tinglysningsoplysninger for fast ejendom, biler og andre aktiver. Tjek ejerskabsforhold, pantebreve, servitutter og andre hæftelser direkte fra den digitale Tingbog',
        },
        [ProviderName.MAILVALIDATOR]: {
            title: 'Email validering',
            description: 'Debbie E-mail validering tjekker, om e-mailadresser er korrekte og eksisterer. Den kontrollerer, at adressen er skrevet rigtigt, at domænet findes, og prøver også at bekræfte om selve e-mailadressen er aktiv, så du kan undgå at sende beskeder til adresser, der ikke findes.',
        },
        [ProviderName.COURT]: {
            title: 'Retskreds',
            description: 'Automatisk find og tilknyt retskreds til sager',
        },
        [ProviderName.VONAGE]: {
            title: 'Vonage',
            description: 'Hent information om telefonnumre, såsom deres gyldighed, type (mobil eller fastnet) og oplysninger om udbyder.',
        },
        [ProviderName.EJF]: {
            title: 'Ejerfortegnelsen',
            description: 'Få adgang til ejendomsejerskabsdata fra Ejerfortegnelsen. Slå ejerskabsoplysninger op for fast ejendom baseret på adresse eller bygningskode.',
        },
    },
    endReasonsSettings: {
        customEndReasons: 'Oprettede afslutningsårsager',
        systemEndReasons: 'Standard afslutningsårsager',
        createEndReason: 'Opret afslutningsårsag',
        label: 'Navn',
        category: 'Kategori',
        labelPlaceholder: 'Navn på afslutningsårsag',
        categoryPlaceholder: 'Vælg kategori',
        uncategorized: 'Ukategoriseret',
        editEndReason: 'Redigér afslutningsårsag',
        deleteEndReason: 'Slet afslutningsårsag',
        deleteEndReasonConfirm: 'Er du sikker på, at du vil slette denne afslutningsårsag? Det kan ikke fortrydes.',
        deleteEndReasonInUse: 'Afslutningsårsagen bruges af afsluttede sager og kan ikke slettes',
        standardReadOnly: 'Standardårsager deles af alle og kan ikke redigeres eller slettes.',
        endReasonNotFound: 'Afslutningsårsagen blev ikke fundet',
        handle: 'Handle',
    },
    voucherTypeSelect: {
        selectBillingVoucherType: 'Vælg afregningsposteringstype',
        selectCaseVoucherType: 'Vælg sagsposteringstype',
        selectPaymentVoucherType: 'Vælg posteringstype for betaling',
        searchVoucherTypes: 'Søg posteringstyper',
        allVoucherTypes: 'Alle posteringstyper',
    },
    paymentTypeSelect: {
        selectPaymentType: 'Vælg betalingstype',
        searchPaymentTypes: 'Søg betalingstyper',
        allPaymentTypes: 'Alle betalingstyper',
    },
    contacts: {
        contact: 'kontakt',
        selectContact: 'Vælg kontakt',
        selectPayoutContact: 'Udbetal til kontakt',
        searchContacts: 'Søg kontakter',
        allContacts: 'Alle kontakter',
        createContact: 'Opret kontakt',
        editContact: 'Rediger kontakt',
        deleteContact: 'Slet kontakt',
        deleteContactConfirm: 'Er du sikker på, at du vil slette kontakten?',
        notSelectableHere: 'Kontakten mangler de oplysninger, der kræves her, og er derfor ikke valgt',
        email: 'Email',
        phone: 'Telefon',
        registryIdentifier: 'CVR-/CPR-nummer',
        bankAccount: 'Kontooplysninger',
    },
    errorEntities: {
        sftpServer: 'SFTP-server',
        sftpUser: 'SFTP-bruger',
        endReason: 'afslutningsårsag',
        update: 'opgave',
        workflow: 'workflow',
        workflowStage: 'workflow stadie',
        creditorLink: 'kreditorlink',
        ultimateCreditor: 'ultimativ kreditor',
        interaction: 'interaktion',
        procedure: 'procedure',
        tribunalCase: 'domstolssag',
        tribunalJob: 'domstolsopgave',
        payout: 'udbetaling',
        document: 'dokument',
        paymentPlan: 'afdragsordning',
        file: 'fil',
        creditor: 'kreditor',
        billing: 'afregning',
        billingCollection: 'afregningssamling',
        caseVoucher: 'postering',
        caseVoucherTable: 'posteringstabel',
        fixedDistribution: 'fast fordeling',
        billingModel: 'afregningsmodel',
        billingAppendixSetup: 'afregningsbilagsopsætning',
        customer: 'kunde',
        user: 'bruger',
        settings: 'indstillinger',
        case: 'sag',
        party: 'part',
        import: 'import',
        transactionAccount: 'transaktionskonto',
        interactionCategory: 'interaktionskategori',
        view: 'visning',
        apiKey: 'API-nøgle',
        searchIndex: 'søgeindeks',
        merge: 'sagsfletning',
        associateCase: 'sagstilknytning',
        deposit: 'indbetaling',
        task: 'opgave',
        chain: 'workflow',
        contact: 'kontaktperson',
        remindDate: 'påmindelsesdato',
        changelog: 'ændringslog',
        referenceId: 'referencenummer',
        aiSuggestion: 'AI-forslag',
        attachment: 'vedhæftet fil',
        preview: 'forhåndsvisning',
        note: 'note',
        rollbackTask: 'opgave-tilbagerulning',
        runTask: 'opgaveudførelse',
        bankAccountDetails: 'bankkontodetaljer',
        bulkActions: 'massehandling',
        pause: 'pause',
        meetingLocation: 'mødested',
        meetingDate: 'mødedato',
        satisfaction: 'tilfredshedsvurdering',
        tags: 'tags',
        template: 'skabelon',
        webhook: 'webhook',
        property: 'egenskab',
        updateType: 'opgavetype',
        phone: 'telefonnummer',
        email: 'e-mailadresse',
        report: 'rapport',
        caseGroup: 'sagsgruppe',
        collector: 'inddriver',
        team: 'team',
        rkiRegistration: 'RKI-registrering',
        interestCalculation: 'renteberegning',
        integration: 'integration',
        asset: 'aktiv',
    },
    generalManagementInsights: {
        tabs: {
            portfolio: 'Sagsportefølje',
            resolutionRate: 'Løsningsgrad',
            caseHandling: 'Sagsbehandling',
            calls: 'Opkald',
            communicationsAndWorkflows: 'Kommunikation & workflows',
            expiration: 'Forældelse',
            revenue: 'Omsætning',
            tribunal: 'Retlig',
            incomingPayments: 'Indbetalinger',
            paymentPlans: 'Afdragsordninger',
        },
        filters: {
            caseGroupsPlaceholder: 'Alle sagsgrupper',
            creditorsPlaceholder: 'Alle kreditorer',
            searchPlaceholder: 'Søg...',
        },
        incomingPayments: {
            byMonthHeader: 'Indbetalinger pr. måned',
            bySourceHeader: 'Fordeling pr. modtager',
            byStateHeader: 'Fordeling pr. type',
            byPaymentTypeHeader: 'Fordeling pr. betalingsmåde',
            countLabel: 'Antal',
            amountLabel: 'Beløb',
            sourceCollector: 'Modtaget hos inddriveren',
            sourceCreditor: 'Modtaget hos kreditor',
            shareOfAmount: (share) => `${share}% af beløb`,
            countWithShare: (count, share) => `${count} indbetalinger (${share}%)`,
            stateLabels: {
                [CaseVoucherState.FullPayment]: 'Fuld betaling',
                [CaseVoucherState.PartialPayment]: 'Delbetaling',
                [CaseVoucherState.Overpayment]: 'Overindbetaling',
                [CaseVoucherState.PaymentPlanEntryPayment]: 'Afdrag på afdragsordning',
                [CaseVoucherState.UnkownPaymentPlanPayment]: 'Ukendt afdrag',
                [CaseVoucherState.AccordPayment]: 'Akkord',
                [CaseVoucherState.PrincipalPayment]: 'Hovedstolsbetaling',
            },
            paymentTypeUnknown: 'Ukendt',
            columnPaymentType: 'Betalingsmåde',
            columnCount: 'Antal',
            columnCountShare: 'Andel af antal',
            columnAmount: 'Beløb',
            columnAmountShare: 'Andel af beløb',
            currencyLabel: 'Valuta',
            noData: 'Ingen data',
        },
        common: {
            incoming: 'Indgående',
            outgoing: 'Udgående',
            others: 'Øvrige',
            noCaseGroup: 'Uden sagsgruppe',
            noData: 'Ingen data',
            creditor: 'Kreditor',
            caseGroup: 'Sagsgruppe',
            updateType: 'Opgavetype',
            user: 'Bruger',
            tag: 'Tag',
            count: 'Antal',
            total: 'I alt',
            payment: 'Betaling',
            paymentPlan: 'Afdragsordning',
            revenue: 'Omsætning',
            open: 'Åbne',
            oldest: 'Ældste',
            over7Days: 'Over 7d',
            over30Days: 'Over 30d',
            medianAge: 'Median alder',
            daysValue: (days) => `${days} dage`,
            xOfY: (a, b) => `${a} af ${b}`,
        },
        portfolio: {
            createdAndEndedCasesPerMonth: 'Oprettede og afsluttede sager per måned',
            createdCasesPerCreditor: 'Oprettede sager per kreditor',
            activeCasesPerMonth: 'Aktive sager per måned',
            submittedAndImposedPerMonth: 'Pålagt per måned',
            ageDistributionOfActiveCases: 'Aldersfordeling af aktive sager',
            top10CreditorsByOutstanding: 'Top 10 kreditorer efter totalt udestående',
            createdCases: 'Oprettede sager',
            activeCases: 'Aktive sager',
            imposedByCreditor: 'Pålagt af kreditor',
            imposedByCollector: 'Pålagt af inddriver',
            compositionFootnote: 'Posteringerne er delt op efter hvem der har registreret dem — kreditor (hovedstol, fakturaer, rykkergebyrer) eller inddriver (renter, omkostninger, retsomkostninger og gebyrer pålagt under inddrivelsen).',
            cases: 'Sager',
            balance: 'Saldo',
            columnCaseCount: 'Antal sager',
            columnTotalOutstanding: 'Totalt udestående',
        },
        caseHandling: {
            allCaseGroups: 'Alle sagsgrupper',
            allCreditors: 'Alle kreditorer',
            allUpdateTypes: 'Alle opgavetyper',
            allResponsibles: 'Alle ansvarlige',
            unassignedOption: 'Ikke-tildelt',
            teamsGroup: 'Teams',
            usersGroup: 'Brugere',
            behindPerUser: 'Bagud per bruger',
            behindPerUserDescription: 'Åbne opgaver pr. bruger - inkluderer ikke-tildelte opgaver så ansvaret kan placeres.',
            behindPerTeam: 'Bagud per team',
            behindPerTeamDescription: 'Åbne opgaver pr. team - så det kan vurderes hvilke teams der er bagud.',
            noOpenTasksByUser: 'Ingen åbne opgaver per bruger',
            noOpenTasksByTeam: 'Ingen åbne opgaver per team',
            unknownUser: 'Ukendt bruger',
            unknownTeam: 'Ukendt team',
            user: 'Bruger',
            currentTaskBacklog: 'Aktuel opgavebeholdning',
            timeSpentPerUpdateType: 'Tidsforbrug per opgavetype',
            avgTimeOnTaskList: (label) => (label ?? '')
                ? `Gns. tid på opgavelisten - ${label}`
                : 'Gns. tid på opgavelisten',
            lessThanOneDay: '< 1d',
            taskBacklogDescription: 'Viser de opgaver som lige nu ligger på opgavelisten. Brug det til at se hvad teamet er bagud med, og hvilke opgavetyper der har brug for prioritering.',
            totalOpenTasks: 'Åbne opgaver i alt',
            oldestLabel: (days) => `Ældste: ${days}`,
            overDeadline: 'Over deadline',
            percentOfTasksWithDeadline: (percent) => `${percent}% af opgaver med deadline`,
            noDeadlinesConfigured: 'Ingen deadlines konfigureret',
            olderThan7Days: 'Ældre end 7 dage',
            percentOfBacklog: (percent) => `${percent}% af bunken`,
            olderThan30Days: 'Ældre end 30 dage',
            unassigned: 'Uden ansvarlig',
            ageDistribution: 'Aldersfordeling',
            ageDistributionDescription: 'Hvor længe har de åbne opgaver ligget på opgavelisten? Søjlerne til højre bør være lave - ellers er der opgaver der er ved at sande til.',
            quantity: 'Antal',
            prioritizationPerUpdateType: 'Prioritering per opgavetype',
            prioritizationDescription: 'Sorteret efter antal opgaver over deadline. Opgavetyper uden deadline konfigureret falder bagest - sæt en deadline på opgavetypen for at få den med i prioriteringen.',
            noTasksOnList: 'Der ligger ingen opgaver på opgavelisten.',
            behindPerCreditor: 'Bagud per kreditor',
            behindPerCreditorDescription: 'Sorteret efter antal opgaver der har ligget mere end 7 dage. Brug det til at se hvilke kreditorer der lige nu kræver ekstra opmærksomhed.',
            noOpenTasksByCreditor: 'Ingen åbne opgaver fordelt på kreditorer.',
            behindPerCaseGroup: 'Bagud per sagsgruppe',
            behindPerCaseGroupDescription: 'Hvilke sagsgrupper har den største ophobning af opgaver, og hvor er der opgaver der ligger og venter længst?',
            noOpenTasksByCaseGroup: 'Ingen åbne opgaver fordelt på sagsgrupper.',
            hoursPerUpdateType: 'Antal timer per opgavetype',
            timeTrackingDescription: 'Tidsregistreringer registreres automatisk på en opgave, når man vælger en opgavetype på opgavelisten. Tiden starter når man kommer ind på en sag og afsluttes når man forlader den eller markerer opgaven løst.',
            average: 'Gennemsnit',
            median: 'Median',
            taskCount: 'Antal opgaver',
            taskQueueDurationDescription: 'Viser hvor længe opgaver i gennemsnit ligger på opgavelisten - målt fra de bliver oprettet til de bliver fortsat.',
            columnAvgPerTask: 'Gns. per opgave',
            columnResolvedTasksCount: 'Antal løste opgaver',
            totalTimeSpent: 'Tidsforbrug i alt',
            weekdays: {
                sun: 'Søn',
                mon: 'Man',
                tue: 'Tir',
                wed: 'Ons',
                thu: 'Tor',
                fri: 'Fre',
                sat: 'Lør',
            },
            onParWithTeam: 'På niveau med teamet',
            comparedToTeam: (signedPct) => `${signedPct} ift. team`,
            resolvedCount: 'Antal løste',
            percentile25: '25%-percentil',
            percentile75: '75%-percentil',
            fastest: 'Hurtigste',
            slowest: 'Langsomste',
            timeSpentDistribution: 'Fordeling af tidsforbrug',
            timeSpentDistributionDescription: 'Hvordan brugerens opgaver fordeler sig over tid - sammenlignet med teamets fordeling. Hvis brugeren ligger til højre for teamet, bruger de generelt længere tid per opgave.',
            team: 'Team',
            efficiencyPerWeekday: 'Effektivitet per ugedag',
            efficiencyPerWeekdayDescription: 'Gennemsnitlig opgavetid per ugedag - brugerens egen tid (mørk) vs. teamets gennemsnit (lys). Søjlerne viser også hvor mange opgaver brugeren har løst på hver dag.',
            userAvg: 'Bruger gns.',
            teamAvg: 'Team gns.',
            tasks: 'Opgaver',
            minutesSuffix: ' min',
        },
        calls: {
            overviewSectionHeader: 'Opkald og omsætning i perioden',
            callsPerMonthHeader: 'Antal opkald per måned',
            creditorReachHeader: 'Kreditorer — hvor nemt får vi fat på debitorerne?',
            outgoingTagsHeader: 'Udgående opkald — tags og succesrate',
            incomingTagsHeader: 'Indgående opkald — tags og succesrate',
            caseworkerPerformanceHeader: 'Medarbejdere — succesrate',
            shareOfCalls: (share) => `${share}% af opkald`,
            stat: {
                totalCalls: 'Opkald i alt',
                totalCallsInfo: 'Det samlede antal opkald-interaktioner registreret på sager i den valgte periode.',
                incomingInfo: 'Antal opkald hvor en debitor (eller andre) har ringet ind.',
                outgoingInfo: 'Antal opkald foretaget af sagsbehandlere.',
                outgoingAnswered: 'Udgående besvaret',
                outgoingAnsweredInfo: "Udgående opkald der ikke har fået tagget 'Intet svar'. Andelen vises ift. alle udgående.",
                outgoingNoAnswer: 'Udgående uden svar',
                outgoingNoAnswerInfo: "Udgående opkald hvor sagsbehandleren har tagget opkaldet med 'Intet svar'. Andelen vises ift. alle udgående.",
                withPayment: 'Med betaling',
                withPaymentInfo: 'Antal opkald der er efterfulgt af en indbetaling på samme sag inden for 7 dage.',
                withNewPaymentPlan: 'Med ny afdragsordning',
                withNewPaymentPlanInfo: 'Antal opkald der er efterfulgt af en oprettet afdragsordning på samme sag inden for 7 dage.',
                collectionCommission: 'Inddrivelseshonorar',
                collectionCommissionInfo: 'Sum af inddrivelseshonorar (billing-bilag) bogført inden for 7 dage efter et opkald i perioden.',
                otherFees: 'Andre honorarer',
                otherFeesInfo: 'Sum af øvrige honorarer (billing-bilag) bogført inden for 7 dage efter et opkald i perioden.',
                totalRevenue: 'Omsætning i alt',
                totalRevenueInfo: "Samlet omsætning (inddrivelseshonorar + andre honorarer) bogført inden for 7 dage efter et opkald i perioden. 'Per opkald' er gennemsnit fordelt på alle opkald.",
                perCall: (amount) => `${amount} per opkald`,
            },
            emptyTags: 'Ingen tags registreret i perioden.',
            unknownUser: 'Ukendt bruger',
            emptyCaseworkers: (minCalls) => `Ingen medarbejdere med mindst ${minCalls} opkald i perioden.`,
            caseworkerHelp: (minCalls) => `Kun medarbejdere med mindst ${minCalls} registrerede opkald i perioden vises. Succesraten måler hvor stor en andel af medarbejderens opkald der er efterfulgt af en indbetaling eller en oprettet afdragsordning på samme sag inden for 7 dage.`,
            emptyCreditors: (minCalls) => `Ingen kreditorer med mindst ${minCalls} opkald i perioden.`,
            creditorReachHelpPrefix: 'Sorter på ',
            creditorReachHelpAnswered: 'Besvaret',
            creditorReachHelpMiddle: ' for at se hvilke kreditorers debitorer der er nemmest at få fat på. Kun udgående opkald indgår i svarprocenten — opkald uden tagget ',
            creditorReachHelpNoAnswer: "'Intet svar'",
            creditorReachHelpMin: (minCalls) => ` tæller som besvaret. Kun kreditorer med mindst ${minCalls} opkald i perioden vises.`,
            answered: 'Besvaret',
            caseworker: 'Medarbejder',
        },
        communications: {
            sectionHeader: 'Kommunikation i perioden',
            templatesHeader: 'Skabeloner — succesrate og afledt omsætning',
            byTypeHeader: 'Interaktioner per type og retning',
            letterReturnsHeader: 'Returbreve — antal, svartid og årsag',
            dataQualityHeader: 'Stamdata-kvalitet per kreditor og sagsgruppe',
            futureWorkflowsHeader: 'Workflows — kommende opgaver per opgavetype',
            shareOfAll: (percent) => `${percent} af alle`,
            shareOfSent: (percent) => `${percent} af afsendte`,
            stat: {
                totalInteractions: 'Interaktioner i alt',
                totalInteractionsInfo: 'Det samlede antal kommunikationsinteraktioner (alle typer, alle retninger) i perioden.',
                outgoingInfo: 'Antal udgående interaktioner i perioden.',
                incomingInfo: 'Antal indgående interaktioner i perioden.',
                withPaymentPlan: 'Med ny afdragsordning',
                withPaymentPlanInfo: 'Interaktioner der er efterfulgt af en ny afdragsordning på samme sag inden for 7 dage.',
                withPayment: 'Med betaling',
                withPaymentInfo: 'Interaktioner der er efterfulgt af en indbetaling på samme sag inden for 7 dage.',
                linkClicks: 'Link-kliks',
                linkClicksInfo: 'Samlet antal link-kliks registreret på interaktioner i perioden.',
                collectionCommission: 'Inddrivelseshonorar',
                collectionCommissionInfo: 'Sum af inddrivelseshonorar på sager der modtog en interaktion i perioden, posteret inden for 7 dage.',
                otherFees: 'Andre honorarer',
                otherFeesInfo: 'Sum af øvrige honorarer (FEE-kategori) på sager der modtog en interaktion i perioden, posteret inden for 7 dage.',
                totalRevenue: 'Omsætning i alt',
                totalRevenueInfo: 'Indtægt henført til den seneste udgående skabelonbesked før hvert gebyr, inden for 7 dage. Hvert gebyr tælles én gang.',
                lettersSent: 'Breve afsendt',
                lettersSentInfo: 'Antal afsendte breve i perioden.',
                lettersReturned: 'Breve returneret',
                lettersReturnedInfo: "Antal breve hvor PostNord har registreret en 'Failed'-hændelse i perioden.",
                averageReturnTime: 'Gennemsnitlig returhastighed',
                averageReturnTimeInfo: 'Gennemsnitligt antal dage fra brevet er afsendt til returhændelsen er registreret.',
            },
            emptyTemplates: 'Ingen skabelon-baserede interaktioner i perioden.',
            emptyInteractions: 'Ingen interaktioner i perioden.',
            emptyReturns: 'Ingen returbreve registreret i perioden.',
            emptyCases: 'Ingen sager fundet.',
            emptyWorkflowTasks: 'Ingen kommende workflow-opgaver fundet.',
            templatesHelp: 'Hver række er én skabelon brugt på udgående interaktioner i perioden. Betalingsaftale % og Betaling % tæller hvor mange af de afsendte interaktioner der inden for 7 dage blev fulgt af henholdsvis en ny betalingsaftale eller en indbetaling på samme sag. Link-kliks er klik-hændelser registreret på interaktionerne. Omsætning er summen af inkassosalær og andre gebyrer posteret på samme sag inden for 7 dage efter afsendelse.',
            dataQualityHelp: 'Tabellen viser hvor god kontaktdataen er per kreditor og sagsgruppe. Lave returrater og lave fejlrater betyder at vi får fat på debitorerne via de valgte kanaler. Tal i parentes er det absolutte antal leveringsfejl.',
            workflowHelp: 'Volumen af kommende workflow-opgaver per opdateringstype. Baseret på sagens næste planlagte opgave (cases.workflow_next_task_id). Filtre ovenfor anvendes ikke — tabellen viser den aktuelle backlog.',
            daysValue: (days) => `${days} dage`,
            col: {
                template: 'Skabelon',
                type: 'Type',
                sent: 'Afsendt',
                linkClicks: 'Link-kliks',
                returnReason: 'Returårsag',
                shareOfSent: 'Andel af afsendte',
                averageResponseTime: 'Svartid (gns.)',
                lettersReturned: 'Breve retur',
                emailsFailed: 'Emails fejlet',
                eboksFailed: 'e-Boks fejlet',
                cases: 'Sager',
                overdue: 'Forsinket',
                next7Days: 'Næste 7 dage',
                days8To30: '8–30 dage',
                later: 'Senere',
            },
        },
        expiration: {
            headerExpiration: 'Forældelse',
            headerSuspension: 'Evne til at afbryde forældelse',
            clear: 'Ryd',
            loadingForMonth: (month) => `Henter fordeling for ${month}…`,
            distributionPerCreditor: (month) => `Fordeling per kreditor – ${month}`,
            distributionPerCaseGroup: (month) => `Fordeling per sagsgruppe – ${month}`,
        },
        revenue: {
            settledRevenuePerMonth: 'Afregnet omsætning per måned',
            collectionCommissionByCasePostingType: 'Inddrivelseshonorar fordelt på sagsposteringtype',
            otherFeesByFeeType: 'Andre honorarer fordelt på honorartype',
            billingSpeedPerCreditor: 'Faktureringshastighed per kreditor',
            workInProgressNotYetBilled: 'Igangværende arbejde (endnu ikke faktureret)',
            revenuePerCreditor: 'Omsætning per kreditor',
            revenuePerCaseGroup: 'Omsætning per sagsgruppe',
            collectionCommission: 'Inddrivelseshonorar',
            fees: 'Honorarer',
            otherFees: 'Andre honorarer',
            avgDaysToBilling: 'Gns. dage til fakturering',
            billed: 'Faktureret',
            unbilled: 'Ikke-faktureret',
            totalOtherFees: 'I alt andre honorarer',
            totalCollectionCommission: 'I alt inddrivelseshonorar',
            name: 'Navn',
        },
        tribunal: {
            paymentOrderOutcomes: 'Udfald af betalingspåkrav',
            casesFiledAndBailiffMeetingsPerMonth: 'Antal domstolssager indleveret og fogedmøder per måned',
            courtProcessingTime: 'Behandlingstid hos retskredsene (Betalingspåkrav)',
            percentOfCases: (share) => `${share}% af sager`,
            stat: {
                totalFiled: 'Indleveret i alt',
                totalFiledInfo: 'Antallet af unikke sager hvor der er oprettet eller gensendt et betalingspåkrav i den valgte periode. Datoen er tidspunktet for indlevering af betalingspåkravet.',
                paidAfterFiling: 'Betalt efter indlevering',
                paidAfterFilingInfo: "Antallet af sager der er afsluttet som betalt inden for 3 måneder efter den seneste handling i domstolsmodulet. Sagerne tælles med ud fra datoen for det oprindelige betalingspåkrav — ikke betalingsdatoen. Kræver at sagen er afsluttet med årsag 'Betalt' i Debbie.",
                paidBetweenFirstAndSecondEndorsement: 'Betalt mellem 1. og 2. påtegning',
                paidBetweenFirstAndSecondEndorsementInfo: 'Antallet af unikke sager hvor der er registreret en indbetaling mellem 1. påtegning og op til 5 dage efter 2. påtegning (for at fange indbetalinger der først registreres senere). Sagen behøver ikke at være afsluttet som betalt. Sagerne tælles med ud fra datoen for det oprindelige betalingspåkrav.',
                paidBetweenSecondEndorsementAndBailiffMeeting: 'Betalt mellem 2. påtegning og fogedmøde',
                paidBetweenSecondEndorsementAndBailiffMeetingInfo: 'Antallet af unikke sager hvor der er registreret en indbetaling mellem 2. påtegning og op til 5 dage efter fogedmødet (for at fange indbetalinger der først registreres senere). Sagen behøver ikke at være afsluttet som betalt. Sagerne tælles med ud fra datoen for det oprindelige betalingspåkrav. Kræver at fogedmødet er registreret i Debbie.',
                distraintsPerformed: 'Udlæg foretaget',
                distraintsPerformedInfo: 'Antallet af unikke sager hvor der er registreret en udlægs-hændelse. Sagerne tælles med ud fra datoen for det oprindelige betalingspåkrav — ikke datoen for udlægget. Bemærk: Udlæg, der ikke er registreret i Debbie, indgår ikke.',
                paymentPlansCreatedAfterBailiffMeeting: 'Afdragsordninger oprettet efter fogedmøde',
                paymentPlansCreatedAfterBailiffMeetingInfo: 'Antallet af afdragsordninger oprettet inden for 1 måned efter et fogedmøde. Sagerne tælles med ud fra datoen for det oprindelige betalingspåkrav — ikke datoen for afdragsordningen. Alle oprettede afdragsordninger tæller med, også dem der senere er annulleret eller misligholdt. Kræver at fogedmødet er registreret i Debbie.',
                activePaymentPlansNow: 'Aktive afdragsordninger lige nu',
                activePaymentPlansNowInfo: 'Ud af de afdragsordninger oprettet efter fogedmøde, hvor mange der lige nu er aktive.',
                finishedPaymentPlans: 'Fuldførte afdragsordninger',
                finishedPaymentPlansInfo: 'Ud af de afdragsordninger oprettet efter fogedmøde, hvor mange der er fuldført (betalt helt af).',
                objections: 'Indsigelser',
                objectionsInfo: 'Antallet af fogedsager der er lukket med indsigelse efter 1. påtegning. Sagerne tælles med ud fra datoen for det oprindelige betalingspåkrav — ikke datoen for indsigelsen. Bemærk: Indsigelser, der ikke er registreret i Debbie, indgår ikke.',
                insolvencies: 'Insolvens',
                insolvenciesInfo: 'Antallet af unikke sager hvor der er registreret insolvens. Sagerne tælles med ud fra datoen for det oprindelige betalingspåkrav — ikke datoen for insolvensregistreringen. Bemærk: Insolvenser, der ikke er registreret i Debbie, indgår ikke.',
            },
            bailiffMeetings: 'Fogedmøder',
            courtSpeedBenchmarkDescription: 'Samlet tid fra sagens start til hvert trin i den forenklede proces. Tallet nedenunder viser tiden fra forrige trin.',
            court: 'Retskreds',
            firstEndorsement: '1. påtegning',
            secondEndorsement: '2. påtegning',
            invitation: 'Indkaldelse',
            bailiffMeeting: 'Fogedmøde',
            casesByCourt: 'Sager indleveret per retskreds',
            casesByCourtDescription: 'Antallet af originalt indleverede betalingspåkrav denne tenant har indsendt til hver retskreds i den valgte periode, samt hvor mange retten har returneret med krav om at indsende et revideret betalingspåkrav.',
            casesByCourtCount: 'Sager indleveret',
            casesByCourtShare: 'Andel af samlet',
            casesByCourtRevised: 'Returneret til udbedring af mangler',
            casesByCourtRevisedShare: 'Revideringsandel',
        },
    },
    agentToolLabels: {
        [ToolName.SearchTools]: 'Søg værktøjer',
        [ToolName.GetTool]: 'Inspicér værktøj',
        [ToolName.ListPendingProposals]: 'Vis afventende forslag',
        [ToolName.EscalateToHuman]: 'Eskalér til sagsbehandler',
        [ToolName.ReportOutcome]: 'Rapportér udfald',
        [ToolName.GetCustomer]: 'Hent skyldneroplysninger',
        [ToolName.GetCreditor]: 'Hent kreditoroplysninger',
        [ToolName.GetWorkflow]: 'Hent workflow-status',
        [ToolName.GetCurrentPaymentPlan]: 'Hent aktiv afdragsordning',
        [ToolName.SearchCaseHistory]: 'Søg sagshistorik',
        [ToolName.SearchContactPersons]: 'Søg kontaktpersoner',
        [ToolName.SearchProperties]: 'Søg sagsegenskaber',
        [ToolName.SearchInteractions]: 'Søg interaktioner',
        [ToolName.GetInteraction]: 'Hent interaktion',
        [ToolName.SearchVouchers]: 'Søg bilag',
        [ToolName.GetVoucher]: 'Hent bilag',
        [ToolName.SearchTemplates]: 'Søg skabeloner',
        [ToolName.GetTemplate]: 'Hent skabelon',
        [ToolName.SearchMentions]: 'Søg mentions',
        [ToolName.SearchUpdateTypes]: 'Søg opgavetyper',
        [ToolName.GetUpdateType]: 'Hent opgavetype',
        [ToolName.SearchUpdates]: 'Søg anvendte opgaver',
        [ToolName.GetUpdate]: 'Hent opgave',
        [ToolName.SearchDocuments]: 'Søg dokumenter',
        [ToolName.GetDocument]: 'Hent dokument',
        [ToolName.GetFile]: 'Læs fil',
        [ToolName.SearchPaymentPlans]: 'Søg afdragsordninger',
        [ToolName.GetPaymentPlan]: 'Hent afdragsordning',
        [ToolName.SearchTribunalCases]: 'Søg retssager',
        [ToolName.GetTribunalCase]: 'Hent retssag',
        [ToolName.CreateInteraction]: 'Send besked',
        [ToolName.CreateCreditorMessage]: 'Send kreditorbesked',
        [ToolName.CreatePaymentPlan]: 'Opret afdragsordning',
        [ToolName.CreateUpdate]: 'Anvend opgave',
        [ToolName.EndCase]: 'Afslut sag',
    },
    agentToolDescriptions: {
        [ToolName.SearchTools]: 'Find hvilke værktøjer agenten har til rådighed. Kald uden filtre for at se kategorier.',
        [ToolName.GetTool]: 'Slå det præcise inputformat op for et bestemt værktøj og gør det tilgængeligt for kald.',
        [ToolName.ListPendingProposals]: 'Se forslag på denne sag, der endnu mangler en afgørelse.',
        [ToolName.EscalateToHuman]: 'Afslut kørslen og opret en notifikation om en konkret handling eller beslutning, der kræver en sagsbehandlers opmærksomhed.',
        [ToolName.ReportOutcome]: 'Afslut kørslen med et struktureret udfald, når der ikke foretages handling.',
        [ToolName.GetCustomer]: 'Læs basisoplysninger om skyldneren på denne sag.',
        [ToolName.GetCreditor]: 'Læs oplysninger om kreditor på denne sag.',
        [ToolName.GetWorkflow]: 'Læs sagens workflow-status og hvad workflowet planlægger som næste skridt.',
        [ToolName.GetCurrentPaymentPlan]: 'Læs den aktive afdragsordning, hvis nogen.',
        [ToolName.SearchCaseHistory]: 'Gennemse kronologisk tidslinje for aktivitet på denne sag.',
        [ToolName.SearchContactPersons]: 'Vis alternative kontaktpersoner (advokater, værger, arbejdsgivere mv.) tilknyttet sagen.',
        [ToolName.SearchProperties]: 'Vis tenant-konfigurerede egenskaber på denne sag.',
        [ToolName.SearchInteractions]: 'Vis interaktioner (e-mails, SMS, breve, noter) på denne sag.',
        [ToolName.GetInteraction]: 'Læs fuldt indhold af en specifik interaktion.',
        [ToolName.SearchVouchers]: 'Vis bilag (hovedstol, renter, gebyrer, betalinger) på denne sag.',
        [ToolName.GetVoucher]: 'Læs fulde detaljer for et bestemt bilag inkl. restbeløb.',
        [ToolName.SearchTemplates]: 'Gennemse interaktionsskabeloner konfigureret for denne tenant.',
        [ToolName.GetTemplate]: 'Læs fuldt indhold af en bestemt skabelon.',
        [ToolName.SearchMentions]: 'Søg i kataloget over {{mention}}-placeholdere brugt i interaktionstekster.',
        [ToolName.SearchUpdateTypes]: 'Søg opgavetyper tilgængelige på denne sag (pauser, overdragelser, statusændringer).',
        [ToolName.GetUpdateType]: 'Læs fulde detaljer for en opgavetype inkl. den procedure den udløser.',
        [ToolName.SearchUpdates]: 'Vis opgaver, der er anvendt på denne sag.',
        [ToolName.GetUpdate]: 'Læs detaljer for en specifik opgave anvendt på sagen.',
        [ToolName.SearchDocuments]: 'Vis dokumenter tilknyttet sagen (fundamenter, domme, forlig).',
        [ToolName.GetDocument]: 'Læs et dokuments domæne-metadata (type, signeret/fundament-status mv.). Kald get_file med fileId for selve teksten.',
        [ToolName.GetFile]: 'Læs den udtrukne tekst af en fil via id, fra hvor end den er vedhæftet.',
        [ToolName.SearchPaymentPlans]: 'Vis afdragsordninger på sagen, inkl. annullerede og afsluttede.',
        [ToolName.GetPaymentPlan]: 'Læs fulde detaljer for en bestemt afdragsordning.',
        [ToolName.SearchTribunalCases]: 'Vis retssager (foged- / domstolssager) tilknyttet denne sag.',
        [ToolName.GetTribunalCase]: 'Læs fulde detaljer for en retssag inkl. hændelser og noter.',
        [ToolName.CreateInteraction]: 'Send en besked til debitor.',
        [ToolName.CreateCreditorMessage]: 'Send en besked til kreditor via kreditorportalen.',
        [ToolName.CreatePaymentPlan]: 'Opret en afdragsordning.',
        [ToolName.CreateUpdate]: 'Anvend en opgave på sagen (registrér en hændelse, pause, overdragelse).',
        [ToolName.EndCase]: 'Afslut sagen med en specifik årsag.',
    },
    agentProposals: {
        title: 'Agent-forslag',
        empty: 'Ingen agent-forslag på denne sag.',
        pending: 'Afventer',
        approved: 'Godkendt',
        rejected: 'Afvist',
        failed: 'Fejlede',
        stale: 'Forældet',
        superseded: 'Overskrevet',
        dismissed: 'Afvist fra visning',
        executing: 'Udfører',
        approve: 'Godkend',
        reject: 'Afvis',
        retry: 'Prøv igen',
        dismiss: 'Fjern',
        invalidEdits: 'Ugyldige ændringer',
        reasoning: 'Begrundelse',
        proposedInput: 'Forslag',
        appliedInput: 'Anvendt input',
        finalVersion: 'Endelig version',
        agentVersion: 'Agentens forslag',
        decidedBy: 'Afgjort af',
        proposedAt: 'Foreslået',
        snapshot: 'Sagstilstand ved forslag',
        errorMessage: 'Fejl',
        output: 'Resultat',
    },
    categoryInsights: {
        tabTitle: 'Kategorier',
        category: 'Kategori',
        allCategories: 'Alle kategorier',
        interactions: 'Interaktioner',
        uncategorized: 'Ikke kategoriseret',
        addedByCaseworkers: 'Tilføjet af sagsbehandlere',
        removedByCaseworkers: 'Fjernet af sagsbehandlere',
        noInteractions: 'Ingen kategoriserede interaktioner i perioden.',
        removed: 'Fjernet af en sagsbehandler',
        addedByAi: 'Tilføjet af AI',
    },
    agentPerformance: {
        tabTitle: 'Agentforslag',
        action: 'Handling',
        allActions: 'Alle handlinger',
        taskPrompt: 'Opgaveprompt',
        task: 'Opgave',
        allTaskPrompts: 'Alle opgaveprompts',
        startedManually: 'Startet manuelt',
        unknownUpdateType: 'Ukendt opgavetype',
        accepted: 'Godkendt',
        proposals: 'Forslag',
        decisionTime: 'Beslutningstid',
        escalated: 'Eskaleret til sagsbehandler',
        oldestPending: 'Ældste: {age}',
        comparedToPrevious: 'Sammenlignet med forrige periode',
        percentagePoints: '{points} %-point',
        duration: {
            minutes: '{minutes} min.',
            hours: '{hours} t.',
            days: '{days} dage',
        },
        decisions: {
            [ProposalDecision.Pending]: 'Afventer',
            [ProposalDecision.ApprovedAsIs]: 'Godkendt uændret',
            [ProposalDecision.Edited]: 'Rettet',
            [ProposalDecision.Rejected]: 'Afvist',
            [ProposalDecision.Failed]: 'Fejlet',
            [ProposalDecision.Closed]: 'Lukket',
        },
        allDecisions: 'Alle',
        noProposals: 'Ingen forslag i perioden.',
    },
    agentNotices: {
        humanEscalation: 'Kræver sagsbehandlers opmærksomhed',
        systemFailure: 'Agenten kunne ikke færdiggøre gennemgangen',
        attention: 'Opmærksomhed',
        filterHumanEscalation: 'Sagsbehandlereskalering',
        filterSystemFailure: 'Systemfejl',
    },
    agentSettings: {
        tabTitle: 'Agent',
        title: 'Agent-værktøjspolitikker',
        description: 'Styr hvilke tunge handlinger agenten må foreslå. Alle foreslåede handlinger skal godkendes af en sagsbehandler før udførsel.',
        heavyOnlyNote: 'Kun tunge handlinger kan konfigureres. Læseværktøjer (søg og hent) er altid tilgængelige for agenten.',
        policies: {
            [ToolPolicy.Disabled]: 'Deaktiveret',
            [ToolPolicy.RequireApproval]: 'Kræver godkendelse',
            [ToolPolicy.AutoRun]: 'Kør automatisk',
        },
        policyDescriptions: {
            [ToolPolicy.Disabled]: 'Agenten kan slet ikke foreslå denne handling.',
            [ToolPolicy.RequireApproval]: 'Agenten må foreslå; en sagsbehandler gennemgår og beslutter.',
            [ToolPolicy.AutoRun]: 'Agenten må foreslå; handlingen udføres automatisk uden gennemgang.',
        },
        default: 'Standard',
        saved: 'Politik opdateret',
        saveError: 'Kunne ikke opdatere politik',
    },
    agentProposalBodies: {
        reply: 'Svar',
        replyingTo: 'Svar på',
        numberOfInstallments: 'Antal afdrag',
        upfrontDate: 'Forudbetalingsdato',
        addScheduledChange: 'Tilføj ændring',
        unknownUpdateType: 'Ukendt opgavetype',
        procedureTasks: 'Opgaver der udføres når opgaven anvendes',
        outstandingBalance: 'Udestående saldo',
        endCaseConsequences: 'Når sagen afsluttes',
        endCaseConsequencePlans: 'Aktive afdragsordninger annulleres',
        endCaseConsequenceRki: 'RKI-registreringer slettes',
        endCaseConsequenceProposals: 'Øvrige afventende agent-forslag bortfalder',
        endCaseConsequenceFinal: 'En afsluttet sag kan ikke længere modtage beskeder eller afdragsordninger',
        startDateInPast: 'Startdato må ikke være i fortiden',
        message: 'Besked',
        letterBody: 'Brevtekst',
        letterWrapperNote: 'Skabelonen tilføjer brevhoved, adresseblok og underskrift ved afsendelse.',
        oneAttachment: '1 vedhæftning',
        attachments: 'vedhæftninger',
        startDate: 'Startdato',
        installmentAmount: 'Afdragsbeløb',
        upfront: 'Forud',
        scheduledChanges: 'Planlagte beløbsændringer',
        fromDate: 'Fra',
        updateText: 'Opgavetekst',
        updateType: 'Opgavetype',
        creditorMessage: 'Kreditorbesked',
        continuation: 'Opgavens tilstand efter anvendelse',
        continueNow: 'Fortsættes med det samme',
        leavePaused: 'Behold som aktiv pause',
        keepScheduledDate: 'Behold planlagt fortsættelse',
        noDetails: 'Ingen yderligere detaljer.',
        to: 'til',
        recipientDebtor: 'Debitor',
        recipientCreditor: 'Kreditor',
        startsOn: 'Starter',
        installments: 'afdrag',
        upfrontInline: 'forud d.',
        summaryEnds: 'Slutter',
        summaryTotal: 'I alt',
        summaryPerInstallment: 'pr. afdrag',
    },
    tribunalSettings: {
        box4CaseStatementTemplate: 'Rubrik 4 - Skabelon til sagsfremstilling',
        caseStatementTemplate: 'Skabelon til sagsfremstilling',
        submission: 'Indlevering',
        ignorePaymentsWarning: 'Ignorer advarsel om at sagen indeholder indbetalinger',
        box1Creditor: 'Rubrik 1 - Kreditor (og eventuel repræsentant)',
        creditor: 'Kreditor',
        representative: 'Eventuel repræsentant',
        contactInformation: 'Kontaktoplysninger',
        noPhoneMeetingBelow: 'Ønsk ikke telefonmøde, hvis kravets samlede beløb er under (DKK):',
        representativePhone: 'Repræsentantens telefonnummer',
        representativeEmail: 'Repræsentantens email',
        representativeRegistrationNumber: 'Repræsentantens reg.nr.',
        representativeAccountNumber: 'Repræsentantens konto.nr.',
        box2Debtor: 'Rubrik 2 - Skyldner',
        includeCprInPaymentDemand: 'Inkluder CPR-nummer i betalingspåkrav',
        box4ClaimSize: 'Rubrik 4 - Kravets størrelse',
        excludeVoucherTypesDescription: 'Ekskluder udvalgte sagsposteringstyper ved indleveringen af betalingspåkravet. For eksempel inkassoomkostninger.',
        selectVoucherTypesToSubtract: 'Vælg sagsposteringstyper som skal fratrækkes ved indlevering',
        box5CaseStatement: 'Rubrik 5 - Sagsfremstilling',
        box9SubmittedBy: 'Rubrik 9 - Indsendt af (kreditor eller kreditors repræsentant)',
        courtCosts: 'Sagsomkostninger',
        selectCourtCostVoucherType: 'Vælg sagsomkostningernes sagsposteringstype',
        vouchersToOverride: 'Posteringer som skal overskrives (fjernes fra sagen)',
        selectVouchers: 'Vælg posteringer',
        vouchersToSubtractFromCourtCosts: 'Posteringer som skal modregnes i sagsomkostningerne',
        keepHigherExtrajudicialCosts: 'Behold udenretlige omkostninger, hvis de er højere end de indenretlige',
        interestActSection8a: 'Renteloven § 8 a',
        interestActSection8aDescription: 'Sagsomkostninger tilkendt ved dom eller anden retsafgørelse i en borgerlig sag forrentes fra fuldbyrdelsesfristens udløb med rente som fastsat efter § 5, stk. 1 og 2.',
        selectInterestVoucherTypesAfterVerdict: 'Vælg posteringstyper som der skal regnes rente af 14 dage fra dom',
        insolvencyDeclaration: 'Insolvenserklæring',
        useCustomInsolvencyUpdateType: 'Brug tilpasset insolvens opgavetype',
        defaultEmailTemplate: 'E-mail standardskabelon',
        defaultEmailAttachmentTemplate: 'E-mail-vedhæftningens standardskabelon',
        editTemplate: 'Redigér skabelon',
    },
    cosmoSettings: {
        header: 'Cosmo Indstillinger',
        warningPrefix: 'OBS:',
        warning: 'Lav ikke ændringer på denne side uden konsultation med Debbie support.',
        identityProviderDescription: 'Vælg hvilke identitetsudbydere der skal bruges til henholdsvis personer og virksomheder. En identitetsudbyder er den dataudbyder som bruges til unikt at identificere en person eller virksomhed',
        personIdentityProvider: 'Person identitetsudbyder',
        selectPersonIdentityProvider: 'Vælg person identitetsudbyder',
        companyIdentityProvider: 'Virksomheds identitetsudbyder',
        selectCompanyIdentityProvider: 'Vælg virksomheds identitetsudbyder',
        subscriptionStrategyDescription: 'Vælg hvornår brugere skal tilmeldes Cosmo',
        strategyOnOpenCases: 'Tilmeld brugere på alle aktive sager og afmeld når sagerne afsluttes',
        strategyOnAllCustomers: '[not implemented] Tilmeld brugere ved kundeoprettelse og afmeld ved sletning',
        strategyManual: 'Manuel tilmelding og afmelding af brugere. Ingen automatisk tilmelding/afmelding.',
        providers: 'Udbydere',
        disabledProviders: 'Deaktiverede udbydere',
        notActivated: 'Ikke aktiveret',
        settings: 'Indstillinger',
        deactivate: 'Deaktiver',
        activate: 'Aktiver',
        identityProvider: 'Identitetsudbyder',
        persons: 'Personer',
        companies: 'Virksomheder',
    },
    dnsSetup: {
        checkDns: 'Tjek DNS',
        title: 'DNS-opsætning',
        allRecordsConfirmed: 'Alle records er bekræftet',
        domainVerification: 'Domæneverificering',
        email: 'E-mail',
        outboundEmails: 'Udgående e-mails (DKIM & SPF)',
        spfExistingPrefix: 'Hvis der allerede findes en SPF-record, skal du sørge for at tilføje',
        spfExistingSuffix: 'til den eksisterende record.',
        inboundEmails: 'Indgående e-mails',
        inboundForwarded: 'Alle indgående mails skal automatisk videresendes.',
        sites: 'Sider',
        debtorWebApp: 'Debitor webapp',
        creditorWebApp: 'Kreditor webapp',
        verified: 'Verificeret',
        type: 'Type',
        hostname: 'Hostname',
        value: 'Værdi',
        currentValue: 'Nuværende værdi',
    },
    createTenant: {
        tenantType: 'Kontotype',
        agency: 'Inkassobureau',
        agencyDescription: 'Inkassobureau der inddriver på vegne af eksterne kunder. Inddrevne midler fordeles til kreditorerne, og funktioner som fogedret/retssager er slået til.',
        accountsReceivable: 'Debitorbogholderi',
        accountsReceivableDescription: 'Virksomhed der selv inddriver sine tilgodehavender. Kontoen er selv den eneste kreditor og bruger en forenklet debitorbogholderimodel.',
        companyName: 'Virksomhedens navn',
        vatNumber: 'CVR-nummer (DK12345678)',
        billingAddress: 'Faktureringsadresse',
        country: 'Land',
        language: 'Sprog',
        currency: 'Valuta',
        timezone: 'Tidszone',
        demoDescription: "Demokonto til salgspræsentationer. Disse konti kan have testdata, og nogle statistikker vil være fiktive. Afsendelse af e-mails, sms'er osv. simuleres, og der sendes ingen rigtige data. Data sendes til brugeren, der bruger systemet.",
        sandboxDescription: "Bruges til kunder, der har brug for et sandkassemiljø. Afsendelse af e-mails, sms'er osv. simuleres, og der sendes ingen rigtige data. Data sendes til brugeren, der bruger systemet.",
        gettingStartedDescription: "Konti efter go-live, hvor konfiguration, API-integration, onboarding osv. er i gang. Kontoen kan senere sættes som aktiv. Afsendelse af e-mails, sms'er osv. simuleres, og der sendes ingen rigtige data. Data sendes til brugeren, der bruger systemet.",
        demoMockData: 'Demo-testdata',
        noMockData: '-- Ingen testdata --',
        addFrisbiiPaymentGateway: 'Tilføj Frisbii payment gateway',
        principalType: 'Hovedstolstype',
        interestType: 'Rentetype',
        noInterest: '-- Ingen rente --',
        quantityCreditors: 'Antal kreditorer',
        quantityCasesPerCreditor: 'Antal sager pr. kreditor',
        privateDebtors: 'Private debitorer',
        companyDebtors: 'Virksomhedsdebitorer',
        mixed: 'Blandet',
        createTenant: 'Opret konto',
    },
    experianClientNumber: {
        header: 'Indsend Experian klientnummer',
        withAksCustomerNumber: 'med AKS kundenummer:',
        partnershipText: 'har indgået samarbejde med nedenstående virksomhed. Der anmodes derfor om et RKI klientnummer til',
        forFutureRegistrations: 'til fremtidige indberetninger.',
        companyName: 'Virksomhedsnavn:',
        address: 'Adresse:',
        clientNumberRegistered: 'Klientnummeret blev registreret',
        clientNumberPlaceholder: 'Klientnummer',
        submit: 'Indsend',
    },
    satisfaction: {
        backToMyCase: 'Tilbage til min sag',
        header: 'Din mening betyder meget for os',
        intro: 'For at kunne yde den bedst mulige service, vil vi meget gerne høre om din oplevelse.',
        whichSmiley: 'Hvilken smiley beskriver bedst din oplevelse ved behandlingen af sag #',
        optionalComment: 'Eventuel kommentar',
        submit: 'Indsend',
        thanks: 'Tak for din indsendelse af tilfredshed',
    },
    webappSettings: {
        title: 'Webapps',
        debtorWeb: 'Debitorweb',
        creditorWeb: 'Kreditorweb',
        creditorIntroduction: 'Vælg, hvilke oplysninger kreditorer kan se i deres portal.',
        documentsTitle: 'Dokumenter',
        hideDocumentsDescription: 'Skjul sagernes dokumenter i kreditorportalen. Dokumenterne er fortsat tilgængelige for jeres sagsbehandlere.',
    },
    lighthouse: {
        cosmo: 'Cosmo',
        modules: 'Moduler',
        recalculateTenant: 'Genberegn tenant',
        recalculateTenantDescription: 'Genberegn renter, forældelse og fakturering på alle afventende og verificerede sager på tenanten.',
        recalculateTenantConfirm: 'Genberegn alle afventende og verificerede sager på denne tenant? Det kan oprette faktureringsreguleringer.',
        recalculate: 'Genberegn',
        recalculation: 'Genberegning',
        recalculationRunsInBackground: 'Den kører i baggrunden.',
    },
    debtorWebSettings: {
        introduction: 'Tilpas tekster og selvbetjening i den portal, dine skyldnere møder.',
        textsTitle: 'Tekster og kontakt',
        textsDescription: 'Brug standardteksterne, eller skriv jeres egne. Teksterne vises på skyldnerens sag.',
        customWelcome: 'Brug egen velkomsttekst',
        welcomeDescription: 'Erstatter introduktionen øverst på sagen.',
        defaultText: 'Standardtekst',
        defaultWelcomeDescription: 'Standardteksten viser skyldnerens saldo, kreditors navn og en introduktion til portalens muligheder.',
        showContactInformation: 'Vis kontaktoplysninger',
        contactInformationDescription: 'Vis kontaktsektionen med jeres e-mail og telefonnummer på sagen.',
        customContact: 'Brug egen kontakttekst',
        contactDescription: 'Teksten vises sammen med jeres kontaktoplysninger.',
        paymentsTitle: 'Betaling og afdrag',
        allowPartialPayments: 'Tillad delbetalinger',
        partialPaymentsDescription: 'Giv skyldneren mulighed for at betale en del af saldoen via betalingsportalen.',
        encouragePaymentPlan: 'Vis opfordring til afdragsordning',
        paymentPlanDescription: 'Vis en opfordring til at anmode om en afdragsordning, når det er muligt på sagen.',
        detailsTitle: 'Oplysninger og sagsnummer',
        allowSelfOverwrite: 'Tillad ændringer uden godkendelse',
        selfOverwriteDescription: 'Lad skyldnere overskrive deres egne oplysninger uden en sagsbehandlers godkendelse.',
        preferOriginalJournalNumber: 'Brug oprindeligt sagsnummer',
        journalNumberDescription: 'Vis sagsnummeret fra jeres tidligere system. Hvis det mangler, bruges sagsnummeret i Debbie.',
        unsavedChanges: 'Ændringer ikke gemt',
        saveDescription: 'Ændringer træder i kraft, når du gemmer.',
        saveChanges: 'Gem ændringer',
        emptyText: 'Udfyld din egen tekst, eller slå tilpasningen fra for at bruge standardteksten.',
        leaveWithoutSaving: 'Du har ændringer, som ikke er gemt. Vil du forlade siden?',
        welcomeText: 'Velkomsttekst',
        contactUsText: 'Kontakt os-tekst',
        hideContactInformation: 'Skjul kontaktoplysninger',
        noPartialPayments: 'Ingen delbetalinger',
        doNotEncouragePaymentPlan: 'Opfordr ikke til afdragsordning',
        useMigratedJournalNumber: 'Brug migreret jr. nummer (fallback til debbie jr. nummer)',
    },
};
//# sourceMappingURL=da.js.map